import { useState, useMemo, useEffect, useRef, useCallback } from "react";
import { LineChart, Line, BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from "recharts";

// ─── EASTER EGG ───────────────────────────────────────────────────────────────
var EMOJIS = ["📚","📚","✏️","✏️","🎓","🎓","📖","📝","🖊️","🎒"];

function EasterEggRain({ onDone }) {
  var [items] = useState(function() {
    var arr = [];
    for (var i = 0; i < 45; i++) {
      arr.push({
        id: i,
        emoji: EMOJIS[Math.floor(Math.random() * EMOJIS.length)],
        left: Math.random() * 100,
        delay: Math.random() * 1.8,
        duration: 1.5 + Math.random() * 1.5,
        size: 18 + Math.floor(Math.random() * 28),
        rotate: Math.random() * 360,
      });
    }
    return arr;
  });
  useEffect(function() {
    var t = setTimeout(onDone, 4000);
    return function() { clearTimeout(t); };
  }, [onDone]);
  return (
    <div style={{ position:"fixed", top:0, left:0, width:"100%", height:"100%", pointerEvents:"none", zIndex:99999, overflow:"hidden" }}>
      {items.map(function(item) {
        return (
          <div key={item.id} style={{
            position:"absolute",
            left: item.left + "%",
            top: "-60px",
            fontSize: item.size,
            animation: "rain-fall " + item.duration + "s " + item.delay + "s ease-in both",
          }}>{item.emoji}</div>
        );
      })}
    </div>
  );
}

var easterEggActive = false;
function triggerEasterEgg(imgEl) {
  if (easterEggActive) return;
  easterEggActive = true;
  // Capture current position
  var rect = imgEl.getBoundingClientRect();
  imgEl.style.setProperty('--egg-x', rect.left + 'px');
  imgEl.style.setProperty('--egg-y', rect.top + 'px');
  imgEl.classList.add("emblem-bounce");
  setTimeout(function() {
    imgEl.classList.remove("emblem-bounce");
    imgEl.classList.add("emblem-spin");
    if (window.__setShowRain__) window.__setShowRain__(true);
    setTimeout(function() {
      imgEl.classList.remove("emblem-spin");
      imgEl.style.removeProperty('--egg-x');
      imgEl.style.removeProperty('--egg-y');
      easterEggActive = false;
    }, 3500);
  }, 650);
}


var CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800;900&family=Playfair+Display:wght@700;800;900&display=swap');
  * { box-sizing:border-box; margin:0; padding:0; }
  body { background:#121212; color:#E0E0E0; font-family:'Outfit',sans-serif; }
  input, select, textarea { background:#1E1E1E; border:1px solid #2A2A2A; color:#E0E0E0; padding:11px 14px; border-radius:8px; font-family:'Outfit',sans-serif; font-size:13px; outline:none; width:100%; transition:border-color 0.15s; }
  @keyframes rain-fall {
    0% { top: -60px; opacity: 1; transform: rotate(0deg) scale(1); }
    80% { opacity: 1; }
    100% { top: 110vh; opacity: 0; transform: rotate(720deg) scale(0.5); }
  }
  @keyframes emblem-bounce {
    0% { transform: scale(1) rotate(0deg); }
    15% { transform: scale(1.5) rotate(-20deg); }
    30% { transform: scale(0.85) rotate(12deg); }
    45% { transform: scale(1.25) rotate(-8deg); }
    60% { transform: scale(0.95) rotate(5deg); }
    75% { transform: scale(1.08) rotate(-3deg); }
    100% { transform: scale(1) rotate(0deg); }
  }
  @keyframes emblem-spin {
    0%   { top:var(--egg-y); left:var(--egg-x); transform: rotate(0deg) scale(1); }
    10%  { top:10vh;  left:70vw;  transform: rotate(200deg) scale(4); }
    22%  { top:60vh;  left:5vw;   transform: rotate(400deg) scale(3); }
    35%  { top:20vh;  left:80vw;  transform: rotate(560deg) scale(4.5); }
    48%  { top:75vh;  left:50vw;  transform: rotate(720deg) scale(2.5); }
    60%  { top:5vh;   left:20vw;  transform: rotate(880deg) scale(4); }
    72%  { top:50vh;  left:75vw;  transform: rotate(980deg) scale(3); }
    85%  { top:30vh;  left:40vw;  transform: rotate(1040deg) scale(2); }
    100% { top:var(--egg-y); left:var(--egg-x); transform: rotate(1080deg) scale(1); }
  }
  .emblem-bounce { animation: emblem-bounce 0.65s cubic-bezier(0.36, 0.07, 0.19, 0.97) forwards; cursor: pointer; }
  .emblem-spin { animation: emblem-spin 3.2s cubic-bezier(0.4, 0, 0.2, 1) forwards; cursor: pointer; position: fixed !important; z-index: 99998; width: 60px !important; height: 60px !important; }
  input:focus, select:focus, textarea:focus { border-color:#56B9E9; }
  input::placeholder { color:rgba(224,224,224,0.35); }
  select option { background:#1E1E1E; color:#E0E0E0; }
  .btn { padding:9px 18px; border-radius:8px; font-size:13px; font-weight:600; cursor:pointer; border:none; font-family:'Outfit',sans-serif; transition:opacity 0.15s; }
  .btn:hover { opacity:0.85; }
  .btn-primary { background:#E0E0E0; color:#121212; }
  .btn-secondary { background:transparent; color:#E0E0E0; border:1px solid rgba(224,224,224,0.18); }
  .btn-secondary:hover { background:rgba(224,224,224,0.06); }
  .btn-sm { padding:6px 12px; font-size:12px; }
  .card { background:#1E1E1E; border:1px solid #2A2A2A; border-radius:12px; padding:22px; }
  .label { font-size:10px; letter-spacing:0.1em; color:rgba(224,224,224,0.45); font-weight:700; display:block; margin-bottom:7px; }
  .tag { display:inline-block; padding:3px 10px; border-radius:20px; font-size:11px; font-weight:600; border:1px solid transparent; }
  .modal-bg { position:fixed; inset:0; background:rgba(0,0,0,0.75); display:flex; align-items:center; justify-content:center; z-index:100; backdrop-filter:blur(4px); }
  .fade-in { animation:fadeIn 0.2s ease; }
  @keyframes fadeIn { from{opacity:0;transform:translateY(6px)} to{opacity:1;transform:none} }
  .nav-pill { padding:7px 16px; border-radius:8px; font-size:13px; font-weight:500; cursor:pointer; color:rgba(224,224,224,0.45); transition:all 0.15s; }
  .nav-pill:hover { color:#E0E0E0; background:rgba(224,224,224,0.06); }
  .nav-pill.active { background:#E0E0E0; color:#121212; font-weight:700; }
`

var API_URL = "https://api.goinvestors.co.uk";

function apiHeaders() {
  return { "Content-Type": "application/json", "Authorization": "Bearer " + (localStorage.getItem("gi_token") || "") };
}

function apiFetch(path, opts) {
  return fetch(API_URL + path, Object.assign({ headers: apiHeaders() }, opts || {})).then(function(r) { return r.json(); });
}

function apiPost(path, body) {
  return fetch(API_URL + path, { method:"POST", headers:apiHeaders(), body:JSON.stringify(body) }).then(function(r) { return r.json(); });
}

function apiPut(path, body) {
  return fetch(API_URL + path, { method:"PUT", headers:apiHeaders(), body:JSON.stringify(body) }).then(function(r) { return r.json(); });
}

function apiDelete(path) {
  return fetch(API_URL + path, { method:"DELETE", headers:apiHeaders() }).then(function(r) { return r.json(); });
}

var DB = {
  getFranchises:    function() { return apiFetch("/api/franchises"); },
  saveFranchises:   function(data) {
    // Sync each franchise - create new ones, update existing
    return Promise.all(data.map(function(f) {
      if (f._isNew) {
        return apiPost("/api/franchises", f);
      }
      return apiPut("/api/franchises/" + f.id, f);
    }));
  },
  deleteFranchise:  function(id) { return apiDelete("/api/franchises/" + id); },
  addFinancial:     function(fId, row) { return apiPost("/api/franchises/" + fId + "/financials", row); },
  updateFinancial:  function(fId, month, row) { return apiPut("/api/franchises/" + fId + "/financials/" + encodeURIComponent(month), row); },
  deleteFinancial:  function(fId, month) { return apiDelete("/api/franchises/" + fId + "/financials/" + encodeURIComponent(month)); },
  addInvestor:      function(fId, inv) { return apiPost("/api/franchises/" + fId + "/investors", inv); },
  removeInvestor:   function(fId, userId) { return apiDelete("/api/franchises/" + fId + "/investors/" + userId); },
  updateOwners:     function(fId, owners) { return apiPut("/api/franchises/" + fId + "/owners", { owners:owners }); },
  getSession:       function() { try { return Promise.resolve(JSON.parse(localStorage.getItem("gi_session"))); } catch(e) { return Promise.resolve(null); } },
  saveSession:      function(u) { localStorage.setItem("gi_session", JSON.stringify(u)); if (u && u.token) localStorage.setItem("gi_token", u.token); },
  clearSession:     function() { localStorage.removeItem("gi_session"); localStorage.removeItem("gi_token"); },
  getUsers:         function() { return apiFetch("/api/users"); },
  createUser:       function(u) { return apiPost("/api/users", u); },
  updateUser:       function(id, data) { return apiPut("/api/users/" + id, data); },
  deleteUser:       function(id) { return apiDelete("/api/users/" + id); },
  saveUsers:        function() { return Promise.resolve(); },
  getDeclarations:  function() { return apiFetch("/api/declarations"); },
  submitDeclaration:function(d) { return apiPost("/api/declarations", d); },
  approveDeclaration:function(id) { return apiPut("/api/declarations/" + id + "/approve", {}); },
  rejectDeclaration: function(id) { return apiPut("/api/declarations/" + id + "/reject", {}); },
  deleteDeclaration: function(id) { return apiDelete("/api/declarations/" + id); },
  updateDeclaration: function(id, data) { return apiPut("/api/declarations/" + id, data); },
  saveDeclarations: function() { return Promise.resolve(); },
  getActivity:      function() { return apiFetch("/api/activity"); },
  logActivity:      function(action, details) { return apiPost("/api/activity", { action:action, details:details }); },
  clearActivity:    function() { return apiDelete("/api/activity"); },
  saveActivity:     function() { return Promise.resolve(); },
  getCompliance:    function(userId) { return userId ? apiFetch("/api/compliance/" + userId) : apiFetch("/api/compliance"); },
  saveCompliance:   function() { return Promise.resolve(); },
  uploadDoc:        function(userId, docType, file) {
    var formData = new FormData();
    formData.append("file", file);
    return fetch(API_URL + "/api/compliance/" + userId + "/" + encodeURIComponent(docType), {
      method:"POST",
      headers:{ "Authorization":"Bearer " + (localStorage.getItem("gi_token") || "") },
      body:formData
    }).then(function(r) { return r.json(); });
  },
  deleteDoc:        function(userId, docType) { return apiDelete("/api/compliance/" + userId + "/" + encodeURIComponent(docType)); },
  saveComplianceMeta:function(userId, meta) { return apiPut("/api/compliance/" + userId + "/meta", meta); },
  getPending:       function() { return apiFetch("/api/pipeline"); },
  createPipeline:   function(entry) { return apiPost("/api/pipeline", entry); },
  updatePipeline:   function(id, entry) { return apiPut("/api/pipeline/" + id, entry); },
  deletePipeline:   function(id) { return apiDelete("/api/pipeline/" + id); },
  getProfit:        function(directorView) { return apiFetch("/api/profit" + (directorView ? "?directorView=true" : "")); },
  setOpeningBalance: function(data) { return apiPost("/api/profit/opening-balance", data); },
  deleteOpeningBalance: function(data) { return apiFetch("/api/profit/opening-balance", { method:"DELETE", body:JSON.stringify(data) }); },
  addOwner:         function(franchiseId, data) { return apiPost("/api/franchises/" + franchiseId + "/owners/add", data); },
  postWithdrawal:   function(data) { return apiPost("/api/profit/withdraw", data); },
  editWithdrawal:   function(id, data) { return apiPut("/api/profit/withdraw/" + id, data); },
  deleteWithdrawal: function(id) { return apiDelete("/api/profit/withdraw/" + id); },
  savePending:      function() { return Promise.resolve(); },
  reset:            function() { localStorage.removeItem("gi_session"); localStorage.removeItem("gi_token"); }
};

// ─── SEED DATA ────────────────────────────────────────────────────────────────
var SEED_USERS = [
  { id:"u1", name:"Marcus Reid",  email:"marcus@example.com",  password:"investor123",   role:"investor",   active:true },
  { id:"u2", name:"Sophia Chen",  email:"sophia@example.com",  password:"investor123",   role:"investor",   active:true },
  { id:"u3", name:"Lena Torres",  email:"lena@example.com",    password:"investor123",   role:"investor",   active:true },
  { id:"u4", name:"James Patel",  email:"james@example.com",   password:"investor123",   role:"investor",   active:true },
  { id:"u5", name:"Alex Harper",  email:"alex@example.com",    password:"franchisee123", role:"franchisee", active:true, franchiseId:"f1" },
  { id:"u6", name:"Nina Osei",    email:"nina@example.com",    password:"franchisee123", role:"franchisee", active:true, franchiseId:"f2" },
  { id:"u7", name:"Tom Brennan",  email:"tom@example.com",     password:"franchisee123", role:"franchisee", active:true, franchiseId:"f3" },
];

var SEED_DATA = [
  { id:"f1", name:"Downtown Grill", location:"New York, NY",
    investors:[
      { id:"i1", name:"Marcus Reid", email:"marcus@example.com", password:"investor123", sharePercent:15 },
      { id:"i2", name:"Sophia Chen", email:"sophia@example.com", password:"investor123", sharePercent:10 },
    ],
    financials:[
      { month:"Nov 2024", income:78000, rent:12000, salaries:22000, royalty:7800, otherExpenses:7200 },
      { month:"Dec 2024", income:95000, rent:12000, salaries:26000, royalty:9500, otherExpenses:10500 },
      { month:"Jan 2025", income:84000, rent:12000, salaries:23000, royalty:8400, otherExpenses:7600 },
      { month:"Feb 2025", income:76000, rent:12000, salaries:21000, royalty:7600, otherExpenses:7400 },
      { month:"Mar 2025", income:92000, rent:12000, salaries:25000, royalty:9200, otherExpenses:8800 },
      { month:"Apr 2025", income:88000, rent:12000, salaries:24000, royalty:8800, otherExpenses:7200 },
    ]},
  { id:"f2", name:"Westside Bakery", location:"Los Angeles, CA",
    investors:[
      { id:"i1", name:"Marcus Reid", email:"marcus@example.com", password:"investor123", sharePercent:20 },
      { id:"i3", name:"Lena Torres", email:"lena@example.com",   password:"investor123", sharePercent:12 },
    ],
    financials:[
      { month:"Nov 2024", income:48000, rent:7000, salaries:14000, royalty:4800, otherExpenses:4200 },
      { month:"Dec 2024", income:62000, rent:7000, salaries:18000, royalty:6200, otherExpenses:6800 },
      { month:"Jan 2025", income:54000, rent:7000, salaries:16000, royalty:5400, otherExpenses:4600 },
      { month:"Feb 2025", income:61000, rent:7000, salaries:18000, royalty:6100, otherExpenses:5900 },
      { month:"Mar 2025", income:58000, rent:7000, salaries:17000, royalty:5800, otherExpenses:5200 },
      { month:"Apr 2025", income:67000, rent:7000, salaries:19000, royalty:6700, otherExpenses:7300 },
    ]},
  { id:"f3", name:"Harbor Fitness", location:"Miami, FL",
    investors:[
      { id:"i2", name:"Sophia Chen", email:"sophia@example.com", password:"investor123", sharePercent:18 },
      { id:"i4", name:"James Patel", email:"james@example.com",  password:"investor123", sharePercent:25 },
    ],
    financials:[
      { month:"Nov 2024", income:38000, rent:5000, salaries:11000, royalty:3800, otherExpenses:5200 },
      { month:"Dec 2024", income:44000, rent:5000, salaries:13000, royalty:4400, otherExpenses:6600 },
      { month:"Jan 2025", income:43000, rent:5000, salaries:13000, royalty:4300, otherExpenses:5700 },
      { month:"Feb 2025", income:47000, rent:5000, salaries:14000, royalty:4700, otherExpenses:6300 },
      { month:"Mar 2025", income:51000, rent:5000, salaries:15000, royalty:5100, otherExpenses:5900 },
      { month:"Apr 2025", income:56000, rent:5000, salaries:16000, royalty:5600, otherExpenses:7400 },
    ]},
];

var ADMIN = { email:"admin@goinvestors.com", password:"admin2025", role:"admin", name:"Admin", id:"admin" };


var PALETTE = ["#56B9E9","#4DE7A6","#cf6679","#a78bfa","#f97316","#38bdf8","#fb923c","#4ade80","#56B9E9","#4DE7A6"];

// ─── HELPERS ──────────────────────────────────────────────────────────────────
function parseMonthDate(monthStr) {
  if (!monthStr) return 0;
  try {
    var s = monthStr.toString();
    var parts = s.split(" ");
    if (parts.length < 2) return 0;
    var mo = MONTH_NAMES.indexOf(parts[0]);
    var yr = parseInt(parts[1]);
    if (mo === -1 || isNaN(yr)) return 0;
    return yr * 12 + mo;
  } catch(e) { return 0; }
}

// Get the correct share % for a person at a given month (respects history)
function getShareForMonth(allEntries, email, month) {
  var monthIdx = parseMonthDate(month);
  // Filter entries for this person
  var personEntries = allEntries.filter(function(e) {
    return (e.email||"").toLowerCase() === (email||"").toLowerCase();
  });
  if (!personEntries.length) return 0;
  // Find the entry effective at this month
  var applicable = personEntries.filter(function(e) {
    var from = parseMonthDate(e.effectiveFrom);
    var to = e.effectiveTo ? parseMonthDate(e.effectiveTo) : Infinity;
    return from <= monthIdx && monthIdx < to;
  });
  if (!applicable.length) {
    // Fallback: use earliest entry
    applicable = personEntries.filter(function(e) { return parseMonthDate(e.effectiveFrom) <= monthIdx; });
    applicable.sort(function(a,b) { return parseMonthDate(b.effectiveFrom) - parseMonthDate(a.effectiveFrom); });
  }
  return applicable.length ? parseFloat(applicable[0].sharePercent) || 0 : parseFloat(personEntries[0].sharePercent) || 0;
}

function fmt(n) { var num = parseFloat(n) || 0; return "£" + num.toLocaleString("en-GB", { minimumFractionDigits:2, maximumFractionDigits:2 }); }
function pct(n) { return (parseFloat(n)||0).toFixed(1) + "%"; }
function totalExp(m) {
  if (!m) return 0;
  return (parseFloat(m.expenses)||0) + (parseFloat(m.rent)||0) + (parseFloat(m.salaries)||0) + (parseFloat(m.royalty)||0) + (parseFloat(m.otherExpenses)||0);
}
var HO_SECTIONS = ["dashboard","franchises","investors","pipeline","approvals","compliance","profit"];

// Month list Jan 2025 → Jan 2200
var MONTH_NAMES = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
var ALL_MONTHS = (function() {
  var list = [];
  for (var y = 2025; y <= 2200; y++) {
    var max = (y === 2200) ? 1 : 12;
    for (var mi = 0; mi < max; mi++) {
      list.push(MONTH_NAMES[mi] + " " + y);
    }
  }
  return list;
})();

// Overdue helpers
function getOverdueMonth() {
  var now = new Date();
  var prev = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  return MONTH_NAMES[prev.getMonth()] + " " + prev.getFullYear();
}
function isOverdue(declarations, email) {
  var now = new Date();
  if (now.getDate() <= 10) return false;
  var due = getOverdueMonth();
  return !declarations.some(function(d) {
    return (d.franchiseeEmail === email || d.investorEmail === email) && d.month === due;
  });
}

// Export helpers
function exportCSV(rows, filename) {
  var headers = Object.keys(rows[0]);
  var body = rows.map(function(r) {
    return headers.map(function(h) { return JSON.stringify(r[h] || ""); }).join(",");
  });
  var csv = [headers.join(",")].concat(body).join("\n");
  var a = document.createElement("a");
  a.href = URL.createObjectURL(new Blob([csv], { type:"text/csv" }));
  a.download = filename;
  a.click();
}

function exportPDF(franchises, investorName) {
  var win = window.open("", "_blank");
  var rows = [];
  franchises.forEach(function(f) {
    f.financials.forEach(function(m) {
      var net = m.income - totalExp(m);
      if (investorName) {
        var inv = f.investors.find(function(i) { return i.name === investorName; });
        if (inv) rows.push({ Franchise:f.name, Month:m.month, "Share":inv.sharePercent+"%", "Your Profit":fmt(net*inv.sharePercent/100) });
      } else {
        rows.push({ Franchise:f.name, Location:f.location, Month:m.month, Income:fmt(m.income), Expenses:fmt(totalExp(m)), "Net Profit":fmt(net), Margin:pct(net/m.income*100) });
      }
    });
  });
  var hdrs = rows.length ? Object.keys(rows[0]) : [];
  var hrow = hdrs.map(function(h) { return "<th>" + h + "</th>"; }).join("");
  var brows = rows.map(function(r) {
    return "<tr>" + Object.values(r).map(function(v) { return "<td>" + v + "</td>"; }).join("") + "</tr>";
  }).join("");
  var tbl = rows.length
    ? "<table border='1' cellpadding='6' style='border-collapse:collapse;width:100%;font-size:12px'><thead><tr>" + hrow + "</tr></thead><tbody>" + brows + "</tbody></table>"
    : "<p>No data.</p>";
  var ttl = investorName ? investorName + "'s Portfolio" : "Full Report";
  var html = "<html><head><title>GoInvestors</title><style>body{font-family:sans-serif;padding:32px}</style></head><body>"
    + "<h1>GoInvestors - " + ttl + "</h1>"
    + "<p>Generated " + new Date().toLocaleDateString("en-GB") + "</p>"
    + tbl + "<scr" + "ipt>window.onload=function(){window.print();}<" + "/script></body></html>";
  win.document.write(html);
  win.document.close();
}

// ─── CHART TOOLTIP ────────────────────────────────────────────────────────────
function ChartTooltip(props) {
  if (!props.active || !props.payload || !props.payload.length) return null;
  return (
    <div style={{ background:"#1E1E1E", border:"1px solid #4b5563", borderRadius:10, padding:"12px 16px", fontFamily:"Outfit,sans-serif", fontSize:12 }}>
      <div style={{ color:"rgba(224,224,224,0.6)", marginBottom:8, fontSize:11 }}>{props.label}</div>
      {props.payload.map(function(p) {
        return <div key={p.dataKey} style={{ color:p.color, marginBottom:4 }}>{p.name}: {fmt(p.value)}</div>;
      })}
    </div>
  );
}

// ─── MINI BAR ─────────────────────────────────────────────────────────────────
function MiniBar(props) {
  var w = Math.min(100, (props.value / props.max) * 100);
  return (
    <div style={{ background:"#2a2a2a", borderRadius:4, height:5, width:"100%", overflow:"hidden" }}>
      <div style={{ width:w+"%", height:"100%", background:props.color, borderRadius:4, transition:"width 0.8s ease" }} />
    </div>
  );
}

// ─── MONTH PICKER ─────────────────────────────────────────────────────────────
function MonthPicker(props) {
  var value = props.value;
  var onChange = props.onChange;
  var label = props.label !== undefined ? props.label : "MONTH";
  var [open, setOpen] = useState(false);
  var [search, setSearch] = useState("");
  var listRef = useRef(null);
  var filtered = search ? ALL_MONTHS.filter(function(m) { return m.toLowerCase().indexOf(search.toLowerCase()) !== -1; }) : ALL_MONTHS;

  useEffect(function() {
    if (open && listRef.current) {
      var idx = value ? filtered.indexOf(value) : 0;
      if (idx < 0) idx = 0;
      listRef.current.scrollTop = Math.max(0, (idx - 3) * 40);
    }
  }, [open]);

  return (
    <div style={{ position:"relative" }}>
      {label ? <label className="label">{label}</label> : null}
      <div onClick={function() { setOpen(function(o) { return !o; }); }}
        style={{ background:"#1E1E1E", border:"1px solid " + (open ? "#56B9E9" : "#2A2A2A"), color:value ? "#E0E0E0" : "#56B9E9", padding:"11px 14px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:13, cursor:"pointer", display:"flex", justifyContent:"space-between", alignItems:"center", userSelect:"none" }}>
        <span>{value || "Select month..."}</span>
        <span style={{ color:"rgba(224,224,224,0.6)", fontSize:10 }}>▼</span>
      </div>
      {open && (
        <div>
          <div style={{ position:"fixed", inset:0, zIndex:299 }} onClick={function() { setOpen(false); setSearch(""); }} />
          <div style={{ position:"absolute", top:"calc(100% + 6px)", left:0, right:0, background:"#1E1E1E", border:"1px solid #4b5563", borderRadius:10, zIndex:300, boxShadow:"0 8px 32px rgba(0,0,0,0.6)", overflow:"hidden" }}>
            <div style={{ padding:"8px 10px", borderBottom:"1px solid #1a1a1a" }}>
              <input autoFocus placeholder="Search e.g. Jan 2025" value={search}
                onChange={function(e) { setSearch(e.target.value); }}
                onClick={function(e) { e.stopPropagation(); }}
                style={{ background:"#2a2a2a", border:"1px solid #4b5563", color:"#E0E0E0", padding:"8px 12px", borderRadius:6, fontFamily:"Outfit,sans-serif", fontSize:12, outline:"none", width:"100%" }} />
            </div>
            <div ref={listRef} style={{ maxHeight:220, overflowY:"auto" }}>
              {filtered.map(function(m) {
                return (
                  <div key={m}
                    onClick={function() { onChange(m); setOpen(false); setSearch(""); }}
                    style={{ padding:"10px 14px", fontSize:13, cursor:"pointer", background:m === value ? "rgba(123,158,255,0.1)" : "transparent", color:m === value ? "#56B9E9" : "#56B9E9", fontFamily:"Outfit,sans-serif", borderBottom:"1px solid #161616" }}
                    onMouseEnter={function(e) { if (m !== value) e.currentTarget.style.background = "#2A2A2A"; }}
                    onMouseLeave={function(e) { if (m !== value) e.currentTarget.style.background = "transparent"; }}>
                    {m}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ─── LOGIN ────────────────────────────────────────────────────────────────────
function LoginScreen(props) {
  var onLogin = props.onLogin;
  var [email, setEmail] = useState("");
  var [password, setPassword] = useState("");
  var [error, setError] = useState("");
  var [loading, setLoading] = useState(false);
  var [screen, setScreen] = useState("login"); // login | forgot | reset | resetDone
  var [resetEmail, setResetEmail] = useState("");
  var [resetToken, setResetToken] = useState("");
  var [newPassword, setNewPassword] = useState("");
  var [resetMsg, setResetMsg] = useState("");

  function handleLogin() {
    setLoading(true); setError("");
    fetch(API_URL + "/api/auth/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: email, password: password })
    }).then(function(r) { return r.json(); }).then(function(data) {
      if (data.error) {
        setError(data.error);
        setLoading(false);
      } else {
        var userWithToken = Object.assign({}, data.user, { token: data.token });
        DB.saveSession(userWithToken);
        onLogin(userWithToken);
        setLoading(false);
      }
    }).catch(function() {
      setError("Connection error. Please try again.");
      setLoading(false);
    });
  }

  function handleForgotPassword() {
    if (!resetEmail) { setError("Please enter your email"); return; }
    setLoading(true); setError("");
    fetch(API_URL + "/api/auth/forgot-password", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: resetEmail })
    }).then(function(r) { return r.json(); }).then(function(data) {
      setResetMsg("If that email exists, a reset link has been sent. Check your inbox.");
      setLoading(false);
    }).catch(function() {
      setError("Connection error. Please try again.");
      setLoading(false);
    });
  }

  function handleResetPassword() {
    if (!newPassword || newPassword.length < 8) { setError("Password must be at least 8 characters"); return; }
    setLoading(true); setError("");
    fetch(API_URL + "/api/auth/reset-password", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token: resetToken, password: newPassword })
    }).then(function(r) { return r.json(); }).then(function(data) {
      if (data.error) { setError(data.error); setLoading(false); }
      else { setScreen("resetDone"); setLoading(false); }
    }).catch(function() {
      setError("Connection error. Please try again.");
      setLoading(false);
    });
  }

  // Check for reset token in URL
  if (screen === "login" && typeof window !== "undefined") {
    var urlParams = new URLSearchParams(window.location.search);
    var tok = urlParams.get("token");
    if (tok && resetToken !== tok) { setResetToken(tok); setScreen("reset"); }
  }

  return (
    <div style={{ minHeight:"100vh", background:"#121212", display:"flex", alignItems:"center", justifyContent:"center", padding:"24px 20px", fontFamily:"Outfit,sans-serif", position:"relative" }}>
      <style>{CSS}</style>
      <div style={{ position:"absolute", top:"30%", left:"50%", transform:"translate(-50%,-50%)", width:600, height:600, background:"radial-gradient(circle,rgba(123,158,255,0.05) 0%,transparent 70%)", pointerEvents:"none" }} />
      <div style={{ width:"100%", maxWidth:400, position:"relative", zIndex:1 }}>
        <div style={{ textAlign:"center", marginBottom:40 }}>
          <div style={{ textAlign:"center", margin:"0 auto 20px" }}>
            <img src="https://www.goinvestors.co.uk/finance-emblem-white.svg" onClick={function(e){ triggerEasterEgg(e.currentTarget); }} alt="GoTutors" style={{ height:56, display:"block", margin:"0 auto 12px" }} />
            <img src="https://www.goinvestors.co.uk/finance-wordmark-white.svg" alt="GoTutors" style={{ height:32, display:"block", margin:"0 auto" }} />
          </div>
          <p style={{ color:"rgba(224,224,224,0.6)", fontSize:13, marginTop:6 }}>Franchise investment tracking platform</p>
        </div>
        <div className="card" style={{ padding:32 }}>
          {screen === "login" && (
            <div>
              <div style={{ marginBottom:16 }}>
                <label className="label">EMAIL</label>
                <input type="email" placeholder="your@email.com" value={email}
                  onChange={function(e) { setEmail(e.target.value); }}
                  onKeyDown={function(e) { if (e.key === "Enter") handleLogin(); }} />
              </div>
              <div style={{ marginBottom:22 }}>
                <label className="label">PASSWORD</label>
                <input type="password" placeholder="..." value={password}
                  onChange={function(e) { setPassword(e.target.value); }}
                  onKeyDown={function(e) { if (e.key === "Enter") handleLogin(); }} />
              </div>
              {error && <div style={{ background:"rgba(207,102,121,0.08)", border:"1px solid #2e1010", borderRadius:8, padding:"10px 14px", color:"#cf6679", fontSize:12, marginBottom:16 }}>{error}</div>}
              <button className="btn btn-primary" style={{ width:"100%", justifyContent:"center", padding:13 }} onClick={handleLogin} disabled={loading}>
                {loading ? "Signing in..." : "Sign In"}
              </button>
              <div style={{ textAlign:"center", marginTop:16 }}>
                <span style={{ fontSize:12, color:"#56B9E9", cursor:"pointer" }}
                  onClick={function() { setScreen("forgot"); setError(""); setResetMsg(""); }}
                  onMouseEnter={function(e) { e.target.style.color="#56B9E9"; }}
                  onMouseLeave={function(e) { e.target.style.color="#56B9E9"; }}>
                  Forgot your password?
                </span>
              </div>
            </div>
          )}
          {screen === "forgot" && (
            <div>
              <h3 style={{ fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:17, marginBottom:6 }}>Reset Password</h3>
              <p style={{ fontSize:12, color:"#56B9E9", marginBottom:18 }}>Enter your email and we will send you a reset link.</p>
              <div style={{ marginBottom:16 }}>
                <label className="label">EMAIL</label>
                <input type="email" placeholder="your@email.com" value={resetEmail}
                  onChange={function(e) { setResetEmail(e.target.value); }}
                  onKeyDown={function(e) { if (e.key === "Enter") handleForgotPassword(); }} />
              </div>
              {error && <div style={{ background:"rgba(207,102,121,0.08)", border:"1px solid #2e1010", borderRadius:8, padding:"10px 14px", color:"#cf6679", fontSize:12, marginBottom:16 }}>{error}</div>}
              {resetMsg && <div style={{ background:"rgba(77,231,166,0.1)", border:"1px solid rgba(52,211,153,0.3)", borderRadius:8, padding:"10px 14px", color:"#4DE7A6", fontSize:12, marginBottom:16 }}>{resetMsg}</div>}
              {!resetMsg && (
                <button className="btn btn-primary" style={{ width:"100%", justifyContent:"center", padding:13 }} onClick={handleForgotPassword} disabled={loading}>
                  {loading ? "Sending..." : "Send Reset Link"}
                </button>
              )}
              <div style={{ textAlign:"center", marginTop:16 }}>
                <span style={{ fontSize:12, color:"#56B9E9", cursor:"pointer" }}
                  onClick={function() { setScreen("login"); setError(""); setResetMsg(""); }}
                  onMouseEnter={function(e) { e.target.style.color="#56B9E9"; }}
                  onMouseLeave={function(e) { e.target.style.color="#56B9E9"; }}>
                  Back to login
                </span>
              </div>
            </div>
          )}
          {screen === "reset" && (
            <div>
              <h3 style={{ fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:17, marginBottom:6 }}>Set New Password</h3>
              <p style={{ fontSize:12, color:"#56B9E9", marginBottom:18 }}>Choose a new password for your account.</p>
              <div style={{ marginBottom:22 }}>
                <label className="label">NEW PASSWORD</label>
                <input type="password" placeholder="Min 8 characters" value={newPassword}
                  onChange={function(e) { setNewPassword(e.target.value); }}
                  onKeyDown={function(e) { if (e.key === "Enter") handleResetPassword(); }} />
              </div>
              {error && <div style={{ background:"rgba(207,102,121,0.08)", border:"1px solid #2e1010", borderRadius:8, padding:"10px 14px", color:"#cf6679", fontSize:12, marginBottom:16 }}>{error}</div>}
              <button className="btn btn-primary" style={{ width:"100%", justifyContent:"center", padding:13 }} onClick={handleResetPassword} disabled={loading}>
                {loading ? "Saving..." : "Set New Password"}
              </button>
            </div>
          )}
          {screen === "resetDone" && (
            <div style={{ textAlign:"center" }}>
              <div style={{ fontSize:32, marginBottom:16 }}>✓</div>
              <h3 style={{ fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:17, marginBottom:8, color:"#4DE7A6" }}>Password Updated!</h3>
              <p style={{ fontSize:13, color:"#56B9E9", marginBottom:20 }}>Your password has been changed successfully.</p>
              <button className="btn btn-primary" style={{ width:"100%", justifyContent:"center", padding:13 }}
                onClick={function() { setScreen("login"); setNewPassword(""); setResetToken(""); window.history.replaceState({}, "", "/"); }}>
                Back to Login
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// ─── INVESTOR PORTAL ──────────────────────────────────────────────────────────
function InvestorPortal(props) {
  var user = props.user;
  var franchises = props.franchises;
  var onLogout = props.onLogout;
  var embedded = props.embedded || false;
  var myFranchises = franchises.filter(function(f) { return f.investors.some(function(i) { return i.email === user.email; }); });
  var [openId, setOpenId] = useState(null);
  var [investorProfitData, setInvestorProfitData] = useState([]);
  var [investorProfitLoaded, setInvestorProfitLoaded] = useState(false);
  var [invPortalView, setInvPortalView] = useState("overview");
  useEffect(function() {
    DB.getProfit().then(function(d){ setInvestorProfitData(d||[]); setInvestorProfitLoaded(true); });
  }, []);

  var portfolio = myFranchises.map(function(f) {
    var inv = f.investors.find(function(i) { return i.email === user.email; });
    var latest = f.financials.length ? f.financials[f.financials.length - 1] : null;
    var latestProfit = latest ? (latest.income - totalExp(latest)) * inv.sharePercent / 100 : 0;
    var totalProfit = f.financials.reduce(function(s, m) { return s + (m.income - totalExp(m)) * inv.sharePercent / 100; }, 0);
    return Object.assign({}, f, { share:inv.sharePercent, latestProfit:latestProfit, totalProfit:totalProfit });
  });

  var totalMonthly = portfolio.reduce(function(s, p) { return s + p.latestProfit; }, 0);
  var totalAllTime = portfolio.reduce(function(s, p) { return s + p.totalProfit; }, 0);

  var chartData = useMemo(function() {
    var months = {};
    portfolio.forEach(function(f) {
      f.financials.forEach(function(m) {
        if (!months[m.month]) months[m.month] = { month:m.month };
        months[m.month][f.name] = Math.round((m.income - totalExp(m)) * f.share / 100);
      });
    });
    return Object.values(months).slice(-6);
  }, [portfolio]);

  return (
    <div style={{ fontFamily:"Outfit,sans-serif", background:"#121212", minHeight:"100vh", color:"#E0E0E0" }}>
      <style>{CSS}</style>
      <div style={{ borderBottom:"1px solid #141414", padding:"14px 32px", display:"flex", alignItems:"center", justifyContent:"space-between", background:"#1E1E1E", position:"sticky", top:0, zIndex:50 }}>
        <div style={{ display:"flex", alignItems:"center", gap:12 }}>
          <img src="https://www.goinvestors.co.uk/finance-emblem-white.svg" onClick={function(e){ triggerEasterEgg(e.currentTarget); }} alt="GoTutors" style={{ height:32 }} /><img src="https://www.goinvestors.co.uk/finance-wordmark-white.svg" alt="GoTutors" style={{ height:24, marginLeft:10 }} />
          <span className="tag" style={{ background:"rgba(255,255,255,0.05)", color:"#E0E0E0" }}>Investor</span>
        </div>
        <div style={{ display:"flex", gap:8, alignItems:"center" }}>
          <button className="btn btn-sm btn-secondary" onClick={function() { exportPDF(myFranchises, user.name); }}>PDF</button>
          <button className="btn btn-sm btn-secondary" onClick={function() {
            var rows = portfolio.reduce(function(acc, f) {
              return acc.concat(f.financials.map(function(m) {
                return { Franchise:f.name, Month:m.month, "Share%":f.share, Profit:Math.round((m.income - totalExp(m)) * f.share / 100) };
              }));
            }, []);
            exportCSV(rows, user.name.replace(" ","_") + "_portfolio.csv");
          }}>CSV</button>
          <button className={"nav-pill" + (invPortalView === "profit" ? " active" : "")} onClick={function() { setInvPortalView(invPortalView === "profit" ? "overview" : "profit"); }}>Profit</button>
          <button className={"nav-pill" + (openId === "account" ? " active" : "")} onClick={function() { setOpenId(openId === "account" ? null : "account"); }}>My Account</button>
          <div style={{ width:30, height:30, borderRadius:"50%", background:"rgba(123,158,255,0.1)", display:"flex", alignItems:"center", justifyContent:"center", color:"#56B9E9", fontFamily:"Playfair Display,serif", fontWeight:800, fontSize:13 }}>{user.name.charAt(0)}</div>
          <button className="btn btn-sm btn-secondary" onClick={onLogout}>Sign out</button>
        </div>
      </div>

      <div style={{ maxWidth:960, margin:"0 auto", padding:"36px 24px" }} className="fade-in">
        {openId === "account" ? (
          <div>
            <h1 style={{ fontFamily:"Playfair Display,serif", fontWeight:900, fontSize:26, letterSpacing:"-0.03em", marginBottom:8 }}>My Account</h1>
            <p style={{ color:"#56B9E9", fontSize:13, marginBottom:24 }}>Manage your account settings.</p>
            <AccountSection user={user} />
          </div>
        ) : invPortalView === "profit" ? (
          <div>
            <h1 style={{ fontFamily:"Playfair Display,serif", fontWeight:900, fontSize:26, marginBottom:20 }}>Profit</h1>
            {!investorProfitLoaded ? <div style={{ color:"#56B9E9" }}>Loading...</div> : (
              <div style={{ display:"flex", flexDirection:"column", gap:16 }}>
                {investorProfitData.map(function(f) {
                  var allPeople = (f.owners||[]).concat(f.investors||[]);
                  return (
                    <div key={f.franchiseId} className="card" style={{ padding:"16px 18px" }}>
                      <div style={{ fontWeight:700, fontSize:15, color:"#E0E0E0", marginBottom:12 }}>{f.franchiseName}</div>
                      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:12 }}>
                        {allPeople.map(function(person, pi) {
                          var color = person.type === "owner" ? "#4DE7A6" : "#7B9EFF";
                          var isMe = (person.email||"").toLowerCase() === (user.email||"").toLowerCase();
                          return (
                            <div key={pi} className="card" style={{ padding:"13px 16px", borderLeft:"3px solid "+color, opacity: isMe ? 1 : 0.6 }}>
                              <div style={{ fontWeight:600, fontSize:13, color:"#E0E0E0", marginBottom:8 }}>{person.name} {isMe && <span style={{ fontSize:10, color:color, background:color+"15", padding:"1px 6px", borderRadius:10 }}>you</span>}</div>
                              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:8 }}>
                                <div><div style={{ fontSize:9, color:"rgba(224,224,224,0.45)", marginBottom:2 }}>OWED</div><div style={{ fontSize:13, fontWeight:700, color: person.totalOwed>=0?color:"#cf6679" }}>{fmt(person.totalOwed)}</div></div>
                                <div><div style={{ fontSize:9, color:"rgba(224,224,224,0.45)", marginBottom:2 }}>TAKEN</div><div style={{ fontSize:13, fontWeight:700, color:"rgba(224,224,224,0.5)" }}>{fmt(person.totalTaken)}</div></div>
                                <div><div style={{ fontSize:9, color:"rgba(224,224,224,0.45)", marginBottom:2 }}>REMAINING</div><div style={{ fontSize:13, fontWeight:800, color: person.remaining>=0?"#4DE7A6":"#cf6679" }}>{fmt(person.remaining)}</div></div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      {(f.withdrawals||[]).length > 0 && f.withdrawals.map(function(w,wi){
                        return (
                          <div key={wi} style={{ display:"flex", justifyContent:"space-between", padding:"8px 0", borderBottom:"1px solid rgba(255,255,255,0.04)", fontSize:12 }}>
                            <div><span style={{ color:"#E0E0E0", fontWeight:600 }}>{w.userName}</span><span style={{ color:"rgba(224,224,224,0.5)", marginLeft:8 }}>{w.method} · {w.dateTaken ? new Date(w.dateTaken).toLocaleDateString("en-GB") : ""}</span></div>
                            <span style={{ color:"#cf6679", fontWeight:700 }}>-{fmt(w.amount)}</span>
                          </div>
                        );
                      })}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        ) : (
        <div>
        <div style={{ marginBottom:30 }}>
          <h1 style={{ fontFamily:"Playfair Display,serif", fontWeight:900, fontSize:26, letterSpacing:"-0.03em" }}>Welcome back, {user.name.split(" ")[0]}</h1>
          <p style={{ color:"rgba(224,224,224,0.6)", fontSize:13, marginTop:4 }}>Portfolio across {portfolio.length} franchise{portfolio.length !== 1 ? "s" : ""}</p>
        </div>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:14, marginBottom:28 }}>
          {[{ label:"THIS MONTH", value:fmt(totalMonthly), color:"#56B9E9" },{ label:"ALL-TIME", value:fmt(totalAllTime), color:"#E0E0E0" },{ label:"STAKES", value:portfolio.length, color:"#cf6679" }].map(function(k) {
            return (
              <div key={k.label} className="card">
                <label className="label">{k.label}</label>
                <div style={{ fontFamily:"Playfair Display,serif", fontWeight:900, fontSize:28, color:k.color }}>{k.value}</div>
              </div>
            );
          })}
        </div>
        {chartData.length > 1 && (
          <div className="card" style={{ marginBottom:28 }}>
            <label className="label" style={{ marginBottom:16 }}>MONTHLY EARNINGS BY FRANCHISE</label>
            <ResponsiveContainer width="100%" height={200}>
              <BarChart data={chartData} barGap={4}>
                <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)" vertical={false} />
                <XAxis dataKey="month" tick={{ fill:"#333333", fontSize:11 }} axisLine={false} tickLine={false} />
                <YAxis tick={{ fill:"#333333", fontSize:11 }} axisLine={false} tickLine={false} tickFormatter={function(v) { return "£" + Math.round(v/1000) + "k"; }} />
                <Tooltip content={<ChartTooltip />} />
                <Legend wrapperStyle={{ fontSize:11, color:"rgba(224,224,224,0.6)" }} />
                {portfolio.map(function(f, i) { return <Bar key={f.id} dataKey={f.name} fill={PALETTE[i % PALETTE.length]} radius={[4,4,0,0]} />; })}
              </BarChart>
            </ResponsiveContainer>
          </div>
        )}
        <label className="label" style={{ marginBottom:12 }}>YOUR FRANCHISES</label>
        <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
          {portfolio.map(function(f, i) {
            var color = PALETTE[i % PALETTE.length];
            var isOpen = openId === f.id;
            return (
              <div key={f.id} className="card" style={{ cursor:"pointer" }} onClick={function() { setOpenId(isOpen ? null : f.id); }}>
                <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between" }}>
                  <div style={{ display:"flex", alignItems:"center", gap:14 }}>
                    <div style={{ width:40, height:40, borderRadius:10, background:color+"22", border:"1px solid "+color+"44", display:"flex", alignItems:"center", justifyContent:"center", color:color, fontSize:18 }}>◈</div>
                    <div>
                      <div style={{ fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:14 }}>{f.name}</div>
                      <div style={{ fontSize:11, color:"rgba(224,224,224,0.6)", marginTop:2 }}>{f.location} · {f.share}% share</div>
                    </div>
                  </div>
                  <div style={{ display:"flex", alignItems:"center", gap:20 }}>
                    <div style={{ textAlign:"right" }}>
                      <div style={{ fontFamily:"Playfair Display,serif", fontWeight:800, fontSize:18, color:"#E0E0E0" }}>{fmt(f.latestProfit)}</div>
                      <div style={{ fontSize:11, color:"rgba(224,224,224,0.6)" }}>this month</div>
                    </div>
                    <div style={{ color:"rgba(224,224,224,0.6)", fontSize:12 }}>▼</div>
                  </div>
                </div>
                {isOpen && (
                  <div className="fade-in" style={{ marginTop:18, borderTop:"1px solid #374151", paddingTop:18 }}>
                    <table style={{ width:"100%", borderCollapse:"collapse", fontSize:12 }}>
                      <thead><tr>{["MONTH","INCOME","EXPENSES","NET PROFIT","YOUR SHARE"].map(function(h) { return <th key={h} style={{ textAlign:"left", padding:"8px 0", color:"#56B9E9", fontSize:10, letterSpacing:"0.1em", fontWeight:500 }}>{h}</th>; })}</tr></thead>
                      <tbody>
                        {[].concat(f.financials).sort(function(a,b){ return parseMonthDate(b.month)-parseMonthDate(a.month); }).map(function(m, idx) {
                          var net = m.income - totalExp(m);
                          var mine = net * f.share / 100;
                          return (
                            <tr key={idx} style={{ borderTop:"1px solid #141414" }}>
                              <td style={{ padding:"10px 0", color:"rgba(224,224,224,0.6)" }}>{m.month}</td>
                              <td style={{ padding:"10px 0", color:"#56B9E9" }}>{fmt(m.income)}</td>
                              <td style={{ padding:"10px 0", color:"#cf6679" }}>{fmt(totalExp(m))}</td>
                              <td style={{ padding:"10px 0", color:"#E0E0E0" }}>{fmt(net)}</td>
                              <td style={{ padding:"10px 0", color:"#E0E0E0", fontWeight:500 }}>{fmt(mine)}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            );
          })}
        </div>
        </div>
        )}
      </div>
    </div>
  );
}

// ─── CHANGE PASSWORD SECTION ─────────────────────────────────────────────────
function AccountSection(props) {
  var user = props.user;
  var [showPw, setShowPw] = useState(false);
  return (
    <div style={{ display:"flex", flexDirection:"column", gap:14, maxWidth:420 }}>
      <div className="card" style={{ padding:22 }}>
        <label className="label" style={{ marginBottom:12 }}>ACCOUNT DETAILS</label>
        <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
          <div style={{ display:"flex", justifyContent:"space-between" }}>
            <span style={{ fontSize:12, color:"#56B9E9" }}>Name</span>
            <span style={{ fontSize:13, color:"#E0E0E0", fontWeight:500 }}>{user.name}</span>
          </div>
          <div style={{ display:"flex", justifyContent:"space-between" }}>
            <span style={{ fontSize:12, color:"#56B9E9" }}>Email</span>
            <span style={{ fontSize:13, color:"#E0E0E0" }}>{user.email}</span>
          </div>
          <div style={{ display:"flex", justifyContent:"space-between" }}>
            <span style={{ fontSize:12, color:"#56B9E9" }}>Role</span>
            <span style={{ fontSize:13, color:"#56B9E9", textTransform:"capitalize" }}>{user.role === "franchisee_investor" ? "Franchisee + Investor" : user.role}</span>
          </div>
        </div>
      </div>
      {!showPw ? (
        <button className="btn btn-secondary" style={{ alignSelf:"flex-start" }} onClick={function() { setShowPw(true); }}>
          Change Password
        </button>
      ) : (
        <div>
          <button className="btn btn-secondary btn-sm" style={{ marginBottom:14 }} onClick={function() { setShowPw(false); }}>
            ← Cancel
          </button>
          <ChangePasswordSection user={user} />
        </div>
      )}
    </div>
  );
}

function ChangePasswordSection(props) {
  var user = props.user;
  var [curPw, setCurPw] = useState("");
  var [newPw, setNewPw] = useState("");
  var [confPw, setConfPw] = useState("");
  var [msg, setMsg] = useState(null);
  var [err, setErr] = useState(null);
  var [loading, setLoading] = useState(false);

  function handleChange() {
    if (!curPw || !newPw || !confPw) { setErr("All fields required"); return; }
    if (newPw.length < 8) { setErr("New password must be at least 8 characters"); return; }
    if (newPw !== confPw) { setErr("Passwords do not match"); return; }
    setLoading(true); setErr(null); setMsg(null);
    fetch(API_URL + "/api/users/" + user.id + "/change-password", {
      method:"PUT",
      headers:{ "Content-Type":"application/json", "Authorization":"Bearer " + (localStorage.getItem("gi_token")||"") },
      body: JSON.stringify({ currentPassword:curPw, newPassword:newPw })
    }).then(function(r) { return r.json(); }).then(function(data) {
      setLoading(false);
      if (data.error) { setErr(data.error); }
      else { setMsg("Password changed successfully!"); setCurPw(""); setNewPw(""); setConfPw(""); }
    }).catch(function() { setLoading(false); setErr("Connection error. Please try again."); });
  }

  return (
    <div className="card" style={{ padding:24, marginTop:24 }}>
      <label className="label" style={{ marginBottom:14 }}>CHANGE PASSWORD</label>
      <div style={{ display:"flex", flexDirection:"column", gap:12, maxWidth:400 }}>
        <div><label className="label">CURRENT PASSWORD</label><input type="password" placeholder="Current password" value={curPw} onChange={function(e){setCurPw(e.target.value);}} /></div>
        <div><label className="label">NEW PASSWORD</label><input type="password" placeholder="Min 8 characters" value={newPw} onChange={function(e){setNewPw(e.target.value);}} /></div>
        <div><label className="label">CONFIRM NEW PASSWORD</label><input type="password" placeholder="Repeat new password" value={confPw} onChange={function(e){setConfPw(e.target.value);}} /></div>
        {err && <div style={{ background:"rgba(207,102,121,0.08)", border:"1px solid #4a1010", borderRadius:8, padding:"10px 14px", color:"#cf6679", fontSize:12 }}>{err}</div>}
        {msg && <div style={{ background:"rgba(77,231,166,0.1)", border:"1px solid rgba(52,211,153,0.3)", borderRadius:8, padding:"10px 14px", color:"#4DE7A6", fontSize:12 }}>{msg}</div>}
        <button className="btn btn-primary btn-sm" style={{ alignSelf:"flex-start" }} onClick={handleChange} disabled={loading}>
          {loading ? "Saving..." : "Change Password"}
        </button>
      </div>
    </div>
  );
}

// ─── FRANCHISEE PORTAL ────────────────────────────────────────────────────────
function FranchiseePortal(props) {
  var user = props.user;
  var franchises = props.franchises;
  var onLogout = props.onLogout;
  var embedded = props.embedded || false;
  // All branches this user is an owner of
  var myFranchises = franchises.filter(function(f) {
    if (f.id === user.franchiseId) return true;
    return f.owners && f.owners.some(function(o){ return o.isCurrent !== false && (o.email||"").toLowerCase() === (user.email||"").toLowerCase(); });
  });
  var myFranchise = myFranchises.length === 1 ? myFranchises[0] : (franchises.find(function(f){ return f.id === user.franchiseId; }) || myFranchises[0] || null);
  var [selectedBranchId, setSelectedBranchId] = useState(null);
  var activeBranch = selectedBranchId ? myFranchises.find(function(f){ return f.id === selectedBranchId; }) : null;
  var [portalView, setPortalView] = useState("overview");
  var [portalYear, setPortalYear] = useState(null);
  var [portalPayments, setPortalPayments] = useState({});
  var [declarations, setDeclarations] = useState([]);
  var [declForm, setDeclForm] = useState({ month:"", income:"", rent:"", salaries:"", otherExpenses:"", franchiseId:"" });
  var [declSearch, setDeclSearch] = useState("");
  var [declFilterBranch, setDeclFilterBranch] = useState("all");
  var [declFilterMonth, setDeclFilterMonth] = useState("all");
  var [editRequestId, setEditRequestId] = useState(null);
  var [editRequestNote, setEditRequestNote] = useState("");
  var [directorView, setDirectorView] = useState(false);
  var [portalBranchOpen, setPortalBranchOpen] = useState({});
  var [salaryForm, setSalaryForm] = useState({ franchiseId:"", amount:"", effectiveFrom:"" });
  var [showSalaryHistory, setShowSalaryHistory] = useState({});
  var [salaryData, setSalaryData] = useState({});
  var [toast, setToast] = useState(null);
  var [profitData, setProfitData] = useState([]);
  var [profitLoading, setProfitLoading] = useState(false);
  var [withdrawModal, setWithdrawModal] = useState(null);
  var [withdrawForm, setWithdrawForm] = useState({ amount:"", method:"Bank Transfer", date:"", notes:"" });
  var [profitHistoryOpen, setProfitHistoryOpen] = useState(false);
  var [profitSearch, setProfitSearch] = useState("");
  var [profitPLFranchise, setProfitPLFranchise] = useState(null);
  var [profitPLYear, setProfitPLYear] = useState(new Date().getFullYear());
  var [profitHistFranchise, setProfitHistFranchise] = useState(null);
  var [profitHistSearch, setProfitHistSearch] = useState('');
  var [profitHistYear, setProfitHistYear] = useState(0);
  var [profitTopSearch, setProfitTopSearch] = useState('');

  useEffect(function() { DB.getDeclarations().then(function(d) { setDeclarations(d); }); }, []);
  useEffect(function() {
    setProfitLoading(true);
    DB.getProfit(directorView).then(function(d) { setProfitData(d || []); setProfitLoading(false); });
  }, [directorView]);
  useEffect(function() {
    if (!myFranchises.length) return;
    myFranchises.forEach(function(f){
      apiFetch("/api/franchises/" + f.id + "/salaries").then(function(d){
        if (d && Array.isArray(d)) setSalaryData(function(s){ var n=Object.assign({},s); n[f.id]=d; return n; });
      }).catch(function(){});
    });
  }, [myFranchises.length, portalView]);

  function showToast(msg) { setToast(msg); setTimeout(function() { setToast(null); }, 2500); }

  var myDeclarations = declarations.filter(function(d) { return d.franchiseeId === user.id || d.franchiseeEmail === user.email; });

  // Get active salary for a specific user in a branch at a given month
  function getActiveSalary(franchiseId, month, userId) {
    if (!userId) return 0;
    // First check separately loaded salaryData, then fall back to franchise.salaries from main load
    var franchise = myFranchises.find(function(f){ return f.id === franchiseId; });
    var entries = (salaryData[franchiseId] && salaryData[franchiseId].length)
      ? salaryData[franchiseId]
      : (franchise ? (franchise.salaries || []) : []);
    var userEntries = entries.filter(function(s){ return s.userId === userId; });
    if (!userEntries.length) return 0;
    var filtered = userEntries.filter(function(s){ return parseMonthDate(s.effectiveFrom) <= parseMonthDate(month); });
    if (!filtered.length) return 0;
    filtered.sort(function(a,b){ return parseMonthDate(b.effectiveFrom)-parseMonthDate(a.effectiveFrom); });
    return filtered[0].amount || 0;
  }

  function submitDeclaration(paymentType) {
    var declFranchise = declForm.franchiseId ? myFranchises.find(function(f){ return f.id === declForm.franchiseId; }) : (myFranchises.length === 1 ? myFranchises[0] : null);
    if (!declForm.month) { showToast("Please select a month."); return; }
    if (!declForm.income) { showToast("Please enter income."); return; }
    if (declForm.rent === "") { showToast("Please enter rent (use 0 if none)."); return; }
    if (declForm.salaries === "") { showToast("Please enter salaries (use 0 if none)."); return; }
    if (declForm.otherExpenses === "") { showToast("Please enter other expenses (use 0 if none)."); return; }
    if (!declFranchise) { showToast("Please select a branch."); return; }
    var payload = {
      franchiseeEmail: user.email,
      franchiseeName: user.name,
      franchiseId: declFranchise.id,
      franchiseName: declFranchise.name,
      month: declForm.month,
      income: parseFloat(declForm.income) || 0,
      rent: parseFloat(declForm.rent) || 0,
      salaries: parseFloat(declForm.salaries) || 0,
      royalty: parseFloat(declForm.income) * 0.125 || 0,
      otherExpenses: parseFloat(declForm.otherExpenses) || 0,
      status: "pending",
      paymentType: paymentType || 'save_only',
    };
    DB.submitDeclaration(payload).then(function(res) {
      DB.getDeclarations().then(function(d) {
        if (d && Array.isArray(d)) setDeclarations(d);
      });
      setDeclForm({ month:"", income:"", rent:"", salaries:"", otherExpenses:"", franchiseId:"" });
      showToast(paymentType === 'submit_and_pay' ? "Submitted — completing payment on JotForm." : "Submitted - awaiting admin approval.");
    }).catch(function(e) {
      console.log("Declaration error:", e);
      showToast("Error submitting. Please try again.");
    });
  }

  function statusColor(s) { return s === "approved" ? "#4DE7A6" : s === "rejected" ? "#cf6679" : "#cf6679"; }
  function statusBg(s)    { return s === "approved" ? "rgba(77,231,166,0.1)" : s === "rejected" ? "rgba(207,102,121,0.1)" : "rgba(207,102,121,0.1)"; }

  var dueMonth = getOverdueMonth();
  var overdueWarning = isOverdue(declarations, user.email) && !myFranchises.some(function(f){ return f.financials.some(function(m){ return m.month === dueMonth; }); });
  // All overdue months across all franchises
  var allOverdueMonths = (function(){
    try {
    var now9 = new Date();
    var result = [];
    var sIdx9 = 2025 * 12 + 8;
    var eIdx9 = now9.getFullYear() * 12 + now9.getMonth();
    for (var mi9 = sIdx9; mi9 < eIdx9; mi9++) {
      var yr9 = Math.floor(mi9/12); var mo9 = mi9%12;
      var due9 = new Date(yr9, mo9+1, 10);
      if (due9 > now9) break;
      var mStr9 = MONTH_NAMES[mo9] + " " + yr9;
      myFranchises.forEach(function(f9){
        var hasDecl = declarations.some(function(d){ return d.franchiseId===f9.id && d.month===mStr9; });
        var hasFin = f9.financials.some(function(m){ return m.month===mStr9; });
        if (!hasDecl && !hasFin) result.push({ month:mStr9, franchise:f9 });
      });
    }
    return result;
    } catch(e) { return []; }
  })();
  // Load investor payments for this franchise
  useEffect(function() {
    if (!myFranchise) return;
    apiFetch("/api/franchises/" + myFranchise.id + "/investor-payments").then(function(data) {
      if (data && data.payments) {
        var map = {};
        data.payments.forEach(function(p) { map[myFranchise.id + "_" + p.month] = { paid:p.paid, datePaid:p.date_paid||"" }; });
        setPortalPayments(map);
      }
    }).catch(function(){});
  }, [myFranchise && myFranchise.id]);

  return (
    <div style={{ fontFamily:"Outfit,sans-serif", background:"#121212", minHeight:"100vh", color:"#E0E0E0" }}>
      <style>{CSS}</style>
      {toast && <div style={{ position:"fixed", bottom:24, right:24, background:"#56B9E9", color:"#080808", padding:"12px 20px", borderRadius:10, fontSize:13, fontWeight:500, zIndex:500 }}>✓ {toast}</div>}
      <div style={{ borderBottom:"1px solid #141414", padding:"14px 32px", display:"flex", alignItems:"center", justifyContent:"space-between", background:"#1E1E1E", position:"sticky", top:0, zIndex:50 }}>
        <div style={{ display:"flex", alignItems:"center", gap:12 }}>
          <img src="https://www.goinvestors.co.uk/finance-emblem-white.svg" onClick={function(e){ triggerEasterEgg(e.currentTarget); }} alt="GoTutors" style={{ height:32 }} /><img src="https://www.goinvestors.co.uk/finance-wordmark-white.svg" alt="GoTutors" style={{ height:24, marginLeft:10 }} />
          <span className="tag" style={{ background:"rgba(77,231,166,0.1)", color:"#4DE7A6" }}>Franchisee</span>
        </div>
        <nav style={{ display:"flex", gap:4, alignItems:"center" }}>
          {user && user.role === "director" && (
            <button className="btn btn-sm" style={{ background:"rgba(86,185,233,0.15)", color:"#56B9E9", border:"1px solid rgba(86,185,233,0.4)", marginRight:8, fontSize:12 }}
              onClick={function(){ setDirectorView(true); }}>
              Director View ↗
            </button>
          )}
          {[["overview","Overview"],["declare","Declare Figures"],["profit","Profit"],["account","My Account"]].map(function(item) {
            return <div key={item[0]} className={"nav-pill" + (portalView === item[0] ? " active" : "")} onClick={function() { setPortalView(item[0]); }}>{item[1]}</div>;
          })}
        </nav>
        <div style={{ display:"flex", gap:8, alignItems:"center" }}>
          <div style={{ width:30, height:30, borderRadius:"50%", background:"rgba(77,231,166,0.1)", display:"flex", alignItems:"center", justifyContent:"center", color:"#4DE7A6", fontFamily:"Playfair Display,serif", fontWeight:800, fontSize:13 }}>{user.name.charAt(0)}</div>
          <button className="btn btn-sm btn-secondary" onClick={onLogout}>Sign out</button>
        </div>
      </div>

      {/* DIRECTOR VIEW — full screen */}
      {user && user.role === "director" && directorView && (
        <DirectorView user={user} franchises={franchises} onExit={function(){ setDirectorView(false); }} />
      )}

      {!directorView && <div style={{ maxWidth:900, margin:"0 auto", padding:"36px 24px" }} className="fade-in">
        {overdueWarning && !directorView && (
          <div style={{ background:"rgba(207,102,121,0.08)", border:"1px solid #4a1010", borderRadius:12, padding:"14px 20px", marginBottom:24, display:"flex", alignItems:"center", gap:14 }}>
            <div style={{ width:36, height:36, borderRadius:"50%", background:"rgba(240,104,104,0.15)", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, fontSize:18 }}>⚠</div>
            <div style={{ flex:1 }}>
              <div style={{ fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:15, color:"#cf6679", marginBottom:3 }}>Declaration Overdue</div>
              <div style={{ fontSize:13, color:"#a04040" }}>Figures for <strong style={{ color:"#cf6679" }}>{dueMonth}</strong> were due by the 10th. Please submit immediately.</div>
            </div>
            <button className="btn" style={{ background:"#cf6679", color:"#080808", fontSize:12, padding:"9px 16px", borderRadius:8, flexShrink:0 }} onClick={function() { setPortalView("declare"); }}>Submit Now</button>
          </div>
        )}

        {(!directorView) && portalView === "overview" && (
          <div>
            <div style={{ marginBottom:20 }}>
              <h1 style={{ fontFamily:"Playfair Display,serif", fontWeight:900, fontSize:26, letterSpacing:"-0.03em" }}>Welcome back, {user.name.split(" ")[0]}</h1>
              <p style={{ color:"rgba(224,224,224,0.6)", fontSize:13, marginTop:4 }}>{myFranchises.length} branch{myFranchises.length !== 1 ? "es" : ""} assigned to your account</p>
            </div>

            {myFranchises.length === 0 && <div className="card" style={{ color:"rgba(224,224,224,0.45)", fontSize:13 }}>No franchise assigned to your account yet.</div>}

            {myFranchises.length > 0 && (function() {
              // Branch selector
              var displayFranchises = activeBranch ? [activeBranch] : myFranchises;

              // All years across selected branches
              var allYears = Array.from(new Set(
                displayFranchises.reduce(function(acc, f){
                  return acc.concat(f.financials.map(function(m){
                    var match = (m.month||"").toString().match(/\b(20\d\d)\b/);
                    return match ? parseInt(match[1]) : null;
                  }).filter(Boolean));
                }, [])
              )).sort(function(a,b){ return b-a; });
              if (!allYears.length) allYears = [new Date().getFullYear()];
              var curYear = allYears.indexOf(portalYear) === -1 ? allYears[0] : portalYear;
              var hasPrev = allYears.indexOf(curYear) < allYears.length - 1;
              var hasNext = allYears.indexOf(curYear) > 0;

              // Financials filtered by year and selected branches
              var yearFinancials = displayFranchises.reduce(function(acc, f){
                return acc.concat(f.financials.filter(function(m){
                  var match = (m.month||"").toString().match(/\b(20\d\d)\b/);
                  return match && parseInt(match[1]) === curYear;
                }).map(function(m){ return Object.assign({}, m, { franchiseName: f.name }); }));
              }, []);

              var totalIncome = yearFinancials.reduce(function(s,m){ return s+m.income; }, 0);
              var totalExpenses = yearFinancials.reduce(function(s,m){ return s+totalExp(m); }, 0);
              var totalProfit = totalIncome - totalExpenses;
              var margin = totalIncome > 0 ? ((totalProfit/totalIncome)*100).toFixed(1) : 0;

              // Group by month for combined table
              var monthMap = {};
              yearFinancials.forEach(function(m){
                if (!monthMap[m.month]) monthMap[m.month] = { month:m.month, income:0, rent:0, salaries:0, royalty:0, otherExpenses:0 };
                monthMap[m.month].income += m.income;
                monthMap[m.month].rent += (m.rent||0);
                monthMap[m.month].salaries += (m.salaries||0);
                monthMap[m.month].royalty += (m.royalty||0);
                monthMap[m.month].otherExpenses += (m.otherExpenses||0);
              });
              var combinedMonths = Object.values(monthMap).sort(function(a,b){ return parseMonthDate(b.month)-parseMonthDate(a.month); });

              return (
                <div>
                  {/* KPI cards with year selector */}
                  <div style={{ marginBottom:20 }}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}>
                      <label className="label" style={{ margin:0 }}>{activeBranch ? activeBranch.name : "ALL BRANCHES"}</label>
                      <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                        <button className="btn btn-sm btn-secondary" style={{ padding:"5px 10px", opacity:hasPrev?1:0.3 }}
                          onClick={function(){ if(hasPrev) setPortalYear(allYears[allYears.indexOf(curYear)+1]); }}>←</button>
                        <span style={{ fontSize:14, fontWeight:700, color:"#E0E0E0", minWidth:40, textAlign:"center" }}>{curYear}</span>
                        <button className="btn btn-sm btn-secondary" style={{ padding:"5px 10px", opacity:hasNext?1:0.3 }}
                          onClick={function(){ if(hasNext) setPortalYear(allYears[allYears.indexOf(curYear)-1]); }}>→</button>
                      </div>
                    </div>
                    <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr 1fr", gap:12 }}>
                      <div className="card" style={{ padding:16, borderLeft:"3px solid #56B9E9" }}>
                        <div className="label" style={{ marginBottom:6 }}>TOTAL REVENUE</div>
                        <div style={{ fontFamily:"Playfair Display,serif", fontWeight:800, fontSize:20, color:"#56B9E9" }}>{fmt(totalIncome)}</div>
                        <div style={{ fontSize:11, color:"rgba(224,224,224,0.4)", marginTop:4 }}>{activeBranch ? activeBranch.name : "all branches"}</div>
                      </div>
                      <div className="card" style={{ padding:16, borderLeft:"3px solid #cf6679" }}>
                        <div className="label" style={{ marginBottom:6 }}>TOTAL EXPENSES</div>
                        <div style={{ fontFamily:"Playfair Display,serif", fontWeight:800, fontSize:20, color:"#cf6679" }}>{fmt(totalExpenses)}</div>
                        <div style={{ fontSize:11, color:"rgba(224,224,224,0.4)", marginTop:4 }}>{activeBranch ? activeBranch.name : "all branches"}</div>
                      </div>
                      <div className="card" style={{ padding:16, borderLeft:"3px solid #4DE7A6" }}>
                        <div className="label" style={{ marginBottom:6 }}>NET PROFIT</div>
                        <div style={{ fontFamily:"Playfair Display,serif", fontWeight:800, fontSize:20, color:"#4DE7A6" }}>{fmt(totalProfit)}</div>
                        <div style={{ fontSize:11, color:"rgba(224,224,224,0.4)", marginTop:4 }}>{activeBranch ? activeBranch.name : "all branches"}</div>
                      </div>
                      <div className="card" style={{ padding:16, borderLeft:"3px solid rgba(255,255,255,0.2)" }}>
                        <div className="label" style={{ marginBottom:6 }}>MARGIN</div>
                        <div style={{ fontFamily:"Playfair Display,serif", fontWeight:800, fontSize:20, color:"#E0E0E0" }}>{margin}%</div>
                        <div style={{ fontSize:11, color:"rgba(224,224,224,0.4)", marginTop:4 }}>{curYear}</div>
                      </div>
                    </div>
                  </div>

                  {/* Branch selector */}
                  {myFranchises.length > 1 && (
                    <div style={{ marginBottom:20 }}>
                      <label className="label" style={{ marginBottom:8 }}>SELECT BRANCH</label>
                      <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
                        <button className="btn btn-sm" style={{ background:!selectedBranchId?"#E0E0E0":"#1E1E1E", color:!selectedBranchId?"#121212":"rgba(224,224,224,0.6)", border:"1px solid #2A2A2A" }}
                          onClick={function(){ setSelectedBranchId(null); }}>All Branches</button>
                        {myFranchises.map(function(f){
                          var isSel = selectedBranchId === f.id;
                          return (
                            <button key={f.id} className="btn btn-sm" style={{ background:isSel?"rgba(86,185,233,0.15)":"#1E1E1E", color:isSel?"#56B9E9":"rgba(224,224,224,0.6)", border:"1px solid "+(isSel?"rgba(86,185,233,0.4)":"#2A2A2A") }}
                              onClick={function(){ setSelectedBranchId(isSel?null:f.id); }}>
                              {f.name}
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  )}

                  {/* Combined monthly P&L table */}
                  {combinedMonths.length > 0 && (
                    <div style={{ marginBottom:24 }}>
                      <label className="label" style={{ marginBottom:10 }}>MONTHLY BREAKDOWN — {curYear}</label>
                      <div className="card" style={{ padding:0, overflow:"hidden", overflowX:"auto" }}>
                        <table style={{ width:"100%", borderCollapse:"collapse", fontSize:12 }}>
                          <thead><tr style={{ borderBottom:"1px solid #2A2A2A" }}>
                            {["MONTH","INCOME","RENT","SALARIES","ROYALTY","OTHER","TOTAL EXP","NET"].map(function(h){
                              return <th key={h} style={{ padding:"11px 14px", textAlign: h==="MONTH"?"left":"right", fontSize:10, letterSpacing:"0.1em", color:"rgba(224,224,224,0.45)", fontWeight:700, whiteSpace:"nowrap" }}>{h}</th>;
                            })}
                          </tr></thead>
                          <tbody>
                            {combinedMonths.map(function(m){
                              var exp = totalExp(m);
                              var net = m.income - exp;
                              return (
                                <tr key={m.month} style={{ borderBottom:"1px solid rgba(255,255,255,0.04)" }}>
                                  <td style={{ padding:"11px 14px", color:"rgba(224,224,224,0.7)" }}>{m.month}</td>
                                  <td style={{ padding:"11px 14px", textAlign:"right", color:"#56B9E9" }}>{fmt(m.income)}</td>
                                  <td style={{ padding:"11px 14px", textAlign:"right", color:"rgba(224,224,224,0.6)" }}>{fmt(m.rent||0)}</td>
                                  <td style={{ padding:"11px 14px", textAlign:"right", color:"rgba(224,224,224,0.6)" }}>{fmt(m.salaries||0)}</td>
                                  <td style={{ padding:"11px 14px", textAlign:"right", color:"rgba(224,224,224,0.6)" }}>{fmt(m.royalty||0)}</td>
                                  <td style={{ padding:"11px 14px", textAlign:"right", color:"rgba(224,224,224,0.6)" }}>{fmt(m.otherExpenses||0)}</td>
                                  <td style={{ padding:"11px 14px", textAlign:"right", color:"#cf6679", fontWeight:500 }}>{fmt(exp)}</td>
                                  <td style={{ padding:"11px 14px", textAlign:"right", color:net>=0?"#4DE7A6":"#cf6679", fontWeight:700 }}>{fmt(net)}</td>
                                </tr>
                              );
                            })}
                            <tr style={{ borderTop:"2px solid #2A2A2A", background:"#252525" }}>
                              <td style={{ padding:"11px 14px", color:"rgba(224,224,224,0.45)", fontSize:11 }}>TOTAL</td>
                              <td style={{ padding:"11px 14px", textAlign:"right", color:"#56B9E9", fontWeight:700, fontFamily:"Playfair Display,serif" }}>{fmt(totalIncome)}</td>
                              <td style={{ padding:"11px 14px", textAlign:"right", color:"rgba(224,224,224,0.6)", fontWeight:700 }}>{fmt(combinedMonths.reduce(function(s,m){return s+(m.rent||0);},0))}</td>
                              <td style={{ padding:"11px 14px", textAlign:"right", color:"rgba(224,224,224,0.6)", fontWeight:700 }}>{fmt(combinedMonths.reduce(function(s,m){return s+(m.salaries||0);},0))}</td>
                              <td style={{ padding:"11px 14px", textAlign:"right", color:"rgba(224,224,224,0.6)", fontWeight:700 }}>{fmt(combinedMonths.reduce(function(s,m){return s+(m.royalty||0);},0))}</td>
                              <td style={{ padding:"11px 14px", textAlign:"right", color:"rgba(224,224,224,0.6)", fontWeight:700 }}>{fmt(combinedMonths.reduce(function(s,m){return s+(m.otherExpenses||0);},0))}</td>
                              <td style={{ padding:"11px 14px", textAlign:"right", color:"#cf6679", fontWeight:700, fontFamily:"Playfair Display,serif" }}>{fmt(totalExpenses)}</td>
                              <td style={{ padding:"11px 14px", textAlign:"right", color:totalProfit>=0?"#4DE7A6":"#cf6679", fontWeight:700, fontFamily:"Playfair Display,serif" }}>{fmt(totalProfit)}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}

                  {/* Combined Financials, Margin History, Yearly Margins — shown when all branches selected */}
                  {!activeBranch && myFranchises.length > 1 && combinedMonths.length > 0 && (function(){
                    // Year summary
                    var yInc = combinedMonths.reduce(function(s,m){return s+m.income;},0);
                    var yExp = combinedMonths.reduce(function(s,m){return s+totalExp(m);},0);
                    var yNet = yInc - yExp;

                    // All years combined across all branches
                    var allYrMap = {};
                    myFranchises.forEach(function(f){
                      f.financials.forEach(function(m){
                        var match = m.month&&m.month.toString().match(/(20[0-9][0-9])/);
                        if (!match) return;
                        var yr = match[1];
                        if (!allYrMap[yr]) allYrMap[yr] = { income:0, net:0 };
                        allYrMap[yr].income += m.income;
                        allYrMap[yr].net += m.income - totalExp(m);
                      });
                    });
                    var yearRows = Object.keys(allYrMap).sort(function(a,b){return b-a;}).map(function(yr){
                      var y = allYrMap[yr];
                      return { year:yr, income:y.income, net:y.net, margin:y.income>0?y.net/y.income*100:0 };
                    });

                    return (
                      <div>
                        {/* FINANCIALS summary */}
                        <div style={{ marginBottom:20 }}>
                          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:10 }}>
                            <label className="label" style={{ margin:0 }}>FINANCIALS — ALL BRANCHES</label>
                          </div>
                          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:8, marginBottom:12 }}>
                            <div style={{ background:"#252525", borderRadius:8, padding:"10px 14px" }}>
                              <div style={{ fontSize:9, color:"rgba(224,224,224,0.45)", letterSpacing:"0.1em", marginBottom:3 }}>YEAR INCOME</div>
                              <div style={{ color:"#56B9E9", fontWeight:700, fontSize:16, fontFamily:"Playfair Display,serif" }}>{fmt(yInc)}</div>
                            </div>
                            <div style={{ background:"#252525", borderRadius:8, padding:"10px 14px" }}>
                              <div style={{ fontSize:9, color:"rgba(224,224,224,0.45)", letterSpacing:"0.1em", marginBottom:3 }}>YEAR EXPENSES</div>
                              <div style={{ color:"#cf6679", fontWeight:700, fontSize:16, fontFamily:"Playfair Display,serif" }}>{fmt(yExp)}</div>
                            </div>
                            <div style={{ background:"#252525", borderRadius:8, padding:"10px 14px" }}>
                              <div style={{ fontSize:9, color:"rgba(224,224,224,0.45)", letterSpacing:"0.1em", marginBottom:3 }}>YEAR NET PROFIT</div>
                              <div style={{ color:yNet>=0?"#4DE7A6":"#cf6679", fontWeight:700, fontSize:16, fontFamily:"Playfair Display,serif" }}>{fmt(yNet)}</div>
                            </div>
                          </div>
                        </div>

                        {/* MONTHLY MARGIN HISTORY */}
                        <div style={{ marginBottom:20 }}>
                          <label className="label" style={{ marginBottom:10 }}>MONTHLY MARGIN HISTORY — ALL BRANCHES</label>
                          <div className="card" style={{ padding:0, overflow:"hidden" }}>
                            <table style={{ width:"100%", borderCollapse:"collapse", fontSize:12 }}>
                              <thead><tr style={{ borderBottom:"1px solid #2A2A2A" }}>
                                {["MONTH","INCOME","NET PROFIT","MARGIN"].map(function(h){ return <th key={h} style={{ padding:"10px 18px", textAlign:"left", fontSize:10, letterSpacing:"0.08em", color:"rgba(224,224,224,0.45)", fontWeight:700 }}>{h}</th>; })}
                              </tr></thead>
                              <tbody>
                                {combinedMonths.map(function(m){
                                  var net = m.income - totalExp(m);
                                  var margin2 = m.income > 0 ? (net/m.income*100).toFixed(1) : "0.0";
                                  return (
                                    <tr key={m.month} style={{ borderBottom:"1px solid rgba(255,255,255,0.04)" }}>
                                      <td style={{ padding:"10px 18px", color:"rgba(224,224,224,0.7)" }}>{m.month}</td>
                                      <td style={{ padding:"10px 18px", color:"#56B9E9" }}>{fmt(m.income)}</td>
                                      <td style={{ padding:"10px 18px", color:net>=0?"#4DE7A6":"#cf6679" }}>{fmt(net)}</td>
                                      <td style={{ padding:"10px 18px" }}>
                                        <span style={{ background: parseFloat(margin2)>=0?"rgba(77,231,166,0.1)":"rgba(207,102,121,0.1)", color:parseFloat(margin2)>=0?"#4DE7A6":"#cf6679", padding:"2px 10px", borderRadius:20, fontSize:11, fontWeight:600 }}>{margin2}%</span>
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>

                        {/* YEARLY MARGINS */}
                        <div style={{ marginBottom:20 }}>
                          <label className="label" style={{ marginBottom:10 }}>YEARLY MARGINS — ALL BRANCHES</label>
                          <div className="card" style={{ padding:0, overflow:"hidden" }}>
                            <table style={{ width:"100%", borderCollapse:"collapse", fontSize:12 }}>
                              <thead><tr style={{ borderBottom:"1px solid #2A2A2A" }}>
                                {["YEAR","REVENUE","NET PROFIT","MARGIN"].map(function(h){ return <th key={h} style={{ padding:"10px 18px", textAlign:"left", fontSize:10, letterSpacing:"0.08em", color:"rgba(224,224,224,0.45)", fontWeight:700 }}>{h}</th>; })}
                              </tr></thead>
                              <tbody>
                                {yearRows.map(function(yr){
                                  return (
                                    <tr key={yr.year} style={{ borderBottom:"1px solid rgba(255,255,255,0.04)" }}>
                                      <td style={{ padding:"10px 18px", color:"rgba(224,224,224,0.7)", fontWeight:600 }}>{yr.year}</td>
                                      <td style={{ padding:"10px 18px", color:"#56B9E9" }}>{fmt(yr.income)}</td>
                                      <td style={{ padding:"10px 18px", color:yr.net>=0?"#4DE7A6":"#cf6679" }}>{fmt(yr.net)}</td>
                                      <td style={{ padding:"10px 18px" }}>
                                        <span style={{ background:yr.margin>=0?"rgba(77,231,166,0.1)":"rgba(207,102,121,0.1)", color:yr.margin>=0?"#4DE7A6":"#cf6679", padding:"2px 10px", borderRadius:20, fontSize:11, fontWeight:600 }}>{yr.margin.toFixed(1)}%</span>
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>

                        {/* FRANCHISEE P&L — combined same structure as individual */}
                        <div style={{ marginBottom:20 }}>
                          <label className="label" style={{ marginBottom:10 }}>FRANCHISEE PROFIT & LOSS — ALL BRANCHES</label>
                          <div className="card" style={{ padding:0, overflow:"hidden" }}>
                            <table style={{ width:"100%", borderCollapse:"collapse", fontSize:12 }}>
                              <thead><tr style={{ borderBottom:"1px solid #2A2A2A" }}>
                                <th style={{ padding:"11px 14px", textAlign:"left", fontSize:10, letterSpacing:"0.1em", color:"rgba(224,224,224,0.45)", fontWeight:700 }}>MONTH</th>
                                <th style={{ padding:"11px 14px", textAlign:"left", fontSize:10, letterSpacing:"0.1em", color:"rgba(224,224,224,0.45)", fontWeight:700 }}>FRANCHISEE</th>
                                <th style={{ padding:"11px 14px", textAlign:"right", fontSize:10, letterSpacing:"0.1em", color:"rgba(224,224,224,0.45)", fontWeight:700 }}>NET PROFIT</th>
                                <th style={{ padding:"11px 14px", textAlign:"right", fontSize:10, letterSpacing:"0.1em", color:"#4DE7A6", fontWeight:700 }}>SHARE</th>
                                <th style={{ padding:"11px 14px", textAlign:"right", fontSize:10, letterSpacing:"0.1em", color:"#56B9E9", fontWeight:700 }}>SALARY</th>
                                <th style={{ padding:"11px 14px", textAlign:"right", fontSize:10, letterSpacing:"0.1em", color:"#E0E0E0", fontWeight:700, background:"rgba(255,255,255,0.03)" }}>TH</th>
                              </tr></thead>
                              <tbody>
                                {(function(){
                                  // Get all unique owners across all branches
                                  var ownerMap = {};
                                  myFranchises.forEach(function(f){
                                    (f.owners||[]).forEach(function(o){
                                      var key = (o.email||"").toLowerCase();
                                      if (!ownerMap[key]) ownerMap[key] = { name:o.name, email:o.email };
                                    });
                                  });
                                  var allOwners = Object.values(ownerMap);

                                  // Get all unique months across all branches for this year
                                  var monthSet = {};
                                  myFranchises.forEach(function(f){
                                    f.financials.forEach(function(m){
                                      var match = (m.month||"").toString().match(/\b(20\d\d)\b/);
                                      if (match && parseInt(match[1]) === curYear) monthSet[m.month] = true;
                                    });
                                  });
                                  var allMonths = Object.keys(monthSet).sort(function(a,b){ return parseMonthDate(b)-parseMonthDate(a); });

                                  return allMonths.map(function(month){
                                    // Calculate per-owner figures by summing across each branch
                                    var ownerFigures = allOwners.map(function(o){
                                      var ownerShare = 0;
                                      var ownerSalary = 0;
                                      myFranchises.forEach(function(f){
                                        var fOwner = (f.owners||[]).find(function(fo){ return (fo.email||"").toLowerCase()===(o.email||"").toLowerCase(); });
                                        if (!fOwner) return;
                                        var fMth = f.financials.find(function(fm){ return fm.month===month; });
                                        if (!fMth) return;
                                        var fNet = fMth.income - totalExp(fMth);
                                        // This owner's salary for this branch/month
                                        var fSalE = (f.salaries||[]).filter(function(s){
                                          return s.userEmail && (s.userEmail||"").toLowerCase()===(o.email||"").toLowerCase() && parseMonthDate(s.effectiveFrom)<=parseMonthDate(month);
                                        });
                                        fSalE.sort(function(a,b){ return parseMonthDate(b.effectiveFrom)-parseMonthDate(a.effectiveFrom); });
                                        var fSal = fSalE.length ? fSalE[0].amount : 0;
                                        // All owners' salaries for this branch/month
                                        var allFSals = (f.owners||[]).reduce(function(ss,fo){
                                          var foE=(f.salaries||[]).filter(function(s){ return s.userEmail&&(s.userEmail||"").toLowerCase()===(fo.email||"").toLowerCase()&&parseMonthDate(s.effectiveFrom)<=parseMonthDate(month); });
                                          foE.sort(function(a,b){ return parseMonthDate(b.effectiveFrom)-parseMonthDate(a.effectiveFrom); });
                                          return ss+(foE.length?foE[0].amount:0);
                                        },0);
                                        ownerSalary += fSal;
                                        ownerShare += (fNet - allFSals) * parseFloat(fOwner.sharePercent) / 100;
                                      });
                                      return { owner:o, share:ownerShare, salary:ownerSalary, th:ownerShare+ownerSalary };
                                    });
                                    // Combined net profit for this month across all branches
                                    var monthNet = myFranchises.reduce(function(s,f){
                                      var fMth = f.financials.find(function(fm){ return fm.month===month; });
                                      return fMth ? s + (fMth.income - totalExp(fMth)) : s;
                                    }, 0);

                                    return ownerFigures.map(function(fig, oi){
                                      var isMe = (fig.owner.email||"").toLowerCase()===(user.email||"").toLowerCase();
                                      return (
                                        <tr key={month+"_"+oi} style={{ borderBottom: oi===ownerFigures.length-1?"2px solid rgba(255,255,255,0.06)":"1px solid rgba(255,255,255,0.02)", background:isMe?"rgba(77,231,166,0.02)":"transparent" }}>
                                          {oi===0 && <td rowSpan={ownerFigures.length} style={{ padding:"11px 14px", color:"rgba(224,224,224,0.7)", verticalAlign:"top" }}>{month}</td>}
                                          <td style={{ padding:"11px 14px", color:isMe?"#E0E0E0":"rgba(224,224,224,0.6)", fontWeight:isMe?600:400 }}>
                                            {(fig.owner.name||"").split(" ")[0]}
                                            {isMe && <span style={{ marginLeft:6, fontSize:9, color:"#4DE7A6", background:"rgba(77,231,166,0.1)", padding:"2px 6px", borderRadius:10 }}>you</span>}
                                          </td>
                                          {oi===0 && <td rowSpan={ownerFigures.length} style={{ padding:"11px 14px", textAlign:"right", color:monthNet>=0?"#56B9E9":"#cf6679", fontWeight:500, verticalAlign:"top" }}>{fmt(monthNet)}</td>}
                                          <td style={{ padding:"11px 14px", textAlign:"right", color:fig.share>=0?"#4DE7A6":"#cf6679", fontWeight:500 }}>{fmt(fig.share)}</td>
                                          <td style={{ padding:"11px 14px", textAlign:"right", color:"#56B9E9", fontWeight:500 }}>{fig.salary>0?fmt(fig.salary):"—"}</td>
                                          <td style={{ padding:"11px 14px", textAlign:"right", color:isMe?"#4DE7A6":"rgba(224,224,224,0.5)", fontWeight:isMe?700:400, background:"rgba(255,255,255,0.02)" }}>{fmt(fig.th)}</td>
                                        </tr>
                                      );
                                    });
                                  });
                                })()}
                                {/* Year total row */}
                                {(function(){
                                  var ownerMap2 = {};
                                  myFranchises.forEach(function(f){
                                    (f.owners||[]).forEach(function(o){
                                      var key = (o.email||"").toLowerCase();
                                      if (!ownerMap2[key]) ownerMap2[key] = { name:o.name, email:o.email };
                                    });
                                  });
                                  var allOwners2 = Object.values(ownerMap2);
                                  return allOwners2.map(function(o, oi){
                                    var isMe = (o.email||"").toLowerCase()===(user.email||"").toLowerCase();
                                    var tShare=0; var tSal=0;
                                    // Sum across all months and all branches for this owner
                                    myFranchises.forEach(function(f){
                                      var fOwner=(f.owners||[]).find(function(fo){return (fo.email||"").toLowerCase()===(o.email||"").toLowerCase();});
                                      if(!fOwner) return;
                                      f.financials.forEach(function(fMth){
                                        var match=(fMth.month||"").toString().match(/\b(20\d\d)\b/);
                                        if(!match||parseInt(match[1])!==curYear) return;
                                        var fNet=fMth.income-totalExp(fMth);
                                        var fSalE=(f.salaries||[]).filter(function(s){return s.userEmail&&(s.userEmail||"").toLowerCase()===(o.email||"").toLowerCase()&&parseMonthDate(s.effectiveFrom)<=parseMonthDate(fMth.month);});
                                        fSalE.sort(function(a,b){return parseMonthDate(b.effectiveFrom)-parseMonthDate(a.effectiveFrom);});
                                        var fSal=fSalE.length?fSalE[0].amount:0;
                                        var allFSals2=(f.owners||[]).reduce(function(ss,fo){
                                          var foE=(f.salaries||[]).filter(function(s){return s.userEmail&&(s.userEmail||"").toLowerCase()===(fo.email||"").toLowerCase()&&parseMonthDate(s.effectiveFrom)<=parseMonthDate(fMth.month);});
                                          foE.sort(function(a,b){return parseMonthDate(b.effectiveFrom)-parseMonthDate(a.effectiveFrom);});
                                          return ss+(foE.length?foE[0].amount:0);
                                        },0);
                                        tSal+=fSal; tShare+=(fNet-allFSals2)*parseFloat(fOwner.sharePercent)/100;
                                      });
                                    });
                                    return (
                                      <tr key={"ytot"+oi} style={{ borderTop:oi===0?"2px solid #2A2A2A":"none", background:"#252525" }}>
                                        {oi===0 && <td rowSpan={allOwners2.length} style={{ padding:"11px 14px", color:"rgba(224,224,224,0.45)", fontSize:11, verticalAlign:"top" }}>YEAR TOTAL</td>}
                                        <td style={{ padding:"11px 14px", color:isMe?"#E0E0E0":"rgba(224,224,224,0.6)", fontSize:11, fontWeight:600 }}>{(o.name||"").split(" ")[0]}</td>
                                        {oi===0 && <td rowSpan={allOwners2.length} style={{ padding:"11px 14px", textAlign:"right", color:"#E0E0E0", fontWeight:700, fontFamily:"Playfair Display,serif", verticalAlign:"top" }}>{fmt(yNet)}</td>}
                                        <td style={{ padding:"11px 14px", textAlign:"right", color:"#E0E0E0", fontWeight:700, fontFamily:"Playfair Display,serif" }}>{fmt(tShare)}</td>
                                        <td style={{ padding:"11px 14px", textAlign:"right", color:"#E0E0E0", fontWeight:700, fontFamily:"Playfair Display,serif" }}>{tSal>0?fmt(tSal):"—"}</td>
                                        <td style={{ padding:"11px 14px", textAlign:"right", color:isMe?"#4DE7A6":"rgba(224,224,224,0.5)", fontWeight:700, fontFamily:"Playfair Display,serif", background:"rgba(255,255,255,0.02)" }}>{fmt(tShare+tSal)}</td>
                                      </tr>
                                    );
                                  });
                                })()}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    );
                  })()}

                  {/* Divider before individual branches */}
                  {!activeBranch && myFranchises.length > 1 && (
                    <div style={{ borderTop:"2px solid #2A2A2A", paddingTop:24, marginTop:8, marginBottom:16 }}>
                      <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:16 }}>
                        <div style={{ flex:1, height:1, background:"#2A2A2A" }} />
                        <span style={{ fontSize:11, color:"rgba(224,224,224,0.4)", letterSpacing:"0.1em", whiteSpace:"nowrap" }}>INDIVIDUAL BRANCH DETAILS</span>
                        <div style={{ flex:1, height:1, background:"#2A2A2A" }} />
                      </div>
                    </div>
                  )}
                  {(activeBranch ? [activeBranch] : myFranchises).map(function(currentFranchise) {
                    var branchIsOpen = !activeBranch ? (portalBranchOpen[currentFranchise.id] !== false) : true;
                    return (
                      <div key={currentFranchise.id} style={{ marginBottom:16 }}>
                        {!activeBranch && myFranchises.length > 1 && (
                          <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"12px 16px", background:"#1E1E1E", border:"1px solid #2A2A2A", borderRadius: branchIsOpen ? "10px 10px 0 0" : 10, cursor:"pointer", marginBottom: branchIsOpen ? 0 : 0 }}
                            onClick={function(){ setPortalBranchOpen(function(p){ var n=Object.assign({},p); n[currentFranchise.id]=!branchIsOpen; return n; }); }}>
                            <div>
                              <div style={{ fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:16 }}>{currentFranchise.name}</div>
                              <div style={{ fontSize:12, color:"rgba(224,224,224,0.5)", marginTop:2 }}>{currentFranchise.location}</div>
                            </div>
                            <span style={{ color:"rgba(224,224,224,0.4)", fontSize:14 }}>{branchIsOpen ? "▲" : "▼"}</span>
                          </div>
                        )}
                        {branchIsOpen && (
                        <div style={{ border: !activeBranch && myFranchises.length > 1 ? "1px solid #2A2A2A" : "none", borderTop:"none", borderRadius:"0 0 10px 10px", padding: !activeBranch && myFranchises.length > 1 ? "16px" : "0" }}>
                        {currentFranchise.financials.length === 0
                          ? <div className="card" style={{ color:"rgba(224,224,224,0.45)", fontSize:13, padding:20 }}>No financial data for this branch yet.</div>
                          : (function() {
                            var myFranchise = currentFranchise;
              var sorted = [].concat(myFranchise.financials).sort(function(a,b){ return parseMonthDate(b.month)-parseMonthDate(a.month); });
              var latest = sorted[0];
              var prev = sorted[1] || null;
              var latestNet = latest.income - totalExp(latest);
              var latestMargin = latest.income > 0 ? latestNet/latest.income*100 : 0;
              var prevMarginV = prev && prev.income > 0 ? (prev.income-totalExp(prev))/prev.income*100 : null;
              var marginDiff = prevMarginV !== null ? latestMargin - prevMarginV : null;
              var yearMap = {};
              myFranchise.financials.forEach(function(m) {
                var match = m.month && m.month.toString().match(/(20[0-9][0-9])/);
                if (!match) return;
                var yr = match[1];
                if (!yearMap[yr]) yearMap[yr] = { income:0, net:0 };
                yearMap[yr].income += m.income; yearMap[yr].net += m.income - totalExp(m);
              });
              var yearRows = Object.keys(yearMap).sort(function(a,b){return b-a;}).map(function(yr) {
                var y = yearMap[yr]; return { year:yr, income:y.income, net:y.net, margin:y.income>0?y.net/y.income*100:0 };
              });

              // pagination state via window to avoid hooks
              var pgKey = "fportal_mpage_" + (myFranchise.id||"");
              var pg = parseInt(window[pgKey]||"0")||0;
              var pageSize = 12;
              var totalPgs = Math.ceil(sorted.length/pageSize);
              var safePg = Math.min(pg, totalPgs-1);
              var pgMonths = sorted.slice(safePg*pageSize, safePg*pageSize+pageSize);

              // Franchisee P&L
              var owners = (myFranchise.owners||[]).filter(function(o){return o.name&&o.sharePercent&&o.isCurrent!==false;});
              var allPlYears = yearRows.map(function(y){ return y.year; });
              var invYear = portalYear && allPlYears.indexOf(portalYear) !== -1 ? portalYear : (allPlYears[0] || new Date().getFullYear().toString());
              var plMthsF = sorted.filter(function(m){ var match=m.month&&m.month.toString().match(/(20[0-9][0-9])/); return match&&match[1]===invYear; });
              var hasPrevYear = allPlYears.indexOf(invYear) < allPlYears.length - 1;
              var hasNextYear = allPlYears.indexOf(invYear) > 0;

              return (
                <div style={{ display:"flex", flexDirection:"column", gap:22 }}>
                  {/* Margin summary cards */}
                  <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:12 }}>
                    <div className="card" style={{ padding:16, borderLeft:"3px solid #56B9E9" }}>
                      <div className="label" style={{ marginBottom:6 }}>LATEST MARGIN</div>
                      <div style={{ fontFamily:"Playfair Display,serif", fontWeight:800, fontSize:22, color:"#56B9E9" }}>{pct(latestMargin)}</div>
                      <div style={{ fontSize:11, color:"rgba(224,224,224,0.45)", marginTop:3 }}>{latest.month}</div>
                      {marginDiff !== null && <div style={{ fontSize:11, marginTop:4, color:marginDiff>=0?"#4DE7A6":"#cf6679" }}>{marginDiff>=0?"▲":"▼"} {Math.abs(marginDiff).toFixed(1)}% vs prev month</div>}
                    </div>
                    <div className="card" style={{ padding:16, borderLeft:"3px solid #4DE7A6" }}>
                      <div className="label" style={{ marginBottom:6 }}>PREVIOUS MONTH</div>
                      <div style={{ fontFamily:"Playfair Display,serif", fontWeight:800, fontSize:22, color:"#4DE7A6" }}>{prevMarginV !== null ? pct(prevMarginV) : "—"}</div>
                      <div style={{ fontSize:11, color:"rgba(224,224,224,0.45)", marginTop:3 }}>{prev ? prev.month : "No data"}</div>
                    </div>
                    <div className="card" style={{ padding:16, borderLeft:"3px solid #cf6679" }}>
                      <div className="label" style={{ marginBottom:6 }}>THIS YEAR ({yearRows[0]?yearRows[0].year:"—"})</div>
                      <div style={{ fontFamily:"Playfair Display,serif", fontWeight:800, fontSize:22, color:"#cf6679" }}>{yearRows[0]?pct(yearRows[0].margin):"—"}</div>
                      <div style={{ fontSize:11, color:"rgba(224,224,224,0.45)", marginTop:3 }}>{yearRows[0]?fmt(yearRows[0].net)+" net profit":""}</div>
                    </div>
                  </div>

                  {/* Yearly margins table */}
                  {yearRows.length > 0 && (
                    <div className="card" style={{ padding:0, overflow:"hidden" }}>
                      <div style={{ padding:"14px 18px" }}><label className="label" style={{ margin:0 }}>YEARLY MARGINS</label></div>
                      <table style={{ width:"100%", borderCollapse:"collapse", fontSize:12 }}>
                        <thead><tr style={{ borderBottom:"1px solid #2A2A2A" }}>
                          {["YEAR","TOTAL INCOME","TOTAL EXPENSES","NET PROFIT","MARGIN"].map(function(h){ return <th key={h} style={{ padding:"10px 18px", textAlign:"left", fontSize:10, letterSpacing:"0.08em", color:"rgba(224,224,224,0.45)", fontWeight:700 }}>{h}</th>; })}
                        </tr></thead>
                        <tbody>
                          {yearRows.map(function(y) {
                            var exp = y.income - y.net;
                            return (
                              <tr key={y.year} style={{ borderBottom:"1px solid rgba(255,255,255,0.04)" }}>
                                <td style={{ padding:"12px 18px", fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:14, color:"#E0E0E0" }}>{y.year}</td>
                                <td style={{ padding:"12px 18px", color:"#56B9E9", fontWeight:600 }}>{fmt(y.income)}</td>
                                <td style={{ padding:"12px 18px", color:"#cf6679", fontWeight:600 }}>{fmt(exp)}</td>
                                <td style={{ padding:"12px 18px", color:y.net>=0?"#4DE7A6":"#cf6679", fontWeight:700 }}>{fmt(y.net)}</td>
                                <td style={{ padding:"12px 18px" }}>
                                  <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                                    <div style={{ flex:1, background:"rgba(255,255,255,0.06)", borderRadius:4, height:6, overflow:"hidden" }}>
                                      <div style={{ width:Math.min(Math.abs(y.margin),100)+"%", background:y.margin>=0?"#4DE7A6":"#cf6679", height:"100%", borderRadius:4 }} />
                                    </div>
                                    <span style={{ color:y.margin>=0?"#4DE7A6":"#cf6679", fontWeight:700, minWidth:42, textAlign:"right" }}>{pct(y.margin)}</span>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  )}

                  {/* Monthly margin history with pagination */}
                  {sorted.length > 1 && (
                    <div className="card" style={{ padding:0, overflow:"hidden" }}>
                      <div style={{ padding:"14px 18px", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                        <label className="label" style={{ margin:0 }}>MONTHLY MARGIN HISTORY</label>
                        <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                          <button className="btn btn-secondary btn-sm" style={{ padding:"5px 10px", opacity:safePg<totalPgs-1?1:0.3 }}
                            onClick={function(){ if(safePg<totalPgs-1){ window[pgKey]=safePg+1; setPortalView("overview"); } }}>←</button>
                          <span style={{ fontSize:12, color:"rgba(224,224,224,0.45)", minWidth:120, textAlign:"center" }}>{pgMonths.length>0?pgMonths[pgMonths.length-1].month:""} — {pgMonths.length>0?pgMonths[0].month:""}</span>
                          <button className="btn btn-secondary btn-sm" style={{ padding:"5px 10px", opacity:safePg>0?1:0.3 }}
                            onClick={function(){ if(safePg>0){ window[pgKey]=safePg-1; setPortalView("overview"); } }}>→</button>
                        </div>
                      </div>
                      <table style={{ width:"100%", borderCollapse:"collapse", fontSize:12 }}>
                        <thead><tr style={{ borderBottom:"1px solid #2A2A2A" }}>
                          {["MONTH","INCOME","NET PROFIT","MARGIN","TREND"].map(function(h){ return <th key={h} style={{ padding:"10px 18px", textAlign:"left", fontSize:10, letterSpacing:"0.08em", color:"rgba(224,224,224,0.45)", fontWeight:700 }}>{h}</th>; })}
                        </tr></thead>
                        <tbody>
                          {pgMonths.map(function(m, mi) {
                            var net = m.income - totalExp(m);
                            var margin = m.income > 0 ? net/m.income*100 : 0;
                            var prevM = sorted[safePg*pageSize+mi+1];
                            var prevMgn = prevM&&prevM.income>0?(prevM.income-totalExp(prevM))/prevM.income*100:null;
                            var diff = prevMgn!==null?margin-prevMgn:null;
                            return (
                              <tr key={m.month} style={{ borderBottom:"1px solid rgba(255,255,255,0.04)" }}>
                                <td style={{ padding:"10px 18px", color:"#E0E0E0", fontWeight:500 }}>{m.month}</td>
                                <td style={{ padding:"10px 18px", color:"#56B9E9" }}>{fmt(m.income)}</td>
                                <td style={{ padding:"10px 18px", color:net>=0?"#4DE7A6":"#cf6679", fontWeight:600 }}>{fmt(net)}</td>
                                <td style={{ padding:"10px 18px", color:margin>=0?"#4DE7A6":"#cf6679", fontWeight:700 }}>{pct(margin)}</td>
                                <td style={{ padding:"10px 18px", fontSize:11, color:diff===null?"rgba(224,224,224,0.3)":diff>=0?"#4DE7A6":"#cf6679" }}>
                                  {diff===null?"—":(diff>=0?"▲ +":"▼ ")+diff.toFixed(1)+"%"}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  )}

                  {/* Financials table (read-only, year nav) */}
                  {(function() {
                    var allYrs = Array.from(new Set(myFranchise.financials.map(function(m){ var match=m.month&&m.month.toString().match(/(20[0-9][0-9])/); return match?parseInt(match[1]):null; }).filter(Boolean))).sort(function(a,b){return b-a;});
                    if (!allYrs.length) return null;
                    var curYr = portalYear && allYrs.indexOf(parseInt(portalYear)) !== -1 ? parseInt(portalYear) : allYrs[0];
                    var curYrIdx = allYrs.indexOf(curYr);
                    var hasPrevFin = curYrIdx < allYrs.length - 1;
                    var hasNextFin = curYrIdx > 0;
                    var yrMths = sorted.filter(function(m){ var match=m.month&&m.month.toString().match(/(20[0-9][0-9])/); return match&&parseInt(match[1])===curYr; });
                    var yInc = yrMths.reduce(function(s,m){return s+m.income;},0);
                    var yExp = yrMths.reduce(function(s,m){return s+totalExp(m);},0);
                    return (
                      <div>
                        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:10 }}>
                          <label className="label" style={{ margin:0 }}>FINANCIALS</label>
                          <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                            <button className="btn btn-secondary btn-sm" style={{ padding:"5px 10px", opacity:hasPrevFin?1:0.3 }} onClick={function(){ if(hasPrevFin) setPortalYear(String(allYrs[curYrIdx+1])); }}>←</button>
                            <span style={{ fontSize:13, fontWeight:600, color:"#E0E0E0", minWidth:40, textAlign:"center" }}>{curYr}</span>
                            <button className="btn btn-secondary btn-sm" style={{ padding:"5px 10px", opacity:hasNextFin?1:0.3 }} onClick={function(){ if(hasNextFin) setPortalYear(String(allYrs[curYrIdx-1])); }}>→</button>
                          </div>
                        </div>
                        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:8, marginBottom:12 }}>
                          <div style={{ background:"#252525", borderRadius:8, padding:"10px 14px" }}>
                            <div style={{ fontSize:9, color:"rgba(224,224,224,0.45)", letterSpacing:"0.1em", marginBottom:3 }}>YEAR INCOME</div>
                            <div style={{ color:"#56B9E9", fontWeight:700, fontSize:16, fontFamily:"Playfair Display,serif" }}>{fmt(yInc)}</div>
                          </div>
                          <div style={{ background:"#252525", borderRadius:8, padding:"10px 14px" }}>
                            <div style={{ fontSize:9, color:"rgba(224,224,224,0.45)", letterSpacing:"0.1em", marginBottom:3 }}>YEAR EXPENSES</div>
                            <div style={{ color:"#cf6679", fontWeight:700, fontSize:16, fontFamily:"Playfair Display,serif" }}>{fmt(yExp)}</div>
                          </div>
                          <div style={{ background:"#252525", borderRadius:8, padding:"10px 14px" }}>
                            <div style={{ fontSize:9, color:"rgba(224,224,224,0.45)", letterSpacing:"0.1em", marginBottom:3 }}>YEAR NET PROFIT</div>
                            <div style={{ color:yInc-yExp>=0?"#4DE7A6":"#cf6679", fontWeight:700, fontSize:16, fontFamily:"Playfair Display,serif" }}>{fmt(yInc-yExp)}</div>
                          </div>
                        </div>
                        <div className="card" style={{ padding:0, overflow:"hidden", overflowX:"auto" }}>
                          <table style={{ width:"100%", borderCollapse:"collapse", fontSize:12, minWidth:600 }}>
                            <thead><tr style={{ borderBottom:"1px solid #2A2A2A" }}>{["MONTH","INCOME","RENT","SALARIES","ROYALTY","OTHER","TOTAL EXP","NET PROFIT"].map(function(h){ return <th key={h} style={{ padding:"11px 14px", textAlign:"left", fontSize:10, letterSpacing:"0.1em", color:"rgba(224,224,224,0.45)", fontWeight:700, whiteSpace:"nowrap" }}>{h}</th>; })}</tr></thead>
                            <tbody>
                              {yrMths.length===0
                                ? <tr><td colSpan={8} style={{ padding:"22px 14px", color:"rgba(224,224,224,0.45)", textAlign:"center" }}>No data yet</td></tr>
                                : yrMths.map(function(m){ var exp=totalExp(m); var net=m.income-exp; return (
                                  <tr key={m.month} style={{ borderBottom:"1px solid rgba(255,255,255,0.04)" }}>
                                    <td style={{ padding:"11px 14px", color:"rgba(224,224,224,0.7)" }}>{m.month}</td>
                                    <td style={{ padding:"11px 14px", color:"#56B9E9" }}>{fmt(m.income)}</td>
                                    <td style={{ padding:"11px 14px", color:"rgba(224,224,224,0.6)" }}>{fmt(m.rent||0)}</td>
                                    <td style={{ padding:"11px 14px", color:"rgba(224,224,224,0.6)" }}>{fmt(m.salaries||0)}</td>
                                    <td style={{ padding:"11px 14px", color:"rgba(224,224,224,0.6)" }}>{fmt(m.royalty||0)}</td>
                                    <td style={{ padding:"11px 14px", color:"rgba(224,224,224,0.6)" }}>{fmt(m.otherExpenses||0)}</td>
                                    <td style={{ padding:"11px 14px", color:"#cf6679", fontWeight:500 }}>{fmt(exp)}</td>
                                    <td style={{ padding:"11px 14px", color:net>=0?"#4DE7A6":"#cf6679", fontWeight:600 }}>{fmt(net)}</td>
                                  </tr>
                                ); })
                              }
                            </tbody>
                          </table>
                        </div>
                      </div>
                    );
                  })()}

                  {/* Franchisee P&L (read-only) */}
                  {owners.length > 0 && plMthsF.length > 0 && (
                    <div>
                      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:10 }}>
                        <label className="label" style={{ margin:0 }}>FRANCHISEE PROFIT & LOSS</label>
                        <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                          <button className="btn btn-secondary btn-sm" style={{ padding:"5px 10px", opacity:hasPrevYear?1:0.3 }} onClick={function(){ if(hasPrevYear) setPortalYear(allPlYears[allPlYears.indexOf(invYear)+1]); }}>←</button>
                          <span style={{ fontSize:13, fontWeight:600, color:"#E0E0E0", minWidth:40, textAlign:"center" }}>{invYear}</span>
                          <button className="btn btn-secondary btn-sm" style={{ padding:"5px 10px", opacity:hasNextYear?1:0.3 }} onClick={function(){ if(hasNextYear) setPortalYear(allPlYears[allPlYears.indexOf(invYear)-1]); }}>→</button>
                        </div>
                      </div>
                      <div className="card" style={{ padding:0, overflow:"hidden" }}>
                        <table style={{ width:"100%", borderCollapse:"collapse", fontSize:12 }}>
                          <thead><tr style={{ borderBottom:"1px solid #2A2A2A" }}>
                            <th style={{ padding:"11px 14px", textAlign:"left", fontSize:10, letterSpacing:"0.1em", color:"rgba(224,224,224,0.45)", fontWeight:700 }}>MONTH</th>
                            <th style={{ padding:"11px 14px", textAlign:"left", fontSize:10, letterSpacing:"0.1em", color:"rgba(224,224,224,0.45)", fontWeight:700 }}>FRANCHISEE</th>
                            <th style={{ padding:"11px 14px", textAlign:"right", fontSize:10, letterSpacing:"0.1em", color:"rgba(224,224,224,0.45)", fontWeight:700 }}>NET PROFIT</th>
                            <th style={{ padding:"11px 14px", textAlign:"right", fontSize:10, letterSpacing:"0.1em", color:"#4DE7A6", fontWeight:700 }}>SHARE</th>
                            <th style={{ padding:"11px 14px", textAlign:"right", fontSize:10, letterSpacing:"0.1em", color:"#56B9E9", fontWeight:700 }}>SALARY</th>
                            <th style={{ padding:"11px 14px", textAlign:"right", fontSize:10, letterSpacing:"0.1em", color:"#E0E0E0", fontWeight:700, background:"rgba(255,255,255,0.03)" }}>TH</th>
                          </tr></thead>
                          <tbody>
                            {/* Rolled Over Balance row */}
                            {owners.filter(function(o){ return parseFloat(o.openingBalance||0) > 0; }).map(function(o, oi){
                              var ob = parseFloat(o.openingBalance||0);
                              return (
                                <tr key={"ob-"+oi} style={{ borderBottom:"2px solid rgba(207,183,100,0.3)", background:"rgba(207,183,100,0.04)" }}>
                                  <td style={{ padding:"11px 14px", color:"#CFB764", fontWeight:700, fontSize:12 }}>Rolled Over Balance</td>
                                  <td style={{ padding:"11px 14px", color:"#CFB764", fontSize:12 }}>{o.name}</td>
                                  <td style={{ padding:"11px 14px", textAlign:"right", color:"#CFB764" }}>—</td>
                                  <td style={{ padding:"11px 14px", textAlign:"right", color:"#CFB764" }}>—</td>
                                  <td style={{ padding:"11px 14px", textAlign:"right", color:"#CFB764" }}>—</td>
                                  <td style={{ padding:"11px 14px", textAlign:"right", color:"#CFB764", background:"rgba(255,255,255,0.03)", fontWeight:700 }}>{fmt(ob)}</td>
                                </tr>
                              );
                            })}
                            {plMthsF.map(function(m){
                              var net = m.income - totalExp(m);
                              var franchiseSalEntries = (salaryData[currentFranchise.id] && salaryData[currentFranchise.id].length)
                                ? salaryData[currentFranchise.id]
                                : (currentFranchise.salaries || []);
                              // Match owner to userId using email in salary entries
                              var getOwnerUserIdFromSal = function(o) {
                                var match = franchiseSalEntries.find(function(s){
                                  return s.userEmail && (s.userEmail||"").toLowerCase() === (o.email||"").toLowerCase();
                                });
                                if (match) return match.userId;
                                if ((o.email||"").toLowerCase() === (user.email||"").toLowerCase()) return user.id;
                                return null;
                              };
                              var totalSals = owners.reduce(function(s,o){
                                return s + getActiveSalary(currentFranchise.id, m.month, getOwnerUserIdFromSal(o));
                              }, 0);
                              var afterSalary = net - totalSals;
                              return owners.map(function(o, oi){
                                var isMe = (o.email||"").toLowerCase()===(user.email||"").toLowerCase();
                                var oUserId = getOwnerUserIdFromSal(o);
                                var oSal = getActiveSalary(currentFranchise.id, m.month, oUserId);
                              var share = afterSalary * getShareForMonth(currentFranchise.owners||[], o.email, m.month)/100;
                                var th = oSal + share;
                                return (
                                  <tr key={m.month+"_"+oi} style={{ borderBottom: oi===owners.length-1 ? "2px solid rgba(255,255,255,0.06)" : "1px solid rgba(255,255,255,0.02)", background: isMe?"rgba(77,231,166,0.02)":"transparent" }}>
                                    {oi===0 && <td rowSpan={owners.length} style={{ padding:"11px 14px", color:"rgba(224,224,224,0.7)", verticalAlign:"top" }}>{m.month}</td>}
                                    <td style={{ padding:"11px 14px", color: isMe?"#E0E0E0":"rgba(224,224,224,0.6)", fontWeight: isMe?600:400 }}>
                                      {(o.name||"").split(" ")[0]} <span style={{ color:"rgba(224,224,224,0.35)", fontSize:10 }}>({o.sharePercent}%)</span>
                                      {isMe && <span style={{ marginLeft:6, fontSize:9, color:"#4DE7A6", background:"rgba(77,231,166,0.1)", padding:"2px 6px", borderRadius:10 }}>you</span>}
                                    </td>
                                    {oi===0 && <td rowSpan={owners.length} style={{ padding:"11px 14px", textAlign:"right", color:net>=0?"#56B9E9":"#cf6679", fontWeight:500, verticalAlign:"top" }}>{fmt(net)}</td>}
                                    <td style={{ padding:"11px 14px", textAlign:"right", color:share>=0?"#4DE7A6":"#cf6679", fontWeight:500 }}>{fmt(share)}</td>
                                    <td style={{ padding:"11px 14px", textAlign:"right", color:"#56B9E9", fontWeight:500 }}>{oSal>0?fmt(oSal):"—"}</td>
                                    <td style={{ padding:"11px 14px", textAlign:"right", color: isMe?"#4DE7A6":"rgba(224,224,224,0.5)", fontWeight: isMe?700:400, background:"rgba(255,255,255,0.02)" }}>{fmt(th)}</td>
                                  </tr>
                                );
                              });
                            })}
                            {owners.map(function(o, oi){
                              var isMe = (o.email||"").toLowerCase()===(user.email||"").toLowerCase();
                              var franchiseSalEntries2 = (salaryData[currentFranchise.id] && salaryData[currentFranchise.id].length) ? salaryData[currentFranchise.id] : (currentFranchise.salaries||[]);
                              var getUid2 = function(o2) {
                                var match = franchiseSalEntries2.find(function(s){ return s.userEmail && (s.userEmail||"").toLowerCase()===(o2.email||"").toLowerCase(); });
                                if (match) return match.userId;
                                if ((o2.email||"").toLowerCase()===(user.email||"").toLowerCase()) return user.id;
                                return null;
                              };
                              var oUserId = getUid2(o);
                              var tShare = plMthsF.reduce(function(s,m){
                                var net2=m.income-totalExp(m);
                                var allSal=owners.reduce(function(ss,oo){
                                  return ss+getActiveSalary(currentFranchise.id,m.month,getUid2(oo));
                                },0);
                                return s+(net2-allSal)*parseFloat(o.sharePercent)/100;
                              },0);
                              var tSal = plMthsF.reduce(function(s,m){ return s+getActiveSalary(currentFranchise.id,m.month,oUserId); },0);
                              return (
                                <tr key={"tot"+oi} style={{ borderTop: oi===0?"2px solid #2A2A2A":"none", background:"#252525" }}>
                                  {oi===0 && <td rowSpan={owners.length} style={{ padding:"11px 14px", color:"rgba(224,224,224,0.45)", fontSize:11, verticalAlign:"top" }}>YEAR TOTAL</td>}
                                  <td style={{ padding:"11px 14px", color: isMe?"#E0E0E0":"rgba(224,224,224,0.6)", fontSize:11, fontWeight:600 }}>{(o.name||"").split(" ")[0]}</td>
                                  {oi===0 && <td rowSpan={owners.length} style={{ padding:"11px 14px", textAlign:"right", color:"#E0E0E0", fontWeight:700, fontFamily:"Playfair Display,serif", verticalAlign:"top" }}>{fmt(plMthsF.reduce(function(s,m){return s+m.income-totalExp(m);},0))}</td>}
                                  <td style={{ padding:"11px 14px", textAlign:"right", color:"#E0E0E0", fontWeight:700, fontFamily:"Playfair Display,serif" }}>{fmt(tShare)}</td>
                                  <td style={{ padding:"11px 14px", textAlign:"right", color:"#E0E0E0", fontWeight:700, fontFamily:"Playfair Display,serif" }}>{tSal>0?fmt(tSal):"—"}</td>
                                  <td style={{ padding:"11px 14px", textAlign:"right", color: isMe?"#4DE7A6":"rgba(224,224,224,0.5)", fontWeight:700, fontFamily:"Playfair Display,serif", background:"rgba(255,255,255,0.02)" }}>{fmt(tShare+tSal)}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}

                  {/* Investor P&L (read-only, no paid toggle) */}
                  {myFranchise.investors.length > 0 && plMthsF.length > 0 && (
                    <div>
                      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:10 }}>
                        <label className="label" style={{ margin:0 }}>INVESTOR PROFIT & LOSS</label>
                        <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                          <button className="btn btn-secondary btn-sm" style={{ padding:"5px 10px", opacity:hasPrevYear?1:0.3 }} onClick={function(){ if(hasPrevYear) setPortalYear(allPlYears[allPlYears.indexOf(invYear)+1]); }}>←</button>
                          <span style={{ fontSize:13, fontWeight:600, color:"#E0E0E0", minWidth:40, textAlign:"center" }}>{invYear}</span>
                          <button className="btn btn-secondary btn-sm" style={{ padding:"5px 10px", opacity:hasNextYear?1:0.3 }} onClick={function(){ if(hasNextYear) setPortalYear(allPlYears[allPlYears.indexOf(invYear)-1]); }}>→</button>
                        </div>
                      </div>
                      <div className="card" style={{ padding:0, overflow:"hidden", overflowX:"auto" }}>
                        <table style={{ width:"100%", borderCollapse:"collapse", fontSize:12 }}>
                          <thead><tr style={{ borderBottom:"1px solid #2A2A2A" }}>
                            <th style={{ padding:"11px 14px", textAlign:"left", fontSize:10, letterSpacing:"0.1em", color:"rgba(224,224,224,0.45)", fontWeight:700 }}>MONTH</th>
                            <th style={{ padding:"11px 14px", textAlign:"right", fontSize:10, letterSpacing:"0.1em", color:"rgba(224,224,224,0.45)", fontWeight:700 }}>NET PROFIT</th>
                            {myFranchise.investors.map(function(inv,ii){ var c=PALETTE[ii%PALETTE.length]; return <th key={ii} style={{ padding:"11px 14px", textAlign:"right", fontSize:10, letterSpacing:"0.1em", color:c, fontWeight:700, whiteSpace:"nowrap" }}>{inv.name} ({inv.sharePercent}%)</th>; })}
                            <th style={{ padding:"11px 14px", textAlign:"center", fontSize:10, letterSpacing:"0.1em", color:"rgba(224,224,224,0.45)", fontWeight:700 }}>PAID</th>
                            <th style={{ padding:"11px 14px", textAlign:"left", fontSize:10, letterSpacing:"0.1em", color:"rgba(224,224,224,0.45)", fontWeight:700 }}>DATE PAID</th>
                          </tr></thead>
                          <tbody>
                            {plMthsF.map(function(m){ 
                              var net=m.income-totalExp(m);
                              var allOwnerSalsP=(myFranchise.owners||[]).filter(function(o){return o.isCurrent!==false;}).reduce(function(s,o){var sal=(myFranchise.salaries||[]).filter(function(sl){return (sl.userEmail||"").toLowerCase()===(o.email||"").toLowerCase();}).filter(function(sl){return parseMonthDate(sl.effectiveFrom)<=parseMonthDate(m.month);}).sort(function(a,b){return parseMonthDate(b.effectiveFrom)-parseMonthDate(a.effectiveFrom);});return s+(sal.length?parseFloat(sal[0].amount):0);},0);
                              var afterSalsP=net-allOwnerSalsP;
                              var pKey=myFranchise.id+"_"+m.month;
                              var pmt=portalPayments[pKey]||{paid:false,datePaid:""};
                              return (
                              <tr key={m.month} style={{ borderBottom:"1px solid rgba(255,255,255,0.04)", background:pmt.paid?"rgba(77,231,166,0.03)":"transparent" }}>
                                <td style={{ padding:"11px 14px", color:"rgba(224,224,224,0.7)" }}>{m.month}</td>
                                <td style={{ padding:"11px 14px", textAlign:"right", color:net>=0?"#56B9E9":"#cf6679", fontWeight:500 }}>{fmt(net)}</td>
                                {myFranchise.investors.map(function(inv,ii){ var s=afterSalsP*parseFloat(inv.sharePercent)/100; var c=PALETTE[ii%PALETTE.length]; return <td key={ii} style={{ padding:"11px 14px", textAlign:"right", color:s>=0?c:"#cf6679", fontWeight:500 }}>{fmt(s)}</td>; })}
                                <td style={{ padding:"11px 14px", textAlign:"center" }}>
                                  <span style={{ padding:"3px 12px", borderRadius:20, fontSize:11, fontWeight:600, background:pmt.paid?"rgba(77,231,166,0.12)":"rgba(207,102,121,0.1)", color:pmt.paid?"#4DE7A6":"#cf6679", border:"1px solid "+(pmt.paid?"rgba(77,231,166,0.3)":"rgba(207,102,121,0.25)") }}>
                                    {pmt.paid?"✓ Paid":"Unpaid"}
                                  </span>
                                </td>
                                <td style={{ padding:"11px 14px", color:"rgba(224,224,224,0.5)", fontSize:12 }}>
                                  {pmt.datePaid ? new Date(pmt.datePaid).toLocaleDateString("en-GB") : "—"}
                                </td>
                              </tr>
                            ); })}
                            <tr style={{ borderTop:"2px solid #2A2A2A", background:"#252525" }}>
                              <td style={{ padding:"11px 14px", color:"rgba(224,224,224,0.45)", fontSize:11 }}>YEAR TOTAL</td>
                              <td style={{ padding:"11px 14px", textAlign:"right", color:"#E0E0E0", fontWeight:700, fontFamily:"Playfair Display,serif" }}>{fmt(plMthsF.reduce(function(s,m){return s+m.income-totalExp(m);},0))}</td>
                              {myFranchise.investors.map(function(inv,ii){ var t=plMthsF.reduce(function(s,m){var net2=m.income-totalExp(m);var allSals2=(myFranchise.owners||[]).filter(function(o){return o.isCurrent!==false;}).reduce(function(ss,o){var sal=(myFranchise.salaries||[]).filter(function(sl){return (sl.userEmail||"").toLowerCase()===(o.email||"").toLowerCase();}).filter(function(sl){return parseMonthDate(sl.effectiveFrom)<=parseMonthDate(m.month);}).sort(function(a,b){return parseMonthDate(b.effectiveFrom)-parseMonthDate(a.effectiveFrom);});return ss+(sal.length?parseFloat(sal[0].amount):0);},0);return s+(net2-allSals2)*parseFloat(inv.sharePercent)/100;},0); return <td key={ii} style={{ padding:"11px 14px", textAlign:"right", color:"#E0E0E0", fontWeight:700, fontFamily:"Playfair Display,serif" }}>{fmt(t)}</td>; })}
                              <td colSpan={2} style={{ padding:"11px 14px", color:"rgba(224,224,224,0.45)", fontSize:11 }}>
                                {plMthsF.filter(function(m){ return (portalPayments[myFranchise.id+"_"+m.month]||{}).paid; }).length} / {plMthsF.length} paid
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </div>
              );
            })()}
                        </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              );
            })()}
          </div>
        )}

        {!directorView && portalView === "declare" && (
          <div>
            <div style={{ marginBottom:28 }}>
              <h1 style={{ fontFamily:"Playfair Display,serif", fontWeight:900, fontSize:26, letterSpacing:"-0.03em" }}>Declare Figures</h1>
              <p style={{ color:"rgba(224,224,224,0.6)", fontSize:13, marginTop:4 }}>Submit your monthly income and expenses for admin approval.</p>
            </div>
            {allOverdueMonths.length > 0 && (
              <div style={{ background:"rgba(207,102,121,0.08)", border:"1px solid rgba(207,102,121,0.25)", borderRadius:12, padding:"14px 18px", marginBottom:20 }}>
                <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:10 }}>
                  <span style={{ fontSize:16 }}>⚠</span>
                  <strong style={{ color:"#cf6679", fontSize:13 }}>{allOverdueMonths.length} overdue declaration{allOverdueMonths.length!==1?"s":""}</strong>
                </div>
                <div style={{ display:"flex", flexWrap:"wrap", gap:6 }}>
                  {allOverdueMonths.map(function(item, i){
                    return (
                      <div key={i} style={{ background:"rgba(207,102,121,0.12)", border:"1px solid rgba(207,102,121,0.3)", borderRadius:8, padding:"6px 12px", fontSize:12 }}>
                        <span style={{ color:"#cf6679", fontWeight:600 }}>{item.month}</span>
                        {myFranchises.length > 1 && <span style={{ color:"rgba(224,224,224,0.5)", marginLeft:6 }}>{item.franchise.name}</span>}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
            <div className="card" style={{ marginBottom:28 }}>
              <label className="label" style={{ marginBottom:16 }}>NEW DECLARATION</label>
              {myFranchises.length > 1 && (
                <div style={{ marginBottom:14 }}>
                  <label className="label">BRANCH <span style={{ color:"#cf6679" }}>*</span></label>
                  <select value={declForm.franchiseId} onChange={function(e){ setDeclForm(function(p){ return Object.assign({},p,{franchiseId:e.target.value}); }); }}
                    style={{ background:"#252525", border:"1px solid #2A2A2A", color:declForm.franchiseId?"#E0E0E0":"rgba(224,224,224,0.45)", padding:"11px 14px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none", width:"100%" }}>
                    <option value="">Select branch...</option>
                    {myFranchises.map(function(f){ return <option key={f.id} value={f.id}>{f.name} — {f.location}</option>; })}
                  </select>
                </div>
              )}
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:14 }}>
                <MonthPicker value={declForm.month} onChange={function(v) { setDeclForm(function(p) { return Object.assign({}, p, { month:v }); }); }} />
                <div><label className="label">INCOME (£) <span style={{ color:"#cf6679" }}>*</span></label><input type="number" placeholder="e.g. 85000" value={declForm.income} onChange={function(e) { setDeclForm(function(p) { return Object.assign({}, p, { income:e.target.value }); }); }} /></div>
              </div>
              <div style={{ borderTop:"1px solid #374151", paddingTop:14, marginBottom:14 }}>
                <label className="label" style={{ marginBottom:12 }}>EXPENSE BREAKDOWN</label>
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10 }}>
                  <div><label className="label">RENT (£) <span style={{ color:"#cf6679" }}>*</span></label><input type="number" placeholder="0" value={declForm.rent} onChange={function(e) { setDeclForm(function(p) { return Object.assign({}, p, { rent:e.target.value }); }); }} /></div>
                  <div><label className="label">SALARIES (£) <span style={{ color:"#cf6679" }}>*</span></label><input type="number" placeholder="0" value={declForm.salaries} onChange={function(e) { setDeclForm(function(p) { return Object.assign({}, p, { salaries:e.target.value }); }); }} /></div>
                  <div>
                    <label className="label">ROYALTY (£) <span style={{ color:"rgba(86,185,233,0.6)", fontSize:9, letterSpacing:"0.05em" }}>AUTO-CALCULATED · 12.5%</span></label>
                    <div style={{ background:"#1A1A1A", border:"1px solid #2A2A2A", borderRadius:8, padding:"11px 14px", color:"#56B9E9", fontWeight:600, fontSize:13, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                      <span>{declForm.income ? fmt(parseFloat(declForm.income) * 0.125) : "£0.00"}</span>
                      <span style={{ fontSize:10, color:"rgba(224,224,224,0.35)" }}>12.5% of income</span>
                    </div>
                  </div>
                  <div><label className="label">OTHER (£) <span style={{ color:"#cf6679" }}>*</span></label><input type="number" placeholder="0" value={declForm.otherExpenses} onChange={function(e) { setDeclForm(function(p) { return Object.assign({}, p, { otherExpenses:e.target.value }); }); }} /></div>
                </div>
              </div>
              {(declForm.rent || declForm.salaries || declForm.royalty || declForm.otherExpenses) && (
                <div style={{ background:"#252525", borderRadius:8, padding:"12px 14px", display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14 }}>
                  <span style={{ fontSize:11, color:"rgba(224,224,224,0.6)" }}>TOTAL EXPENSES</span>
                  <span style={{ fontFamily:"Playfair Display,serif", fontWeight:700, color:"#cf6679" }}>{fmt((parseFloat(declForm.rent)||0)+(parseFloat(declForm.salaries)||0)+(parseFloat(declForm.royalty)||0)+(parseFloat(declForm.otherExpenses)||0))}</span>
                </div>
              )}
              {(function(){
                var calcRoyalty = parseFloat(declForm.income) * 0.125 || 0;
                var canSubmit = declForm.month && declForm.income && declForm.rent !== "" && declForm.salaries !== "" && declForm.otherExpenses !== "" && (myFranchises.length <= 1 || declForm.franchiseId);
                return (
                  <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
                    {calcRoyalty > 0 && (
                      <div style={{ background:"rgba(86,185,233,0.06)", border:"1px solid rgba(86,185,233,0.2)", borderRadius:10, padding:"12px 16px" }}>
                        <div style={{ fontSize:11, color:"rgba(224,224,224,0.5)", marginBottom:6 }}>PAYMENT SUMMARY</div>
                        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                          <div>
                            <div style={{ fontSize:13, color:"#E0E0E0" }}>Revenue declared: <strong style={{ color:"#56B9E9" }}>{fmt(parseFloat(declForm.income)||0)}</strong></div>
                            <div style={{ fontSize:13, color:"#E0E0E0", marginTop:4 }}>Royalty due (12.5%): <strong style={{ color:"#4DE7A6" }}>{fmt(calcRoyalty)}</strong></div>
                          </div>
                        </div>
                        <div style={{ fontSize:11, color:"rgba(224,224,224,0.45)", marginTop:10 }}>
                          Clicking "Submit & Pay" will save your declaration and take you to JotForm to complete your payment. The amount is pre-filled — you only need to enter your card details.
                        </div>
                      </div>
                    )}
                    <div style={{ display:"flex", gap:10 }}>
                      <button className="btn btn-primary" style={{ flex:1 }} onClick={function(){
                        if (!canSubmit) return;
                        // Build URL and open JotForm FIRST, then save declaration
                        var declFranchise2 = declForm.franchiseId ? myFranchises.find(function(f){ return f.id === declForm.franchiseId; }) : (myFranchises.length === 1 ? myFranchises[0] : null);
                        var branch = declFranchise2 ? declFranchise2.name : "";
                        var month = (declForm.month||"").split(" ")[0];
                        var year = (declForm.month||"").split(" ")[1] || "";
                        var revenue = parseFloat(declForm.income) || 0;
                        var royalty = revenue * 0.125;
                        // Split name into first/last
                        var nameParts = (user.name||"").trim().split(" ");
                        var firstName = nameParts[0] || "";
                        var lastName = nameParts.slice(1).join(" ") || "";
                        // JotForm pre-fill using unique field names
                        // Using text fields (branch2, month2, year2) instead of hidden dropdowns
                        var fullMonth = (function(){
                          var months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
                          var idx = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"].indexOf(month);
                          return idx !== -1 ? months[idx] : month;
                        })();
                        var jotformUrl = "https://form.jotform.com/252783975723067"
                          + "?name[first]=" + encodeURIComponent(firstName)
                          + "&name[last]=" + encodeURIComponent(lastName)
                          + "&branch2=" + encodeURIComponent(branch)
                          + "&month2=" + encodeURIComponent(fullMonth)
                          + "&year2=" + encodeURIComponent(year)
                          + "&totalRevenue=" + encodeURIComponent(revenue.toFixed(2))
                          + "&royalty=" + encodeURIComponent(royalty.toFixed(2))
                          + "&myProducts[price][0]=" + encodeURIComponent(royalty.toFixed(2))
                          + "&franchise_id=" + encodeURIComponent(myFranchise.id || "");
                        // Open window FIRST (before async) to avoid popup blocker
                        var jotWin = window.open(jotformUrl, "_blank");
                        // Then submit declaration with payment_type
                        submitDeclaration('submit_and_pay');
                        if (!jotWin) { window.location.href = jotformUrl; }
                      }}>
                        Submit &amp; Pay Royalty ↗
                      </button>
                      <button className="btn btn-secondary" onClick={function(){ submitDeclaration('save_only'); }} style={{ flexShrink:0 }}>
                        Save Only
                      </button>
                    </div>
                  </div>
                );
              })()}
            </div>
            {myDeclarations.length > 0 && (
              <div>
                <label className="label" style={{ marginBottom:12 }}>YOUR SUBMISSIONS</label>
                {/* Search + Filters */}
                <div style={{ display:"flex", flexDirection:"column", gap:8, marginBottom:14 }}>
                  <input placeholder="Search by branch or month..." value={declSearch} onChange={function(e){ setDeclSearch(e.target.value); }}
                    style={{ width:"100%", background:"#1E1E1E", border:"1px solid #2A2A2A", color:"#E0E0E0", padding:"10px 14px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none" }} />
                  <div style={{ display:"flex", gap:8 }}>
                    {myFranchises.length > 1 && (
                      <select value={declFilterBranch} onChange={function(e){ setDeclFilterBranch(e.target.value); }}
                        style={{ flex:1, background:"#1E1E1E", border:"1px solid #2A2A2A", color:"rgba(224,224,224,0.6)", padding:"9px 12px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:12, outline:"none" }}>
                        <option value="all">All Branches</option>
                        {myFranchises.map(function(f){ return <option key={f.id} value={f.id}>{f.name}</option>; })}
                      </select>
                    )}
                    <select value={declFilterMonth} onChange={function(e){ setDeclFilterMonth(e.target.value); }}
                      style={{ flex:1, background:"#1E1E1E", border:"1px solid #2A2A2A", color:"rgba(224,224,224,0.6)", padding:"9px 12px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:12, outline:"none" }}>
                      <option value="all">All Months</option>
                      {Array.from(new Set(myDeclarations.map(function(d){ return d.month; }).filter(Boolean))).sort(function(a,b){ return parseMonthDate(b)-parseMonthDate(a); }).map(function(m){ return <option key={m} value={m}>{m}</option>; })}
                    </select>
                  </div>
                </div>
                <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
                  {[].concat(myDeclarations).reverse().filter(function(d){
                    var q = declSearch.toLowerCase();
                    var matchSearch = !declSearch || (d.franchiseName||"").toLowerCase().includes(q) || (d.month||"").toLowerCase().includes(q);
                    var matchBranch = declFilterBranch==="all" || d.franchiseId===declFilterBranch;
                    var matchMonth = declFilterMonth==="all" || d.month===declFilterMonth;
                    return matchSearch && matchBranch && matchMonth;
                  }).map(function(d) {
                    var isEditRequested = d.editRequested;
                    return (
                      <div key={d.id} className="card" style={{ padding:"16px 20px", border:"1px solid "+(isEditRequested?"rgba(86,185,233,0.3)":"#2A2A2A") }}>
                        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
                          <div style={{ flex:1 }}>
                            <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:6, flexWrap:"wrap" }}>
                              <span style={{ fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:14 }}>{d.franchiseName}</span>
                              <span className="tag" style={{ background:statusBg(d.status), color:statusColor(d.status) }}>{d.status}</span>
                              {d.paymentType === 'submit_and_pay' ? (
                              <span className="tag" style={{ background:"rgba(86,185,233,0.12)", color:"#56B9E9", border:"1px solid rgba(86,185,233,0.3)", fontSize:10 }}>💳 Submit & Pay</span>
                            ) : (
                              <span className="tag" style={{ background:"rgba(224,224,224,0.06)", color:"rgba(224,224,224,0.4)", border:"1px solid rgba(224,224,224,0.12)", fontSize:10 }}>Save Only</span>
                            )}
                            {d.paymentType === 'submit_and_pay' && d.paymentStatus === 'confirmed' && (
                              <span className="tag" style={{ background:"rgba(77,231,166,0.12)", color:"#4DE7A6", border:"1px solid rgba(52,211,153,0.3)", fontSize:10 }}>✅ Payment Confirmed</span>
                            )}
                            {d.paymentType === 'submit_and_pay' && d.paymentStatus === 'pending' && (
                              <span className="tag" style={{ background:"rgba(207,183,100,0.12)", color:"#CFB764", border:"1px solid rgba(207,183,100,0.3)", fontSize:10 }}>⏳ Payment Pending</span>
                            )}
                              {isEditRequested && <span className="tag" style={{ background:"rgba(86,185,233,0.1)", color:"#56B9E9", border:"1px solid rgba(86,185,233,0.3)" }}>Edit requested</span>}
                              <span style={{ fontSize:11, color:"#56B9E9" }}>{d.month}</span>
                            </div>
                            <div style={{ display:"flex", gap:14, fontSize:12, flexWrap:"wrap" }}>
                              <span style={{ color:"#56B9E9" }}>Income: {fmt(d.income)}</span>
                              <span style={{ color:"rgba(224,224,224,0.6)" }}>Rent: {fmt(d.rent)}</span>
                              <span style={{ color:"rgba(224,224,224,0.6)" }}>Salaries: {fmt(d.salaries)}</span>
                              <span style={{ color:"rgba(224,224,224,0.6)" }}>Royalty: {fmt(d.royalty)}</span>
                              <span style={{ color:"#cf6679" }}>Total Exp: {fmt(d.rent+d.salaries+d.royalty+d.otherExpenses)}</span>
                            </div>
                          </div>
                          <div style={{ display:"flex", flexDirection:"column", alignItems:"flex-end", gap:8, marginLeft:16 }}>
                            <div style={{ fontSize:11, color:"#56B9E9" }}>{d.submittedAt ? d.submittedAt.slice(0,10) : ""}</div>
                            {d.status === "approved" && !isEditRequested && (
                              <button className="btn btn-sm" style={{ background:"rgba(86,185,233,0.08)", color:"#56B9E9", border:"1px solid rgba(86,185,233,0.25)", fontSize:11 }}
                                onClick={function(){ setEditRequestId(d.id); setEditRequestNote(""); }}>
                                Request Edit
                              </button>
                            )}
                            {isEditRequested && (
                              <span style={{ fontSize:10, color:"rgba(224,224,224,0.4)" }}>Awaiting admin approval</span>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            {/* Edit Request Modal */}
            {editRequestId && (
              <div className="modal-bg" onClick={function(){ setEditRequestId(null); }}>
                <div className="card fade-in" style={{ width:420, padding:28 }} onClick={function(e){ e.stopPropagation(); }}>
                  <h3 style={{ fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:18, marginBottom:8 }}>Request Edit</h3>
                  <p style={{ fontSize:13, color:"rgba(224,224,224,0.6)", marginBottom:16 }}>Please explain what needs to be corrected. Admin will review your request.</p>
                  <textarea value={editRequestNote} onChange={function(e){ setEditRequestNote(e.target.value); }}
                    placeholder="e.g. I entered the wrong revenue figure, correct amount is £12,500..."
                    style={{ width:"100%", background:"#252525", border:"1px solid #2A2A2A", color:"#E0E0E0", padding:"11px 14px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none", minHeight:100, resize:"vertical" }} />
                  <div style={{ display:"flex", gap:10, marginTop:16 }}>
                    <button className="btn btn-primary" onClick={function(){
                      if (!editRequestNote.trim()) { showToast("Please explain what needs to be corrected."); return; }
                      apiPut("/api/declarations/" + editRequestId + "/edit-request", { note:editRequestNote }).then(function(){
                        DB.getDeclarations().then(function(d){ if(d&&Array.isArray(d)) setDeclarations(d); });
                        setEditRequestId(null); setEditRequestNote("");
                        showToast("Edit request sent to admin.");
                      }).catch(function(){ showToast("Error sending request."); });
                    }}>Send Request</button>
                    <button className="btn btn-secondary" onClick={function(){ setEditRequestId(null); }}>Cancel</button>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {!directorView && portalView === "profit" && (
          <div className="fade-in">
            <h1 style={{ fontFamily:"Playfair Display,serif", fontWeight:900, fontSize:26, marginBottom:16 }}>Profit</h1>
            {/* Summary banner — total owed per person across all branches */}
            {!profitLoading && profitData.length > 0 && (function(){
              var personMap = {};
              profitData.forEach(function(f){
                (f.owners||[]).concat(f.investors||[]).forEach(function(p){
                  if (!personMap[p.name]) personMap[p.name] = { name:p.name, remaining:0, type:p.type };
                  personMap[p.name].remaining += (p.remaining||0);
                });
              });
              var people = Object.values(personMap).sort(function(a,b){ return b.remaining - a.remaining; });
              if (!people.length) return null;
              return (
                <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(180px,1fr))", gap:10, marginBottom:16 }}>
                  {people.map(function(p, i){
                    var color = p.type === "owner" ? "#4DE7A6" : "#7B9EFF";
                    return (
                      <div key={i} className="card" style={{ padding:"12px 16px", borderLeft:"3px solid "+color }}>
                        <div style={{ fontSize:11, color:"rgba(224,224,224,0.5)", marginBottom:4, fontWeight:600 }}>{p.name}</div>
                        <div style={{ fontSize:16, fontWeight:800, color: p.remaining >= 0 ? color : "#cf6679" }}>{fmt(p.remaining)}</div>
                        <div style={{ fontSize:9, color:"rgba(224,224,224,0.35)", marginTop:2, letterSpacing:"0.08em" }}>TOTAL REMAINING</div>
                      </div>
                    );
                  })}
                </div>
              );
            })()}
            <input placeholder="Search branches or people..." value={profitTopSearch} onChange={function(e){ setProfitTopSearch(e.target.value); }} style={{ marginBottom:16, width:"100%" }} />
            {profitLoading ? <div style={{ color:"#56B9E9" }}>Loading...</div> : (
              <div style={{ display:"flex", flexDirection:"column", gap:16 }}>
                {profitData.filter(function(f){
                  if (!profitTopSearch) return true;
                  var q = profitTopSearch.toLowerCase();
                  return (f.franchiseName||'').toLowerCase().includes(q) || (f.owners||[]).concat(f.investors||[]).some(function(p){ return (p.name||'').toLowerCase().includes(q); });
                }).map(function(f) {
                  var allPeople = (f.owners||[]).concat(f.investors||[]);
                  return (
                    <div key={f.franchiseId} className="card" style={{ padding:"16px 18px" }}>
                      <div style={{ fontWeight:700, fontSize:15, color:"#E0E0E0", marginBottom:12 }}>{f.franchiseName}</div>
                      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:16 }}>
                        {allPeople.map(function(person, pi) {
                          var color = person.type === "owner" ? "#4DE7A6" : "#7B9EFF";
                          var isMe = (person.email||"").toLowerCase() === (user.email||"").toLowerCase();
                          return (
                            <div key={pi} className="card" style={{ padding:"13px 16px", borderLeft:"3px solid "+color, opacity: isMe ? 1 : 0.7 }}>
                              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:10 }}>
                                <div>
                                  <div style={{ fontWeight:600, fontSize:13, color:"#E0E0E0" }}>{person.name} {isMe && <span style={{ fontSize:10, color:color, background:color+"15", padding:"1px 6px", borderRadius:10 }}>you</span>}</div>
                                  <div style={{ fontSize:10, color:"rgba(224,224,224,0.5)", marginTop:2 }}>{person.type === "owner" ? "Franchisee" : "Investor"} · {person.sharePercent}%</div>
                                </div>
                                {(function(){
                                  var headId = f.headOfCentre;
                                  var isHOC = headId && user && headId === user.id;
                                  var noHOCSet = !headId;
                                  // Only HOC can take profit. If no HOC set, anyone can.
                                  var canTake = person.type === "owner" && (isHOC || noHOCSet);
                                  if (!canTake) return null;
                                  return (
                                    <button className="btn btn-sm" style={{ background:color+"15", color:color, border:"1px solid "+color+"40", fontSize:11 }}
                                      onClick={function(){
                                        var today = new Date().toISOString().split("T")[0];
                                        setWithdrawModal({ franchiseId:f.franchiseId, userId:person.userId, name:person.name, franchiseName:f.franchiseName, email:person.email });
                                        setWithdrawForm({ amount:"", method:"Bank Transfer", date:today, notes:"" });
                                      }}>+ Take Profit</button>
                                  );
                                })()}
                              </div>
                              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:8 }}>
                                <div><div style={{ fontSize:9, color:"rgba(224,224,224,0.45)", letterSpacing:"0.08em", marginBottom:2 }}>TOTAL OWED</div><div style={{ fontSize:13, fontWeight:700, color: person.totalOwed>=0?color:"#cf6679" }}>{fmt(person.totalOwed)}</div></div>
                                <div><div style={{ fontSize:9, color:"rgba(224,224,224,0.45)", letterSpacing:"0.08em", marginBottom:2 }}>TAKEN</div><div style={{ fontSize:13, fontWeight:700, color:"rgba(224,224,224,0.5)" }}>{fmt(person.totalTaken)}</div></div>
                                <div><div style={{ fontSize:9, color:"rgba(224,224,224,0.45)", letterSpacing:"0.08em", marginBottom:2 }}>REMAINING</div><div style={{ fontSize:13, fontWeight:800, color: person.remaining>=0?"#4DE7A6":"#cf6679" }}>{fmt(person.remaining)}</div></div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      {/* P&L button */}
                      {(function(){
                        var franchise = franchises.find(function(fr){ return fr.id === f.franchiseId; }) || myFranchises.find(function(fr){ return fr.id === f.franchiseId; });
                        if (!franchise || !franchise.financials || !franchise.financials.length) return null;
                        var showPL = profitPLFranchise === f.franchiseId;
                        var allMths2 = franchise.financials.slice().sort(function(a,b){ return new Date('01 '+b.month)-new Date('01 '+a.month); });
                        var availYears2 = Array.from(new Set(allMths2.map(function(m){ var match=(m.month||'').match(/(\d{4})/); return match?parseInt(match[1]):null; }).filter(Boolean))).sort(function(a,b){return b-a;});
                        var mths = allMths2.filter(function(m){ return (m.month||'').includes(String(profitPLYear)); });
                        var allOwners = (franchise.owners || []).filter(function(o){ return o.isCurrent !== false; });
                        return (
                          <div style={{ marginTop:12 }}>
                            <div style={{ display:"flex", gap:8, flexWrap:"wrap", marginBottom: (showPL || profitHistFranchise===f.franchiseId) ? 12 : 0 }}>
                              <button className="btn btn-sm btn-secondary" onClick={function(){ setProfitPLFranchise(showPL?null:f.franchiseId); }}>
                                {showPL?"Hide P&L ▲":"View Monthly P&L ▼"}
                              </button>
                              <button className="btn btn-sm btn-secondary" onClick={function(){ setProfitHistFranchise(profitHistFranchise===f.franchiseId?null:f.franchiseId); setProfitHistSearch(''); }}>
                                {profitHistFranchise===f.franchiseId?"Hide History ▲":"Profit Taken History ▼"}
                              </button>
                            </div>
                            {showPL && (
                              <div style={{ overflowX:"auto", marginTop:10 }}>
                              <div style={{ display:"flex", alignItems:"center", justifyContent:"flex-end", gap:8, marginBottom:10 }}>
                                <button className="btn btn-sm btn-secondary" style={{ padding:"3px 10px" }}
                                  onClick={function(){ var idx=availYears2.indexOf(profitPLYear); if(idx<availYears2.length-1) setProfitPLYear(availYears2[idx+1]); }}>‹</button>
                                <span style={{ fontSize:13, fontWeight:700, color:"#E0E0E0", minWidth:40, textAlign:"center" }}>{profitPLYear}</span>
                                <button className="btn btn-sm btn-secondary" style={{ padding:"3px 10px" }}
                                  onClick={function(){ var idx=availYears2.indexOf(profitPLYear); if(idx>0) setProfitPLYear(availYears2[idx-1]); }}>›</button>
                              </div>
                                <table style={{ width:"100%", borderCollapse:"collapse", fontSize:12 }}>
                                  <thead><tr style={{ borderBottom:"1px solid #2A2A2A" }}>
                                    <th style={{ padding:"8px 12px", textAlign:"left", fontSize:10, color:"rgba(224,224,224,0.45)", fontWeight:700 }}>MONTH</th>
                                    <th style={{ padding:"8px 12px", textAlign:"right", fontSize:10, color:"rgba(224,224,224,0.45)", fontWeight:700 }}>NET PROFIT</th>
                                    {allOwners.map(function(o,oi){ return <th key={oi} style={{ padding:"8px 12px", textAlign:"right", fontSize:10, color:"#4DE7A6", fontWeight:700 }}>{o.name.split(" ")[0]}</th>; })}
                                  </tr></thead>
                                  <tbody>
                                    {mths.map(function(m){
                                      var net = m.income - m.rent - m.salaries - m.royalty - m.otherExpenses;
                                      var allOwnerSals = allOwners.reduce(function(s,o){
                                        var sal = (franchise.salaries||[]).filter(function(sl){ return (sl.userEmail||"").toLowerCase()===(o.email||"").toLowerCase(); }).sort(function(a,b){ return new Date('01 '+b.effectiveFrom)-new Date('01 '+a.effectiveFrom); });
                                        return s+(sal.length?parseFloat(sal[0].amount):0);
                                      },0);
                                      return (
                                        <tr key={m.month} style={{ borderBottom:"1px solid rgba(255,255,255,0.04)" }}>
                                          <td style={{ padding:"8px 12px", color:"rgba(224,224,224,0.6)" }}>{m.month}</td>
                                          <td style={{ padding:"8px 12px", textAlign:"right", color:net>=0?"#56B9E9":"#cf6679", fontWeight:600 }}>{fmt(net)}</td>
                                          {allOwners.map(function(o,oi){
                                            var sal = (franchise.salaries||[]).filter(function(sl){ return (sl.userEmail||"").toLowerCase()===(o.email||"").toLowerCase(); }).sort(function(a,b){ return new Date('01 '+b.effectiveFrom)-new Date('01 '+a.effectiveFrom); });
                                            var oSal = sal.length?parseFloat(sal[0].amount):0;
                                            var th = (net-allOwnerSals)*parseFloat(o.sharePercent||0)/100+oSal;
                                            var isMe = (o.email||"").toLowerCase()===(user.email||"").toLowerCase();
                                            return <td key={oi} style={{ padding:"8px 12px", textAlign:"right", color:th>=0?"#4DE7A6":"#cf6679", fontWeight:isMe?700:400 }}>{fmt(th)}</td>;
                                          })}
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </div>
                            )}
                            {/* Profit Taken History */}
                            {profitHistFranchise === f.franchiseId && (
                              <div style={{ marginTop:8 }}>
                                <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:10 }}>
                                  <input placeholder="Search transactions..." value={profitHistSearch}
                                    onChange={function(e){ setProfitHistSearch(e.target.value); }}
                                    style={{ flex:1, marginRight:12, marginBottom:0 }} />
                                  <div style={{ display:"flex", alignItems:"center", gap:6, flexShrink:0 }}>
                                    <button className="btn btn-sm btn-secondary" style={{ padding:"3px 10px" }}
                                      onClick={function(){ setProfitHistYear(function(y){ return y <= 2025 ? 0 : y-1; }); }}>‹</button>
                                    <span style={{ fontSize:13, fontWeight:700, color:"#E0E0E0", minWidth:40, textAlign:"center" }}>{profitHistYear}</span>
                                    <button className="btn btn-sm btn-secondary" style={{ padding:"3px 10px" }}
                                      onClick={function(){ setProfitHistYear(function(y){ return y+1 <= new Date().getFullYear() ? y+1 : y; }); }}>›</button>
                                  </div>
                                </div>
                                {(function(){
                                  var filtered = (f.withdrawals||[]).filter(function(w){
                                    var yr = w.dateTaken ? new Date(w.dateTaken).getFullYear() : null;
                                    if (profitHistYear !== 0 && yr !== profitHistYear) return false;
                                    if (!profitHistSearch) return true;
                                    var q = profitHistSearch.toLowerCase();
                                    return (w.userName||'').toLowerCase().includes(q) || (w.method||'').toLowerCase().includes(q) || (w.notes||'').toLowerCase().includes(q);
                                  });
                                  if (!filtered.length) return <div style={{ color:"rgba(224,224,224,0.5)", fontSize:13 }}>{profitHistYear === 0 ? "No transactions yet" : "No transactions for " + profitHistYear}</div>;
                                  return filtered.map(function(w,wi){
                                    return (
                                      <div key={wi} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"8px 0", borderBottom:"1px solid rgba(255,255,255,0.04)", fontSize:12 }}>
                                        <div>
                                          <div style={{ fontWeight:600, color:"#E0E0E0" }}>{w.userName}</div>
                                          <div style={{ color:"rgba(224,224,224,0.5)", marginTop:2 }}>{w.method} · {w.dateTaken ? new Date(w.dateTaken).toLocaleDateString("en-GB") : ""}</div>
                                          {w.notes && <div style={{ color:"rgba(224,224,224,0.35)", fontSize:11 }}>{w.notes}</div>}
                                        </div>
                                        <span style={{ color:"#cf6679", fontWeight:700 }}>-{fmt(w.amount)}</span>
                                      </div>
                                    );
                                  });
                                })()}
                              </div>
                            )}
                          </div>
                        );
                      })()}
                    </div>
                  );
                })}
              </div>
            )}
            {/* Withdraw Modal */}
            {withdrawModal && (
              <div className="modal-bg" onClick={function(){ setWithdrawModal(null); }}>
                <div className="card fade-in" style={{ width:440, padding:28 }} onClick={function(e){ e.stopPropagation(); }}>
                  <h3 style={{ fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:18, marginBottom:4 }}>Take Profit</h3>
                  <p style={{ fontSize:12, color:"rgba(224,224,224,0.5)", marginBottom:20 }}>{withdrawModal.name} · {withdrawModal.franchiseName}</p>
                  <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
                    <div><label className="label">AMOUNT (£)</label><input type="number" min="0" step="0.01" placeholder="0.00" value={withdrawForm.amount} onChange={function(e){ setWithdrawForm(function(p){ return Object.assign({},p,{amount:e.target.value}); }); }} /></div>
                    <div><label className="label">DATE</label><input type="date" value={withdrawForm.date} onChange={function(e){ setWithdrawForm(function(p){ return Object.assign({},p,{date:e.target.value}); }); }} /></div>
                    <div>
                      <label className="label">METHOD</label>
                      <div style={{ display:"flex", gap:8, flexWrap:"wrap", marginTop:6 }}>
                        {["Bank Transfer","Card","Cash","Cheque"].map(function(m) {
                          var sel = withdrawForm.method === m;
                          return <button key={m} onClick={function(){ setWithdrawForm(function(p){ return Object.assign({},p,{method:m}); }); }} className="btn btn-sm" style={{ background:sel?"rgba(77,231,166,0.12)":"#1E1E1E", color:sel?"#4DE7A6":"rgba(224,224,224,0.5)", border:"1px solid "+(sel?"rgba(77,231,166,0.3)":"#2A2A2A") }}>{m}</button>;
                        })}
                      </div>
                    </div>
                    <div><label className="label">NOTES (optional)</label><input placeholder="Any notes..." value={withdrawForm.notes} onChange={function(e){ setWithdrawForm(function(p){ return Object.assign({},p,{notes:e.target.value}); }); }} /></div>
                    <div style={{ display:"flex", gap:10, marginTop:4 }}>
                      <button className="btn btn-primary" onClick={function(){
                        if (!withdrawForm.amount || !withdrawForm.date) { showToast("Please enter amount and date."); return; }
                        DB.postWithdrawal({ franchiseId:withdrawModal.franchiseId, userId:withdrawModal.userId, userEmail:withdrawModal.email, amount:parseFloat(withdrawForm.amount), method:withdrawForm.method, dateTaken:withdrawForm.date, notes:withdrawForm.notes||null })
                          .then(function(){
                            setWithdrawModal(null);
                            DB.getProfit().then(function(d){ setProfitData(d||[]); });
                            showToast("Withdrawal recorded!");
                          });
                      }}>Save</button>
                      <button className="btn btn-secondary" onClick={function(){ setWithdrawModal(null); }}>Cancel</button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {!directorView && portalView === "account" && (
          <div className="fade-in">
            <h1 style={{ fontFamily:"Playfair Display,serif", fontWeight:900, fontSize:26, letterSpacing:"-0.03em", marginBottom:8 }}>My Account</h1>
            <p style={{ color:"#56B9E9", fontSize:13, marginBottom:24 }}>Manage your account settings.</p>
            <AccountSection user={user} />

            {/* Salary Management */}
            <div className="card" style={{ marginTop:24 }}>
              <label className="label" style={{ marginBottom:4 }}>MY SALARY PER BRANCH</label>
              <p style={{ fontSize:12, color:"rgba(224,224,224,0.5)", marginBottom:16 }}>Your salary is taken before profits are split.</p>
              {myFranchises.map(function(f){
                var entries = salaryData[f.id] || [];
                var currentSalary = entries.length > 0 ? entries[0] : null;
                var isEditing = salaryForm.franchiseId === f.id;
                var isOpen = showSalaryHistory[f.id];
                var fid = f.id;
                return (
                  <div key={fid} style={{ marginBottom:16, paddingBottom:16, borderBottom:"1px solid #2A2A2A" }}>
                    {/* Branch header */}
                    <div style={{ marginBottom:10 }}>
                      <div style={{ fontWeight:600, fontSize:13, color:"#E0E0E0" }}>{f.name}</div>
                      <div style={{ fontSize:11, color:"rgba(224,224,224,0.45)", marginTop:2 }}>{f.location}</div>
                    </div>

                    {/* Current salary display */}
                    {currentSalary ? (
                      <div style={{ background:"rgba(77,231,166,0.06)", border:"1px solid rgba(77,231,166,0.2)", borderRadius:10, padding:"12px 16px", marginBottom:10, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                        <div>
                          <div style={{ fontSize:11, color:"rgba(224,224,224,0.45)", marginBottom:4 }}>CURRENT SALARY</div>
                          <div style={{ fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:18, color:"#4DE7A6" }}>{fmt(currentSalary.amount)}<span style={{ fontSize:12, fontFamily:"Outfit,sans-serif", color:"rgba(224,224,224,0.45)", marginLeft:4 }}>/month</span></div>
                          <div style={{ fontSize:11, color:"rgba(224,224,224,0.4)", marginTop:3 }}>Effective from {currentSalary.effectiveFrom}</div>
                        </div>
                        <div style={{ display:"flex", flexDirection:"column", gap:6, alignItems:"flex-end" }}>
                          <button className="btn btn-sm btn-secondary" style={{ fontSize:11 }}
                            onClick={function(){ setSalaryForm({ franchiseId:fid, amount:"", effectiveFrom:"" }); }}>
                            ✎ Change Salary
                          </button>
                          {entries.length > 1 && (
                            <button className="btn btn-sm btn-secondary" style={{ fontSize:11 }}
                              onClick={function(){ setShowSalaryHistory(function(s){ var n=Object.assign({},s); n[fid]=!s[fid]; return n; }); }}>
                              {isOpen ? "Hide history" : "History (" + entries.length + ")"}
                            </button>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div style={{ background:"rgba(255,255,255,0.03)", border:"1px dashed #2A2A2A", borderRadius:10, padding:"12px 16px", marginBottom:10, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                        <span style={{ fontSize:12, color:"rgba(224,224,224,0.4)" }}>No salary set yet</span>
                        <button className="btn btn-sm btn-primary" style={{ fontSize:11 }}
                          onClick={function(){ setSalaryForm({ franchiseId:fid, amount:"", effectiveFrom:"" }); }}>
                          + Set Salary
                        </button>
                      </div>
                    )}

                    {/* History */}
                    {isOpen && entries.length > 1 && (
                      <div style={{ background:"#252525", borderRadius:8, padding:"10px 14px", marginBottom:10 }}>
                        <div style={{ fontSize:10, color:"rgba(224,224,224,0.45)", letterSpacing:"0.08em", marginBottom:8 }}>SALARY HISTORY</div>
                        {entries.map(function(s, si){
                          return (
                            <div key={s.id} style={{ display:"flex", justifyContent:"space-between", padding:"6px 0", borderBottom: si < entries.length-1 ? "1px solid rgba(255,255,255,0.06)" : "none", fontSize:12 }}>
                              <span style={{ color:"rgba(224,224,224,0.6)" }}>From {s.effectiveFrom}</span>
                              <span style={{ color:"#4DE7A6", fontWeight:600 }}>{fmt(s.amount)}/month</span>
                            </div>
                          );
                        })}
                      </div>
                    )}

                    {/* Edit form — only shown when editing */}
                    {isEditing && (
                      <div style={{ background:"#252525", border:"1px solid #2A2A2A", borderRadius:10, padding:"14px 16px" }}>
                        <div style={{ fontSize:11, color:"rgba(224,224,224,0.45)", letterSpacing:"0.08em", marginBottom:12 }}>
                          {currentSalary ? "SET NEW SALARY (previous will be kept as history)" : "SET SALARY"}
                        </div>
                        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:12 }}>
                          <div>
                            <label className="label">AMOUNT (£)</label>
                            <input type="number" placeholder="e.g. 2500" value={salaryForm.amount}
                              onChange={function(e){ setSalaryForm(function(s){ return Object.assign({},s,{amount:e.target.value}); }); }}
                              style={{ background:"#1E1E1E", border:"1px solid #374151", color:"#E0E0E0", padding:"10px 12px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none", width:"100%" }} />
                          </div>
                          <div>
                            <label className="label">EFFECTIVE FROM</label>
                            <MonthPicker value={salaryForm.effectiveFrom} onChange={function(v){ setSalaryForm(function(s){ return Object.assign({},s,{effectiveFrom:v}); }); }} />
                          </div>
                        </div>
                        <div style={{ display:"flex", gap:8 }}>
                          <button className="btn btn-primary" style={{ flex:1 }}
                            onClick={function(){
                              if (!salaryForm.amount || !salaryForm.effectiveFrom) { showToast("Enter amount and effective month."); return; }
                              apiPost("/api/franchises/" + fid + "/salaries", { userId:user.id, amount:parseFloat(salaryForm.amount), effectiveFrom:salaryForm.effectiveFrom }).then(function(){
                                apiFetch("/api/franchises/" + fid + "/salaries").then(function(d){
                                  if(d&&Array.isArray(d)) setSalaryData(function(prev){ var n=Object.assign({},prev); n[fid]=d; return n; });
                                });
                                setSalaryForm({ franchiseId:"", amount:"", effectiveFrom:"" });
                                showToast("Salary saved!");
                              }).catch(function(){ showToast("Error saving salary."); });
                            }}>Save</button>
                          <button className="btn btn-secondary"
                            onClick={function(){ setSalaryForm({ franchiseId:"", amount:"", effectiveFrom:"" }); }}>Cancel</button>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>

            {/* Bank Details (read-only) */}
            {myFranchises.filter(function(f){ return f.bankDetails; }).map(function(f){
              var bd = f.bankDetails;
              return (
                <div key={f.id} className="card" style={{ marginTop:16, borderLeft:"3px solid rgba(86,185,233,0.4)" }}>
                  <label className="label" style={{ marginBottom:12 }}>{myFranchises.length > 1 ? f.name + " — " : ""}BANK DETAILS</label>
                  <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:16 }}>
                    <div>
                      <div style={{ fontSize:10, color:"rgba(224,224,224,0.4)", letterSpacing:"0.08em", marginBottom:5 }}>ACCOUNT NAME</div>
                      <div style={{ fontSize:14, fontWeight:600, color:"#E0E0E0" }}>{bd.accountName}</div>
                    </div>
                    <div>
                      <div style={{ fontSize:10, color:"rgba(224,224,224,0.4)", letterSpacing:"0.08em", marginBottom:5 }}>SORT CODE</div>
                      <div style={{ fontSize:14, fontWeight:600, color:"#56B9E9", letterSpacing:"0.1em" }}>{bd.sortCode}</div>
                    </div>
                    <div>
                      <div style={{ fontSize:10, color:"rgba(224,224,224,0.4)", letterSpacing:"0.08em", marginBottom:5 }}>ACCOUNT NUMBER</div>
                      <div style={{ fontSize:14, fontWeight:600, color:"#56B9E9", letterSpacing:"0.1em" }}>{bd.accountNumber}</div>
                    </div>
                  </div>
                  <div style={{ marginTop:10, paddingTop:10, borderTop:"1px solid #2A2A2A", fontSize:11, color:"rgba(224,224,224,0.3)" }}>Contact admin to update bank details</div>
                </div>
              );
            })}
          </div>
        )}
      </div>}
    </div>
  );
}

// ─── FRANCHISE DETAIL READ ONLY (for Director View) ──────────────────────────
function FranchiseDetailReadOnly(props) {
  var f = props.franchise;
  var selectedYear = props.selectedYear;
  var setSelectedYear = props.setSelectedYear;
  if (!f) return null;

  var allYears = Array.from(new Set(f.financials.map(function(m){
    var match = (m.month||"").toString().match(/\b(20\d\d)\b/);
    return match ? parseInt(match[1]) : null;
  }).filter(Boolean))).sort(function(a,b){return b-a;});
  if (!allYears.length) allYears = [new Date().getFullYear()];
  var curYear = allYears.indexOf(selectedYear)===-1 ? allYears[0] : selectedYear;
  var mths = f.financials.filter(function(m){
    var match = (m.month||"").toString().match(/\b(20\d\d)\b/);
    return match && parseInt(match[1])===curYear;
  }).sort(function(a,b){ return parseMonthDate(b.month)-parseMonthDate(a.month); });

  var yearIncome = mths.reduce(function(s,m){return s+m.income;},0);
  var yearExp = mths.reduce(function(s,m){return s+totalExp(m);},0);
  var yearProfit = yearIncome - yearExp;
  var margin = yearIncome > 0 ? ((yearProfit/yearIncome)*100).toFixed(1) : 0;

  var allMths = [].concat(f.financials).sort(function(a,b){ return parseMonthDate(b.month)-parseMonthDate(a.month); });
  var latestMargin = allMths.length > 0 ? ((allMths[0].income - totalExp(allMths[0])) / allMths[0].income * 100).toFixed(1) : 0;

  return (
    <div>
      {/* Header */}
      <div style={{ marginBottom:24 }}>
        <h1 style={{ fontFamily:"Playfair Display,serif", fontWeight:900, fontSize:26 }}>{f.name}</h1>
        <p style={{ color:"rgba(224,224,224,0.5)", fontSize:13, marginTop:4 }}>{f.location}</p>
      </div>

      {/* KPI cards */}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:14, marginBottom:24 }}>
        <div className="card" style={{ padding:18, borderLeft:"3px solid #56B9E9" }}>
          <div className="label" style={{ marginBottom:6 }}>LATEST MARGIN</div>
          <div style={{ fontFamily:"Playfair Display,serif", fontWeight:800, fontSize:28, color:"#56B9E9" }}>{latestMargin}%</div>
          <div style={{ fontSize:11, color:"rgba(224,224,224,0.4)", marginTop:4 }}>{allMths.length>0?allMths[0].month:""}</div>
        </div>
        <div className="card" style={{ padding:18, borderLeft:"3px solid #4DE7A6" }}>
          <div className="label" style={{ marginBottom:6 }}>THIS YEAR ({curYear})</div>
          <div style={{ fontFamily:"Playfair Display,serif", fontWeight:800, fontSize:28, color:"#4DE7A6" }}>{margin}%</div>
          <div style={{ fontSize:11, color:"rgba(224,224,224,0.4)", marginTop:4 }}>{fmt(yearProfit)} net profit</div>
        </div>
        <div className="card" style={{ padding:18, borderLeft:"3px solid #E0E0E0" }}>
          <div className="label" style={{ marginBottom:6 }}>YEAR INCOME</div>
          <div style={{ fontFamily:"Playfair Display,serif", fontWeight:800, fontSize:28, color:"#E0E0E0" }}>{fmt(yearIncome)}</div>
          <div style={{ fontSize:11, color:"rgba(224,224,224,0.4)", marginTop:4 }}>expenses: {fmt(yearExp)}</div>
        </div>
      </div>

      {/* Yearly summary */}
      <div className="card" style={{ padding:0, overflow:"hidden", marginBottom:20 }}>
        <div style={{ padding:"14px 18px", borderBottom:"1px solid #2A2A2A" }}>
          <label className="label" style={{ margin:0 }}>YEARLY MARGINS</label>
        </div>
        <table style={{ width:"100%", borderCollapse:"collapse", fontSize:12 }}>
          <thead><tr style={{ borderBottom:"1px solid #2A2A2A" }}>
            <th style={{ padding:"11px 16px", textAlign:"left", fontSize:10, color:"rgba(224,224,224,0.45)", fontWeight:700 }}>YEAR</th>
            <th style={{ padding:"11px 16px", textAlign:"right", fontSize:10, color:"rgba(224,224,224,0.45)", fontWeight:700 }}>TOTAL INCOME</th>
            <th style={{ padding:"11px 16px", textAlign:"right", fontSize:10, color:"rgba(224,224,224,0.45)", fontWeight:700 }}>TOTAL EXPENSES</th>
            <th style={{ padding:"11px 16px", textAlign:"right", fontSize:10, color:"rgba(224,224,224,0.45)", fontWeight:700 }}>NET PROFIT</th>
            <th style={{ padding:"11px 16px", textAlign:"right", fontSize:10, color:"rgba(224,224,224,0.45)", fontWeight:700 }}>MARGIN</th>
          </tr></thead>
          <tbody>
            {allYears.map(function(yr){
              var yMths = f.financials.filter(function(m){ var match=(m.month||"").match(/\b(20\d\d)\b/); return match&&parseInt(match[1])===yr; });
              var yInc = yMths.reduce(function(s,m){return s+m.income;},0);
              var yExp = yMths.reduce(function(s,m){return s+totalExp(m);},0);
              var yProfit = yInc - yExp;
              var yMargin = yInc>0?((yProfit/yInc)*100).toFixed(1):0;
              return (
                <tr key={yr} style={{ borderBottom:"1px solid rgba(255,255,255,0.04)", cursor:"pointer", background: yr===curYear?"rgba(86,185,233,0.05)":"transparent" }}
                  onClick={function(){ setSelectedYear(yr); }}>
                  <td style={{ padding:"11px 16px", fontFamily:"Playfair Display,serif", fontWeight:700 }}>{yr}</td>
                  <td style={{ padding:"11px 16px", textAlign:"right", color:"#56B9E9" }}>{fmt(yInc)}</td>
                  <td style={{ padding:"11px 16px", textAlign:"right", color:"#cf6679" }}>{fmt(yExp)}</td>
                  <td style={{ padding:"11px 16px", textAlign:"right", color:"#4DE7A6" }}>{fmt(yProfit)}</td>
                  <td style={{ padding:"11px 16px", textAlign:"right", color:"#4DE7A6" }}>{yMargin}%</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Monthly financials */}
      <div className="card" style={{ padding:0, overflow:"hidden", marginBottom:20 }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"14px 18px", borderBottom:"1px solid #2A2A2A" }}>
          <label className="label" style={{ margin:0 }}>FINANCIALS</label>
          <div style={{ display:"flex", alignItems:"center", gap:8 }}>
            <button style={{ background:"#252525", border:"1px solid #2A2A2A", color:"rgba(224,224,224,0.6)", borderRadius:6, padding:"5px 10px", fontFamily:"Outfit,sans-serif", fontSize:12, cursor:"pointer" }}
              onClick={function(){ var idx=allYears.indexOf(curYear); if(idx<allYears.length-1) setSelectedYear(allYears[idx+1]); }}>←</button>
            <span style={{ fontSize:13, fontWeight:600, minWidth:40, textAlign:"center" }}>{curYear}</span>
            <button style={{ background:"#252525", border:"1px solid #2A2A2A", color:"rgba(224,224,224,0.6)", borderRadius:6, padding:"5px 10px", fontFamily:"Outfit,sans-serif", fontSize:12, cursor:"pointer" }}
              onClick={function(){ var idx=allYears.indexOf(curYear); if(idx>0) setSelectedYear(allYears[idx-1]); }}>→</button>
          </div>
        </div>
        <table style={{ width:"100%", borderCollapse:"collapse", fontSize:12 }}>
          <thead><tr style={{ borderBottom:"1px solid #2A2A2A" }}>
            {["MONTH","INCOME","RENT","SALARIES","ROYALTY","OTHER","TOTAL EXP","NET PROFIT"].map(function(h){
              return <th key={h} style={{ padding:"11px 14px", textAlign: h==="MONTH"?"left":"right", fontSize:10, color:"rgba(224,224,224,0.45)", fontWeight:700 }}>{h}</th>;
            })}
          </tr></thead>
          <tbody>
            {mths.map(function(m){
              var exp = totalExp(m);
              var net = m.income - exp;
              return (
                <tr key={m.month} style={{ borderBottom:"1px solid rgba(255,255,255,0.04)" }}>
                  <td style={{ padding:"11px 14px", color:"rgba(224,224,224,0.7)" }}>{m.month}</td>
                  <td style={{ padding:"11px 14px", textAlign:"right", color:"#56B9E9" }}>{fmt(m.income)}</td>
                  <td style={{ padding:"11px 14px", textAlign:"right" }}>{fmt(m.rent||0)}</td>
                  <td style={{ padding:"11px 14px", textAlign:"right" }}>{fmt(m.salaries||0)}</td>
                  <td style={{ padding:"11px 14px", textAlign:"right" }}>{fmt(m.royalty||0)}</td>
                  <td style={{ padding:"11px 14px", textAlign:"right" }}>{fmt(m.otherExpenses||0)}</td>
                  <td style={{ padding:"11px 14px", textAlign:"right", color:"#cf6679" }}>{fmt(exp)}</td>
                  <td style={{ padding:"11px 14px", textAlign:"right", color:net>=0?"#4DE7A6":"#cf6679", fontWeight:600 }}>{fmt(net)}</td>
                </tr>
              );
            })}
            {mths.length===0 && <tr><td colSpan={8} style={{ padding:20, textAlign:"center", color:"rgba(224,224,224,0.4)" }}>No data for {curYear}</td></tr>}
          </tbody>
        </table>
      </div>

      {/* Investors */}
      {f.investors && f.investors.length > 0 && (
        <div style={{ marginBottom:20 }}>
          <label className="label" style={{ marginBottom:10 }}>INVESTORS</label>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:8 }}>
            {f.investors.map(function(inv,i){
              return (
                <div key={i} className="card" style={{ padding:"13px 16px", borderLeft:"3px solid #7B9EFF" }}>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                    <div>
                      <div style={{ fontWeight:600, fontSize:13 }}>{inv.name}</div>
                      <div style={{ fontSize:11, color:"rgba(224,224,224,0.5)", marginTop:2 }}>{inv.email}</div>
                    </div>
                    <div style={{ color:"#7B9EFF", fontWeight:700, fontSize:16 }}>{inv.sharePercent}%</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* Investor P&L */}
      {f.investors && f.investors.length > 0 && mths.length > 0 && (
        <div style={{ marginBottom:20 }}>
          <label className="label" style={{ marginBottom:10 }}>INVESTOR P&L</label>
          <div className="card" style={{ padding:0, overflow:"hidden", overflowX:"auto" }}>
            <table style={{ width:"100%", borderCollapse:"collapse", fontSize:12 }}>
              <thead><tr style={{ borderBottom:"1px solid #2A2A2A" }}>
                <th style={{ padding:"11px 14px", textAlign:"left", fontSize:10, color:"rgba(224,224,224,0.45)", fontWeight:700 }}>MONTH</th>
                <th style={{ padding:"11px 14px", textAlign:"right", fontSize:10, color:"rgba(224,224,224,0.45)", fontWeight:700 }}>NET PROFIT</th>
                {f.investors.filter(function(i){return i.name&&i.sharePercent;}).map(function(inv,ii){
                  return <th key={ii} style={{ padding:"11px 14px", textAlign:"right", fontSize:10, color:"#7B9EFF", fontWeight:700, whiteSpace:"nowrap" }}>{inv.name} ({inv.sharePercent}%)</th>;
                })}
              </tr></thead>
              <tbody>
                {mths.map(function(m){
                  var net = m.income - totalExp(m);
                  return (
                    <tr key={m.month} style={{ borderBottom:"1px solid rgba(255,255,255,0.04)" }}>
                      <td style={{ padding:"11px 14px", color:"rgba(224,224,224,0.6)" }}>{m.month}</td>
                      <td style={{ padding:"11px 14px", textAlign:"right", color:net>=0?"#56B9E9":"#cf6679" }}>{fmt(net)}</td>
                      {f.investors.filter(function(i){return i.name&&i.sharePercent;}).map(function(inv,ii){
                        var s = net * parseFloat(inv.sharePercent)/100;
                        return <td key={ii} style={{ padding:"11px 14px", textAlign:"right", color:s>=0?"#7B9EFF":"#cf6679" }}>{fmt(s)}</td>;
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Franchisees — names and shares only */}
      {f.owners && f.owners.length > 0 && (
        <div style={{ marginBottom:20 }}>
          <label className="label" style={{ marginBottom:10 }}>FRANCHISEES</label>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:8 }}>
            {f.owners.filter(function(o){ return o.isCurrent!==false; }).map(function(o,i){
              return (
                <div key={i} className="card" style={{ padding:"13px 16px", borderLeft:"3px solid #34d399" }}>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                    <div>
                      <div style={{ fontWeight:600, fontSize:13 }}>{o.name}</div>
                      <div style={{ fontSize:11, color:"rgba(224,224,224,0.5)", marginTop:2 }}>{o.email}</div>
                    </div>
                    <div style={{ color:"#4DE7A6", fontWeight:700, fontSize:16 }}>{o.sharePercent}%</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

// ─── DIRECTOR VIEW ────────────────────────────────────────────────────────────
function DirectorView(props) {
  var user = props.user;
  var [dashYear, setDashYear] = useState(new Date().getFullYear());
  var franchises = props.franchises;
  var onExit = props.onExit;
  var [view, setView] = useState("dashboard");
  var [selectedId, setSelectedId] = useState(null);
  var [royaltyPayments, setRoyaltyPayments] = useState([]);
  var [pendingFranchises, setPendingFranchises] = useState([]);
  var [users, setUsers] = useState([]);
  var [activity, setActivity] = useState([]);
  var [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  var activeFranchise = franchises.find(function(f){ return f.id === selectedId; });

  useEffect(function() {
    DB.getUsers().then(function(d){ if(d && Array.isArray(d)) setUsers(d); });
    apiFetch("/api/royalty").then(function(d){ if(d&&Array.isArray(d)) setRoyaltyPayments(d); }).catch(function(){});
    DB.getPending().then(function(d){ if(d && Array.isArray(d)) setPendingFranchises(d); });
    DB.getActivity().then(function(d){ if(d && Array.isArray(d)) setActivity(d); }).catch(function(){});
  }, []);

  var navItems = [
    ["dashboard","Dashboard"],
    ["franchises","Franchises"],
    ["investors","Investors"],
    ["pipeline","Pipeline"],
    ["royalty","Royalty"],
    ["profit","Profit"],
    ["compliance","Compliance"],
    ["users","Users"],
    ["activity","Activity"],
  ];

  var filteredFinancials = function(f){ return (f.financials||[]).filter(function(m){ return (m.month||'').includes(String(dashYear)); }); };
  var totalRevenue = franchises.reduce(function(s,f){ return s + filteredFinancials(f).reduce(function(ss,m){ return ss+m.income; },0); }, 0);
  var totalExpAll = franchises.reduce(function(s,f){ return s + filteredFinancials(f).reduce(function(ss,m){ return ss+totalExp(m); },0); }, 0);
  var totalProfit = totalRevenue - totalExpAll;
  var activeBranches = franchises.filter(function(f){ return f.status !== "closed"; }).length;

  return (
    <div style={{ minHeight:"100vh", background:"#121212", color:"#E0E0E0", fontFamily:"Outfit,sans-serif" }}>
      <style>{CSS}</style>
      {/* Top bar */}
      <div style={{ background:"#1E1E1E", borderBottom:"1px solid #2A2A2A", padding:"12px 24px", display:"flex", alignItems:"center", gap:16 }}>
        <div style={{ display:"flex", alignItems:"center", gap:10 }}>
          <img src="https://www.goinvestors.co.uk/finance-emblem-white.svg" onClick={function(e){ triggerEasterEgg(e.currentTarget); }} style={{ width:24, height:24, objectFit:"contain" }} alt="" />
          <span style={{ fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:16 }}>Director View</span>
        </div>
        <div style={{ display:"flex", gap:6, flexWrap:"wrap", flex:1 }}>
          {navItems.map(function(item){
            var isActive = view === item[0];
            return (
              <button key={item[0]}
                style={{ background: isActive?"#E0E0E0":"transparent", color: isActive?"#121212":"rgba(224,224,224,0.6)", border:"1px solid "+(isActive?"#E0E0E0":"rgba(255,255,255,0.15)"), borderRadius:8, padding:"7px 14px", fontFamily:"Outfit,sans-serif", fontSize:13, fontWeight: isActive?600:400, cursor:"pointer" }}
                onClick={function(){ setView(item[0]); setSelectedId(null); }}>
                {item[1]}
              </button>
            );
          })}
        </div>
        <button className="btn btn-sm btn-secondary" style={{ fontSize:11, flexShrink:0 }} onClick={onExit}>← My Branches</button>
      </div>

      <div style={{ padding:"24px 28px" }}>

        {/* DASHBOARD */}
        {view === "dashboard" && (
          <div className="fade-in">
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-end", marginBottom:24 }}>
              <div>
                <h1 style={{ fontFamily:"Playfair Display,serif", fontWeight:900, fontSize:28 }}>Dashboard</h1>
                <p style={{ color:"rgba(224,224,224,0.5)", fontSize:13, marginTop:4 }}>Read-only director view</p>
              </div>
              <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                <button className="btn btn-sm btn-secondary" onClick={function(){ setDashYear(function(y){ return y-1; }); }}>‹</button>
                <span style={{ fontSize:15, fontWeight:700, color:"#E0E0E0", minWidth:48, textAlign:"center" }}>{dashYear}</span>
                <button className="btn btn-sm btn-secondary" onClick={function(){ setDashYear(function(y){ return y+1 <= new Date().getFullYear() ? y+1 : y; }); }}>›</button>
              </div>
            </div>
            <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:14, marginBottom:28 }}>
              {[
                ["TOTAL REVENUE", fmt(totalRevenue), "#56B9E9"],
                ["TOTAL EXPENSES", fmt(totalExpAll), "#cf6679"],
                ["NET PROFIT", fmt(totalProfit), "#4DE7A6"],
                ["ACTIVE BRANCHES", activeBranches, "#E0E0E0"],
              ].map(function(k){
                return (
                  <div key={k[0]} className="card" style={{ padding:18, borderLeft:"3px solid "+k[2] }}>
                    <div className="label" style={{ marginBottom:8 }}>{k[0]}</div>
                    <div style={{ fontFamily:"Playfair Display,serif", fontWeight:800, fontSize:22, color:k[2] }}>{k[1]}</div>
                  </div>
                );
              })}
            </div>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:18 }}>
              <div>
                <label className="label" style={{ marginBottom:10 }}>BRANCHES</label>
                <div className="card" style={{ padding:0, overflow:"hidden" }}>
                  {franchises.filter(function(f){ return f.status!=="closed"; }).slice(0,8).map(function(f,i,arr){
                    var fRev = f.financials.reduce(function(s,m){ return s+m.income; },0);
                    var fExp = f.financials.reduce(function(s,m){ return s+totalExp(m); },0);
                    return (
                      <div key={f.id} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"12px 16px", borderBottom: i<arr.length-1?"1px solid #2A2A2A":"none", cursor:"pointer" }}
                        onClick={function(){ setSelectedId(f.id); setView("franchises"); }}>
                        <div>
                          <div style={{ fontWeight:600, fontSize:13 }}>{f.name}</div>
                          <div style={{ fontSize:11, color:"rgba(224,224,224,0.45)", marginTop:2 }}>{f.location}</div>
                        </div>
                        <div style={{ textAlign:"right" }}>
                          <div style={{ fontSize:13, color:"#4DE7A6", fontWeight:600 }}>{fmt(fRev-fExp)}</div>
                          <div style={{ fontSize:10, color:"rgba(224,224,224,0.4)" }}>net profit</div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div>
                <label className="label" style={{ marginBottom:10 }}>RECENT ACTIVITY</label>
                <div className="card" style={{ padding:0, overflow:"hidden" }}>
                  {activity.slice(0,8).map(function(a,i,arr){
                    return (
                      <div key={i} style={{ padding:"11px 16px", borderBottom: i<arr.length-1?"1px solid #2A2A2A":"none" }}>
                        <div style={{ fontSize:12, color:"#E0E0E0" }}>{a.action}</div>
                        <div style={{ fontSize:11, color:"rgba(224,224,224,0.4)", marginTop:2 }}>{a.details} · {a.createdAt ? a.createdAt.slice(0,10) : ""}</div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* FRANCHISES */}
        {view === "franchises" && !selectedId && (
          <div className="fade-in">
            <h1 style={{ fontFamily:"Playfair Display,serif", fontWeight:900, fontSize:28, marginBottom:20 }}>Franchises</h1>
            <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
              {franchises.map(function(f){
                var fRev = f.financials.reduce(function(s,m){ return s+m.income; },0);
                var fExp = f.financials.reduce(function(s,m){ return s+totalExp(m); },0);
                return (
                  <div key={f.id} className="card" style={{ padding:"14px 18px", cursor:"pointer", opacity: f.status==="closed"?0.6:1 }}
                    onClick={function(){ setSelectedId(f.id); }}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                      <div>
                        <div style={{ fontWeight:700, fontSize:14 }}>{f.name}</div>
                        <div style={{ fontSize:12, color:"rgba(224,224,224,0.5)", marginTop:3 }}>{f.location}</div>
                      </div>
                      <div style={{ textAlign:"right" }}>
                        <div style={{ color:"#56B9E9", fontWeight:600 }}>{fmt(fRev)}</div>
                        <div style={{ fontSize:11, color:"rgba(224,224,224,0.4)" }}>revenue</div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* FRANCHISE DETAIL — read only, no franchisee P&L, no salaries, no edit buttons */}
        {view === "franchises" && selectedId && activeFranchise && (
          <div className="fade-in">
            <button style={{ background:"#1E1E1E", border:"1px solid #2A2A2A", color:"rgba(224,224,224,0.7)", borderRadius:8, padding:"7px 14px", fontFamily:"Outfit,sans-serif", fontSize:13, cursor:"pointer", marginBottom:16 }} onClick={function(){ setSelectedId(null); }}>← Back</button>
            <FranchiseDetailReadOnly franchise={activeFranchise} selectedYear={selectedYear} setSelectedYear={setSelectedYear} />
          </div>
        )}

        {/* INVESTORS */}
        {view === "investors" && (
          <div className="fade-in">
            <h1 style={{ fontFamily:"Playfair Display,serif", fontWeight:900, fontSize:28, marginBottom:20 }}>Investors</h1>
            <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
              {(function(){
                var allInvestors = {};
                franchises.forEach(function(f){
                  (f.investors||[]).forEach(function(inv){
                    if (!allInvestors[inv.email]) allInvestors[inv.email] = { name:inv.name, email:inv.email, branches:[] };
                    allInvestors[inv.email].branches.push({ name:f.name, share:inv.sharePercent });
                  });
                });
                return Object.values(allInvestors).map(function(inv,i){
                  return (
                    <div key={i} className="card" style={{ padding:"14px 18px", borderLeft:"3px solid #7B9EFF" }}>
                      <div style={{ fontWeight:700, fontSize:14, marginBottom:6 }}>{inv.name}</div>
                      <div style={{ fontSize:12, color:"rgba(224,224,224,0.5)", marginBottom:10 }}>{inv.email}</div>
                      <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
                        {inv.branches.map(function(b,bi){
                          return <span key={bi} style={{ background:"rgba(123,158,255,0.1)", color:"#7B9EFF", fontSize:11, padding:"3px 10px", borderRadius:20, border:"1px solid rgba(123,158,255,0.3)" }}>{b.name} · {b.share}%</span>;
                        })}
                      </div>
                    </div>
                  );
                });
              })()}
            </div>
          </div>
        )}

        {/* PIPELINE — read only */}
        {view === "pipeline" && (
          <div className="fade-in">
            <h1 style={{ fontFamily:"Playfair Display,serif", fontWeight:900, fontSize:28, marginBottom:20 }}>Pipeline</h1>
            <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
              {pendingFranchises.map(function(pf,i){
                var sc = pf.status==="active"?"#4DE7A6":pf.status==="signed"?"#56B9E9":"#cf6679";
                var sb = pf.status==="active"?"rgba(77,231,166,0.1)":pf.status==="signed"?"rgba(86,185,233,0.1)":"rgba(207,102,121,0.1)";
                return (
                  <div key={i} className="card" style={{ padding:"14px 18px" }}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
                      <div>
                        <div style={{ fontWeight:700, fontSize:14, marginBottom:4 }}>{pf.companyName}</div>
                        <div style={{ fontSize:12, color:"rgba(224,224,224,0.5)" }}>{pf.location}</div>
                        {pf.notes && <div style={{ fontSize:12, color:"rgba(224,224,224,0.45)", marginTop:6 }}>{pf.notes}</div>}
                      </div>
                      <span style={{ background:sb, color:sc, fontSize:11, fontWeight:600, padding:"3px 10px", borderRadius:20, border:"1px solid "+sc+"40" }}>{pf.status}</span>
                    </div>
                  </div>
                );
              })}
              {pendingFranchises.length===0 && <div className="card" style={{ padding:20, color:"rgba(224,224,224,0.4)", textAlign:"center" }}>No pipeline entries</div>}
            </div>
          </div>
        )}

        {/* ROYALTY — read only */}
        {view === "royalty" && (
          <div className="fade-in">
            <h1 style={{ fontFamily:"Playfair Display,serif", fontWeight:900, fontSize:28, marginBottom:20 }}>Royalty</h1>
            <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
              {franchises.filter(function(f){ return f.status!=="closed"; }).map(function(f){
                var fPay = royaltyPayments.filter(function(p){ return p.franchiseId===f.id; });
                var total = fPay.reduce(function(s,p){ return s+(parseFloat(p.royalty)||0); },0);
                return (
                  <div key={f.id} className="card" style={{ padding:"14px 18px" }}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                      <div>
                        <div style={{ fontWeight:600, fontSize:13 }}>{f.name}</div>
                        <div style={{ fontSize:11, color:"rgba(224,224,224,0.45)", marginTop:2 }}>{f.location}</div>
                      </div>
                      <div style={{ textAlign:"right" }}>
                        <div style={{ color:"#4DE7A6", fontWeight:700 }}>{fmt(total)}</div>
                        <div style={{ fontSize:10, color:"rgba(224,224,224,0.4)" }}>{fPay.length} payments</div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* USERS — read only */}
        {view === "users" && (
          <div className="fade-in">
            <h1 style={{ fontFamily:"Playfair Display,serif", fontWeight:900, fontSize:28, marginBottom:20 }}>Users</h1>
            <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
              {users.map(function(u,i){
                return (
                  <div key={i} className="card" style={{ padding:"13px 16px" }}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                      <div>
                        <div style={{ fontWeight:600, fontSize:13 }}>{u.name}</div>
                        <div style={{ fontSize:11, color:"rgba(224,224,224,0.5)", marginTop:2 }}>{u.email}</div>
                      </div>
                      <span style={{ fontSize:10, fontWeight:600, background:"rgba(86,185,233,0.1)", color:"#56B9E9", padding:"3px 10px", borderRadius:20, border:"1px solid rgba(86,185,233,0.3)" }}>{u.role}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* COMPLIANCE — read only */}
        {view === "compliance" && (
          <div className="fade-in">
            <h1 style={{ fontFamily:"Playfair Display,serif", fontWeight:900, fontSize:28, marginBottom:20 }}>Compliance</h1>
            <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
              {users.filter(function(u){ return u.role==="franchisee"||u.role==="director"||u.role==="franchisee_investor"; }).map(function(u,i){
                return (
                  <div key={i} className="card" style={{ padding:"13px 16px" }}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                      <div>
                        <div style={{ fontWeight:600, fontSize:13 }}>{u.name}</div>
                        <div style={{ fontSize:11, color:"rgba(224,224,224,0.5)", marginTop:2 }}>{u.email}</div>
                      </div>
                      <span style={{ fontSize:11, color:"rgba(224,224,224,0.4)" }}>Franchisee</span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}


        {/* PROFIT */}
        {view === "profit" && (
          <div className="fade-in">
            <h1 style={{ fontFamily:"Playfair Display,serif", fontWeight:900, fontSize:28, marginBottom:20 }}>Profit</h1>
            {profitLoading ? <div style={{ color:"#56B9E9" }}>Loading...</div> : (
              <div style={{ display:"flex", flexDirection:"column", gap:16 }}>
                {profitData.map(function(f) {
                  var allPeople = (f.owners||[]).concat(f.investors||[]);
                  var isExpanded = expandedFranchiseProfit[f.franchiseId] !== false;
                  return (
                    <div key={f.franchiseId} className="card" style={{ padding:0, overflow:"hidden" }}>
                      <div onClick={function(){ setExpandedFranchiseProfit(function(p){ var n=Object.assign({},p); n[f.franchiseId]=!isExpanded; return n; }); }}
                        style={{ padding:"14px 18px", cursor:"pointer", display:"flex", justifyContent:"space-between", alignItems:"center", borderBottom: isExpanded ? "1px solid #2A2A2A" : "none" }}>
                        <div>
                          <div style={{ fontWeight:700, fontSize:15, color:"#E0E0E0" }}>{f.franchiseName}</div>
                          {f.location && <div style={{ fontSize:11, color:"rgba(224,224,224,0.5)" }}>{f.location}</div>}
                        </div>
                        <div style={{ display:"flex", alignItems:"center", gap:12 }}>
                          <div style={{ textAlign:"right" }}>
                            <div style={{ fontSize:10, color:"rgba(224,224,224,0.45)", letterSpacing:"0.08em" }}>TOTAL REMAINING</div>
                            <div style={{ fontSize:16, fontWeight:800, color: allPeople.reduce(function(s,p){ return s+p.remaining; },0) >= 0 ? "#4DE7A6" : "#cf6679" }}>
                              {fmt(allPeople.reduce(function(s,p){ return s+p.remaining; },0))}
                            </div>
                          </div>
                          <span style={{ color:"rgba(224,224,224,0.4)", fontSize:12 }}>{isExpanded ? "▲" : "▼"}</span>
                        </div>
                      </div>
                      {isExpanded && (
                        <div style={{ padding:"14px 18px" }}>
                          {/* People */}
                          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:16 }}>
                            {allPeople.map(function(person, pi) {
                              var color = person.type === "owner" ? "#4DE7A6" : "#7B9EFF";
                              var canWithdraw = person.type === "owner" || (person.type === "investor");
                              return (
                                <div key={pi} className="card" style={{ padding:"13px 16px", borderLeft:"3px solid "+color }}>
                                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:10 }}>
                                    <div>
                                      <div style={{ fontWeight:600, fontSize:13, color:"#E0E0E0" }}>{person.name}</div>
                                      <div style={{ fontSize:10, color:"rgba(224,224,224,0.5)", marginTop:2 }}>
                                        {person.type === "owner" ? "Franchisee" : "Investor"} · {person.sharePercent}%
                                      </div>
                                    </div>
                                    <button className="btn btn-sm" style={{ background:color+"15", color:color, border:"1px solid "+color+"40", fontSize:11, padding:"4px 10px" }}
                                      onClick={function(){
                                        var today = new Date().toISOString().split("T")[0];
                                        setWithdrawModal({ franchiseId:f.franchiseId, userId:person.userId, name:person.name, franchiseName:f.franchiseName, email:person.email });
                                        setWithdrawForm({ amount:"", method:"Bank Transfer", date:today, notes:"" });
                                      }}>+ Take Profit</button>
                                  </div>
                                  <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:8 }}>
                                    <div>
                                      <div style={{ fontSize:9, color:"rgba(224,224,224,0.45)", letterSpacing:"0.08em", marginBottom:2 }}>TOTAL OWED</div>
                                      <div style={{ fontSize:13, fontWeight:700, color: person.totalOwed >= 0 ? color : "#cf6679" }}>{fmt(person.totalOwed)}</div>
                                    </div>
                                    <div>
                                      <div style={{ fontSize:9, color:"rgba(224,224,224,0.45)", letterSpacing:"0.08em", marginBottom:2 }}>TAKEN</div>
                                      <div style={{ fontSize:13, fontWeight:700, color:"rgba(224,224,224,0.5)" }}>{fmt(person.totalTaken)}</div>
                                    </div>
                                    <div>
                                      <div style={{ fontSize:9, color:"rgba(224,224,224,0.45)", letterSpacing:"0.08em", marginBottom:2 }}>REMAINING</div>
                                      <div style={{ fontSize:13, fontWeight:800, color: person.remaining >= 0 ? "#4DE7A6" : "#cf6679" }}>{fmt(person.remaining)}</div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                          {/* Withdrawals for this franchise */}
                          {(f.withdrawals||[]).length > 0 && (
                            <div>
                              <div style={{ fontSize:10, color:"rgba(224,224,224,0.45)", letterSpacing:"0.08em", marginBottom:8 }}>TRANSACTIONS</div>
                              <div style={{ display:"flex", flexDirection:"column", gap:4 }}>
                                {f.withdrawals.map(function(w, wi) {
                                  return (
                                    <div key={wi} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"8px 0", borderBottom:"1px solid rgba(255,255,255,0.04)" }}>
                                      <div>
                                        <span style={{ fontSize:12, fontWeight:600, color:"#E0E0E0" }}>{w.userName}</span>
                                        <span style={{ fontSize:11, color:"rgba(224,224,224,0.5)", marginLeft:8 }}>{w.method} · {w.dateTaken ? new Date(w.dateTaken).toLocaleDateString("en-GB") : ""}</span>
                                        {w.notes && <span style={{ fontSize:11, color:"rgba(224,224,224,0.35)", marginLeft:8 }}>{w.notes}</span>}
                                      </div>
                                      <span style={{ fontSize:13, fontWeight:700, color:"#cf6679" }}>-{fmt(w.amount)}</span>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  );
                })}

                {/* Global transaction history */}
                <div className="card" style={{ padding:0, overflow:"hidden" }}>
                  <div onClick={function(){ setProfitHistoryOpen(function(p){ return !p; }); }}
                    style={{ padding:"14px 18px", cursor:"pointer", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                    <div style={{ fontWeight:700, fontSize:13, color:"#E0E0E0" }}>ALL TRANSACTIONS</div>
                    <span style={{ color:"rgba(224,224,224,0.4)", fontSize:12 }}>{profitHistoryOpen ? "▲" : "▼"}</span>
                  </div>
                  {profitHistoryOpen && (
                    <div style={{ padding:"0 18px 18px" }}>
                      <input placeholder="Search by name, franchise or method..."
                        value={profitSearch} onChange={function(e){ setProfitSearch(e.target.value); }}
                        style={{ marginBottom:12, width:"100%" }} />
                      {(function() {
                        var allW = profitData.reduce(function(acc, f) {
                          return acc.concat((f.withdrawals||[]).map(function(w){ return Object.assign({},w,{franchiseName:f.franchiseName}); }));
                        }, []).filter(function(w) {
                          if (!profitSearch) return true;
                          var q = profitSearch.toLowerCase();
                          return (w.userName||"").toLowerCase().includes(q) || (w.franchiseName||"").toLowerCase().includes(q) || (w.method||"").toLowerCase().includes(q);
                        }).sort(function(a,b){ return new Date(b.dateTaken)-new Date(a.dateTaken); });
                        if (!allW.length) return <div style={{ color:"rgba(224,224,224,0.5)", fontSize:13 }}>No transactions found</div>;
                        return allW.map(function(w, wi) {
                          return (
                            <div key={wi} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"10px 0", borderBottom:"1px solid rgba(255,255,255,0.04)" }}>
                              <div>
                                <div style={{ fontSize:13, fontWeight:600, color:"#E0E0E0" }}>{w.userName}</div>
                                <div style={{ fontSize:11, color:"rgba(224,224,224,0.5)" }}>{w.franchiseName} · {w.method} · {w.dateTaken ? new Date(w.dateTaken).toLocaleDateString("en-GB") : ""}</div>
                                {w.notes && <div style={{ fontSize:11, color:"rgba(224,224,224,0.35)" }}>{w.notes}</div>}
                              </div>
                              <span style={{ fontSize:14, fontWeight:700, color:"#cf6679" }}>-{fmt(w.amount)}</span>
                            </div>
                          );
                        });
                      })()}
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Withdraw Modal */}
            {withdrawModal && (
              <div className="modal-bg" onClick={function(){ setWithdrawModal(null); }}>
                <div className="card fade-in" style={{ width:440, padding:28 }} onClick={function(e){ e.stopPropagation(); }}>
                  <h3 style={{ fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:18, marginBottom:4 }}>Take Profit</h3>
                  <p style={{ fontSize:12, color:"rgba(224,224,224,0.5)", marginBottom:20 }}>{withdrawModal.name} · {withdrawModal.franchiseName}</p>
                  <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
                    <div><label className="label">AMOUNT (£)</label><input type="number" min="0" step="0.01" placeholder="0.00" value={withdrawForm.amount} onChange={function(e){ setWithdrawForm(function(p){ return Object.assign({},p,{amount:e.target.value}); }); }} /></div>
                    <div><label className="label">DATE</label><input type="date" value={withdrawForm.date} onChange={function(e){ setWithdrawForm(function(p){ return Object.assign({},p,{date:e.target.value}); }); }} /></div>
                    <div>
                      <label className="label">METHOD</label>
                      <div style={{ display:"flex", gap:8, flexWrap:"wrap", marginTop:6 }}>
                        {["Bank Transfer","Card","Cash","Cheque"].map(function(m) {
                          var sel = withdrawForm.method === m;
                          return (
                            <button key={m} onClick={function(){ setWithdrawForm(function(p){ return Object.assign({},p,{method:m}); }); }}
                              className="btn btn-sm" style={{ background:sel?"rgba(77,231,166,0.12)":"#1E1E1E", color:sel?"#4DE7A6":"rgba(224,224,224,0.5)", border:"1px solid "+(sel?"rgba(77,231,166,0.3)":"#2A2A2A") }}>
                              {m}
                            </button>
                          );
                        })}
                      </div>
                    </div>
                    <div><label className="label">NOTES (optional)</label><input placeholder="Any notes..." value={withdrawForm.notes} onChange={function(e){ setWithdrawForm(function(p){ return Object.assign({},p,{notes:e.target.value}); }); }} /></div>
                    <div style={{ display:"flex", gap:10, marginTop:4 }}>
                      <button className="btn btn-primary" onClick={function(){
                        if (!withdrawForm.amount || !withdrawForm.date) { showToast("Please enter amount and date."); return; }
                        DB.postWithdrawal({ franchiseId:withdrawModal.franchiseId, userId:withdrawModal.userId, userEmail:withdrawModal.email, amount:parseFloat(withdrawForm.amount), method:withdrawForm.method, dateTaken:withdrawForm.date, notes:withdrawForm.notes||null })
                          .then(function(){
                            setWithdrawModal(null);
                            setProfitLoading(true);
                            DB.getProfit().then(function(d){ setProfitData(d||[]); setProfitLoading(false); });
                            showToast("Withdrawal recorded!");
                          }).catch(function(){ showToast("Error saving withdrawal."); });
                      }}>Save</button>
                      <button className="btn btn-secondary" onClick={function(){ setWithdrawModal(null); }}>Cancel</button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {/* ACTIVITY */}
        {view === "activity" && (
          <div className="fade-in">
            <h1 style={{ fontFamily:"Playfair Display,serif", fontWeight:900, fontSize:28, marginBottom:20 }}>Activity</h1>
            <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
              {activity.map(function(a,i){
                return (
                  <div key={i} className="card" style={{ padding:"12px 16px" }}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                      <div>
                        <div style={{ fontSize:13, fontWeight:500 }}>{a.action}</div>
                        <div style={{ fontSize:11, color:"rgba(224,224,224,0.45)", marginTop:2 }}>{a.details}</div>
                      </div>
                      <div style={{ fontSize:11, color:"rgba(224,224,224,0.35)", flexShrink:0, marginLeft:16 }}>{a.createdAt ? a.createdAt.slice(0,10) : ""}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

      </div>
    </div>
  );
}

// ─── ADMIN APP ────────────────────────────────────────────────────────────────
function AdminApp(props) {
  var user = props.user;
  var [dashYear, setDashYear] = useState(new Date().getFullYear());
  var onLogout = props.onLogout;
  var [franchises, setFranchises] = useState([]);
  var [view, setView] = useState(function() {
    var path = window.location.pathname;
    if (path.startsWith("/franchises/")) return "detail";
    if (path === "/franchises") return "franchises";
    if (path === "/investors") return "investors";
    if (path === "/pipeline") return "pipeline";
    if (path === "/users") return "users";
    if (path === "/approvals") return "approvals";
    if (path === "/compliance") return "compliance";
    if (path === "/profit") return "profit";
    if (path === "/activity") return "activity";
    if (path === "/royalty") return "royalty";
    return "dashboard";
  });
  var [selectedId, setSelectedId] = useState(function() {
    var path = window.location.pathname;
    if (path.startsWith("/franchises/")) return path.replace("/franchises/", "");
    return null;
  });
  var [modal, setModal] = useState(null);
  var [toast, setToast] = useState(null);
  var [fForm, setFForm] = useState({ name:"", location:"", phone:"", email:"", successorId:"" });
  var [successorSearch, setSuccessorSearch] = useState("");
  var [fOwners, setFOwners] = useState([{ name:"", email:"", phone:"", sharePercent:"" }]);
  var [fInvestors, setFInvestors] = useState([]);
  var [invSearch, setInvSearch] = useState("");
  var [ownerSearch, setOwnerSearch] = useState({});
  var [invForm, setInvForm] = useState({ name:"", email:"", phone:"", password:"investor123" });
  var [invStakes, setInvStakes] = useState([{ franchiseId:"", sharePercent:"" }]);
  var [finForm, setFinForm] = useState({ month:"", income:"", rent:"", salaries:"", royalty:"", otherExpenses:"" });
  var [users, setUsers] = useState([]);
  var [userForm, setUserForm] = useState({ name:"", email:"", password:"investor123", role:"investor" });
  var [declarations, setDeclarations] = useState([]);
  var [activity, setActivity] = useState([]);
  var [editingRow, setEditingRow] = useState(null);
  var [editingFranchise, setEditingFranchise] = useState(null);
  var [shareChangeModal, setShareChangeModal] = useState(null);
  var [shareChangeForm, setShareChangeForm] = useState({ effectiveFrom: '', shares: [] });
  var [shareChangeStep, setShareChangeStep] = useState(1); // 1 = select who, 2 = edit shares
  var [expandedShareHistory, setExpandedShareHistory] = useState({});
  var [expandedSalaryHistory, setExpandedSalaryHistory] = useState({});
  var [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  var [adminSalaryForm, setAdminSalaryForm] = useState({});
  var [showActivePipeline, setShowActivePipeline] = useState(false);
  var [bankEditId, setBankEditId] = useState(null);
  var [bankForm, setBankForm] = useState({ accountName:"", sortCode:"", accountNumber:"" });
  var [showBankHistory, setShowBankHistory] = useState(null);
  var [bankHistory, setBankHistory] = useState([]);
  var [expandedApprovals, setExpandedApprovals] = useState({});
  var [showApprovedDecl, setShowApprovedDecl] = useState(false);
  var [invPayments, setInvPayments] = useState({});
  var [searchFranchise, setSearchFranchise] = useState("");
  var [searchUser, setSearchUser] = useState("");
  var [searchInvestor, setSearchInvestor] = useState("");
  var [searchPipeline, setSearchPipeline] = useState("");
  var [showInactive, setShowInactive] = useState(false);
  var [resetPwUserId, setResetPwUserId] = useState(null);
  var [resetPwVal, setResetPwVal] = useState("");
  var [editingNameId, setEditingNameId] = useState(null);
  var [editNameForm, setEditNameForm] = useState({ name:"", email:"" });
  var [royaltyPayments, setRoyaltyPayments] = useState([]);
  var [royaltyYear, setRoyaltyYear] = useState(new Date().getFullYear().toString());
  var [royaltyFilterMonth, setRoyaltyFilterMonth] = useState("all");
  var [royaltyFilterBranch, setRoyaltyFilterBranch] = useState("all");
  var [royaltyModal, setRoyaltyModal] = useState(null);
  var [royaltyForm, setRoyaltyForm] = useState({ franchiseId:"", month:"", revenue:"", royalty:"", paymentDate:"", paymentMethod:"" });
  var [royaltyLoading, setRoyaltyLoading] = useState(false);
  var [royaltySearch, setRoyaltySearch] = useState("");
  var [royaltyDetailId, setRoyaltyDetailId] = useState(null);
  var [royaltyExpandedId, setRoyaltyExpandedId] = useState(null);
  var [royaltyAdminView, setRoyaltyAdminView] = useState(false);
  var [royaltyLinkId, setRoyaltyLinkId] = useState(null);
  var [royaltyLinkFranchiseId, setRoyaltyLinkFranchiseId] = useState("");
  var [adminSubSearch, setAdminSubSearch] = useState("");
  var [adminSubStatus, setAdminSubStatus] = useState("all");
  var [adminSubBranch, setAdminSubBranch] = useState("all");
  var [adminSubMonth, setAdminSubMonth] = useState("all");
  var [adminSubMethod, setAdminSubMethod] = useState("all");
  var [royaltyLinkSearch, setRoyaltyLinkSearch] = useState("");
  var [royaltyBranchMap, setRoyaltyBranchMap] = useState({});
  var [showOverdueRoyalty, setShowOverdueRoyalty] = useState(true);
  var [showMissingDecl, setShowMissingDecl] = useState(true);
  var [missingDeclExpanded, setMissingDeclExpanded] = useState(null);
  var [activityDetail, setActivityDetail] = useState(null);
  var [marginPage, setMarginPage] = useState(0);
  var [expandedPipelineId, setExpandedPipelineId] = useState(null);
  var [filterRole, setFilterRole] = useState("all");
  var [filterStatus, setFilterStatus] = useState("all");
  var [filterPayment, setFilterPayment] = useState("all");
  var [filterMonth, setFilterMonth] = useState("all");
  var [filterFranchise, setFilterFranchise] = useState("all");
  var [selectedInvestorEmail, setSelectedInvestorEmail] = useState(null);
  var [compliance, setCompliance] = useState({});
  var [complianceView, setComplianceView] = useState("list"); // list | person
  var [compliancePersonId, setCompliancePersonId] = useState(null);
  var [compliancePersonType, setCompliancePersonType] = useState(null);
  var [profitData, setProfitData] = useState([]);
  var [profitLoading, setProfitLoading] = useState(false);
  var [profitSearch, setProfitSearch] = useState("");
  var [profitHistoryOpen, setProfitHistoryOpen] = useState(false);
  var [withdrawModal, setWithdrawModal] = useState(null);
  var [withdrawForm, setWithdrawForm] = useState({ amount:"", method:"Bank Transfer", date:"", notes:"" });
  var [editWithdrawModal, setEditWithdrawModal] = useState(null);
  var [editWithdrawForm, setEditWithdrawForm] = useState({ amount:"", method:"Bank Transfer", date:"", notes:"" });
  var [expandedFranchiseProfit, setExpandedFranchiseProfit] = useState({});
  var [profitPLFranchise, setProfitPLFranchise] = useState(null);
  var [profitPLYear, setProfitPLYear] = useState(new Date().getFullYear());
  var [profitHistFranchise, setProfitHistFranchise] = useState(null);
  var [profitHistSearch, setProfitHistSearch] = useState('');
  var [profitHistYear, setProfitHistYear] = useState(0);
  var [profitTopSearch, setProfitTopSearch] = useState('');
  var [openingBalanceModal, setOpeningBalanceModal] = useState(null);
  var [openingBalanceAmount, setOpeningBalanceAmount] = useState('');
  var [openingBalanceNotes, setOpeningBalanceNotes] = useState('');
  var [pendingFranchises, setPendingFranchises] = useState([]);
  var [pendingModal, setPendingModal] = useState(null);
  var [editDeclModal, setEditDeclModal] = useState(null);
  var [editDeclForm, setEditDeclForm] = useState({});
  var [pendingForm, setPendingForm] = useState(null);
  var [royaltyPaidModal, setRoyaltyPaidModal] = useState(null); // declaration to approve
  var [editingUserId, setEditingUserId] = useState(null);

  // Sync URL with view
  useEffect(function() {
    var path = "/";
    if (view === "detail" && selectedId) path = "/franchises/" + selectedId;
    else if (view === "franchises") path = "/franchises";
    else if (view === "investors" || view === "investor-detail") path = "/investors";
    else if (view === "pipeline") path = "/pipeline";
    else if (view === "users") path = "/users";
    else if (view === "approvals") path = "/approvals";
    else if (view === "compliance") path = "/compliance";
    else if (view === "profit") path = "/profit";
    else if (view === "activity") path = "/activity";
    else if (view === "royalty" && royaltyDetailId) path = "/royalty/" + royaltyDetailId;
    else if (view === "royalty") path = "/royalty";
    if (window.location.pathname !== path) {
      window.history.pushState({ view:view, selectedId:selectedId, royaltyDetailId:royaltyDetailId||null }, "", path);
    }
  }, [view, selectedId, royaltyDetailId]);

  // Handle browser back/forward
  useEffect(function() {
    function onPop(e) {
      var path = window.location.pathname;
      if (path.startsWith("/franchises/")) { setView("detail"); setSelectedId(path.replace("/franchises/", "")); setRoyaltyDetailId(null); }
      else if (path === "/franchises") { setView("franchises"); setSelectedId(null); setRoyaltyDetailId(null); }
      else if (path === "/investors") { setView("investors"); setSelectedId(null); setRoyaltyDetailId(null); }
      else if (path === "/pipeline") { setView("pipeline"); setSelectedId(null); setRoyaltyDetailId(null); }
      else if (path === "/users") { setView("users"); setSelectedId(null); setRoyaltyDetailId(null); }
      else if (path === "/approvals") { setView("approvals"); setSelectedId(null); setRoyaltyDetailId(null); }
      else if (path === "/compliance") { setView("compliance"); setSelectedId(null); setRoyaltyDetailId(null); }
      else if (path === "/profit") { setView("profit"); setSelectedId(null); setRoyaltyDetailId(null); }
      else if (path === "/activity") { setView("activity"); setSelectedId(null); setRoyaltyDetailId(null); }
      else if (path.startsWith("/royalty/")) { setView("royalty"); setSelectedId(null); setRoyaltyDetailId(path.replace("/royalty/", "")); }
      else if (path === "/royalty") { setView("royalty"); setSelectedId(null); setRoyaltyDetailId(null); }
      else { setView("dashboard"); setSelectedId(null); setRoyaltyDetailId(null); }
    }
    window.addEventListener("popstate", onPop);
    return function() { window.removeEventListener("popstate", onPop); };
  }, []);

  useEffect(function() {
    DB.getFranchises().then(function(d) {
    setFranchises(d.map(function(f) {
      return Object.assign({}, f, {
        financials: (f.financials || []).map(function(m) {
          return { month:m.month, income:parseFloat(m.income)||0, rent:parseFloat(m.rent)||0, salaries:parseFloat(m.salaries)||0, royalty:parseFloat(m.royalty)||0, otherExpenses:parseFloat(m.otherExpenses)||0 };
        })
      });
    }));
  });
    DB.getUsers().then(function(d) {
      if (d) {
        setUsers(d);
        d.forEach(function(usr) {
          DB.getCompliance(usr.id).then(function(res) {
            if (res && res.docs && res.docs.length > 0) {
              setCompliance(function(prev) {
                var updated = Object.assign({}, prev);
                var role = (usr.role === "investor" || usr.role === "franchisee_investor") ? "investor" : "franchisee";
                var k = role + "_" + usr.email;
                if (!updated[k]) updated[k] = {};
                res.docs.forEach(function(doc) { updated[k][doc.doc_type] = { name:doc.file_name, uploadedAt:doc.uploaded_at, s3Key:doc.s3_key, userId:usr.id }; });
                return updated;
              });
            }
          }).catch(function(){});
        });
      }
    });
    DB.getDeclarations().then(function(d) { setDeclarations(d); });
    DB.getActivity().then(function(d) { setActivity(d); });
    DB.getCompliance().then(function(d) { setCompliance(d || {}); });
    apiFetch("/api/royalty").then(function(d) { if (d && Array.isArray(d)) setRoyaltyPayments(d); }).catch(function(){});
    try { var savedMap = localStorage.getItem("gi_royalty_map"); if (savedMap) setRoyaltyBranchMap(JSON.parse(savedMap)); } catch(e) {}
    DB.getPending().then(function(d) { setPendingFranchises(d); });
    DB.getProfit().then(function(d) { setProfitData(d || []); setProfitLoading(false); });
  }, []);

  function save(updated) { setFranchises(updated); DB.saveFranchises(updated); }
  function saveUsers(updated) { setUsers(updated); DB.saveUsers(updated); }
  function saveDeclarations(updated) { setDeclarations(updated); DB.saveDeclarations(updated); }
  function saveCompliance(updated) { setCompliance(updated); DB.saveCompliance(updated); }
  function savePending(updated) { setPendingFranchises(updated); DB.savePending(updated); }

  function logActivity(action, details) {
    var entry = { id:"act_"+Date.now(), timestamp:new Date().toISOString(), adminName:user.name, action:action, details:details };
    var updated = [entry].concat(activity).slice(0, 200);
    setActivity(updated);
    DB.saveActivity(updated);
  }

  function doApproveDeclaration(d, createRoyalty) {
    var dName = d.franchiseeName || d.investorName || "?";
    DB.approveDeclaration(d.id).then(function() {
      DB.getFranchises().then(function(dd) { if(dd) setFranchises(dd); });
      setDeclarations(declarations.map(function(dec) { return dec.id === d.id ? Object.assign({}, dec, { status:"approved" }) : dec; }));
      logActivity("Approved declaration", dName + " - " + d.franchiseName + " - " + d.month);
      // If royalty has been paid, create royalty payment entry
      if (createRoyalty && d.royalty > 0) {
        apiPost("/api/royalty", {
          franchiseId: d.franchiseId,
          franchiseName: d.franchiseName,
          month: d.month,
          revenue: d.income,
          royalty: d.royalty,
          paymentDate: new Date().toISOString().split("T")[0],
          source: "manual",
          paymentMethod: "cash"
        }).then(function(){
          apiFetch("/api/royalty").then(function(r){ if(r&&Array.isArray(r)) setRoyaltyPayments(r); });
        });
      }
      showToast(createRoyalty ? "Approved & royalty recorded!" : "Approved — royalty not yet paid.");
    });
  }

  function showToast(msg) { setToast(msg); setTimeout(function() { setToast(null); }, 2500); }

  var pendingCount = declarations.filter(function(d) { return d.status === "pending"; }).length;
  var activeFranchise = franchises.find(function(f) { return f.id === selectedId; });
  // Load investor payments when franchise changes
  useState && (function() {})();
  var [_pmtLoaded, _setPmtLoaded] = useState(null);
  if (selectedId && selectedId !== _pmtLoaded) {
    _setPmtLoaded(selectedId);
    apiFetch("/api/franchises/" + selectedId + "/investor-payments").then(function(data) {
      if (data && data.payments) {
        var map = {};
        data.payments.forEach(function(p) { map[selectedId + "_" + p.month] = { paid:p.paid, datePaid:p.date_paid||"", method:p.method||"" }; });
        setInvPayments(map);
      }
    }).catch(function(){});
  }

  var allInvestors = useMemo(function() {
    var map = {};
    franchises.forEach(function(f) {
      f.investors.forEach(function(inv) {
        if (!map[inv.email]) map[inv.email] = Object.assign({}, inv, { stakes:[] });
        var latest = f.financials.length ? f.financials[f.financials.length-1] : null;
        var latestProfit = latest ? (latest.income - totalExp(latest)) * inv.sharePercent / 100 : 0;
        var totalProfit = f.financials.reduce(function(s,m) { return s + (m.income - totalExp(m)) * inv.sharePercent / 100; }, 0);
        map[inv.email].stakes.push({ franchiseId:f.id, franchise:f.name, sharePercent:inv.sharePercent, latestProfit:latestProfit, totalProfit:totalProfit });
      });
    });
    return Object.values(map);
  }, [franchises]);

  var kpis = useMemo(function() {
    var income = 0, expenses = 0;
    franchises.forEach(function(f) {
      var yearMths = f.financials.filter(function(m){ return (m.month||'').includes(String(dashYear)); });
      yearMths.forEach(function(m){ income += m.income; expenses += totalExp(m); });
    });
    return { income:income, expenses:expenses, profit:income-expenses };
  }, [franchises, dashYear]);

  var trendData = useMemo(function() {
    var months = {};
    franchises.forEach(function(f) { f.financials.filter(function(m){ return (m.month||'').includes(String(dashYear)); }).forEach(function(m) {
      if (!months[m.month]) months[m.month] = { month:m.month, income:0, expenses:0, profit:0 };
      months[m.month].income += m.income;
      months[m.month].expenses += totalExp(m);
      months[m.month].profit += m.income - totalExp(m);
    }); });
    return Object.values(months).sort(function(a,b){ var MONTHS=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']; var pa=a.month.split(' '); var pb=b.month.split(' '); return (parseInt(pa[1])*12+MONTHS.indexOf(pa[0]))-(parseInt(pb[1])*12+MONTHS.indexOf(pb[0])); });
  }, [franchises, dashYear]);

  function addFranchise() {
    if (!fForm.name || !fForm.location) return;
    var newId = "f" + Date.now();
    var validInv = fInvestors.filter(function(i) { return i.name && i.email && i.sharePercent; });
    var investors = validInv.map(function(i) { return { id:"i"+Math.random().toString(36).slice(2), name:i.name, email:i.email, phone:i.phone||"", password:i.password||"investor123", sharePercent:parseFloat(i.sharePercent) }; });
    var validOwners = fOwners.filter(function(o) { return o.name; });

    // Auto-create franchisee users for owners who don't have an account yet
    var updatedUsers = [].concat(users);
    validOwners.forEach(function(owner) {
      if (!owner.email) return;
      var exists = users.find(function(u) { return u.email && u.email.toLowerCase() === owner.email.toLowerCase(); });
      if (!exists) {
        updatedUsers.push({
          id: "u" + Date.now() + Math.random().toString(36).slice(2),
          name: owner.name,
          email: owner.email,
          phone: owner.phone || "",
          password: "franchisee123",
          role: "franchisee",
          active: true,
          franchiseId: newId,
        });
      }
    });

    // Also auto-create investor users for new investors
    validInv.forEach(function(inv) {
      if (!inv.email) return;
      var exists = users.find(function(u) { return u.email && u.email.toLowerCase() === inv.email.toLowerCase(); });
      if (!exists) {
        updatedUsers.push({
          id: "u" + Date.now() + Math.random().toString(36).slice(2),
          name: inv.name,
          email: inv.email,
          phone: inv.phone || "",
          password: inv.password || "investor123",
          role: "investor",
          active: true,
        });
      }
    });

    if (updatedUsers.length !== users.length) {
      saveUsers(updatedUsers);
    }

    DB.createFranchise ? null : null;
    apiPost("/api/franchises", { name:fForm.name, location:fForm.location, phone:fForm.phone, email:fForm.email, successorId:fForm.successorId||null, owners:validOwners, investors:investors }).then(function(res) {
      if (res.error) { showToast("Error: " + res.error); return; }
      DB.getFranchises().then(function(d) {
    setFranchises(d.map(function(f) {
      return Object.assign({}, f, {
        financials: (f.financials || []).map(function(m) {
          return { month:m.month, income:parseFloat(m.income)||0, rent:parseFloat(m.rent)||0, salaries:parseFloat(m.salaries)||0, royalty:parseFloat(m.royalty)||0, otherExpenses:parseFloat(m.otherExpenses)||0 };
        })
      });
    }));
  });
      logActivity("Created franchise", fForm.name + " - " + fForm.location);
      DB.logActivity("Created franchise", fForm.name + " - " + fForm.location);
      // Auto-create pipeline entry marked as active
      var pipelineEntry = {
        companyName: fForm.name,
        location: fForm.location,
        status: "active",
        franchisees: validOwners.map(function(o) { return { name:o.name, email:o.email||"", phone:o.phone||"", sharePercent:o.sharePercent||"", paying:"" }; }),
        investors: investors.map(function(i) { return { name:i.name, email:i.email||"", phone:i.phone||"", sharePercent:i.sharePercent||"", paying:"", type:"individual", companyName:"" }; }),
        franchiseCost: "",
        paymentPlan: "",
        ilaSignedFranchisee: false,
        ilaSignedInvestor: false,
        contractSigned: false,
        notes: "Auto-created when franchise was added"
      };
      DB.createPipeline(pipelineEntry).then(function() {
        DB.getPending().then(function(d) { setPendingFranchises(d); });
      });
      setFForm({ name:"", location:"", phone:"", email:"", successorId:"" }); setSuccessorSearch(""); setFInvestors([]); setFOwners([{ name:"", email:"", phone:"", sharePercent:"" }]); setModal(null); showToast("Franchise created!");
    });
  }

  function addInvestor() {
    var validStakes = invStakes.filter(function(s) { return s.franchiseId && s.sharePercent; });
    if (validStakes.length === 0) return;
    // If selecting existing user
    if (!invForm.isNew) {
      if (!invForm.userId) return;
      Promise.all(validStakes.map(function(stake) {
        return apiPost("/api/franchises/" + stake.franchiseId + "/investors", { userId:invForm.userId, sharePercent:parseFloat(stake.sharePercent)||0 });
      })).then(function() {
        DB.getFranchises().then(function(d) {
    setFranchises(d.map(function(f) {
      return Object.assign({}, f, {
        financials: (f.financials || []).map(function(m) {
          return { month:m.month, income:parseFloat(m.income)||0, rent:parseFloat(m.rent)||0, salaries:parseFloat(m.salaries)||0, royalty:parseFloat(m.royalty)||0, otherExpenses:parseFloat(m.otherExpenses)||0 };
        })
      });
    }));
  });
        DB.logActivity("Added investor to branch", invForm.name);
        logActivity("Added investor to branch", invForm.name);
        setInvForm({ name:"", email:"", phone:"", password:"investor123", isNew:false, userId:"" });
        setInvStakes([{ franchiseId:"", sharePercent:"" }]);
        setModal(null); showToast("Investor added!");
      });
    } else {
      // Creating new investor user
      if (!invForm.name || !invForm.email) return;
      DB.createUser({ name:invForm.name, email:invForm.email, phone:invForm.phone||"", password:"Welcome123!", role:"investor" }).then(function(res) {
        if (res.error) { showToast("Error: " + res.error); return; }
        var newUserId = res.id;
        Promise.all(validStakes.map(function(stake) {
          return apiPost("/api/franchises/" + stake.franchiseId + "/investors", { userId:newUserId, sharePercent:parseFloat(stake.sharePercent)||0 });
        })).then(function() {
          DB.getFranchises().then(function(d) {
    setFranchises(d.map(function(f) {
      return Object.assign({}, f, {
        financials: (f.financials || []).map(function(m) {
          return { month:m.month, income:parseFloat(m.income)||0, rent:parseFloat(m.rent)||0, salaries:parseFloat(m.salaries)||0, royalty:parseFloat(m.royalty)||0, otherExpenses:parseFloat(m.otherExpenses)||0 };
        })
      });
    }));
  });
          DB.getUsers().then(function(d) { setUsers(d); });
          DB.logActivity("Created investor and added to branch", invForm.name);
          logActivity("Onboarded investor", invForm.name);
          setInvForm({ name:"", email:"", phone:"", password:"investor123", isNew:false, userId:"" });
          setInvStakes([{ franchiseId:"", sharePercent:"" }]);
          setModal(null); showToast("Investor onboarded!");
        });
      });
    }
  }

  function addFinancial() {
    if (!finForm.month || !finForm.income) return;
    var row = { month:finForm.month, income:parseFloat(finForm.income)||0, rent:parseFloat(finForm.rent)||0, salaries:parseFloat(finForm.salaries)||0, royalty:parseFloat(finForm.royalty)||0, otherExpenses:parseFloat(finForm.otherExpenses)||0 };
    apiPost("/api/franchises/" + selectedId + "/financials", row).then(function() {
      var updated = franchises.map(function(f) {
        if (f.id !== selectedId) return f;
        return Object.assign({}, f, { financials:f.financials.concat([row]) });
      });
      save(updated);
      var fName = (franchises.find(function(f) { return f.id === selectedId; }) || { name:selectedId }).name;
      logActivity("Added financial data", fName + " - " + finForm.month + " - Income: " + fmt(parseFloat(finForm.income)||0));
      DB.logActivity("Added financial data", fName + " - " + finForm.month);
      setFinForm({ month:"", income:"", rent:"", salaries:"", royalty:"", otherExpenses:"" });
      setModal(null); showToast("Financials saved!");
    });
  }

  function deleteFranchise(id) {
    if (!confirm("Delete this franchise? This cannot be undone.")) return;
    var delF = franchises.find(function(f) { return f.id === id; });
    apiDelete("/api/franchises/" + id).then(function() {
      setFranchises(franchises.filter(function(f) { return f.id !== id; }));
      logActivity("Deleted franchise", delF ? delF.name : id);
      DB.logActivity("Deleted franchise", delF ? delF.name : id);
      setView("dashboard"); showToast("Deleted.");
    });
  }

  function removeInvestor(fId, iId) {
    apiDelete("/api/franchises/" + fId + "/investors/" + iId).then(function() {
      save(franchises.map(function(f) {
        if (f.id !== fId) return f;
        return Object.assign({}, f, { investors:f.investors.filter(function(i) { return i.id !== iId; }) });
      }));
      showToast("Investor removed.");
    });
  }

  return (
    <div style={{ fontFamily:"Outfit,sans-serif", background:"#121212", minHeight:"100vh", color:"#E0E0E0" }}>
      <style>{CSS}</style>
      {toast && <div style={{ position:"fixed", bottom:24, right:24, background:"#56B9E9", color:"#080808", padding:"12px 20px", borderRadius:10, fontSize:13, fontWeight:500, zIndex:500 }}>✓ {toast}</div>}

      <div style={{ borderBottom:"1px solid #141414", padding:"14px 32px", display:"flex", alignItems:"center", justifyContent:"space-between", background:"#1E1E1E", position:"sticky", top:0, zIndex:50 }}>
        <div style={{ display:"flex", alignItems:"center", gap:12 }}>
          <img src="https://www.goinvestors.co.uk/finance-emblem-white.svg" onClick={function(e){ triggerEasterEgg(e.currentTarget); }} alt="GoTutors" style={{ height:32 }} /><img src="https://www.goinvestors.co.uk/finance-wordmark-white.svg" alt="GoTutors" style={{ height:24, marginLeft:10 }} />
          <span className="tag" style={{ background:"rgba(123,158,255,0.1)", color:"#56B9E9" }}>Admin</span>
        </div>
        <nav style={{ display:"flex", gap:4 }}>
          {[["dashboard","Dashboard"],["franchises","Franchises"],["investors","Investors"],["pipeline","Pipeline"],["users","Users"],["approvals","Approvals"],["compliance","Compliance"],["royalty","Royalty"],["profit","Profit"],["activity","Activity"]].map(function(item) {
            return (
              <div key={item[0]} className={"nav-pill" + (view === item[0] ? " active" : "")}
                onClick={function() { setView(item[0]); if (item[0] === "compliance") setComplianceView("list"); }}
                style={{ position:"relative" }}>
                {item[1]}
                {item[0] === "approvals" && pendingCount > 0 && <span style={{ position:"absolute", top:4, right:4, width:7, height:7, borderRadius:"50%", background:"#cf6679" }} />}
              </div>
            );
          })}
        </nav>
        <div style={{ display:"flex", gap:8 }}>
          <button className="btn btn-sm btn-secondary" onClick={function() { exportPDF(franchises); }}>PDF</button>
          <button className="btn btn-sm btn-secondary" onClick={function() {
            var rows = franchises.reduce(function(acc, f) {
              return acc.concat(f.financials.map(function(m) { return { Franchise:f.name, Location:f.location, Month:m.month, Income:m.income, Expenses:totalExp(m), Profit:m.income-totalExp(m) }; }));
            }, []);
            if (rows.length) exportCSV(rows, "goinvestors_report.csv");
          }}>CSV</button>
          <button className="btn btn-sm btn-secondary" onClick={onLogout}>Sign out</button>
        </div>
      </div>

      <div style={{ maxWidth:1120, margin:"0 auto", padding:"36px 24px" }}>

        {view === "dashboard" && (
          <div className="fade-in">
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-end", marginBottom:28 }}>
              <div>
                <h1 style={{ fontFamily:"Playfair Display,serif", fontWeight:900, fontSize:28, letterSpacing:"-0.04em" }}>Overview</h1>
                <p style={{ color:"#56B9E9", fontSize:13, marginTop:4 }}>Latest month across all franchises</p>
              </div>
              <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                <button className="btn btn-sm btn-secondary" onClick={function(){ setDashYear(function(y){ return y-1; }); }}>‹</button>
                <span style={{ fontSize:15, fontWeight:700, color:"#E0E0E0", minWidth:48, textAlign:"center" }}>{dashYear}</span>
                <button className="btn btn-sm btn-secondary" onClick={function(){ setDashYear(function(y){ return y+1 <= new Date().getFullYear() ? y+1 : y; }); }}>›</button>
                <button className="btn btn-primary btn-sm" onClick={function() { setModal("new-franchise"); }}>+ New Franchise</button>
              </div>
            </div>
            <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:14, marginBottom:14 }}>
              {[{ label:"TOTAL REVENUE", value:fmt(kpis.income), color:"#56B9E9" },{ label:"TOTAL EXPENSES", value:fmt(kpis.expenses), color:"#cf6679" },{ label:"NET PROFIT", value:fmt(kpis.profit), color:"#E0E0E0" },{ label:"FRANCHISES", value:franchises.length, color:"#4DE7A6" }].map(function(k) {
                return (
                  <div key={k.label} className="card">
                    <label className="label">{k.label}</label>
                    <div style={{ fontFamily:"Playfair Display,serif", fontWeight:900, fontSize:26, color:k.color }}>{k.value}</div>
                  </div>
                );
              })}
            </div>
            {(function() {
              var yearRoy = royaltyPayments.filter(function(r){ return (r.month||"").includes(String(dashYear)); });
              var yearRoyTotal = yearRoy.reduce(function(s,r){ return s+(parseFloat(r.royalty)||0); }, 0);
              var royMonths = (function(){ var m={}; yearRoy.forEach(function(r){ if(r.month) m[r.month]=true; }); return Object.keys(m).length; })();
              var activeBranchCount = franchises.filter(function(f){ return f.status !== "closed"; }).length;
              var monthlyAvg = royMonths > 0 ? yearRoyTotal / royMonths : 0;
              var avgPerBranch = royMonths > 0 && activeBranchCount > 0 ? yearRoyTotal / (royMonths * activeBranchCount) : 0;
              return (
                <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:14, marginBottom:28 }}>
                  <div className="card">
                    <label className="label">{dashYear} ROYALTIES</label>
                    <div style={{ fontFamily:"Playfair Display,serif", fontWeight:900, fontSize:26, color:"#FAC775" }}>{fmt(yearRoyTotal)}</div>
                  </div>
                  <div className="card">
                    <label className="label">MONTHLY AVG ROYALTY</label>
                    <div style={{ fontFamily:"Playfair Display,serif", fontWeight:900, fontSize:26, color:"#FAC775" }}>{fmt(monthlyAvg)}</div>
                  </div>
                  <div className="card">
                    <label className="label">AVG PER BRANCH / MONTH</label>
                    <div style={{ fontFamily:"Playfair Display,serif", fontWeight:900, fontSize:26, color:"#FAC775" }}>{fmt(avgPerBranch)}</div>
                  </div>
                </div>
              );
            })()}
            {trendData.length > 1 && (
              <div className="card" style={{ marginBottom:28 }}>
                <label className="label" style={{ marginBottom:16 }}>PORTFOLIO TREND</label>
                <ResponsiveContainer width="100%" height={220}>
                  <LineChart data={trendData}>
                    <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)" vertical={false} />
                    <XAxis dataKey="month" tick={{ fill:"#56B9E9", fontSize:11 }} axisLine={false} tickLine={false} />
                    <YAxis tick={{ fill:"#56B9E9", fontSize:11 }} axisLine={false} tickLine={false} tickFormatter={function(v) { return "£"+Math.round(v/1000)+"k"; }} />
                    <Tooltip content={<ChartTooltip />} />
                    <Legend wrapperStyle={{ fontSize:11, color:"rgba(224,224,224,0.6)" }} />
                    <Line type="monotone" dataKey="income" name="Income" stroke="#56B9E9" strokeWidth={2} dot={false} />
                    <Line type="monotone" dataKey="expenses" name="Expenses" stroke="#cf6679" strokeWidth={2} dot={false} />
                    <Line type="monotone" dataKey="profit" name="Profit" stroke="#56B9E9" strokeWidth={2.5} dot={{ fill:"#E0E0E0", r:3 }} />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            )}
            <div style={{ display:"flex", gap:10, marginBottom:16 }}>
              <input placeholder="Search branches..." value={searchFranchise} onChange={function(e) { setSearchFranchise(e.target.value); }}
                style={{ flex:1, background:"#1E1E1E", border:"1px solid #374151", color:"#E0E0E0", padding:"9px 14px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none" }} />
            </div>
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(310px,1fr))", gap:14 }}>
              {franchises.filter(function(f) {
                if (!searchFranchise) return true;
                var q = searchFranchise.toLowerCase();
                return f.name.toLowerCase().includes(q) || (f.location||"").toLowerCase().includes(q);
              }).map(function(f, fi) {
                var yearMths = (f.financials||[]).filter(function(m){ return (m.month||'').includes(String(dashYear)); });
                var latest = yearMths.length ? yearMths[yearMths.length-1] : null;
                var profit = latest ? latest.income - totalExp(latest) : 0;
                var color = PALETTE[fi % PALETTE.length];
                return (
                  <div key={f.id} className="card card-hover" style={{ cursor:"pointer" }} onClick={function() { setSelectedId(f.id); setView("detail"); }}>
                    <div style={{ display:"flex", justifyContent:"space-between", marginBottom:14 }}>
                      <div>
                        <div style={{ fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:14 }}>{f.name}</div>
                        <div style={{ fontSize:11, color:"#56B9E9", marginTop:3 }}>{f.location}</div>
                        {f.owners && f.owners.length > 0 && (
                          <div style={{ fontSize:11, color:"rgba(224,224,224,0.6)", marginTop:2 }}>
                            {f.owners.filter(function(o){ return o.isCurrent!==false; }).map(function(o) { return o.name + (o.sharePercent ? " " + o.sharePercent + "%" : ""); }).join(" · ")}
                          </div>
                        )}
                      </div>
                      <span style={{ background:"rgba(224,224,224,0.08)", color:"#E0E0E0", fontSize:11, fontWeight:700, padding:"4px 12px", borderRadius:20, border:"1px solid rgba(224,224,224,0.15)", display:"flex", alignItems:"center", justifyContent:"center", whiteSpace:"nowrap" }}>{f.investors.length} investor{f.investors.length !== 1 ? "s" : ""}</span>
                    </div>
                    {latest ? (
                      <div>
                        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:8, marginBottom:12 }}>
                          {[["REV",latest.income,"#56B9E9"],["EXP",totalExp(latest),"#cf6679"],["NET",profit,"#E0E0E0"]].map(function(item) {
                            return (
                              <div key={item[0]}><div style={{ fontSize:10, color:"#56B9E9", letterSpacing:"0.1em", marginBottom:3 }}>{item[0]}</div><div style={{ color:item[2], fontWeight:500, fontSize:12 }}>{fmt(item[1])}</div></div>
                            );
                          })}
                        </div>
                        <MiniBar value={profit} max={latest.income} color={color} />
                        <div style={{ fontSize:11, color:"#56B9E9", marginTop:5 }}>{pct(profit/latest.income*100)} margin · {latest.month}</div>
                      </div>
                    ) : <div style={{ fontSize:12, color:"#56B9E9" }}>No data yet</div>}
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {view === "franchises" && (
          <div className="fade-in">
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-end", marginBottom:18 }}>
              <h1 style={{ fontFamily:"Playfair Display,serif", fontWeight:900, fontSize:28, letterSpacing:"-0.04em" }}>Franchises</h1>
              <button className="btn btn-primary btn-sm" onClick={function() { setModal("new-franchise"); }}>+ New Franchise</button>
            </div>
            <div style={{ display:"flex", gap:10, marginBottom:18 }}>
              <input placeholder="Search franchises..." value={searchFranchise} onChange={function(e) { setSearchFranchise(e.target.value); }}
                style={{ flex:1, background:"#1E1E1E", border:"1px solid #374151", color:"#E0E0E0", padding:"9px 14px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none" }} />
            </div>
            <div className="card" style={{ padding:0, overflow:"hidden" }}>
              <table style={{ width:"100%", borderCollapse:"collapse", fontSize:12 }}>
                <thead><tr style={{ borderBottom:"1px solid #374151" }}>{["FRANCHISE","LOCATION","FRANCHISEES","INVESTORS","REVENUE","PROFIT","MARGIN",""].map(function(h) { return <th key={h} style={{ padding:"13px 18px", textAlign:"left", fontSize:10, letterSpacing:"0.1em", color:"#56B9E9", fontWeight:500 }}>{h}</th>; })}</tr></thead>
                <tbody>
                  {franchises.filter(function(f) {
                    if (!searchFranchise) return true;
                    var q = searchFranchise.toLowerCase();
                    return f.name.toLowerCase().includes(q) || (f.location||"").toLowerCase().includes(q);
                  }).map(function(f, fi) {
                    var l = f.financials.length ? f.financials[f.financials.length-1] : null;
                    var profit = l ? l.income - totalExp(l) : null;
                    var color = PALETTE[fi % PALETTE.length];
                    return (
                      <tr key={f.id} style={{ borderBottom:"1px solid #141414", cursor:"pointer" }} onClick={function() { setSelectedId(f.id); setView("detail"); }}>
                        <td style={{ padding:"13px 18px" }}><span style={{ color:color, fontWeight:500 }}>{f.name}</span></td>
                        <td style={{ padding:"13px 18px", color:"rgba(224,224,224,0.6)" }}>{f.location}</td>
                        <td style={{ padding:"13px 18px" }}>
                          {(function() {
                            var fees = (f.owners || []).filter(function(o) { return o.name && o.isCurrent !== false; });
                            if (!fees.length) return <span style={{ color:"#56B9E9", fontSize:12 }}>—</span>;
                            return (
                              <div style={{ display:"flex", flexDirection:"column", gap:3 }}>
                                {fees.map(function(o, oi) {
                                  return (
                                    <div key={oi} style={{ display:"flex", alignItems:"center", gap:6 }}>
                                      <span style={{ fontSize:12, color:"#E0E0E0", fontWeight:500 }}>{o.name}</span>
                                      {o.sharePercent ? <span className="tag" style={{ background:"rgba(77,231,166,0.1)", color:"#4DE7A6", fontSize:10 }}>{o.sharePercent}%</span> : null}
                                    </div>
                                  );
                                })}
                              </div>
                            );
                          })()}
                        </td>
                        <td style={{ padding:"13px 18px" }}><span className="tag" style={{ background:"#2A2A2A", color:"rgba(224,224,224,0.6)" }}>{f.investors.length}</span></td>
                        <td style={{ padding:"13px 18px", color:"#56B9E9" }}>{l ? fmt(l.income) : "—"}</td>
                        <td style={{ padding:"13px 18px", color:"#E0E0E0" }}>{profit !== null ? fmt(profit) : "—"}</td>
                        <td style={{ padding:"13px 18px" }}>{profit !== null ? <span className="tag" style={{ background:"rgba(255,255,255,0.05)", color:"#E0E0E0" }}>{pct(profit/l.income*100)}</span> : "—"}</td>
                        <td style={{ padding:"13px 18px" }} onClick={function(e) { e.stopPropagation(); deleteFranchise(f.id); }}>
                          <span style={{ color:"#2A2A2A", cursor:"pointer", fontSize:13 }} onMouseEnter={function(e) { e.target.style.color="#cf6679"; }} onMouseLeave={function(e) { e.target.style.color="#2A2A2A"; }}>✕</span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {view === "detail" && activeFranchise && (
          <div className="fade-in">
            <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:28 }}>
              <button className="btn btn-secondary btn-sm" onClick={function() { setView("dashboard"); }}>Back</button>
              <div style={{ flex:1 }}>
                <h1 style={{ fontFamily:"Playfair Display,serif", fontWeight:900, fontSize:24, letterSpacing:"-0.04em" }}>{activeFranchise.name}</h1>
                <div style={{ display:"flex", alignItems:"center", gap:8, flexWrap:"wrap", marginTop:4 }}>
                  <p style={{ color:"#56B9E9", fontSize:13 }}>{activeFranchise.location}{activeFranchise.phone ? " · " + activeFranchise.phone : ""}{activeFranchise.email ? " · " + activeFranchise.email : ""}</p>
                  {activeFranchise.status === "closed" && <span className="tag" style={{ background:"rgba(207,102,121,0.1)", color:"#cf6679", fontSize:11, border:"1px solid rgba(207,102,121,0.25)" }}>Closed{activeFranchise.closedDate?" · "+activeFranchise.closedDate:""}</span>}
                  {activeFranchise.successorId && (function(){
                    var succ = franchises.find(function(f){ return f.id === activeFranchise.successorId; });
                    return succ ? <span className="tag" style={{ background:"rgba(86,185,233,0.08)", color:"#56B9E9", fontSize:11, border:"1px solid rgba(86,185,233,0.2)" }}>Succeeded by: {succ.name}</span> : null;
                  })()}
                </div>
                {activeFranchise.owners && activeFranchise.owners.length > 0 && (
                  <div style={{ display:"flex", gap:8, flexWrap:"wrap", marginTop:8 }}>
                    {activeFranchise.owners.filter(function(o){ return o.isCurrent!==false; }).map(function(o, oi) {
                      return (
                        <div key={oi} style={{ background:"#252525", border:"1px solid #374151", borderRadius:8, padding:"6px 12px", fontSize:12, display:"flex", alignItems:"center", gap:8 }}>
                          <span style={{ color:"#E0E0E0", fontWeight:500 }}>{o.name}</span>
                          {o.sharePercent ? <span style={{ color:"#56B9E9", marginLeft:6 }}>{o.sharePercent}% owner</span> : null}
                          {o.phone ? <span style={{ color:"rgba(224,224,224,0.6)", marginLeft:6 }}>· {o.phone}</span> : null}
                          {o.email ? <span style={{ color:"rgba(224,224,224,0.6)", marginLeft:6 }}>· {o.email}</span> : null}
                          <span style={{ color:"#333333", cursor:"pointer", marginLeft:6, fontSize:12 }}
                            onMouseEnter={function(e){e.target.style.color="#cf6679";}}
                            onMouseLeave={function(e){e.target.style.color="#333333";}}
                            onClick={function() {
                              if (!confirm("Remove " + o.name + " as owner?")) return;
                              var newOwners = (activeFranchise.owners || []).filter(function(_, i) { return i !== oi; });
                              apiPut("/api/franchises/" + activeFranchise.id + "/owners", { owners:newOwners }).then(function() {
                                save(franchises.map(function(f) { return f.id === activeFranchise.id ? Object.assign({}, f, { owners:newOwners }) : f; }));
                                DB.logActivity("Removed owner", o.name + " from " + activeFranchise.name);
                                logActivity("Removed owner", o.name + " from " + activeFranchise.name);
                                showToast(o.name + " removed.");
                              });
                            }}>✕</span>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
              <button className="btn btn-secondary btn-sm" style={{ flexShrink:0 }} onClick={function() {
                setEditingFranchise({
                  id: activeFranchise.id,
                  name: activeFranchise.name,
                  location: activeFranchise.location,
                  phone: activeFranchise.phone || "",
                  email: activeFranchise.email || "",
                  owners: (activeFranchise.owners || []).filter(function(o){ return o.isCurrent !== false; }),
                  royaltyStartMonth: activeFranchise.royaltyStartMonth || "",
                  status: activeFranchise.status || "active",
                  closedDate: activeFranchise.closedDate || "",
                  headOfCentre: activeFranchise.headOfCentre || ""
                });
              }}>✎ Edit Franchise</button>
            </div>

            {/* Overdue warning on franchise detail — per month, not per person */}
            {(function() {
              var overdueMonths = [];
              var now3 = new Date();
              for (var mi2 = 0; mi2 < 3; mi2++) {
                var cd = new Date(now3.getFullYear(), now3.getMonth() - 1 - mi2, 1);
                if (!(now3.getDate() <= 10 && mi2 === 0)) {
                  var cm = MONTH_NAMES[cd.getMonth()] + " " + cd.getFullYear();
                  var hasDeclaration = declarations.some(function(d) { return d.franchiseId === activeFranchise.id && d.month === cm; });
                  var hasFinancials = activeFranchise.financials.some(function(m) { return m.month === cm; });
                  if (!hasDeclaration && !hasFinancials) overdueMonths.push(cm);
                }
              }
              if (!overdueMonths.length) return null;
              return (
                <div style={{ background:"rgba(207,102,121,0.08)", border:"1px solid #4a1010", borderRadius:10, padding:"12px 16px", marginBottom:18 }}>
                  <div style={{ fontSize:12, color:"#cf6679", fontWeight:600, marginBottom:8 }}>⚠ Missing declarations</div>
                  <div style={{ display:"flex", flexWrap:"wrap", gap:6 }}>
                    {overdueMonths.map(function(m) {
                      return <span key={m} className="tag" style={{ background:"rgba(207,102,121,0.1)", color:"#cf6679", fontSize:11 }}>{m} not submitted</span>;
                    })}
                  </div>
                </div>
              );
            })()}

            {/* Edit Franchise Modal */}
            {editingFranchise && editingFranchise.id === activeFranchise.id && (
              <div className="modal-bg" onClick={function() { setEditingFranchise(null); }}>
                <div className="card fade-in" style={{ width:560, padding:30, maxHeight:"90vh", overflowY:"auto" }} onClick={function(e) { e.stopPropagation(); }}>
                  <h3 style={{ fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:19, marginBottom:6 }}>Edit Franchise</h3>
                  <p style={{ fontSize:12, color:"#56B9E9", marginBottom:20 }}>Update franchise details and ownership structure.</p>
                  <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
                    <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
                      <div><label className="label">COMPANY NAME</label><input placeholder="Company name" value={editingFranchise.name} onChange={function(e) { var v=e.target.value; setEditingFranchise(function(p) { return Object.assign({},p,{name:v}); }); }} /></div>
                      <div><label className="label">LOCATION</label><input placeholder="e.g. London, UK" value={editingFranchise.location} onChange={function(e) { var v=e.target.value; setEditingFranchise(function(p) { return Object.assign({},p,{location:v}); }); }} /></div>
                    </div>
                    <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
                      <div><label className="label">EMAIL</label><input type="email" placeholder="franchise@email.com" value={editingFranchise.email} onChange={function(e) { var v=e.target.value; setEditingFranchise(function(p) { return Object.assign({},p,{email:v}); }); }} /></div>
                      <div><label className="label">PHONE</label><input type="tel" placeholder="+44 7700 900000" value={editingFranchise.phone} onChange={function(e) { var v=e.target.value; setEditingFranchise(function(p) { return Object.assign({},p,{phone:v}); }); }} /></div>
                    </div>
                    <div>
                      <label className="label">ROYALTY TRACKING START MONTH</label>
                      <p style={{ fontSize:11, color:"rgba(224,224,224,0.45)", marginBottom:8 }}>The first month this branch is required to pay royalty</p>
                      <MonthPicker value={editingFranchise.royaltyStartMonth||""} onChange={function(v){ setEditingFranchise(function(p){ return Object.assign({},p,{royaltyStartMonth:v}); }); }} />
                    </div>
                    <div style={{ borderTop:"1px solid #2A2A2A", paddingTop:14 }}>
                      <label className="label">HEAD OF CENTRE</label>
                      <p style={{ fontSize:11, color:"rgba(224,224,224,0.45)", marginBottom:8 }}>Only this person can log profit withdrawals for all franchisees</p>
                      <select value={editingFranchise.headOfCentre||""} onChange={function(e){ setEditingFranchise(function(p){ return Object.assign({},p,{headOfCentre:e.target.value||null}); }); }}
                        style={{ width:"100%", background:"#1E1E1E", border:"1px solid #2A2A2A", color:"#E0E0E0", padding:"10px 12px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:13 }}>
                        <option value="">— None selected —</option>
                        {(activeFranchise.owners||[]).filter(function(o){ return o.isCurrent !== false; }).map(function(o,oi){
                          var u = users.find(function(u2){ return (u2.email||"").toLowerCase()===(o.email||"").toLowerCase(); });
                          return <option key={oi} value={u?u.id:""}>{o.name} ({o.email})</option>;
                        })}
                      </select>
                    </div>
                    <div style={{ borderTop:"1px solid #2A2A2A", paddingTop:14 }}>
                      <label className="label">BRANCH STATUS</label>
                      <div style={{ display:"flex", gap:8, marginTop:8 }}>
                        <button className="btn btn-sm" style={{ background:editingFranchise.status==="active"?"rgba(77,231,166,0.12)":"#1E1E1E", color:editingFranchise.status==="active"?"#4DE7A6":"rgba(224,224,224,0.5)", border:"1px solid "+(editingFranchise.status==="active"?"rgba(77,231,166,0.3)":"#2A2A2A") }}
                          onClick={function(){ setEditingFranchise(function(p){ return Object.assign({},p,{status:"active",closedDate:""}); }); }}>
                          Active
                        </button>
                        <button className="btn btn-sm" style={{ background:editingFranchise.status==="closed"?"rgba(207,102,121,0.12)":"#1E1E1E", color:editingFranchise.status==="closed"?"#cf6679":"rgba(224,224,224,0.5)", border:"1px solid "+(editingFranchise.status==="closed"?"rgba(207,102,121,0.3)":"#2A2A2A") }}
                          onClick={function(){ setEditingFranchise(function(p){ return Object.assign({},p,{status:"closed"}); }); }}>
                          Closed
                        </button>
                      </div>
                      {editingFranchise.status === "closed" && (
                        <div style={{ marginTop:10 }}>
                          <label className="label">CLOSURE DATE</label>
                          <MonthPicker value={editingFranchise.closedDate||""} onChange={function(v){ setEditingFranchise(function(p){ return Object.assign({},p,{closedDate:v}); }); }} />
                        </div>
                      )}
                    </div>
                    <div style={{ borderTop:"1px solid #374151", paddingTop:14 }}>
                      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:10 }}>
                        <label className="label" style={{ margin:0 }}>OWNERS</label>
                        <button className="btn btn-secondary btn-sm" onClick={function() { setEditingFranchise(function(p) { return Object.assign({},p,{owners:p.owners.concat([{name:"",email:"",phone:"",sharePercent:""}])}); }); }}>+ Add Owner</button>
                      </div>
                      <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
                        {editingFranchise.owners.map(function(o, oi) {
                          return (
                            <div key={oi} style={{ background:"#252525", borderRadius:10, padding:"12px 14px", position:"relative" }}>
                              {editingFranchise.owners.length > 1 && (
                                <button onClick={function() { setEditingFranchise(function(p) { return Object.assign({},p,{owners:p.owners.filter(function(_,i){return i!==oi;})}); }); }} style={{ position:"absolute",top:10,right:12,background:"transparent",border:"none",cursor:"pointer",color:"#56B9E9",fontSize:13 }} onMouseEnter={function(e){e.target.style.color="#cf6679";}} onMouseLeave={function(e){e.target.style.color="#56B9E9";}}>✕</button>
                              )}
                              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 80px", gap:8, marginBottom:8 }}>
                                <div><label className="label">NAME</label><input placeholder="Owner name" value={o.name} onChange={function(e) { var v=e.target.value; setEditingFranchise(function(p) { return Object.assign({},p,{owners:p.owners.map(function(r,i){return i===oi?Object.assign({},r,{name:v}):r;})}); }); }} /></div>
                                <div><label className="label">EMAIL</label><input type="email" placeholder="owner@email.com" value={o.email||""} onChange={function(e) { var v=e.target.value; setEditingFranchise(function(p) { return Object.assign({},p,{owners:p.owners.map(function(r,i){return i===oi?Object.assign({},r,{email:v}):r;})}); }); }} /></div>
                                <div><label className="label">SHARE %</label><input type="number" min="0" max="100" placeholder="50" value={o.sharePercent||""} onChange={function(e) { var v=e.target.value; setEditingFranchise(function(p) { return Object.assign({},p,{owners:p.owners.map(function(r,i){return i===oi?Object.assign({},r,{sharePercent:v}):r;})}); }); }} /></div>
                              </div>
                              <div><label className="label">PHONE</label><input type="tel" placeholder="+44 7700 900000" value={o.phone||""} onChange={function(e) { var v=e.target.value; setEditingFranchise(function(p) { return Object.assign({},p,{owners:p.owners.map(function(r,i){return i===oi?Object.assign({},r,{phone:v}):r;})}); }); }} /></div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                    <div style={{ display:"flex", gap:10, marginTop:4 }}>
                      <button className="btn btn-primary" onClick={function() {
                        if (!editingFranchise.name || !editingFranchise.location) return;
                        var newOwners = (editingFranchise.owners||[]).filter(function(o){ return !o.id && o.name && o.email; });
                        apiPut("/api/franchises/" + editingFranchise.id, { name:editingFranchise.name, location:editingFranchise.location, phone:editingFranchise.phone, email:editingFranchise.email, royaltyStartMonth:editingFranchise.royaltyStartMonth||null, status:editingFranchise.status||"active", closedDate:editingFranchise.closedDate||null, headOfCentre:editingFranchise.headOfCentre||null }).then(function() {
                          // Add any new owners individually
                          var addPromises = newOwners.map(function(o) {
                            return apiPost("/api/franchises/" + editingFranchise.id + "/owners/add", { name:o.name, email:o.email, phone:o.phone||"", sharePercent:o.sharePercent||"0" });
                          });
                          return Promise.all(addPromises);
                        }).then(function() {
                          DB.getFranchises().then(function(d) {
                            setFranchises(d.map(function(f) {
                              return Object.assign({}, f, { financials: (f.financials || []).map(function(m) { return { month:m.month, income:parseFloat(m.income)||0, rent:parseFloat(m.rent)||0, salaries:parseFloat(m.salaries)||0, royalty:parseFloat(m.royalty)||0, otherExpenses:parseFloat(m.otherExpenses)||0 }; }) });
                            }));
                          });
                          DB.logActivity("Edited franchise", editingFranchise.name);
                          logActivity("Edited franchise", editingFranchise.name);
                          setEditingFranchise(null);
                          showToast(newOwners.length ? "Franchise updated and " + newOwners.length + " owner(s) added!" : "Franchise updated!");
                        }).catch(function(){ showToast("Error saving changes."); });
                      }}>Save Changes</button>
                      <button className="btn btn-secondary" onClick={function() { setEditingFranchise(null); }}>Cancel</button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Share Change Modal */}
            {shareChangeModal && shareChangeModal.franchiseId === activeFranchise.id && (
              <div className="modal-bg" onClick={function() { setShareChangeModal(null); }}>
                <div className="card fade-in" style={{ width:500, padding:30, maxHeight:"85vh", overflowY:"auto" }} onClick={function(e) { e.stopPropagation(); }}>
                  <h3 style={{ fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:18, marginBottom:4 }}>Change Ownership Shares</h3>
                  <p style={{ fontSize:12, color:"rgba(224,224,224,0.5)", marginBottom:20 }}>{shareChangeModal.franchiseName}</p>

                  {shareChangeStep === 1 && (
                    <div>
                      <p style={{ fontSize:13, color:"#E0E0E0", marginBottom:16 }}>Who are you changing shares for? Select all that apply.</p>
                      <div style={{ display:"flex", flexDirection:"column", gap:8, marginBottom:20 }}>
                        {shareChangeForm.shares.map(function(s, si) {
                          var color = s.type === "owner" ? "#34d399" : "#7B9EFF";
                          var typeLabel = s.type === "owner" ? "Franchisee" : "Investor";
                          return (
                            <div key={si} onClick={function(){ setShareChangeForm(function(p){ var ns=[].concat(p.shares); ns[si]=Object.assign({},ns[si],{selected:!ns[si].selected}); return Object.assign({},p,{shares:ns}); }); }}
                              style={{ background: s.selected ? color+"15" : "#252525", borderRadius:10, padding:"12px 14px", cursor:"pointer", display:"flex", justifyContent:"space-between", alignItems:"center", border:"1px solid "+(s.selected?color+"40":"#2A2A2A"), borderLeft:"3px solid "+(s.selected?color:"#2A2A2A") }}>
                              <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                                <div style={{ width:20, height:20, borderRadius:4, border:"2px solid "+(s.selected?color:"rgba(224,224,224,0.2)"), background:s.selected?color:"transparent", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                                  {s.selected && <span style={{ color:"#121212", fontSize:12, fontWeight:800 }}>✓</span>}
                                </div>
                                <div>
                                  <div style={{ fontWeight:600, fontSize:13, color:"#E0E0E0" }}>{s.name}</div>
                                  <div style={{ fontSize:11, color:"rgba(224,224,224,0.5)" }}>{typeLabel} · Current: {s.sharePercent}%</div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      {/* Add new person */}
                      <div style={{ borderTop:"1px solid #2A2A2A", paddingTop:12, marginBottom:16 }}>
                        <p style={{ fontSize:11, color:"rgba(224,224,224,0.45)", marginBottom:10 }}>Adding a new franchisee to this branch?</p>
                        <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
                          <input placeholder="Full name" id="newOwnerName" style={{ flex:1, minWidth:120 }} />
                          <input placeholder="Email" id="newOwnerEmail" style={{ flex:1, minWidth:140 }} />
                          <input placeholder="Share %" id="newOwnerShare" type="number" min="0" max="100" style={{ width:80 }} />
                          <button className="btn btn-sm" style={{ background:"rgba(77,231,166,0.1)", color:"#4DE7A6", border:"1px solid rgba(52,211,153,0.3)", whiteSpace:"nowrap" }}
                            onClick={function(){
                              var name = document.getElementById('newOwnerName').value.trim();
                              var email = document.getElementById('newOwnerEmail').value.trim();
                              var share = document.getElementById('newOwnerShare').value;
                              if (!name) { showToast("Please enter a name."); return; }
                              setShareChangeForm(function(p){
                                return Object.assign({},p,{
                                  shares: p.shares.concat([{ type:'owner', name:name, email:email, phone:"", sharePercent:share, selected:true, isNew:true }])
                                });
                              });
                              document.getElementById('newOwnerName').value = '';
                              document.getElementById('newOwnerEmail').value = '';
                              document.getElementById('newOwnerShare').value = '';
                              showToast(name + " added — they will be ticked and included in step 2.");
                            }}>+ Add to list</button>
                        </div>
                      </div>
                      <div style={{ display:"flex", gap:10 }}>
                        <button className="btn btn-primary" onClick={function(){
                          var anySelected = shareChangeForm.shares.some(function(s){ return s.selected; });
                          if (!anySelected) { showToast("Please select at least one person."); return; }
                          setShareChangeStep(2);
                        }}>Next →</button>
                        <button className="btn btn-secondary" onClick={function() { setShareChangeModal(null); }}>Cancel</button>
                      </div>
                    </div>
                  )}

                  {shareChangeStep === 2 && (
                    <div>
                      <button onClick={function(){ setShareChangeStep(1); }} style={{ background:"none", border:"none", color:"#56B9E9", cursor:"pointer", fontSize:12, padding:0, marginBottom:16 }}>← Back</button>
                      <div style={{ marginBottom:16 }}>
                        <label className="label">EFFECTIVE FROM</label>
                        <MonthPicker value={shareChangeForm.effectiveFrom} onChange={function(v){ setShareChangeForm(function(p){ return Object.assign({},p,{effectiveFrom:v}); }); }} />
                      </div>
                      <p style={{ fontSize:12, color:"rgba(224,224,224,0.5)", marginBottom:12 }}>Edit new share % for selected people. Unselected people keep their current share.</p>
                      <div style={{ display:"flex", flexDirection:"column", gap:8, marginBottom:16 }}>
                        {shareChangeForm.shares.map(function(s, si) {
                          var color = s.type === "owner" ? "#34d399" : "#7B9EFF";
                          var isSelected = s.selected;
                          return (
                            <div key={si} style={{ background:"#252525", borderRadius:10, padding:"12px 14px", borderLeft:"3px solid "+(isSelected?color:"#2A2A2A"), opacity: isSelected ? 1 : 0.5 }}>
                              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                                <div>
                                  <div style={{ fontWeight:600, fontSize:13, color:"#E0E0E0" }}>{s.name}</div>
                                  <div style={{ fontSize:11, color:"rgba(224,224,224,0.5)" }}>{s.type === "owner" ? "Franchisee" : "Investor"}</div>
                                </div>
                                {isSelected ? (
                                  <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                                    <input type="number" min="0" max="100" step="0.5" placeholder="New %"
                                      value={s.sharePercent}
                                      onChange={function(e){ var v=e.target.value; setShareChangeForm(function(p){ var ns=[].concat(p.shares); ns[si]=Object.assign({},ns[si],{sharePercent:v}); return Object.assign({},p,{shares:ns}); }); }}
                                      style={{ width:80, background:"#1E1E1E", border:"1px solid "+color+"60", color:"#E0E0E0", padding:"6px 8px", borderRadius:6, fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none", textAlign:"center" }} />
                                    <span style={{ color:"rgba(224,224,224,0.4)", fontSize:13 }}>%</span>
                                  </div>
                                ) : (
                                  <span style={{ color:"rgba(224,224,224,0.4)", fontSize:13, fontWeight:600 }}>{s.sharePercent}% (unchanged)</span>
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      {(function(){
                        var total = shareChangeForm.shares.reduce(function(s,x){ return s + (parseFloat(x.sharePercent)||0); }, 0);
                        var ok = Math.abs(total - 100) < 0.01;
                        return (
                          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"12px 14px", background: ok ? "rgba(77,231,166,0.06)" : "rgba(207,102,121,0.06)", borderRadius:10, border:"1px solid "+(ok?"rgba(77,231,166,0.2)":"rgba(207,102,121,0.2)"), marginBottom:20 }}>
                            <span style={{ fontSize:13, fontWeight:600, color:"rgba(224,224,224,0.7)" }}>TOTAL (OWNERS + INVESTORS)</span>
                            <span style={{ fontSize:16, fontWeight:800, color: ok ? "#4DE7A6" : "#cf6679" }}>{total.toFixed(1)}% {ok ? "✓" : "≠ 100%"}</span>
                          </div>
                        );
                      })()}
                      <div style={{ display:"flex", gap:10 }}>
                        <button className="btn btn-primary" onClick={function() {
                          if (!shareChangeForm.effectiveFrom) { showToast("Please set an effective from month."); return; }
                          var total = shareChangeForm.shares.reduce(function(s,x){ return s + (parseFloat(x.sharePercent)||0); }, 0);
                          if (Math.abs(total - 100) > 0.01) { showToast("Shares must total exactly 100%. Current total: " + total.toFixed(1) + "%"); return; }
                          var newOwners = shareChangeForm.shares.filter(function(s){ return s.type==="owner" && s.isNew; });
                          var existingOwnerChanges = shareChangeForm.shares.filter(function(s){ return s.type==="owner" && s.selected && !s.isNew; });
                          var invChanges = shareChangeForm.shares.filter(function(s){ return s.type==="investor" && s.selected; });
                          var promises = [];
                          // Add new owners first
                          newOwners.forEach(function(o){
                            promises.push(apiPost("/api/franchises/" + shareChangeModal.franchiseId + "/owners/add", { name:o.name, email:o.email, phone:o.phone||"", sharePercent:o.sharePercent, effectiveFrom:shareChangeForm.effectiveFrom }));
                          });
                          // Share-change for all existing owners (to record new % with effective date)
                          var allExistingOwners = shareChangeForm.shares.filter(function(s){ return s.type==="owner" && !s.isNew; });
                          if (allExistingOwners.length) {
                            promises.push(apiPost("/api/franchises/" + shareChangeModal.franchiseId + "/owners/share-change", {
                              effectiveFrom: shareChangeForm.effectiveFrom,
                              changes: allExistingOwners.map(function(s){ return { name:s.name, email:s.email, phone:s.phone||"", sharePercent:s.sharePercent }; })
                            }));
                          }
                          if (invChanges.length) {
                            var allInvChanges = shareChangeForm.shares.filter(function(s){ return s.type==="investor"; });
                            promises.push(apiPost("/api/franchises/" + shareChangeModal.franchiseId + "/investors/share-change", {
                              effectiveFrom: shareChangeForm.effectiveFrom,
                              changes: allInvChanges.map(function(s){ return { userId:s.userId, sharePercent:s.sharePercent }; })
                            }));
                          }
                          Promise.all(promises).then(function() {
                            DB.getFranchises().then(function(d){ if(d) save(d); });
                            setShareChangeModal(null);
                            showToast(newOwners.length ? "New owner added and shares updated!" : "Share changes recorded!");
                          }).catch(function(){ showToast("Error saving share changes."); });
                        }}>Save Changes</button>
                        <button className="btn btn-secondary" onClick={function() { setShareChangeModal(null); }}>Cancel</button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
            {/* MARGIN OVERVIEW */}
            {activeFranchise.financials.length > 0 && (function() {
              var sorted = [].concat(activeFranchise.financials).sort(function(a,b) { return parseMonthDate(b.month)-parseMonthDate(a.month); });
              var latest = sorted[0];
              var prev = sorted[1] || null;
              var latestNet = latest ? latest.income - totalExp(latest) : 0;
              var latestMargin = latest && latest.income > 0 ? latestNet / latest.income * 100 : 0;
              var prevNet = prev ? prev.income - totalExp(prev) : 0;
              var prevMargin = prev && prev.income > 0 ? prevNet / prev.income * 100 : null;
              var marginDiff = prevMargin !== null ? latestMargin - prevMargin : null;

              // Yearly margins
              var yearMap = {};
              activeFranchise.financials.forEach(function(m) {
                var match = m.month && m.month.toString().match(/(20[0-9][0-9])/);
                if (!match) return;
                var yr = match[1];
                if (!yearMap[yr]) yearMap[yr] = { income:0, net:0 };
                yearMap[yr].income += m.income;
                yearMap[yr].net += m.income - totalExp(m);
              });
              var yearRows = Object.keys(yearMap).sort(function(a,b) { return b-a; }).map(function(yr) {
                var y = yearMap[yr];
                return { year:yr, income:y.income, net:y.net, margin:y.income > 0 ? y.net/y.income*100 : 0 };
              });

              // All monthly margins for history
              var monthlyMargins = sorted.slice(0, 12);

              return (
                <div style={{ marginBottom:22 }}>
                  {/* Summary cards */}
                  <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:12, marginBottom:16 }}>
                    <div className="card" style={{ padding:16, borderLeft:"3px solid #56B9E9" }}>
                      <div className="label" style={{ marginBottom:6 }}>LATEST MARGIN</div>
                      <div style={{ fontFamily:"Playfair Display,serif", fontWeight:800, fontSize:22, color:"#56B9E9" }}>{pct(latestMargin)}</div>
                      <div style={{ fontSize:11, color:"rgba(224,224,224,0.45)", marginTop:3 }}>{latest.month}</div>
                      {marginDiff !== null && (
                        <div style={{ fontSize:11, marginTop:4, color: marginDiff >= 0 ? "#4DE7A6" : "#cf6679" }}>
                          {marginDiff >= 0 ? "▲" : "▼"} {Math.abs(marginDiff).toFixed(1)}% vs prev month
                        </div>
                      )}
                    </div>
                    <div className="card" style={{ padding:16, borderLeft:"3px solid " + (prevMargin !== null ? "#4DE7A6" : "#2A2A2A") }}>
                      <div className="label" style={{ marginBottom:6 }}>PREVIOUS MONTH</div>
                      <div style={{ fontFamily:"Playfair Display,serif", fontWeight:800, fontSize:22, color: prevMargin !== null ? "#4DE7A6" : "rgba(224,224,224,0.3)" }}>{prevMargin !== null ? pct(prevMargin) : "—"}</div>
                      <div style={{ fontSize:11, color:"rgba(224,224,224,0.45)", marginTop:3 }}>{prev ? prev.month : "No data"}</div>
                    </div>
                    <div className="card" style={{ padding:16, borderLeft:"3px solid #cf6679" }}>
                      <div className="label" style={{ marginBottom:6 }}>THIS YEAR ({yearRows[0] ? yearRows[0].year : "—"})</div>
                      <div style={{ fontFamily:"Playfair Display,serif", fontWeight:800, fontSize:22, color:"#cf6679" }}>{yearRows[0] ? pct(yearRows[0].margin) : "—"}</div>
                      <div style={{ fontSize:11, color:"rgba(224,224,224,0.45)", marginTop:3 }}>{yearRows[0] ? fmt(yearRows[0].net) + " net profit" : ""}</div>
                    </div>
                  </div>

                  {/* Historic margin by year */}
                  {yearRows.length > 0 && (
                    <div className="card" style={{ padding:0, overflow:"hidden", marginBottom:12 }}>
                      <div style={{ padding:"14px 18px 0", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                        <label className="label" style={{ margin:0 }}>YEARLY MARGINS</label>
                      </div>
                      <table style={{ width:"100%", borderCollapse:"collapse", fontSize:12 }}>
                        <thead>
                          <tr style={{ borderBottom:"1px solid #2A2A2A" }}>
                            {["YEAR","TOTAL INCOME","TOTAL EXPENSES","NET PROFIT","MARGIN"].map(function(h) {
                              return <th key={h} style={{ padding:"10px 18px", textAlign:"left", fontSize:10, letterSpacing:"0.08em", color:"rgba(224,224,224,0.45)", fontWeight:700 }}>{h}</th>;
                            })}
                          </tr>
                        </thead>
                        <tbody>
                          {yearRows.map(function(y, yi) {
                            var exp = y.income - y.net;
                            var barW = Math.min(Math.abs(y.margin), 100);
                            return (
                              <tr key={y.year} style={{ borderBottom:"1px solid rgba(255,255,255,0.04)" }}>
                                <td style={{ padding:"12px 18px", fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:14, color:"#E0E0E0" }}>{y.year}</td>
                                <td style={{ padding:"12px 18px", color:"#56B9E9", fontWeight:600 }}>{fmt(y.income)}</td>
                                <td style={{ padding:"12px 18px", color:"#cf6679", fontWeight:600 }}>{fmt(exp)}</td>
                                <td style={{ padding:"12px 18px", color: y.net >= 0 ? "#4DE7A6" : "#cf6679", fontWeight:700 }}>{fmt(y.net)}</td>
                                <td style={{ padding:"12px 18px" }}>
                                  <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                                    <div style={{ flex:1, background:"rgba(255,255,255,0.06)", borderRadius:4, height:6, overflow:"hidden" }}>
                                      <div style={{ width:barW+"%", background: y.margin >= 0 ? "#4DE7A6" : "#cf6679", height:"100%", borderRadius:4 }} />
                                    </div>
                                    <span style={{ color: y.margin >= 0 ? "#4DE7A6" : "#cf6679", fontWeight:700, minWidth:42, textAlign:"right" }}>{pct(y.margin)}</span>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  )}

                  {/* Monthly margin history with pagination */}
                  {sorted.length > 1 && (function() {
                    var pageSize = 12;
                    var totalPages = Math.ceil(sorted.length / pageSize);
                    var safePage = Math.min(marginPage, totalPages - 1);
                    var pageMonths = sorted.slice(safePage * pageSize, safePage * pageSize + pageSize);
                    var hasPrev = safePage < totalPages - 1;
                    var hasNext = safePage > 0;
                    var startLabel = pageMonths.length > 0 ? pageMonths[pageMonths.length-1].month : "";
                    var endLabel = pageMonths.length > 0 ? pageMonths[0].month : "";
                    return (
                      <div className="card" style={{ padding:0, overflow:"hidden" }}>
                        <div style={{ padding:"14px 18px", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                          <label className="label" style={{ margin:0 }}>MONTHLY MARGIN HISTORY</label>
                          <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                            <button className="btn btn-secondary btn-sm" style={{ padding:"5px 10px", opacity:hasPrev?1:0.3 }}
                              onClick={function() { if (hasPrev) setMarginPage(safePage+1); }}>←</button>
                            <span style={{ fontSize:12, color:"rgba(224,224,224,0.45)", minWidth:120, textAlign:"center" }}>{startLabel} — {endLabel}</span>
                            <button className="btn btn-secondary btn-sm" style={{ padding:"5px 10px", opacity:hasNext?1:0.3 }}
                              onClick={function() { if (hasNext) setMarginPage(safePage-1); }}>→</button>
                          </div>
                        </div>
                        <table style={{ width:"100%", borderCollapse:"collapse", fontSize:12 }}>
                          <thead>
                            <tr style={{ borderBottom:"1px solid #2A2A2A" }}>
                              {["MONTH","INCOME","NET PROFIT","MARGIN","TREND"].map(function(h) {
                                return <th key={h} style={{ padding:"10px 18px", textAlign:"left", fontSize:10, letterSpacing:"0.08em", color:"rgba(224,224,224,0.45)", fontWeight:700 }}>{h}</th>;
                              })}
                            </tr>
                          </thead>
                          <tbody>
                            {pageMonths.map(function(m, mi) {
                              var net = m.income - totalExp(m);
                              var margin = m.income > 0 ? net/m.income*100 : 0;
                              var nextInPage = pageMonths[mi+1];
                              var nextInAll = sorted[safePage * pageSize + mi + 1];
                              var prevM = nextInPage || nextInAll;
                              var prevMarginM = prevM && prevM.income > 0 ? (prevM.income-totalExp(prevM))/prevM.income*100 : null;
                              var diff = prevMarginM !== null ? margin - prevMarginM : null;
                              return (
                                <tr key={m.month} style={{ borderBottom:"1px solid rgba(255,255,255,0.04)" }}>
                                  <td style={{ padding:"10px 18px", color:"#E0E0E0", fontWeight:500 }}>{m.month}</td>
                                  <td style={{ padding:"10px 18px", color:"#56B9E9" }}>{fmt(m.income)}</td>
                                  <td style={{ padding:"10px 18px", color: net >= 0 ? "#4DE7A6" : "#cf6679", fontWeight:600 }}>{fmt(net)}</td>
                                  <td style={{ padding:"10px 18px", color: margin >= 0 ? "#4DE7A6" : "#cf6679", fontWeight:700 }}>{pct(margin)}</td>
                                  <td style={{ padding:"10px 18px", fontSize:11, color: diff === null ? "rgba(224,224,224,0.3)" : diff >= 0 ? "#4DE7A6" : "#cf6679" }}>
                                    {diff === null ? "—" : (diff >= 0 ? "▲ +" : "▼ ") + diff.toFixed(1) + "%"}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    );
                  })()}
                </div>
              );
            })()}

            {activeFranchise.financials.length > 1 && (
              <div className="card" style={{ marginBottom:22 }}>
                <label className="label" style={{ marginBottom:14 }}>INCOME VS EXPENSES</label>
                <ResponsiveContainer width="100%" height={190}>
                  <LineChart data={activeFranchise.financials.sort(function(a,b){ return parseMonthDate(a.month)-parseMonthDate(b.month); }).slice(-6).map(function(m) { return { month:m.month, income:parseFloat(m.income)||0, expenses:(parseFloat(m.rent)||0)+(parseFloat(m.salaries)||0)+(parseFloat(m.royalty)||0)+(parseFloat(m.otherExpenses)||0), profit:(parseFloat(m.income)||0)-((parseFloat(m.rent)||0)+(parseFloat(m.salaries)||0)+(parseFloat(m.royalty)||0)+(parseFloat(m.otherExpenses)||0)) }; })}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#1E1E1E" vertical={false} />
                    <XAxis dataKey="month" tick={{ fill:"#56B9E9", fontSize:11 }} axisLine={false} tickLine={false} />
                    <YAxis tick={{ fill:"#56B9E9", fontSize:11 }} axisLine={false} tickLine={false} tickFormatter={function(v) { return "£"+Math.round(v/1000)+"k"; }} />
                    <Tooltip content={<ChartTooltip />} />
                    <Legend wrapperStyle={{ fontSize:11, color:"rgba(224,224,224,0.6)" }} />
                    <Line type="monotone" dataKey="income" name="Income" stroke="#56B9E9" strokeWidth={2} dot={false} />
                    <Line type="monotone" dataKey="expenses" name="Expenses" stroke="#cf6679" strokeWidth={2} dot={false} />
                    <Line type="monotone" dataKey="profit" name="Profit" stroke="#56B9E9" strokeWidth={2.5} dot={{ fill:"#E0E0E0", r:3 }} />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            )}
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:18 }}>
              <div style={{ gridColumn:"1 / -1" }}>
                {(function() {
                  var allYears = Array.from(new Set(activeFranchise.financials.map(function(m) {
                    if (!m.month) return null;
                    var s = m.month.toString();
                    var match = s.match(/\b(20\d\d)\b/);
                    return match ? parseInt(match[1]) : null;
                  }).filter(Boolean))).sort(function(a,b) { return b-a; });
                  if (allYears.length === 0) allYears = [new Date().getFullYear()];
                  var currentYear = allYears.indexOf(selectedYear) === -1 ? allYears[0] : selectedYear;
                  var yearFinancials = activeFranchise.financials.filter(function(m) {
                    if (!m.month) return false;
                    var match = m.month.toString().match(/\b(20\d\d)\b/);
                    return match && parseInt(match[1]) === currentYear;
                  });
                  var yearIncome = yearFinancials.reduce(function(s,m) { return s+m.income; }, 0);
                  var yearExp = yearFinancials.reduce(function(s,m) { return s+totalExp(m); }, 0);
                  var yearNet = yearIncome - yearExp;
                  var prevYear = currentYear - 1;
                  var nextYear = currentYear + 1;
                  var hasPrev = activeFranchise.financials.some(function(m) { var match = m.month && m.month.toString().match(/\b(20\d\d)\b/); return match && parseInt(match[1]) === prevYear; });
                  var hasNext = activeFranchise.financials.some(function(m) { var match = m.month && m.month.toString().match(/\b(20\d\d)\b/); return match && parseInt(match[1]) === nextYear; });

                  return (
                    <div>
                      {/* Year navigation */}
                      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:10 }}>
                        <label className="label" style={{ margin:0 }}>FINANCIALS</label>
                        <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                          <button className="btn btn-secondary btn-sm" style={{ padding:"5px 10px", opacity:hasPrev?1:0.3 }} onClick={function() { if (hasPrev) setSelectedYear(prevYear); }}>←</button>
                          <select value={currentYear} onChange={function(e) { setSelectedYear(parseInt(e.target.value)); }}
                            style={{ background:"#1E1E1E", border:"1px solid #374151", color:"#E0E0E0", padding:"6px 12px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none", fontWeight:600 }}>
                            {allYears.map(function(y) { return <option key={y} value={y}>{y}</option>; })}
                          </select>
                          <button className="btn btn-secondary btn-sm" style={{ padding:"5px 10px", opacity:hasNext?1:0.3 }} onClick={function() { if (hasNext) setSelectedYear(nextYear); }}>→</button>
                          <button className="btn btn-primary btn-sm" onClick={function() { setModal("new-financial"); }}>+ Add Month</button>
                        </div>
                      </div>

                      {/* Year summary totals */}
                      {yearFinancials.length > 0 && (
                        <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:8, marginBottom:12 }}>
                          <div style={{ background:"#252525", borderRadius:8, padding:"10px 14px" }}>
                            <div style={{ fontSize:9, color:"#56B9E9", letterSpacing:"0.1em", marginBottom:3 }}>YEAR INCOME</div>
                            <div style={{ fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:16, color:"#56B9E9" }}>{fmt(yearIncome)}</div>
                          </div>
                          <div style={{ background:"#252525", borderRadius:8, padding:"10px 14px" }}>
                            <div style={{ fontSize:9, color:"#56B9E9", letterSpacing:"0.1em", marginBottom:3 }}>YEAR EXPENSES</div>
                            <div style={{ fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:16, color:"#cf6679" }}>{fmt(yearExp)}</div>
                          </div>
                          <div style={{ background:"#252525", borderRadius:8, padding:"10px 14px" }}>
                            <div style={{ fontSize:9, color:"#56B9E9", letterSpacing:"0.1em", marginBottom:3 }}>YEAR NET PROFIT</div>
                            <div style={{ fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:16, color: yearNet >= 0 ? "#E0E0E0" : "#cf6679" }}>{fmt(yearNet)}</div>
                          </div>
                        </div>
                      )}

                      <div className="card" style={{ padding:0, overflow:"hidden", overflowX:"auto" }}>
                        <table style={{ width:"100%", borderCollapse:"collapse", fontSize:12, minWidth:700 }}>
                          <thead><tr style={{ borderBottom:"1px solid #374151" }}>{["MONTH","INCOME","RENT","SALARIES","ROYALTY","OTHER","TOTAL EXP","NET PROFIT",""].map(function(h) { return <th key={h} style={{ padding:"11px 14px", textAlign:"left", fontSize:10, letterSpacing:"0.1em", color:"#56B9E9", fontWeight:500, whiteSpace:"nowrap" }}>{h}</th>; })}</tr></thead>
                          <tbody>
                            {yearFinancials.length === 0
                              ? <tr><td colSpan={9} style={{ padding:"22px 14px", color:"#56B9E9", textAlign:"center" }}>No data for {currentYear}</td></tr>
                              : [].concat(yearFinancials).sort(function(a,b){ return parseMonthDate(b.month)-parseMonthDate(a.month); }).map(function(m) {
                                var realIdx = activeFranchise.financials.indexOf(m);
                                var exp = totalExp(m); var net = m.income - exp;
                                var isEditing = editingRow && editingRow.franchiseId === activeFranchise.id && editingRow.monthIndex === realIdx;
                          if (isEditing) {
                            return (
                              <tr key={"edit-"+realIdx} style={{ borderBottom:"1px solid #141414", background:"#121212" }}>
                                <td style={{ padding:"8px 14px" }}>
                                  <MonthPicker value={editingRow.fields.month} onChange={function(v) { setEditingRow(function(r) { return Object.assign({}, r, { fields:Object.assign({}, r.fields, { month:v }) }); }); }} label="" />
                                </td>
                                {["income","rent","salaries","royalty","otherExpenses"].map(function(field) {
                                  return (
                                    <td key={field} style={{ padding:"8px 6px" }}>
                                      <input type="number" value={editingRow.fields[field] || 0}
                                        onChange={function(e) { var val = e.target.value; setEditingRow(function(r) { var f2 = Object.assign({}, r.fields); f2[field] = val; return Object.assign({}, r, { fields:f2 }); }); }}
                                        style={{ background:"#2a2a2a", border:"1px solid #666", color:"#E0E0E0", padding:"7px 10px", borderRadius:6, fontFamily:"Outfit,sans-serif", fontSize:12, outline:"none", width:"100%", maxWidth:90 }} />
                                    </td>
                                  );
                                })}
                                <td style={{ padding:"8px 14px", color:"#cf6679" }}>{fmt((parseFloat(editingRow.fields.rent)||0)+(parseFloat(editingRow.fields.salaries)||0)+(parseFloat(editingRow.fields.royalty)||0)+(parseFloat(editingRow.fields.otherExpenses)||0))}</td>
                                <td style={{ padding:"8px 14px" }}>
                                  <div style={{ display:"flex", gap:6 }}>
                                    <button className="btn btn-sm" style={{ background:"rgba(77,231,166,0.1)", color:"#4DE7A6", border:"1px solid rgba(52,211,153,0.3)", fontSize:11, padding:"5px 10px" }}
                                      onClick={function() {
                                        var oldRow = activeFranchise.financials[realIdx];
                                        var newRow = { month:editingRow.fields.month, income:parseFloat(editingRow.fields.income)||0, rent:parseFloat(editingRow.fields.rent)||0, salaries:parseFloat(editingRow.fields.salaries)||0, royalty:parseFloat(editingRow.fields.royalty)||0, otherExpenses:parseFloat(editingRow.fields.otherExpenses)||0 };
                                        var changes = [];
                                        if (oldRow.month !== newRow.month) changes.push("Month: " + oldRow.month + " to " + newRow.month);
                                        if (oldRow.income !== newRow.income) changes.push("Income: " + fmt(oldRow.income) + " to " + fmt(newRow.income));
                                        var updated = franchises.map(function(f) {
                                          if (f.id !== activeFranchise.id) return f;
                                          return Object.assign({}, f, { financials:f.financials.map(function(row, idx) { return idx === realIdx ? newRow : row; }) });
                                        });
                                        apiPut("/api/franchises/" + activeFranchise.id + "/financials/" + encodeURIComponent(oldRow.month), newRow).then(function() {
                                          save(updated);
                                          if (changes.length) { logActivity("Edited financial row", activeFranchise.name + " - " + newRow.month + ": " + changes.join(", ")); DB.logActivity("Edited financial row", activeFranchise.name + " - " + newRow.month); }
                                          setEditingRow(null); showToast("Row updated.");
                                        });
                                      }}>Save</button>
                                    <button className="btn btn-sm btn-secondary" style={{ fontSize:11, padding:"5px 10px" }} onClick={function() { setEditingRow(null); }}>Cancel</button>
                                    <button className="btn btn-sm" style={{ background:"rgba(207,102,121,0.1)", color:"#cf6679", border:"1px solid rgba(240,104,104,0.3)", fontSize:11, padding:"5px 10px" }}
                                      onClick={function() {
                                        if (!confirm("Delete this row?")) return;
                                        var delMonth = activeFranchise.financials[realIdx].month;
                                        apiDelete("/api/franchises/" + activeFranchise.id + "/financials/" + encodeURIComponent(delMonth)).then(function() {
                                          var updated = franchises.map(function(f) {
                                            if (f.id !== activeFranchise.id) return f;
                                            return Object.assign({}, f, { financials:f.financials.filter(function(_, idx) { return idx !== realIdx; }) });
                                          });
                                          save(updated);
                                          logActivity("Deleted financial row", activeFranchise.name + " - " + delMonth);
                                          DB.logActivity("Deleted financial row", activeFranchise.name + " - " + delMonth);
                                          setEditingRow(null); showToast("Row deleted.");
                                        });
                                      }}>Delete</button>
                                  </div>
                                </td>
                              </tr>
                            );
                          }
                          return (
                            <tr key={m.month} style={{ borderBottom:"1px solid #141414" }} onMouseEnter={function(e) { e.currentTarget.style.background="#252525"; }} onMouseLeave={function(e) { e.currentTarget.style.background="transparent"; }}>
                              <td style={{ padding:"11px 14px", color:"rgba(224,224,224,0.6)" }}>{m.month}</td>
                              <td style={{ padding:"11px 14px", color:"#56B9E9" }}>{fmt(m.income)}</td>
                              <td style={{ padding:"11px 14px", color:"rgba(224,224,224,0.6)" }}>{fmt(m.rent || 0)}</td>
                              <td style={{ padding:"11px 14px", color:"rgba(224,224,224,0.6)" }}>{fmt(m.salaries || 0)}</td>
                              <td style={{ padding:"11px 14px", color:"rgba(224,224,224,0.6)" }}>{fmt(m.royalty || 0)}</td>
                              <td style={{ padding:"11px 14px", color:"rgba(224,224,224,0.6)" }}>{fmt(m.otherExpenses || 0)}</td>
                              <td style={{ padding:"11px 14px", color:"#cf6679", fontWeight:500 }}>{fmt(exp)}</td>
                              <td style={{ padding:"11px 14px", color:"#E0E0E0", fontWeight:600 }}>{fmt(net)}</td>
                              <td style={{ padding:"11px 14px" }}>
                                <div style={{ display:"flex", gap:8, alignItems:"center" }}>
                                  <span style={{ cursor:"pointer", color:"#56B9E9", fontSize:13 }}
                                    onMouseEnter={function(e) { e.target.style.color="#56B9E9"; }}
                                    onMouseLeave={function(e) { e.target.style.color="#56B9E9"; }}
                                    onClick={function() { setEditingRow({ franchiseId:activeFranchise.id, monthIndex:realIdx, fields:Object.assign({}, m) }); }}>✎</span>
                                  <span style={{ cursor:"pointer", color:"#333333", fontSize:13 }}
                                    onMouseEnter={function(e) { e.target.style.color="#cf6679"; }}
                                    onMouseLeave={function(e) { e.target.style.color="#333333"; }}
                                    onClick={function() {
                                      if (!confirm("Delete " + m.month + "?")) return;
                                      apiDelete("/api/franchises/" + activeFranchise.id + "/financials/" + encodeURIComponent(m.month)).then(function() {
                                        var updated = franchises.map(function(f) {
                                          if (f.id !== activeFranchise.id) return f;
                                          return Object.assign({}, f, { financials:f.financials.filter(function(_, idx) { return idx !== realIdx; }) });
                                        });
                                        save(updated);
                                        DB.logActivity("Deleted financial row", activeFranchise.name + " - " + m.month);
                                        logActivity("Deleted financial row", activeFranchise.name + " - " + m.month);
                                        showToast("Row deleted.");
                                      });
                                    }}>✕</span>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  );
                })()}
              </div>
              <div style={{ display:"flex", flexDirection:"column", gap:20, gridColumn:"1 / -1" }}>

                {/* FRANCHISEES */}
                <div>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:10 }}>
                    <label className="label" style={{ margin:0 }}>FRANCHISEES</label>
                    <button className="btn btn-sm" style={{ background:"rgba(77,231,166,0.1)", color:"#4DE7A6", border:"1px solid rgba(52,211,153,0.3)", fontSize:11 }}
                      onClick={function() {
                        var currentOwners = (activeFranchise.owners||[]).filter(function(o){ return o.isCurrent !== false; });
                        var currentInvs = (activeFranchise.investors||[]).filter(function(i){ return i.isCurrent !== false; });
                        setShareChangeModal({ franchiseId: activeFranchise.id, franchiseName: activeFranchise.name });
                        setShareChangeForm({
                          effectiveFrom: "",
                          shares: currentOwners.map(function(o){ return { type:'owner', name:o.name, email:o.email, phone:o.phone||"", sharePercent:o.sharePercent||"", selected: false }; })
                            .concat(currentInvs.map(function(i){ return { type:'investor', userId:i.userId, name:i.name, email:i.email, sharePercent:i.sharePercent||"", selected: false }; }))
                        });
                        setShareChangeStep(1);
                      }}>✏ Change Shares</button>
                  </div>
                  {(function() {
                    var owners = (activeFranchise.owners || []).filter(function(o){ return o.isCurrent !== false; });
                    var allOwners = activeFranchise.owners || [];
                    var franchiseSals = activeFranchise.salaries || [];
                    var franchiseeUsers = users.filter(function(u) { return (u.role === "franchisee" || u.role === "franchisee_investor") && u.franchiseId === activeFranchise.id; });
                    var allFranchisees = [].concat(owners.map(function(o) {
                      var matchedUser = users.find(function(u) { return u.email && o.email && u.email.toLowerCase() === o.email.toLowerCase(); });
                      return { name:o.name, email:o.email, phone:o.phone, sharePercent:o.sharePercent, effectiveFrom:o.effectiveFrom, userId: matchedUser ? matchedUser.id : null };
                    }));
                    franchiseeUsers.forEach(function(u) {
                      var already = allFranchisees.find(function(f) { return f.email && f.email.toLowerCase() === u.email.toLowerCase(); });
                      if (!already) allFranchisees.push({ name:u.name, email:u.email, phone:u.phone, sharePercent:"", userId:u.id });
                    });
                    if (allFranchisees.length === 0) {
                      return <div style={{ color:"#56B9E9", fontSize:12, padding:"10px 0" }}>No franchisees assigned to this branch.</div>;
                    }
                    return (
                      <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
                        {allFranchisees.map(function(u, uidx) {
                          var afid = activeFranchise.id;
                          var uid = u.userId;
                          var userSals = franchiseSals.filter(function(s){ return s.userId === uid; }).sort(function(a,b){ return parseMonthDate(b.effectiveFrom)-parseMonthDate(a.effectiveFrom); });
                          var currentSal = userSals.length > 0 ? userSals[0] : null;
                          var salHistKey = afid + "_" + uidx + "_sal";
                          return (
                            <div key={uidx} className="card" style={{ padding:"13px 16px", borderLeft:"3px solid #34d399" }}>
                              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", gap:12, flexWrap:"wrap" }}>
                                <div style={{ display:"flex", alignItems:"center", gap:10, flex:1 }}>
                                  <div style={{ width:32, height:32, borderRadius:"50%", background:"rgba(77,231,166,0.1)", border:"1px solid rgba(52,211,153,0.3)", display:"flex", alignItems:"center", justifyContent:"center", color:"#4DE7A6", fontFamily:"Playfair Display,serif", fontWeight:800, fontSize:12, flexShrink:0 }}>{u.name.charAt(0)}</div>
                                  <div>
                                    <div style={{ display:"flex", alignItems:"center", gap:6, marginBottom:2 }}>
                                      <span style={{ fontWeight:600, fontSize:13 }}>{u.name}</span>
                                      <span className="tag" style={{ background:"rgba(77,231,166,0.1)", color:"#4DE7A6", fontSize:10 }}>Franchisee</span>
                                    </div>
                                    <div style={{ fontSize:11, color:"rgba(224,224,224,0.6)" }}>{u.email}{u.phone ? " · " + u.phone : ""}</div>
                                  </div>
                                </div>
                                <div style={{ textAlign:"right" }}>
                                  <div style={{ color:"#4DE7A6", fontWeight:700, fontSize:18 }}>{u.sharePercent}%</div>
                                  {u.effectiveFrom && <div style={{ fontSize:10, color:"rgba(224,224,224,0.35)" }}>from {u.effectiveFrom}</div>}
                                </div>
                              </div>
                              {/* Salary section */}
                              <div style={{ marginTop:10, paddingTop:10, borderTop:"1px solid #2A2A2A" }}>
                                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:8 }}>
                                  <div style={{ fontSize:11, color:"rgba(224,224,224,0.45)" }}>SALARY</div>
                                  {currentSal
                                    ? <span style={{ fontSize:12, color:"#4DE7A6", fontWeight:600 }}>{fmt(currentSal.amount)}/mo <span style={{ color:"rgba(224,224,224,0.35)", fontWeight:400, fontSize:11 }}>from {currentSal.effectiveFrom}</span></span>
                                    : <span style={{ fontSize:12, color:"rgba(224,224,224,0.35)" }}>Not set</span>
                                  }
                                </div>
                                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr auto", gap:6, alignItems:"flex-end" }}>
                                  <div>
                                    <label className="label" style={{ fontSize:9 }}>AMOUNT (£)</label>
                                    <input type="number" placeholder="e.g. 2500"
                                      value={(adminSalaryForm[afid+"_"+uidx]||{}).amount||""}
                                      onChange={function(e){ var v=e.target.value; setAdminSalaryForm(function(s){ var n=Object.assign({},s); n[afid+"_"+uidx]=Object.assign({},n[afid+"_"+uidx]||{},{amount:v}); return n; }); }}
                                      style={{ width:"100%", background:"#1E1E1E", border:"1px solid #2A2A2A", color:"#E0E0E0", padding:"7px 10px", borderRadius:6, fontFamily:"Outfit,sans-serif", fontSize:12, outline:"none" }} />
                                  </div>
                                  <div>
                                    <label className="label" style={{ fontSize:9 }}>EFFECTIVE FROM</label>
                                    <MonthPicker label={null} value={(adminSalaryForm[afid+"_"+uidx]||{}).month||""} onChange={function(v){ setAdminSalaryForm(function(s){ var n=Object.assign({},s); n[afid+"_"+uidx]=Object.assign({},n[afid+"_"+uidx]||{},{month:v}); return n; }); }} />
                                  </div>
                                  <button className="btn btn-sm" style={{ background:"rgba(86,185,233,0.1)", color:"#56B9E9", border:"1px solid rgba(86,185,233,0.3)", fontSize:11, padding:"7px 12px" }}
                                    onClick={function(){
                                      if (!uid) { showToast("No user account linked."); return; }
                                      var formVal = adminSalaryForm[afid+"_"+uidx] || {};
                                      var salAmt = parseFloat(formVal.amount||"") || 0;
                                      var salMon = formVal.month || "";
                                      if (!salAmt || !salMon) { showToast("Enter amount and effective month."); return; }
                                      apiPost("/api/franchises/" + afid + "/salaries", { userId:uid, amount:salAmt, effectiveFrom:salMon }).then(function(){
                                        DB.getFranchises().then(function(d){ if(d) save(d); });
                                        setAdminSalaryForm(function(s){ var n=Object.assign({},s); n[afid+"_"+uidx]={}; return n; });
                                        showToast("Salary saved for " + u.name.split(" ")[0] + "!");
                                      }).catch(function(){ showToast("Error saving salary."); });
                                    }}>Save</button>
                                </div>
                                {/* Salary History */}
                                {userSals.length > 1 && (
                                  <div style={{ marginTop:8 }}>
                                    <button onClick={function(){ setExpandedSalaryHistory(function(p){ var n=Object.assign({},p); n[salHistKey]=!n[salHistKey]; return n; }); }}
                                      style={{ background:"none", border:"none", color:"rgba(224,224,224,0.45)", fontSize:11, cursor:"pointer", padding:0, display:"flex", alignItems:"center", gap:4 }}>
                                      SALARY HISTORY {expandedSalaryHistory[salHistKey] ? "▲" : "▼"}
                                    </button>
                                    {expandedSalaryHistory[salHistKey] && (
                                      <div style={{ marginTop:6, display:"flex", flexDirection:"column", gap:4 }}>
                                        {userSals.map(function(s, si){
                                          return (
                                            <div key={si} style={{ display:"flex", justifyContent:"space-between", fontSize:11, color:"rgba(224,224,224,0.55)", padding:"4px 0", borderBottom:"1px solid #1e1e1e" }}>
                                              <span>{s.effectiveFrom}</span>
                                              <span style={{ color:"#4DE7A6" }}>{fmt(s.amount)}/mo</span>
                                            </div>
                                          );
                                        })}
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        })}
                        {/* Share History */}
                        {(function(){
                          var histOwners = allOwners.filter(function(o){ return o.isCurrent === false; });
                          if (histOwners.length === 0) return null;
                          var histKey = activeFranchise.id + "_owner_hist";
                          return (
                            <div style={{ marginTop:4 }}>
                              <button onClick={function(){ setExpandedShareHistory(function(p){ var n=Object.assign({},p); n[histKey]=!n[histKey]; return n; }); }}
                                style={{ background:"none", border:"none", color:"rgba(224,224,224,0.45)", fontSize:11, cursor:"pointer", padding:0, display:"flex", alignItems:"center", gap:4 }}>
                                SHARE HISTORY {expandedShareHistory[histKey] ? "▲" : "▼"}
                              </button>
                              {expandedShareHistory[histKey] && (
                                <div className="card" style={{ marginTop:6, padding:"10px 14px" }}>
                                  {histOwners.map(function(o, oi){
                                    return (
                                      <div key={oi} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"6px 0", borderBottom:"1px solid #1e1e1e", fontSize:12 }}>
                                        <div>
                                          <span style={{ color:"#E0E0E0", fontWeight:500 }}>{o.name}</span>
                                          <span style={{ color:"rgba(224,224,224,0.4)", marginLeft:8, fontSize:11 }}>{o.effectiveFrom}{o.effectiveTo ? " → " + o.effectiveTo : ""}</span>
                                        </div>
                                        <span style={{ color:"rgba(224,224,224,0.6)", fontWeight:600 }}>{o.sharePercent}%</span>
                                      </div>
                                    );
                                  })}
                                </div>
                              )}
                            </div>
                          );
                        })()}
                      </div>
                    );
                  })()}
                </div>

                {/* INVESTORS */}
                <div>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:10 }}>
                    <label className="label" style={{ margin:0 }}>INVESTORS</label>
                    <button className="btn btn-primary btn-sm" onClick={function() { setInvStakes([{ franchiseId:selectedId, sharePercent:"" }]); setModal("new-investor"); }}>+ Add Investor</button>
                  </div>
                  <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
                    {(activeFranchise.investors||[]).filter(function(i){ return i.isCurrent !== false; }).length === 0
                      ? <div style={{ color:"#56B9E9", fontSize:12 }}>No investors yet</div>
                      : (activeFranchise.investors||[]).filter(function(i){ return i.isCurrent !== false; }).map(function(inv, i) {
                        var latest = activeFranchise.financials.length ? activeFranchise.financials[activeFranchise.financials.length-1] : null;
                        var profit = latest ? (latest.income - totalExp(latest)) * inv.sharePercent / 100 : 0;
                        var color = PALETTE[i % PALETTE.length];
                        return (
                          <div key={inv.id || i} className="card" style={{ padding:"13px 16px", borderLeft:"3px solid "+color }}>
                            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                              <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                                <div style={{ width:32, height:32, borderRadius:"50%", background:color+"22", border:"1px solid "+color+"44", display:"flex", alignItems:"center", justifyContent:"center", color:color, fontFamily:"Playfair Display,serif", fontWeight:800, fontSize:12 }}>{inv.name.charAt(0)}</div>
                                <div>
                                  <div style={{ display:"flex", alignItems:"center", gap:6, marginBottom:2 }}>
                                    <span style={{ fontWeight:600, fontSize:13 }}>{inv.name}</span>
                                    <span className="tag" style={{ background:color+"22", color:color, fontSize:10 }}>Investor</span>
                                  </div>
                                  <div style={{ fontSize:11, color:"#56B9E9" }}>{inv.sharePercent}% share · {inv.email}{inv.phone ? " · " + inv.phone : ""}</div>
                                  {inv.effectiveFrom && <div style={{ fontSize:10, color:"rgba(224,224,224,0.35)" }}>from {inv.effectiveFrom}</div>}
                                </div>
                              </div>
                              <div style={{ display:"flex", alignItems:"center", gap:12 }}>
                                <div style={{ textAlign:"right" }}>
                                  <div style={{ color:"#E0E0E0", fontWeight:500 }}>{fmt(profit)}</div>
                                  <div style={{ fontSize:10, color:"#56B9E9" }}>this month</div>
                                </div>
                                <span style={{ color:"#2A2A2A", cursor:"pointer", fontSize:12 }} onMouseEnter={function(e) { e.target.style.color="#cf6679"; }} onMouseLeave={function(e) { e.target.style.color="#2A2A2A"; }} onClick={function() { removeInvestor(activeFranchise.id, inv.id); }}>✕</span>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    {/* Investor Share History */}
                    {(function(){
                      var histInvs = (activeFranchise.investors||[]).filter(function(i){ return i.isCurrent === false; });
                      if (histInvs.length === 0) return null;
                      var histKey = activeFranchise.id + "_inv_hist";
                      return (
                        <div style={{ marginTop:4 }}>
                          <button onClick={function(){ setExpandedShareHistory(function(p){ var n=Object.assign({},p); n[histKey]=!n[histKey]; return n; }); }}
                            style={{ background:"none", border:"none", color:"rgba(224,224,224,0.45)", fontSize:11, cursor:"pointer", padding:0, display:"flex", alignItems:"center", gap:4 }}>
                            SHARE HISTORY {expandedShareHistory[histKey] ? "▲" : "▼"}
                          </button>
                          {expandedShareHistory[histKey] && (
                            <div className="card" style={{ marginTop:6, padding:"10px 14px" }}>
                              {histInvs.map(function(i, ii){
                                return (
                                  <div key={ii} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"6px 0", borderBottom:"1px solid #1e1e1e", fontSize:12 }}>
                                    <div>
                                      <span style={{ color:"#E0E0E0", fontWeight:500 }}>{i.name}</span>
                                      <span style={{ color:"rgba(224,224,224,0.4)", marginLeft:8, fontSize:11 }}>{i.effectiveFrom}{i.effectiveTo ? " → " + i.effectiveTo : ""}</span>
                                    </div>
                                    <span style={{ color:"rgba(224,224,224,0.6)", fontWeight:600 }}>{i.sharePercent}%</span>
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      );
                    })()}
                  </div>
                </div>

              </div>

              {/* P&L TABLES */}
              {(function() {
                var plAllYears = Array.from(new Set(activeFranchise.financials.map(function(m) {
                  var match = m.month && m.month.toString().match(/(20[0-9][0-9])/);
                  return match ? parseInt(match[1]) : null;
                }).filter(Boolean))).sort(function(a,b) { return b-a; });
                if (!plAllYears.length) return null;
                var plCurYear = plAllYears.indexOf(selectedYear) === -1 ? plAllYears[0] : selectedYear;
                var plMths = [].concat(activeFranchise.financials.filter(function(m) {
                  var match = m.month && m.month.toString().match(/(20[0-9][0-9])/);
                  return match && parseInt(match[1]) === plCurYear;
                })).sort(function(a, b) { return parseMonthDate(b.month) - parseMonthDate(a.month); });
                var hasPL = plAllYears.indexOf(plCurYear) < plAllYears.length - 1;
                var hasNL = plAllYears.indexOf(plCurYear) > 0;
                var navBar = (
                  <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                    <button className="btn btn-secondary btn-sm" style={{ padding:"5px 10px", opacity:hasPL?1:0.3 }} onClick={function() { if (hasPL) setSelectedYear(plAllYears[plAllYears.indexOf(plCurYear)+1]); }}>{"<"}</button>
                    <span style={{ fontSize:13, fontWeight:600, color:"#E0E0E0", minWidth:40, textAlign:"center" }}>{plCurYear}</span>
                    <button className="btn btn-secondary btn-sm" style={{ padding:"5px 10px", opacity:hasNL?1:0.3 }} onClick={function() { if (hasNL) setSelectedYear(plAllYears[plAllYears.indexOf(plCurYear)-1]); }}>{">"}</button>
                  </div>
                );
                var owners = (activeFranchise.owners || []).filter(function(o) { return o.name && o.sharePercent && o.isCurrent !== false; });
                // Get salary data from franchise object
                var franchiseSalaries = activeFranchise.salaries || [];
                function getAdminSalary(ownerId, month) {
                  if (!ownerId) return 0;
                  var ownerSalaries = franchiseSalaries.filter(function(s){ return s.userId === ownerId; });
                  if (!ownerSalaries.length) return 0;
                  var filtered = ownerSalaries.filter(function(s){ return parseMonthDate(s.effectiveFrom) <= parseMonthDate(month); });
                  if (!filtered.length) return 0;
                  filtered.sort(function(a,b){ return parseMonthDate(b.effectiveFrom)-parseMonthDate(a.effectiveFrom); });
                  return filtered[0].amount || 0;
                }
                // Find user IDs for owners by matching email
                function getOwnerUserId(owner) {
                  var u = (users||[]).find(function(u){ return (u.email||"").toLowerCase()===(owner.email||"").toLowerCase(); });
                  return u ? u.id : null;
                }
                return (
                  <div style={{ display:"flex", flexDirection:"column", gap:18, gridColumn:"1 / -1" }}>
                    {owners.length > 0 && (
                      <div>
                        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:10 }}>
                          <label className="label" style={{ margin:0 }}>FRANCHISEE PROFIT & LOSS</label>
                          {navBar}
                        </div>
                        <div className="card" style={{ padding:0, overflow:"hidden" }}>
                          <table style={{ width:"100%", borderCollapse:"collapse", fontSize:12 }}>
                            <thead>
                              <tr style={{ borderBottom:"1px solid #374151" }}>
                                <th style={{ padding:"11px 14px", textAlign:"left", fontSize:10, letterSpacing:"0.1em", color:"#56B9E9", fontWeight:500 }}>MONTH</th>
                                <th style={{ padding:"11px 14px", textAlign:"left", fontSize:10, letterSpacing:"0.1em", color:"#56B9E9", fontWeight:500 }}>FRANCHISEE</th>
                                <th style={{ padding:"11px 14px", textAlign:"right", fontSize:10, letterSpacing:"0.1em", color:"#56B9E9", fontWeight:500 }}>NET PROFIT</th>
                                <th style={{ padding:"11px 14px", textAlign:"right", fontSize:10, letterSpacing:"0.1em", color:"#4DE7A6", fontWeight:500 }}>SHARE</th>
                                <th style={{ padding:"11px 14px", textAlign:"right", fontSize:10, letterSpacing:"0.1em", color:"#56B9E9", fontWeight:500 }}>SALARY</th>
                                <th style={{ padding:"11px 14px", textAlign:"right", fontSize:10, letterSpacing:"0.1em", color:"#E0E0E0", fontWeight:500, background:"rgba(255,255,255,0.03)" }}>TH</th>
                              </tr>
                            </thead>
                            <tbody>
                              {plMths.length === 0
                                ? <tr><td colSpan={6} style={{ padding:"22px 14px", color:"#56B9E9", textAlign:"center" }}>No data for {plCurYear}</td></tr>
                                : plMths.map(function(m) {
                                  var net = m.income - totalExp(m);
                                  var totalSalaries = owners.reduce(function(sum, o){
                                    var uid = getOwnerUserId(o);
                                    return sum + (uid ? getAdminSalary(uid, m.month) : 0);
                                  }, 0);
                                  var afterSalary = net - totalSalaries;
                                  return owners.map(function(o, oi) {
                                    var uid = getOwnerUserId(o);
                                    var ownerSal = uid ? getAdminSalary(uid, m.month) : 0;
                                    var share = afterSalary * parseFloat(o.sharePercent) / 100;
                                    var takeHome = ownerSal + share;
                                    return (
                                      <tr key={m.month+"_"+oi} style={{ borderBottom: oi===owners.length-1 ? "2px solid #1f2937" : "1px solid rgba(255,255,255,0.03)", background:oi>0?"rgba(255,255,255,0.01)":"transparent" }}>
                                        {oi===0 && <td rowSpan={owners.length} style={{ padding:"11px 14px", color:"rgba(224,224,224,0.6)", verticalAlign:"top" }}>{m.month}</td>}
                                        <td style={{ padding:"11px 14px", color:"rgba(224,224,224,0.8)", fontWeight:500 }}>{(o.name||"").split(" ")[0]} <span style={{ color:"rgba(224,224,224,0.4)", fontSize:10 }}>({o.sharePercent}%)</span></td>
                                        {oi===0 && <td rowSpan={owners.length} style={{ padding:"11px 14px", textAlign:"right", color: net >= 0 ? "#56B9E9" : "#cf6679", fontWeight:500, verticalAlign:"top" }}>{fmt(net)}</td>}
                                        <td style={{ padding:"11px 14px", textAlign:"right", color: share >= 0 ? "#4DE7A6" : "#cf6679", fontWeight:500 }}>{fmt(share)}</td>
                                        <td style={{ padding:"11px 14px", textAlign:"right", color:"#56B9E9", fontWeight:500 }}>{ownerSal > 0 ? fmt(ownerSal) : "—"}</td>
                                        <td style={{ padding:"11px 14px", textAlign:"right", color:"#E0E0E0", fontWeight:700, background:"rgba(255,255,255,0.02)" }}>{fmt(takeHome)}</td>
                                      </tr>
                                    );
                                  });
                                })}
                              {plMths.length > 0 && owners.map(function(o, oi) {
                                var uid = getOwnerUserId(o);
                                var tShare = plMths.reduce(function(s,m){
                                  var net2=m.income-totalExp(m);
                                  var allSal=owners.reduce(function(ss,oo){ var uu=getOwnerUserId(oo); return ss+(uu?getAdminSalary(uu,m.month):0); },0);
                                  return s+(net2-allSal)*parseFloat(o.sharePercent)/100;
                                },0);
                                var tSal = plMths.reduce(function(s,m){ return s+(uid?getAdminSalary(uid,m.month):0); },0);
                                var tNet = oi===0 ? plMths.reduce(function(s,m){return s+m.income-totalExp(m);},0) : null;
                                return (
                                  <tr key={"tot"+oi} style={{ borderTop: oi===0?"2px solid #374151":"none", background:"#252525" }}>
                                    {oi===0 && <td rowSpan={owners.length} style={{ padding:"11px 14px", color:"#56B9E9", fontSize:11, verticalAlign:"top" }}>YEAR TOTAL</td>}
                                    <td style={{ padding:"11px 14px", color:"rgba(224,224,224,0.7)", fontSize:11, fontWeight:600 }}>{(o.name||"").split(" ")[0]}</td>
                                    {oi===0 && <td rowSpan={owners.length} style={{ padding:"11px 14px", textAlign:"right", color:"#E0E0E0", fontWeight:700, fontFamily:"Playfair Display,serif", verticalAlign:"top" }}>{fmt(tNet)}</td>}
                                    <td style={{ padding:"11px 14px", textAlign:"right", color:"#E0E0E0", fontWeight:700, fontFamily:"Playfair Display,serif" }}>{fmt(tShare)}</td>
                                    <td style={{ padding:"11px 14px", textAlign:"right", color:"#E0E0E0", fontWeight:700, fontFamily:"Playfair Display,serif" }}>{tSal>0?fmt(tSal):"—"}</td>
                                    <td style={{ padding:"11px 14px", textAlign:"right", color:"#4DE7A6", fontWeight:700, fontFamily:"Playfair Display,serif", background:"rgba(255,255,255,0.02)" }}>{fmt(tShare+tSal)}</td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                    {activeFranchise.investors.length > 0 && (
                      <div>
                        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:10 }}>
                          <label className="label" style={{ margin:0 }}>INVESTOR PROFIT & LOSS</label>
                          {navBar}
                        </div>
                        <div className="card" style={{ padding:0, overflow:"hidden", overflowX:"auto" }}>
                          <table style={{ width:"100%", borderCollapse:"collapse", fontSize:12, minWidth:700 }}>
                            <thead>
                              <tr style={{ borderBottom:"1px solid rgba(28,25,96,0.15)" }}>
                                <th style={{ padding:"11px 14px", textAlign:"left", fontSize:10, letterSpacing:"0.1em", color:"#56B9E9", fontWeight:500 }}>MONTH</th>
                                <th style={{ padding:"11px 14px", textAlign:"right", fontSize:10, letterSpacing:"0.1em", color:"#56B9E9", fontWeight:500 }}>NET PROFIT</th>
                                {activeFranchise.investors.map(function(inv, ii) {
                                  var c = PALETTE[ii % PALETTE.length];
                                  return <th key={ii} style={{ padding:"11px 14px", textAlign:"right", fontSize:10, letterSpacing:"0.1em", color:c, fontWeight:500, whiteSpace:"nowrap" }}>{inv.name} ({inv.sharePercent}%)</th>;
                                })}
                                <th style={{ padding:"11px 14px", textAlign:"center", fontSize:10, letterSpacing:"0.1em", color:"#56B9E9", fontWeight:500 }}>PAID</th>
                                <th style={{ padding:"11px 14px", textAlign:"left", fontSize:10, letterSpacing:"0.1em", color:"#56B9E9", fontWeight:500 }}>DATE PAID</th>
                                <th style={{ padding:"11px 14px", textAlign:"left", fontSize:10, letterSpacing:"0.1em", color:"#56B9E9", fontWeight:500 }}>METHOD</th>
                              </tr>
                            </thead>
                            <tbody>
                              {plMths.length === 0
                                ? <tr><td colSpan={99} style={{ padding:"22px 14px", color:"#56B9E9", textAlign:"center" }}>No data for {plCurYear}</td></tr>
                                : plMths.map(function(m) {
                                  var net = m.income - totalExp(m);
                                  var allOwnerSals3=(activeFranchise.owners||[]).filter(function(o){return o.isCurrent!==false;}).reduce(function(s,o){var sal=(activeFranchise.salaries||[]).filter(function(sl){return (sl.userEmail||"").toLowerCase()===(o.email||"").toLowerCase();}).filter(function(sl){return parseMonthDate(sl.effectiveFrom)<=parseMonthDate(m.month);}).sort(function(a,b){return parseMonthDate(b.effectiveFrom)-parseMonthDate(a.effectiveFrom);});return s+(sal.length?parseFloat(sal[0].amount):0);},0);
                                  var afterSals3=net-allOwnerSals3;
                                  var pKey = activeFranchise.id + "_" + m.month;
                                  var pmt = invPayments[pKey] || { paid:false, datePaid:"", method:"" };
                                  return (
                                    <tr key={m.month} style={{ borderBottom:"1px solid rgba(28,25,96,0.06)", background: pmt.paid ? "rgba(77,231,166,0.05)" : "transparent" }}>
                                      <td style={{ padding:"11px 14px", color:"rgba(224,224,224,0.6)" }}>{m.month}</td>
                                      <td style={{ padding:"11px 14px", textAlign:"right", color: net >= 0 ? "#56B9E9" : "#cf6679", fontWeight:500 }}>{fmt(net)}</td>
                                      {activeFranchise.investors.map(function(inv, ii) {
                                        var s = afterSals3 * parseFloat(inv.sharePercent) / 100;
                                        var c = PALETTE[ii % PALETTE.length];
                                        return <td key={ii} style={{ padding:"11px 14px", textAlign:"right", color: s >= 0 ? c : "#cf6679", fontWeight:500 }}>{fmt(s)}</td>;
                                      })}
                                      <td style={{ padding:"8px 14px", textAlign:"center" }}>
                                        <button onClick={function() {
                                          var newPmt = Object.assign({}, pmt, { paid:!pmt.paid, datePaid: !pmt.paid ? new Date().toISOString().slice(0,10) : "" });
                                          var next = Object.assign({}, invPayments);
                                          next[pKey] = newPmt;
                                          setInvPayments(next);
                                          apiPut("/api/franchises/" + activeFranchise.id + "/investor-payments", { month:m.month, paid:newPmt.paid, datePaid:newPmt.datePaid, method:newPmt.method }).catch(function(){});
                                        }} style={{ padding:"4px 12px", borderRadius:20, fontSize:11, fontWeight:600, cursor:"pointer", border:"1px solid", background: pmt.paid ? "rgba(77,231,166,0.1)" : "rgba(255,255,255,0.04)", color: pmt.paid ? "#4DE7A6" : "#56B9E9", borderColor: pmt.paid ? "rgba(77,231,166,0.3)" : "#2A2A2A" }}>
                                          {pmt.paid ? "✓ Yes" : "No"}
                                        </button>
                                      </td>
                                      <td style={{ padding:"8px 14px" }}>
                                        <input type="date" value={pmt.datePaid} onChange={function(e) {
                                          var v = e.target.value;
                                          var newPmt = Object.assign({}, pmt, { datePaid:v });
                                          var next = Object.assign({}, invPayments);
                                          next[pKey] = newPmt;
                                          setInvPayments(next);
                                          apiPut("/api/franchises/" + activeFranchise.id + "/investor-payments", { month:m.month, paid:pmt.paid, datePaid:v, method:pmt.method }).catch(function(){});
                                        }} style={{ fontSize:11, padding:"4px 8px", width:130, background:"#1E1E1E", border:"1px solid rgba(28,25,96,0.15)", color:"#E0E0E0", borderRadius:6, fontFamily:"Outfit,sans-serif", outline:"none" }} />
                                      </td>
                                      <td style={{ padding:"8px 14px" }}>
                                        <select value={pmt.method} onChange={function(e) {
                                          var v = e.target.value;
                                          var newPmt = Object.assign({}, pmt, { method:v });
                                          var next = Object.assign({}, invPayments);
                                          next[pKey] = newPmt;
                                          setInvPayments(next);
                                          apiPut("/api/franchises/" + activeFranchise.id + "/investor-payments", { month:m.month, paid:pmt.paid, datePaid:pmt.datePaid, method:v }).catch(function(){});
                                        }} style={{ fontSize:11, padding:"4px 8px", background:"#1E1E1E", border:"1px solid rgba(28,25,96,0.15)", color: pmt.method ? "#E0E0E0" : "#56B9E9", borderRadius:6, fontFamily:"Outfit,sans-serif", outline:"none" }}>
                                          <option value="">Select...</option>
                                          <option value="Card">Card</option>
                                          <option value="Cash">Cash</option>
                                          <option value="Transfer">Transfer</option>
                                        </select>
                                      </td>
                                    </tr>
                                  );
                                })}
                              {plMths.length > 0 && (
                                <tr style={{ borderTop:"2px solid rgba(28,25,96,0.15)", background:"#252525" }}>
                                  <td style={{ padding:"11px 14px", color:"#56B9E9", fontSize:11 }}>YEAR TOTAL</td>
                                  <td style={{ padding:"11px 14px", textAlign:"right", color:"#E0E0E0", fontWeight:700, fontFamily:"Playfair Display,serif" }}>{fmt(plMths.reduce(function(s,m){return s+m.income-totalExp(m);},0))}</td>
                                  {activeFranchise.investors.map(function(inv, ii) {
                                    var t=plMths.reduce(function(s,m){var net2=m.income-totalExp(m);var allSals4=(activeFranchise.owners||[]).filter(function(o){return o.isCurrent!==false;}).reduce(function(ss,o){var sal=(activeFranchise.salaries||[]).filter(function(sl){return (sl.userEmail||"").toLowerCase()===(o.email||"").toLowerCase();}).filter(function(sl){return parseMonthDate(sl.effectiveFrom)<=parseMonthDate(m.month);}).sort(function(a,b){return parseMonthDate(b.effectiveFrom)-parseMonthDate(a.effectiveFrom);});return ss+(sal.length?parseFloat(sal[0].amount):0);},0);return s+(net2-allSals4)*parseFloat(inv.sharePercent)/100;},0);
                                    return <td key={ii} style={{ padding:"11px 14px", textAlign:"right", color:"#E0E0E0", fontWeight:700, fontFamily:"Playfair Display,serif" }}>{fmt(t)}</td>;
                                  })}
                                  <td colSpan={3} style={{ padding:"11px 14px", color:"#56B9E9", fontSize:11 }}>
                                    {plMths.filter(function(m){ var pk=activeFranchise.id+"_"+m.month; return (invPayments[pk]||{}).paid; }).length} / {plMths.length} paid
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })()}

              {/* BANK DETAILS */}
              {(function(){
                var bd = activeFranchise.bankDetails || null;
                var afid = activeFranchise.id;
                var isEditing = bankEditId === afid;
                return (
                  <div style={{ gridColumn:"1 / -1", marginTop:8 }}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}>
                      <label className="label" style={{ margin:0 }}>BANK DETAILS</label>
                      {!isEditing && <button className="btn btn-sm btn-secondary" style={{ fontSize:11 }} onClick={function(){ setBankEditId(afid); setBankForm({ accountName:bd?bd.accountName:"", sortCode:bd?bd.sortCode:"", accountNumber:bd?bd.accountNumber:"" }); }}>✎ {bd?"Edit":"Add"}</button>}
                    </div>

                    {/* View mode */}
                    {!isEditing && (
                      bd ? (
                        <div className="card" style={{ borderLeft:"3px solid rgba(86,185,233,0.4)" }}>
                          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:20 }}>
                            <div>
                              <div style={{ fontSize:10, color:"rgba(224,224,224,0.4)", letterSpacing:"0.08em", marginBottom:6 }}>ACCOUNT NAME</div>
                              <div style={{ fontSize:14, fontWeight:600, color:"#E0E0E0" }}>{bd.accountName}</div>
                            </div>
                            <div>
                              <div style={{ fontSize:10, color:"rgba(224,224,224,0.4)", letterSpacing:"0.08em", marginBottom:6 }}>SORT CODE</div>
                              <div style={{ fontSize:14, fontWeight:600, color:"#56B9E9", letterSpacing:"0.1em" }}>{bd.sortCode}</div>
                            </div>
                            <div>
                              <div style={{ fontSize:10, color:"rgba(224,224,224,0.4)", letterSpacing:"0.08em", marginBottom:6 }}>ACCOUNT NUMBER</div>
                              <div style={{ fontSize:14, fontWeight:600, color:"#56B9E9", letterSpacing:"0.1em" }}>{bd.accountNumber}</div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="card" style={{ border:"1px dashed #2A2A2A", textAlign:"center", padding:24, color:"rgba(224,224,224,0.35)", fontSize:13 }}>
                          No bank details added yet
                        </div>
                      )
                    )}

                    {/* Edit mode */}
                    {isEditing && (
                      <div className="card">
                        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:14, marginBottom:14 }}>
                          <div>
                            <label className="label">ACCOUNT NAME</label>
                            <input value={bankForm.accountName} onChange={function(e){ setBankForm(function(p){ return Object.assign({},p,{accountName:e.target.value}); }); }}
                              placeholder="e.g. Fine Daycare Ltd"
                              style={{ width:"100%", background:"#252525", border:"1px solid #2A2A2A", color:"#E0E0E0", padding:"10px 14px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none" }} />
                          </div>
                          <div>
                            <label className="label">SORT CODE</label>
                            <input value={bankForm.sortCode} onChange={function(e){ setBankForm(function(p){ return Object.assign({},p,{sortCode:e.target.value}); }); }}
                              placeholder="e.g. 20-45-67" maxLength={8}
                              style={{ width:"100%", background:"#252525", border:"1px solid #2A2A2A", color:"#E0E0E0", padding:"10px 14px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none" }} />
                          </div>
                          <div>
                            <label className="label">ACCOUNT NUMBER</label>
                            <input value={bankForm.accountNumber} onChange={function(e){ setBankForm(function(p){ return Object.assign({},p,{accountNumber:e.target.value}); }); }}
                              placeholder="e.g. 12345678" maxLength={8}
                              style={{ width:"100%", background:"#252525", border:"1px solid #2A2A2A", color:"#E0E0E0", padding:"10px 14px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none" }} />
                          </div>
                        </div>
                        <div style={{ display:"flex", gap:8, justifyContent:"flex-end" }}>
                          <button className="btn btn-secondary btn-sm" onClick={function(){ setBankEditId(null); }}>Cancel</button>
                          <button className="btn btn-primary btn-sm" onClick={function(){
                            if (!bankForm.accountName||!bankForm.sortCode||!bankForm.accountNumber) { showToast("All fields required."); return; }
                            apiPost("/api/franchises/" + afid + "/bank-details", bankForm).then(function(){
                              DB.getFranchises().then(function(d){ if(d) save(d); });
                              setBankEditId(null);
                              showToast("Bank details saved!");
                            }).catch(function(){ showToast("Error saving."); });
                          }}>Save Bank Details</button>
                        </div>
                      </div>
                    )}

                    {/* History */}
                    <div style={{ marginTop:10 }}>
                      <div style={{ display:"flex", alignItems:"center", gap:8, padding:"10px 14px", background:"rgba(255,255,255,0.02)", border:"1px solid #2A2A2A", borderRadius: showBankHistory===afid?"10px 10px 0 0":10, cursor:"pointer" }}
                        onClick={function(){
                          var next = showBankHistory===afid ? null : afid;
                          setShowBankHistory(next);
                          if (next) {
                            apiFetch("/api/franchises/" + afid + "/bank-details").then(function(d){
                              if (d && Array.isArray(d)) setBankHistory(d);
                            }).catch(function(){});
                          }
                        }}>
                        <span style={{ fontSize:11, color:"rgba(224,224,224,0.45)", letterSpacing:"0.08em" }}>CHANGE HISTORY</span>
                        <span style={{ marginLeft:"auto", color:"rgba(224,224,224,0.3)", fontSize:12 }}>{showBankHistory===afid?"▲":"▼"}</span>
                      </div>
                      {showBankHistory===afid && (
                        <div style={{ border:"1px solid #2A2A2A", borderTop:"none", borderRadius:"0 0 10px 10px", overflow:"hidden" }}>
                          {bankHistory.length === 0
                            ? <div style={{ padding:"14px 16px", fontSize:12, color:"rgba(224,224,224,0.35)" }}>No history yet</div>
                            : bankHistory.map(function(h, hi){
                              return (
                                <div key={h.id} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"11px 16px", borderBottom: hi<bankHistory.length-1?"1px solid #2A2A2A":"none", fontSize:12 }}>
                                  <div>
                                    <span style={{ color:"#E0E0E0", fontWeight:500 }}>{h.accountName}</span>
                                    <span style={{ color:"#56B9E9", marginLeft:12 }}>{h.sortCode}</span>
                                    <span style={{ color:"#56B9E9", marginLeft:12 }}>{h.accountNumber}</span>
                                  </div>
                                  <div style={{ textAlign:"right" }}>
                                    <div style={{ color:"rgba(224,224,224,0.45)", fontSize:11 }}>{h.createdAt ? h.createdAt.slice(0,10) : ""}</div>
                                    {h.updatedBy && <div style={{ color:"rgba(224,224,224,0.3)", fontSize:10 }}>{h.updatedBy}</div>}
                                  </div>
                                </div>
                              );
                            })
                          }
                        </div>
                      )}
                    </div>
                  </div>
                );
              })()}

            </div>
          </div>
        )}

        {view === "investors" && (
          <div className="fade-in">
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-end", marginBottom:18 }}>
              <div>
                <h1 style={{ fontFamily:"Playfair Display,serif", fontWeight:900, fontSize:28, letterSpacing:"-0.04em" }}>All Investors</h1>
                <p style={{ color:"#56B9E9", fontSize:13, marginTop:4 }}>{allInvestors.length} investors across {franchises.length} franchises</p>
              </div>
              <button className="btn btn-primary btn-sm" onClick={function() { setInvStakes([{ franchiseId:"", sharePercent:"" }]); setModal("new-investor"); }}>+ Onboard Investor</button>
            </div>
            <div style={{ display:"flex", gap:10, marginBottom:18 }}>
              <input placeholder="Search investors by name or email..." value={searchInvestor} onChange={function(e) { setSearchInvestor(e.target.value); }}
                style={{ flex:1, background:"#1E1E1E", border:"1px solid #374151", color:"#E0E0E0", padding:"9px 14px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none" }} />
              <select value={filterFranchise} onChange={function(e) { setFilterFranchise(e.target.value); }}
                style={{ background:"#1E1E1E", border:"1px solid #374151", color:"rgba(224,224,224,0.6)", padding:"9px 14px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none" }}>
                <option value="all">All Branches</option>
                {franchises.map(function(f) { return <option key={f.id} value={f.id}>{f.location} - {f.name}</option>; })}
              </select>
            </div>
            <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
              {allInvestors.filter(function(inv) {
                var q = searchInvestor.toLowerCase();
                var matchSearch = !searchInvestor || inv.name.toLowerCase().includes(q) || inv.email.toLowerCase().includes(q);
                var matchFranchise = filterFranchise === "all" || inv.stakes.some(function(st) { return st.franchiseId === filterFranchise; });
                return matchSearch && matchFranchise;
              }).map(function(inv, i) {
                var monthly = inv.stakes.reduce(function(s,st) { return s+st.latestProfit; }, 0);
                var alltime = inv.stakes.reduce(function(s,st) { return s+st.totalProfit; }, 0);
                var color = PALETTE[i % PALETTE.length];
                return (
                  <div key={inv.email} className="card">
                    <div style={{ display:"flex", alignItems:"center", gap:14 }}>
                      <div style={{ width:46, height:46, borderRadius:"50%", background:color+"22", border:"2px solid "+color+"44", display:"flex", alignItems:"center", justifyContent:"center", color:color, fontFamily:"Playfair Display,serif", fontWeight:900, fontSize:17, flexShrink:0 }}>{inv.name.charAt(0)}</div>
                      <div style={{ flex:1 }}>
                        <div style={{ fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:14, cursor:"pointer", color:"#E0E0E0" }} onClick={function() { setSelectedInvestorEmail(inv.email); setView("investor-detail"); }}>{inv.name}</div>
                        <div style={{ fontSize:11, color:"#56B9E9", marginTop:2 }}>{inv.email}{inv.phone ? " · " + inv.phone : ""}</div>
                        <div style={{ display:"flex", gap:6, marginTop:7, flexWrap:"wrap" }}>
                          {inv.stakes.map(function(st) {
                            return <span key={st.franchiseId} className="tag" style={{ background:"#252525", color:"rgba(224,224,224,0.6)", cursor:"pointer" }} onClick={function() { setSelectedId(st.franchiseId); setView("detail"); }}>{st.franchise} · {st.sharePercent}%</span>;
                          })}
                        </div>
                      </div>
                      <div style={{ display:"flex", gap:20, flexShrink:0 }}>
                        <div style={{ textAlign:"right" }}>
                          <div style={{ fontSize:10, color:"#56B9E9", letterSpacing:"0.1em", marginBottom:4 }}>THIS MONTH</div>
                          <div style={{ fontFamily:"Playfair Display,serif", fontWeight:800, fontSize:20, color:"#E0E0E0" }}>{fmt(monthly)}</div>
                        </div>
                        <div style={{ textAlign:"right" }}>
                          <div style={{ fontSize:10, color:"#56B9E9", letterSpacing:"0.1em", marginBottom:4 }}>ALL-TIME</div>
                          <div style={{ fontFamily:"Playfair Display,serif", fontWeight:800, fontSize:20, color:color }}>{fmt(alltime)}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {view === "investor-detail" && (function() {
          var inv = allInvestors.find(function(i) { return i.email === selectedInvestorEmail; });
          if (!inv) return null;
          var totalMonthly = inv.stakes.reduce(function(s,st) { return s+st.latestProfit; }, 0);
          var totalAllTime = inv.stakes.reduce(function(s,st) { return s+st.totalProfit; }, 0);
          var color = PALETTE[allInvestors.indexOf(inv) % PALETTE.length];
          return (
            <div className="fade-in">
              <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:28 }}>
                <button className="btn btn-secondary btn-sm" onClick={function() { setView("investors"); }}>Back</button>
                <div>
                  <h1 style={{ fontFamily:"Playfair Display,serif", fontWeight:900, fontSize:26, letterSpacing:"-0.04em" }}>{inv.name}</h1>
                  <p style={{ color:"#56B9E9", fontSize:13, marginTop:2 }}>{inv.email}{inv.phone ? " · " + inv.phone : ""}</p>
                </div>
              </div>

              <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:14, marginBottom:28 }}>
                {[
                  { label:"THIS MONTH", value:fmt(totalMonthly), color:"#E0E0E0" },
                  { label:"ALL-TIME EARNINGS", value:fmt(totalAllTime), color:color },
                  { label:"BRANCHES", value:inv.stakes.length, color:"#4DE7A6" },
                ].map(function(k) {
                  return (
                    <div key={k.label} className="card">
                      <label className="label">{k.label}</label>
                      <div style={{ fontFamily:"Playfair Display,serif", fontWeight:900, fontSize:26, color:k.color }}>{k.value}</div>
                    </div>
                  );
                })}
              </div>

              <div style={{ display:"flex", flexDirection:"column", gap:20 }}>
                {inv.stakes.map(function(st, si) {
                  var franchise = franchises.find(function(f) { return f.id === st.franchiseId; });
                  if (!franchise) return null;
                  var stColor = PALETTE[si % PALETTE.length];
                  var allTimeForBranch = franchise.financials.reduce(function(s,m) { return s + (m.income - totalExp(m)) * st.sharePercent / 100; }, 0);
                  return (
                    <div key={st.franchiseId} className="card">
                      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:16 }}>
                        <div style={{ display:"flex", alignItems:"center", gap:12 }}>
                          <div style={{ width:42, height:42, borderRadius:10, background:stColor+"22", border:"1px solid "+stColor+"44", display:"flex", alignItems:"center", justifyContent:"center", color:stColor, fontSize:18 }}>◈</div>
                          <div>
                            <div style={{ fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:16 }}>{franchise.name}</div>
                            <div style={{ fontSize:12, color:"rgba(224,224,224,0.6)", marginTop:2 }}>{franchise.location} · {st.sharePercent}% ownership</div>
                          </div>
                        </div>
                        <div style={{ display:"flex", gap:20, textAlign:"right" }}>
                          <div>
                            <div style={{ fontSize:10, color:"#56B9E9", letterSpacing:"0.1em", marginBottom:4 }}>THIS MONTH</div>
                            <div style={{ fontFamily:"Playfair Display,serif", fontWeight:800, fontSize:18, color:"#E0E0E0" }}>{fmt(st.latestProfit)}</div>
                          </div>
                          <div>
                            <div style={{ fontSize:10, color:"#56B9E9", letterSpacing:"0.1em", marginBottom:4 }}>ALL-TIME</div>
                            <div style={{ fontFamily:"Playfair Display,serif", fontWeight:800, fontSize:18, color:stColor }}>{fmt(allTimeForBranch)}</div>
                          </div>
                        </div>
                      </div>

                      <div className="card" style={{ padding:0, overflow:"hidden", overflowX:"auto" }}>
                        <table style={{ width:"100%", borderCollapse:"collapse", fontSize:12, minWidth:600 }}>
                          <thead>
                            <tr style={{ borderBottom:"1px solid #374151" }}>
                              {["MONTH","INCOME","RENT","SALARIES","ROYALTY","OTHER","TOTAL EXP","NET PROFIT","YOUR SHARE"].map(function(h) {
                                return <th key={h} style={{ padding:"10px 14px", textAlign:"left", fontSize:10, letterSpacing:"0.1em", color:"#56B9E9", fontWeight:500, whiteSpace:"nowrap" }}>{h}</th>;
                              })}
                            </tr>
                          </thead>
                          <tbody>
                            {franchise.financials.length === 0
                              ? <tr><td colSpan={9} style={{ padding:"20px 14px", color:"#56B9E9", textAlign:"center" }}>No financial data yet.</td></tr>
                              : [].concat(franchise.financials).reverse().map(function(m, mi) {
                                var exp = totalExp(m);
                                var net = m.income - exp;
                                var share = net * st.sharePercent / 100;
                                return (
                                  <tr key={mi} style={{ borderBottom:"1px solid #141414" }}
                                    onMouseEnter={function(e) { e.currentTarget.style.background="#252525"; }}
                                    onMouseLeave={function(e) { e.currentTarget.style.background="transparent"; }}>
                                    <td style={{ padding:"10px 14px", color:"rgba(224,224,224,0.6)" }}>{m.month}</td>
                                    <td style={{ padding:"10px 14px", color:"#56B9E9" }}>{fmt(m.income)}</td>
                                    <td style={{ padding:"10px 14px", color:"rgba(224,224,224,0.6)" }}>{fmt(m.rent||0)}</td>
                                    <td style={{ padding:"10px 14px", color:"rgba(224,224,224,0.6)" }}>{fmt(m.salaries||0)}</td>
                                    <td style={{ padding:"10px 14px", color:"rgba(224,224,224,0.6)" }}>{fmt(m.royalty||0)}</td>
                                    <td style={{ padding:"10px 14px", color:"rgba(224,224,224,0.6)" }}>{fmt(m.otherExpenses||0)}</td>
                                    <td style={{ padding:"10px 14px", color:"#cf6679", fontWeight:500 }}>{fmt(exp)}</td>
                                    <td style={{ padding:"10px 14px", color:"#E0E0E0" }}>{fmt(net)}</td>
                                    <td style={{ padding:"10px 14px", color:"#E0E0E0", fontWeight:700 }}>{fmt(share)}</td>
                                  </tr>
                                );
                              })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })()}

        {view === "approvals" && (
          <div className="fade-in">
            <div style={{ marginBottom:18 }}>
              <h1 style={{ fontFamily:"Playfair Display,serif", fontWeight:900, fontSize:28, letterSpacing:"-0.04em" }}>Approvals</h1>
              <p style={{ color:"#56B9E9", fontSize:13, marginTop:4 }}>{pendingCount} pending · {declarations.filter(function(d) { return d.status === "approved"; }).length} approved · {declarations.filter(function(d) { return d.status === "rejected"; }).length} rejected</p>
            </div>
            <div style={{ display:"flex", flexDirection:"column", gap:10, marginBottom:18 }}>
              <input placeholder="Search by person or franchise..." value={searchFranchise} onChange={function(e) { setSearchFranchise(e.target.value); }}
                style={{ width:"100%", background:"#1E1E1E", border:"1px solid #374151", color:"#E0E0E0", padding:"11px 16px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:14, outline:"none" }} />
              <div style={{ display:"flex", gap:10 }}>
              <select value={filterStatus} onChange={function(e) { setFilterStatus(e.target.value); }}
                style={{ flex:1, background:"#1E1E1E", border:"1px solid #374151", color:"rgba(224,224,224,0.6)", padding:"9px 14px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none" }}>
                <option value="all">All Status</option>
                <option value="pending">Pending</option>
                <option value="approved">Approved</option>
                <option value="rejected">Rejected</option>
              </select>
              <select value={filterPayment} onChange={function(e) { setFilterPayment(e.target.value); }}
                style={{ flex:1, background:"#1E1E1E", border:"1px solid #374151", color:"rgba(224,224,224,0.6)", padding:"9px 14px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none" }}>
                <option value="all">All Payment Types</option>
                <option value="save_only">Save Only</option>
                <option value="confirmed">✅ Payment Confirmed</option>
                <option value="pending_payment">⏳ Payment Pending</option>
              </select>
              <select value={filterFranchise} onChange={function(e) { setFilterFranchise(e.target.value); }}
                style={{ flex:1, background:"#1E1E1E", border:"1px solid #374151", color:"rgba(224,224,224,0.6)", padding:"9px 14px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none" }}>
                <option value="all">All Branches</option>
                {franchises.map(function(f) { return <option key={f.id} value={f.id}>{f.location} - {f.name}</option>; })}
              </select>
              <select value={filterMonth} onChange={function(e) { setFilterMonth(e.target.value); }}
                style={{ flex:1, background:"#1E1E1E", border:"1px solid #374151", color:"rgba(224,224,224,0.6)", padding:"9px 14px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none" }}>
                <option value="all">All Months</option>
                <option value="pending">Pending only</option>
                {Array.from(new Set(declarations.map(function(d) { return d.month; }).filter(Boolean))).sort(function(a,b){ return parseMonthDate(b.toString())-parseMonthDate(a.toString()); }).map(function(m) { return <option key={m} value={m}>{m}</option>; })}
              </select>
              </div>
            </div>
            {(function() {
              var today = new Date();
              if (today.getDate() <= 10) return null;
              var overdueEntries = [];
              var now2 = new Date();
              var startYr2 = 2025, startMo2 = 8;
              var totalMo2 = (now2.getFullYear() - startYr2) * 12 + (now2.getMonth() - startMo2) + 1;
              for (var mi = 0; mi < totalMo2; mi++) {
                var moIdx2 = startMo2 + mi;
                var checkYr2 = startYr2 + Math.floor(moIdx2 / 12);
                var checkMoIdx2 = moIdx2 % 12;
                var dueDt2 = new Date(checkYr2, checkMoIdx2 + 1, 10);
                if (now2 < dueDt2) break;
                var checkMonth = MONTH_NAMES[checkMoIdx2] + " " + checkYr2;
                franchises.forEach(function(franchise) {
                  if (franchise.status === "closed") return;
                  var hasDeclaration = declarations.some(function(d) { return d.franchiseId === franchise.id && d.month === checkMonth; });
                  var hasFinancials = franchise.financials.some(function(m) { return m.month === checkMonth; });
                  if (!hasDeclaration && !hasFinancials) {
                    overdueEntries.push({ franchise:franchise, month:checkMonth });
                  }
                });
              }
              if (!overdueEntries.length) return null;

              // Group by franchise
              var groupedByFranchise = {};
              overdueEntries.forEach(function(e) {
                var fid = e.franchise.id;
                if (!groupedByFranchise[fid]) groupedByFranchise[fid] = { franchise:e.franchise, months:[] };
                groupedByFranchise[fid].months.push(e.month);
              });
              var franchiseGroups = Object.values(groupedByFranchise).sort(function(a,b){ return b.months.length - a.months.length; });

              return (
                <div style={{ marginBottom:24 }}>
                  {/* Collapsible header */}
                  <div style={{ display:"flex", alignItems:"center", gap:10, padding:"13px 18px", background:"rgba(207,102,121,0.08)", border:"1px solid rgba(207,102,121,0.25)", borderRadius:showMissingDecl ? "12px 12px 0 0" : 12, cursor:"pointer" }}
                    onClick={function(){ setShowMissingDecl(function(v){ return !v; }); }}>
                    <span style={{ fontSize:16 }}>⚠</span>
                    <span style={{ fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:15, color:"#cf6679" }}>Missing declarations</span>
                    <span style={{ background:"rgba(207,102,121,0.15)", color:"#cf6679", fontSize:10, padding:"3px 10px", borderRadius:20, border:"1px solid rgba(207,102,121,0.3)" }}>{overdueEntries.length} total</span>
                    <span style={{ marginLeft:"auto", color:"rgba(224,224,224,0.4)", fontSize:13 }}>{showMissingDecl ? "▲" : "▼"}</span>
                  </div>

                  {showMissingDecl && (
                    <div style={{ border:"1px solid rgba(207,102,121,0.25)", borderTop:"none", borderRadius:"0 0 12px 12px", padding:"12px", display:"flex", flexDirection:"column", gap:8 }}>
                      {franchiseGroups.map(function(group) {
                        var fid = group.franchise.id;
                        var isOpen = missingDeclExpanded === fid;
                        return (
                          <div key={fid} style={{ background:"#1E1E1E", border:"1px solid rgba(207,102,121,0.2)", borderRadius:10, overflow:"hidden" }}>
                            <div style={{ display:"flex", alignItems:"center", gap:12, padding:"11px 14px", background:"rgba(207,102,121,0.03)" }}>
                              {/* Branch name - clickable to royalty */}
                              <div style={{ flex:1, cursor:"pointer" }} onClick={function(){ setView("royalty"); setRoyaltyDetailId(fid); }}>
                                <div style={{ fontWeight:600, fontSize:13, color:"#56B9E9", textDecoration:"underline" }}>{group.franchise.name}</div>
                                <div style={{ fontSize:11, color:"rgba(224,224,224,0.45)", marginTop:2 }}>{group.franchise.location}</div>
                              </div>
                              <span style={{ background:"rgba(207,102,121,0.12)", color:"#cf6679", fontSize:10, padding:"3px 9px", borderRadius:20, border:"1px solid rgba(207,102,121,0.3)" }}>{group.months.length} missing</span>
                              {/* Expand arrow */}
                              <span style={{ color:"rgba(224,224,224,0.3)", fontSize:12, cursor:"pointer", padding:"4px 6px" }}
                                onClick={function(){ setMissingDeclExpanded(isOpen ? null : fid); }}>
                                {isOpen ? "▲" : "▼"}
                              </span>
                            </div>
                            {isOpen && (
                              <div style={{ borderTop:"1px solid rgba(207,102,121,0.15)", padding:"10px 14px", display:"flex", flexWrap:"wrap", gap:6 }}>
                                {group.months.map(function(month) {
                                  return (
                                    <div key={month} style={{ background:"rgba(207,102,121,0.1)", border:"1px solid rgba(207,102,121,0.25)", borderRadius:7, padding:"5px 12px", fontSize:12, color:"#cf6679" }}>
                                      {month}
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            })()}
            {declarations.length === 0 && <div className="card" style={{ color:"#56B9E9", fontSize:13, textAlign:"center", padding:40 }}>No declarations submitted yet.</div>}
            {(function(){
              var q = searchFranchise.toLowerCase();
              var allFiltered = [].concat(declarations).reverse().filter(function(d) {
                var matchSearch = !searchFranchise || (d.franchiseeName||"").toLowerCase().includes(q) || (d.franchiseName||"").toLowerCase().includes(q) || (d.month||"").toLowerCase().includes(q);
                var matchStatus = filterStatus === "all" || d.status === filterStatus;
                var matchFranchise = filterFranchise === "all" || d.franchiseId === filterFranchise;
                var matchMonth = filterMonth === "all" || (filterMonth === "pending" && d.status === "pending") || d.month === filterMonth;
                var matchPayment = filterPayment === "all" ||
                  (filterPayment === "save_only" && d.paymentType !== "submit_and_pay") ||
                  (filterPayment === "confirmed" && d.paymentStatus === "confirmed") ||
                  (filterPayment === "pending_payment" && d.paymentType === "submit_and_pay" && d.paymentStatus === "pending");
                return matchSearch && matchStatus && matchFranchise && matchMonth && matchPayment;
              });
              // Always separate approved into collapsed section regardless of filter
              var nonApproved = allFiltered.filter(function(d){ return d.status !== "approved"; });
              var approved = allFiltered.filter(function(d){ return d.status === "approved"; });
              // If filter is specifically set to "approved", show them in approved section only
              var showingApprovedFilter = filterStatus === "approved";
              var renderCard = function(d) {
                var totalExpenses = d.rent + d.salaries + d.royalty + d.otherExpenses;
                var net = d.income - totalExpenses;
                var isPending = d.status === "pending";
                var isApproved = d.status === "approved";
                var isEditRequested = d.editRequested;
                var sc = isApproved ? "#4DE7A6" : d.status === "rejected" ? "#cf6679" : "#cf6679";
                var sb = isApproved ? "rgba(77,231,166,0.1)" : d.status === "rejected" ? "rgba(207,102,121,0.1)" : "rgba(207,102,121,0.1)";
                var dName = d.franchiseeName || d.investorName || "?";
                return (
                  <div key={d.id} className="card" style={{ opacity:isPending||isEditRequested ? 1 : 0.7, border:"1px solid "+(isEditRequested?"rgba(86,185,233,0.4)":"#2A2A2A") }}>
                    {isEditRequested && (
                      <div style={{ background:"rgba(86,185,233,0.08)", borderBottom:"1px solid rgba(86,185,233,0.2)", padding:"10px 16px", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                        <div>
                          <span style={{ color:"#56B9E9", fontWeight:600, fontSize:12 }}>✎ Edit Request from Franchisee</span>
                          {d.editRequestNote && <div style={{ fontSize:12, color:"rgba(224,224,224,0.6)", marginTop:3 }}>"{d.editRequestNote}"</div>}
                        </div>
                        <button className="btn btn-sm" style={{ background:"rgba(86,185,233,0.12)", color:"#56B9E9", border:"1px solid rgba(86,185,233,0.3)", fontSize:11 }}
                          onClick={function(){
                            if (!confirm("Approve this edit request? The declaration will be reset to pending so the franchisee can resubmit.")) return;
                            apiPut("/api/declarations/" + d.id + "/edit-request-approve", {}).then(function(){
                              DB.getDeclarations().then(function(dd){ if(dd&&Array.isArray(dd)) setDeclarations(dd); });
                              logActivity("Approved edit request", dName + " - " + d.franchiseName + " - " + d.month);
                              showToast("Edit approved — declaration reset to pending.");
                            });
                          }}>✓ Approve Edit</button>
                      </div>
                    )}
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:14 }}>
                      <div>
                        <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:4 }}>
                          <span style={{ fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:15 }}>{dName}</span>
                          <span style={{ color:"#56B9E9", fontSize:13 }}>→</span>
                          <span style={{ color:"#56B9E9", fontSize:13 }}>{d.franchiseName}</span>
                          <span className="tag" style={{ background:sb, color:sc }}>{d.status}</span>
                          {d.paymentType === 'submit_and_pay' ? (
                            <span className="tag" style={{ background:"rgba(86,185,233,0.12)", color:"#56B9E9", border:"1px solid rgba(86,185,233,0.3)", fontSize:10 }}>💳 Submit & Pay</span>
                          ) : (
                            <span className="tag" style={{ background:"rgba(224,224,224,0.06)", color:"rgba(224,224,224,0.4)", border:"1px solid rgba(224,224,224,0.12)", fontSize:10 }}>Save Only</span>
                          )}
                          {d.paymentType === 'submit_and_pay' && d.paymentStatus === 'confirmed' && (
                            <span className="tag" style={{ background:"rgba(77,231,166,0.12)", color:"#4DE7A6", border:"1px solid rgba(52,211,153,0.3)", fontSize:10 }}>✅ Payment Confirmed</span>
                          )}
                          {d.paymentType === 'submit_and_pay' && d.paymentStatus === 'pending' && (
                            <span style={{ display:"inline-flex", alignItems:"center", gap:6 }}>
                              <span className="tag" style={{ background:"rgba(207,183,100,0.12)", color:"#CFB764", border:"1px solid rgba(207,183,100,0.3)", fontSize:10 }}>⏳ Payment Pending</span>
                              <button className="btn btn-sm" style={{ background:"rgba(77,231,166,0.1)", color:"#4DE7A6", border:"1px solid rgba(52,211,153,0.3)", fontSize:10, padding:"2px 8px" }}
                                onClick={function(){
                                  apiPut("/api/declarations/" + d.id + "/confirm-payment", {}).then(function(){
                                    setDeclarations(declarations.map(function(dec){ return dec.id === d.id ? Object.assign({},dec,{ paymentStatus:'confirmed' }) : dec; }));
                                    showToast("Payment marked as confirmed!");
                                  });
                                }}>✓ Mark Confirmed</button>
                            </span>
                          )}
                        </div>
                        <div style={{ fontSize:12, color:"rgba(224,224,224,0.6)" }}>{d.month} · {d.submittedAt ? d.submittedAt.slice(0,10) : ""}</div>
                      </div>
                      <div style={{ display:"flex", gap:8, alignItems:"center", flexShrink:0 }}>
                        {(isPending || isEditRequested) && (
                          <div style={{ display:"flex", gap:8, flexShrink:0 }}>
                            <button className="btn btn-sm" style={{ background:"rgba(77,231,166,0.1)", color:"#4DE7A6", border:"1px solid rgba(52,211,153,0.3)" }}
                              onClick={function() {
                                if (d.paymentType !== 'submit_and_pay') {
                                  // Save Only — ask about royalty
                                  setRoyaltyPaidModal(d);
                                } else {
                                  // Submit & Pay — approve directly, royalty handled by JotForm
                                  doApproveDeclaration(d, false);
                                }
                              }}>✓ Approve</button>
                            <button className="btn btn-sm" style={{ background:"rgba(207,102,121,0.1)", color:"#cf6679", border:"1px solid rgba(240,104,104,0.3)" }}
                              onClick={function() {
                                DB.rejectDeclaration(d.id).then(function() {
                                  setDeclarations(declarations.map(function(dec) { return dec.id === d.id ? Object.assign({}, dec, { status:"rejected" }) : dec; }));
                                  DB.logActivity("Rejected declaration", dName + " - " + d.franchiseName + " - " + d.month);
                                  logActivity("Rejected declaration", dName + " - " + d.franchiseName + " - " + d.month);
                                  showToast("Rejected.");
                                });
                              }}>✕ Reject</button>
                          </div>
                        )}
                      </div>
                    </div>
                    <div style={{ display:"flex", gap:8, flexShrink:0, marginLeft:"auto", marginBottom:14 }}>
                        <button className="btn btn-sm btn-secondary" style={{ fontSize:11 }}
                          onClick={function() {
                            setEditDeclModal({ id:d.id, franchiseId:d.franchiseId, month:d.month, income:d.income, rent:d.rent, salaries:d.salaries, royalty:d.royalty, otherExpenses:d.otherExpenses, oldMonth:d.month, status:d.status });
                            setEditDeclForm({ month:d.month, income:String(d.income), rent:String(d.rent), salaries:String(d.salaries), royalty:String(d.royalty), otherExpenses:String(d.otherExpenses) });
                          }}>✎ Edit</button>
                        <button className="btn btn-sm" style={{ background:"rgba(207,102,121,0.1)", color:"#cf6679", border:"1px solid rgba(240,104,104,0.3)", fontSize:11 }}
                          onClick={function() {
                            if (!confirm("Delete this declaration? This will also remove the financial entry if it was approved.")) return;
                            var dId = d.id; var dFranchiseId = d.franchiseId; var dMonth = d.month;
                            apiDelete("/api/declarations/" + dId).then(function() {
                              // Also delete the financial entry if it exists
                              apiDelete("/api/franchises/" + dFranchiseId + "/financials/" + encodeURIComponent(dMonth)).catch(function(){});
                              setDeclarations(declarations.filter(function(dec) { return dec.id !== dId; }));
                              setFranchises(franchises.map(function(f) {
                                if (f.id !== dFranchiseId) return f;
                                return Object.assign({}, f, { financials: f.financials.filter(function(m){ return m.month !== dMonth; }) });
                              }));
                              DB.logActivity("Deleted declaration", dName + " - " + d.franchiseName + " - " + dMonth);
                              logActivity("Deleted declaration", dName + " - " + d.franchiseName + " - " + dMonth);
                              showToast("Declaration and financial entry deleted.");
                            });
                          }}>✕ Delete</button>
                      </div>
                    <div style={{ display:"grid", gridTemplateColumns:"repeat(7,1fr)", gap:8 }}>
                      {[["INCOME",d.income,"#56B9E9"],["RENT",d.rent,"#999"],["SALARIES",d.salaries,"#999"],["ROYALTY",d.royalty,"#999"],["OTHER",d.otherExpenses,"#999"],["TOTAL EXP",totalExpenses,"#cf6679"],["NET",net,"#E0E0E0"]].map(function(item) {
                        return (
                          <div key={item[0]} style={{ background:"#252525", borderRadius:8, padding:"10px 12px" }}>
                            <div style={{ fontSize:9, color:"#56B9E9", letterSpacing:"0.1em", marginBottom:4 }}>{item[0]}</div>
                            <div style={{ color:item[2], fontWeight:600, fontSize:13, fontFamily:"Playfair Display,serif" }}>{fmt(item[1])}</div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              };
              return (
                <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
                  {nonApproved.map(function(d){ return renderCard(d); })}
                  {approved.length > 0 && (
                    <div>
                      <div style={{ display:"flex", alignItems:"center", gap:10, padding:"13px 18px", background:"rgba(77,231,166,0.05)", border:"1px solid rgba(77,231,166,0.2)", borderRadius: showApprovedDecl ? "12px 12px 0 0" : 12, cursor:"pointer" }}
                        onClick={function(){ setShowApprovedDecl(function(v){ return !v; }); }}>
                        <span style={{ fontSize:15 }}>checkmark</span>
                        <span style={{ fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:15, color:"#4DE7A6" }}>Approved declarations</span>
                        <span style={{ background:"rgba(77,231,166,0.15)", color:"#4DE7A6", fontSize:10, padding:"3px 10px", borderRadius:20, border:"1px solid rgba(77,231,166,0.3)" }}>{approved.length}</span>
                        <span style={{ marginLeft:"auto", color:"rgba(224,224,224,0.4)", fontSize:13 }}>{showApprovedDecl ? "▲" : "▼"}</span>
                      </div>
                      {showApprovedDecl && (
                        <div style={{ border:"1px solid rgba(77,231,166,0.2)", borderTop:"none", borderRadius:"0 0 12px 12px", display:"flex", flexDirection:"column", gap:12, padding:12 }}>
                          {approved.map(function(d){ return renderCard(d); })}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              );
            })()}
          </div>
        )}

        {/* Royalty Paid Confirmation Modal */}
        {royaltyPaidModal && (
          <div className="modal-bg" onClick={function(){ setRoyaltyPaidModal(null); }}>
            <div className="card fade-in" style={{ width:440, padding:28 }} onClick={function(e){ e.stopPropagation(); }}>
              <h3 style={{ fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:18, marginBottom:8 }}>Approve Declaration</h3>
              <p style={{ fontSize:13, color:"rgba(224,224,224,0.6)", marginBottom:6 }}>
                {royaltyPaidModal.franchiseName} — {royaltyPaidModal.month}
              </p>
              <div style={{ background:"rgba(207,183,100,0.08)", border:"1px solid rgba(207,183,100,0.2)", borderRadius:8, padding:"12px 16px", marginBottom:20 }}>
                <p style={{ fontSize:13, color:"#CFB764", marginBottom:4, fontWeight:600 }}>👑 Has royalty been paid for this month?</p>
                <p style={{ fontSize:11, color:"rgba(224,224,224,0.45)" }}>
                  Royalty amount: <strong style={{ color:"#CFB764" }}>£{(royaltyPaidModal.royalty||0).toFixed(2)}</strong><br/>
                  If yes — figures will update P&L and royalty will be marked as paid.<br/>
                  If no — figures will update P&L only. Royalty will remain outstanding.
                </p>
              </div>
              <div style={{ display:"flex", gap:10 }}>
                <button className="btn btn-primary" style={{ background:"rgba(77,231,166,0.15)", color:"#4DE7A6", border:"1px solid rgba(52,211,153,0.4)" }}
                  onClick={function(){
                    doApproveDeclaration(royaltyPaidModal, true);
                    setRoyaltyPaidModal(null);
                  }}>✓ Yes, royalty paid</button>
                <button className="btn btn-secondary"
                  onClick={function(){
                    doApproveDeclaration(royaltyPaidModal, false);
                    setRoyaltyPaidModal(null);
                  }}>✗ No, not yet paid</button>
                <button className="btn btn-sm" style={{ marginLeft:"auto", color:"rgba(224,224,224,0.4)" }}
                  onClick={function(){ setRoyaltyPaidModal(null); }}>Cancel</button>
              </div>
            </div>
          </div>
        )}

        {/* Edit Declaration Modal */}
        {editDeclModal && (
          <div className="modal-bg" onClick={function(){ setEditDeclModal(null); }}>
            <div className="card fade-in" style={{ width:500, padding:28 }} onClick={function(e){ e.stopPropagation(); }}>
              <h3 style={{ fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:18, marginBottom:4 }}>Edit Declaration</h3>
              <p style={{ fontSize:12, color:"rgba(224,224,224,0.5)", marginBottom:20 }}>{editDeclModal.status === "approved" ? "⚠ This declaration is approved — editing will also update the financial records." : "Editing pending declaration."}</p>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
                <div style={{ gridColumn:"1/-1" }}>
                  <label className="label">MONTH</label>
                  <MonthPicker value={editDeclForm.month||""} onChange={function(v){ setEditDeclForm(function(p){ return Object.assign({},p,{month:v}); }); }} />
                </div>
                {[["income","INCOME"],["rent","RENT"],["salaries","SALARIES"],["royalty","ROYALTY"],["otherExpenses","OTHER EXPENSES"]].map(function(f){
                  return (
                    <div key={f[0]}>
                      <label className="label">{f[1]}</label>
                      <input type="number" min="0" step="0.01" value={editDeclForm[f[0]]||""} onChange={function(e){ var v=e.target.value; setEditDeclForm(function(p){ var n=Object.assign({},p); n[f[0]]=v; return n; }); }} />
                    </div>
                  );
                })}
              </div>
              <div style={{ display:"flex", gap:10, marginTop:20 }}>
                <button className="btn btn-primary" onClick={function(){
                  var updated = {
                    month: editDeclForm.month,
                    income: parseFloat(editDeclForm.income)||0,
                    rent: parseFloat(editDeclForm.rent)||0,
                    salaries: parseFloat(editDeclForm.salaries)||0,
                    royalty: parseFloat(editDeclForm.royalty)||0,
                    otherExpenses: parseFloat(editDeclForm.otherExpenses)||0,
                  };
                  // Update declaration
                  apiPut("/api/declarations/" + editDeclModal.id, updated).then(function(){
                    // If approved, also update financials
                    if (editDeclModal.status === "approved") {
                      // Delete old financial entry if month changed
                      if (editDeclModal.oldMonth !== updated.month) {
                        apiDelete("/api/franchises/" + editDeclModal.franchiseId + "/financials/" + encodeURIComponent(editDeclModal.oldMonth)).catch(function(){});
                      }
                      // Upsert new financial entry
                      apiPost("/api/franchises/" + editDeclModal.franchiseId + "/financials", updated);
                    }
                    setDeclarations(declarations.map(function(dec){
                      if (dec.id !== editDeclModal.id) return dec;
                      return Object.assign({}, dec, updated);
                    }));
                    DB.getFranchises().then(function(d){ if(d) setFranchises(d); });
                    setEditDeclModal(null);
                    logActivity("Edited declaration", editDeclModal.id);
                    showToast("Declaration updated!");
                  }).catch(function(){ showToast("Error updating declaration."); });
                }}>Save Changes</button>
                <button className="btn btn-secondary" onClick={function(){ setEditDeclModal(null); }}>Cancel</button>
              </div>
            </div>
          </div>
        )}

        {view === "users" && (
          <div className="fade-in">
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-end", marginBottom:18 }}>
              <div>
                <h1 style={{ fontFamily:"Playfair Display,serif", fontWeight:900, fontSize:28, letterSpacing:"-0.04em" }}>Users</h1>
                <p style={{ color:"#56B9E9", fontSize:13, marginTop:4 }}>{users.length} accounts</p>
              </div>
              <button className="btn btn-primary btn-sm" onClick={function() { setModal("new-user"); }}>+ Add User</button>
            </div>
            <div style={{ display:"flex", flexDirection:"column", gap:10, marginBottom:18 }}>
              <input placeholder="Search by name or email..." value={searchUser} onChange={function(e) { setSearchUser(e.target.value); }}
                style={{ width:"100%", background:"#1E1E1E", border:"1px solid #374151", color:"#E0E0E0", padding:"11px 16px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:14, outline:"none" }} />
              <div style={{ display:"flex", gap:10 }}>
              <select value={filterRole} onChange={function(e) { setFilterRole(e.target.value); }}
                style={{ flex:1, background:"#1E1E1E", border:"1px solid #374151", color:"rgba(224,224,224,0.6)", padding:"9px 14px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none" }}>
                <option value="all">All Roles</option>
                <option value="admin">Admin</option>
                <option value="franchisee">Franchisee</option>
                <option value="investor">Investor</option>
                <option value="franchisee_investor">Franchisee + Investor</option>
                <option value="hq_support">HQ Support</option>
              </select>
              <select value={filterFranchise} onChange={function(e) { setFilterFranchise(e.target.value); }}
                style={{ flex:1, background:"#1E1E1E", border:"1px solid #374151", color:"rgba(224,224,224,0.6)", padding:"9px 14px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none" }}>
                <option value="all">All Branches</option>
                {franchises.map(function(f) { return <option key={f.id} value={f.id}>{f.location} - {f.name}</option>; })}
              </select>
              </div>
            </div>
            {(function() {
              var filteredUsers = users.filter(function(u) {
                var q = searchUser.toLowerCase();
                var matchSearch = !searchUser || u.name.toLowerCase().includes(q) || u.email.toLowerCase().includes(q);
                var matchRole = filterRole === "all" || u.role === filterRole;
                var matchFranchise = filterFranchise === "all" || u.franchiseId === filterFranchise ||
                  franchises.some(function(f) { return f.id === filterFranchise && f.investors.some(function(i) { return i.email === u.email; }); });
                return matchSearch && matchRole && matchFranchise;
              });
              var activeUsers = filteredUsers.filter(function(u) { return u.active !== false; });
              var inactiveUsers = filteredUsers.filter(function(u) { return u.active === false; });
              var renderUser = function(u) {
                var roleColor = u.role === "admin" ? "#56B9E9" : u.role === "franchisee" ? "#4DE7A6" : u.role === "hq_support" ? "#56B9E9" : "#E0E0E0";
                var isEditing = editingUserId === u.id;
                var isInvestor = u.role === "investor" || u.role === "franchisee_investor";
                var isFranchisee = u.role === "franchisee" || u.role === "franchisee_investor";
                var isHO = u.role === "hq_support";
                var investorStakes = isInvestor ? franchises.reduce(function(acc, f) {
                  var inv = f.investors.find(function(i) { return i.email === u.email; });
                  if (inv) acc.push({ id:f.id, name:f.name, sharePercent:inv.sharePercent });
                  return acc;
                }, []) : [];
                var franchiseeStakes = isFranchisee ? franchises.reduce(function(acc, f) {
                  var owners = f.owners || [];
                  var owner = owners.find(function(o) { return o.email && o.email.toLowerCase() === u.email.toLowerCase(); });
                  var isAssigned = f.id === u.franchiseId || owner;
                  if (isAssigned) acc.push({ id:f.id, name:f.name, sharePercent:owner ? owner.sharePercent : null });
                  return acc;
                }, []) : [];

                return (
                  <div key={u.id} className="card" style={{ padding:"16px 20px" }}>
                    <div style={{ display:"flex", alignItems:"center", gap:14 }}>
                      <div style={{ width:38, height:38, borderRadius:"50%", background:u.active ? roleColor+"22" : "#2A2A2A", border:"1px solid "+(u.active?roleColor+"44":"#2A2A2A"), display:"flex", alignItems:"center", justifyContent:"center", color:u.active?roleColor:"#333333", fontFamily:"Playfair Display,serif", fontWeight:800, fontSize:14 }}>{u.name.charAt(0)}</div>
                      <div style={{ flex:1 }}>
                        <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:3 }}>
                          <span style={{ fontWeight:600, fontSize:14, color:u.active?"#E0E0E0":"#999" }}>{u.name}</span>
                          <span className="tag" style={{ background:roleColor+"22", color:roleColor, fontSize:10 }}>{u.role === "hq_support" ? "HQ Support" : u.role === "franchisee_investor" ? "Franchisee + Investor" : u.role}</span>
                          {!u.active && <span className="tag" style={{ background:"rgba(207,102,121,0.1)", color:"#cf6679", fontSize:10 }}>suspended</span>}
                        </div>
                        <div style={{ fontSize:11, color:"rgba(224,224,224,0.6)" }}>{u.email}</div>
                        {isFranchisee && (
                          <div style={{ marginTop:6, display:"flex", gap:6, flexWrap:"wrap", alignItems:"center" }}>
                            {franchiseeStakes.map(function(s) {
                              var stF2 = franchises.find(function(f) { return f.id === s.id; });
                              var stLabel2 = stF2 ? stF2.location + " - " + stF2.name : s.name;
                              return <span key={s.id} className="tag" style={{ background:"rgba(77,231,166,0.1)", color:"#4DE7A6", fontSize:10 }}>{stLabel2}{s.sharePercent ? " " + s.sharePercent + "%" : ""}</span>;
                            })}
                            <button className="btn btn-sm" style={{ padding:"3px 10px", fontSize:10, background:"transparent", color:"#4DE7A6", border:"1px solid rgba(52,211,153,0.3)" }}
                              onClick={function() { setEditingUserId(isEditing ? null : u.id); }}>
                              {isEditing ? "Done" : "Manage Branches"}
                            </button>
                          </div>
                        )}
                        {isInvestor && (
                          <div style={{ marginTop:6, display:"flex", gap:6, flexWrap:"wrap", alignItems:"center" }}>
                            {investorStakes.map(function(s) {
                              var stF = franchises.find(function(f) { return f.id === s.id; });
                              var stLabel = stF ? stF.location + " - " + stF.name : s.name;
                              return <span key={s.id} className="tag" style={{ background:"#252525", color:"rgba(224,224,224,0.6)", fontSize:10 }}>{stLabel} {s.sharePercent}%</span>;
                            })}
                            <button className="btn btn-sm" style={{ padding:"3px 10px", fontSize:10, background:"transparent", color:"rgba(224,224,224,0.6)", border:"1px solid #222" }}
                              onClick={function() { setEditingUserId(isEditing ? null : u.id); }}>
                              {isEditing ? "Done" : "Manage Branches"}
                            </button>
                          </div>
                        )}
                        {u.role !== "admin" && !isInvestor && !isFranchisee && (
                          <div style={{ marginTop:6 }}>
                            <button className="btn btn-sm" style={{ padding:"3px 10px", fontSize:10, background:"transparent", color:"#56B9E9", border:"1px solid #374151" }}
                              onClick={function() { setEditingUserId(isEditing ? null : u.id); }}>
                              {isEditing ? "Done" : "Manage Access"}
                            </button>
                          </div>
                        )}
                      </div>
                      <div style={{ display:"flex", alignItems:"center", gap:12, flexShrink:0 }}>
                        <div onClick={function() {
                          var uid = u.id; var uactive = u.active; var uname = u.name;
                          apiPut("/api/users/" + uid, { active:!uactive }).then(function() {
                            setUsers(users.map(function(uu) { return uu.id === uid ? Object.assign({}, uu, { active:!uactive }) : uu; }));
                            DB.logActivity(uactive ? "Suspended user" : "Reactivated user", uname);
                            logActivity(uactive ? "Suspended user" : "Reactivated user", uname);
                            showToast(uname + (uactive ? " suspended" : " reactivated"));
                          });
                        }} style={{ width:44, height:24, borderRadius:12, background:u.active?"#56B9E9":"#2A2A2A", border:"1px solid "+(u.active?"#56B9E9":"#56B9E9"), cursor:"pointer", position:"relative", flexShrink:0 }}>
                          <div style={{ width:18, height:18, borderRadius:"50%", background:u.active?"#fff":"#999", position:"absolute", top:2, left:u.active?22:2, transition:"left 0.2s" }} />
                        </div>
                        <button className="btn btn-secondary btn-sm" style={{ fontSize:10, padding:"4px 10px" }}
                          onClick={function() { var uid = u.id; setResetPwUserId(uid); setResetPwVal(""); }}>Reset PW</button>
                        <button className="btn btn-secondary btn-sm" style={{ fontSize:10, padding:"4px 10px" }}
                          onClick={function() { var uid = u.id; var uname = u.name; var uemail = u.email||""; setEditingNameId(uid); setEditNameForm({ name:uname, email:uemail }); }}>Edit</button>
                        <span style={{ color:"#2A2A2A", cursor:"pointer", fontSize:13 }} onMouseEnter={function(e){e.target.style.color="#cf6679";}} onMouseLeave={function(e){e.target.style.color="#2A2A2A";}}
                          onClick={function() {
                            if (!confirm("Delete this user?")) return;
                            apiDelete("/api/users/" + u.id).then(function() {
                              setUsers(users.filter(function(uu) { return uu.id !== u.id; }));
                              DB.logActivity("Deleted user", u.name);
                              logActivity("Deleted user", u.name); showToast("User deleted.");
                            });
                          }}>✕</span>
                      </div>
                    </div>

                    {/* Investor branch assignment */}
                    {isEditing && isInvestor && (
                      <div className="fade-in" style={{ marginTop:14, borderTop:"1px solid #1a1a1a", paddingTop:14 }}>
                        <label className="label" style={{ marginBottom:10 }}>BRANCH ASSIGNMENTS</label>
                        <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
                          {franchises.map(function(f) {
                            var existing = f.investors.find(function(i) { return i.email === u.email; });
                            return (
                              <div key={f.id} style={{ display:"flex", alignItems:"center", gap:12, padding:"10px 14px", background:"#252525", borderRadius:8 }}>
                                <div style={{ flex:1, fontSize:13, color:"rgba(224,224,224,0.6)" }}>{f.location}<span style={{ fontSize:11, color:"rgba(224,224,224,0.6)", marginLeft:8 }}>· {f.name}</span></div>
                                {existing ? (
                                  <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                                    <span style={{ color:"#56B9E9", fontSize:12, fontWeight:500 }}>{existing.sharePercent}%</span>
                                    <button className="btn btn-sm" style={{ background:"rgba(207,102,121,0.1)", color:"#cf6679", border:"1px solid rgba(240,104,104,0.3)", fontSize:11, padding:"4px 10px" }}
                                      onClick={function() {
                                        var updated = franchises.map(function(fr) {
                                          if (fr.id !== f.id) return fr;
                                          return Object.assign({}, fr, { investors:fr.investors.filter(function(i) { return i.email !== u.email; }) });
                                        });
                                        apiDelete("/api/franchises/" + f.id + "/investors/" + u.id).then(function() {
                                          save(updated); DB.logActivity("Removed investor from branch", u.name + " from " + f.name); logActivity("Removed investor from branch", u.name + " from " + f.name); showToast("Removed from " + f.name);
                                        });
                                      }}>Remove</button>
                                  </div>
                                ) : (
                                  <div style={{ display:"flex", alignItems:"center", gap:6 }}>
                                    <input type="number" min="0" max="100" placeholder="%" id={"share_"+u.id+"_"+f.id}
                                      style={{ width:60, background:"#1E1E1E", border:"1px solid #222", color:"#E0E0E0", padding:"6px 8px", borderRadius:6, fontFamily:"Outfit,sans-serif", fontSize:12, outline:"none" }} />
                                    <button className="btn btn-sm" style={{ background:"rgba(123,158,255,0.1)", color:"#56B9E9", border:"1px solid rgba(123,158,255,0.3)", fontSize:11, padding:"4px 10px" }}
                                      onClick={function() {
                                        var inp = document.getElementById("share_"+u.id+"_"+f.id);
                                        var sp = parseFloat(inp ? inp.value : 0);
                                        if (!sp) return;
                                        apiPost("/api/franchises/" + f.id + "/investors", { userId:u.id, sharePercent:sp }).then(function() {
                                          DB.getFranchises().then(function(d) {
    setFranchises(d.map(function(f) {
      return Object.assign({}, f, {
        financials: (f.financials || []).map(function(m) {
          return { month:m.month, income:parseFloat(m.income)||0, rent:parseFloat(m.rent)||0, salaries:parseFloat(m.salaries)||0, royalty:parseFloat(m.royalty)||0, otherExpenses:parseFloat(m.otherExpenses)||0 };
        })
      });
    }));
  });
                                          DB.logActivity("Assigned investor to branch", u.name + " to " + f.name + " (" + sp + "%)");
                                          logActivity("Assigned investor to branch", u.name + " to " + f.name + " (" + sp + "%)"); showToast("Added to " + f.name);
                                        });
                                      }}>Add</button>
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}

                    {/* Franchisee branch assignment */}
                    {isEditing && isFranchisee && (
                      <div className="fade-in" style={{ marginTop:14, borderTop:"1px solid #1a1a1a", paddingTop:14 }}>
                        <label className="label" style={{ marginBottom:10 }}>BRANCH ASSIGNMENTS</label>
                        <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
                          {franchises.map(function(f) {
                            var owners = f.owners || [];
                            var ownerEntry = owners.find(function(o) { return o.email && o.email.toLowerCase() === u.email.toLowerCase(); });
                            var isAssigned = ownerEntry || f.id === u.franchiseId;
                            return (
                              <div key={f.id} style={{ display:"flex", alignItems:"center", gap:12, padding:"10px 14px", background:"#252525", borderRadius:8 }}>
                                <div style={{ flex:1, fontSize:13, color:"rgba(224,224,224,0.6)" }}>{f.location}<span style={{ fontSize:11, color:"rgba(224,224,224,0.6)", marginLeft:8 }}>· {f.name}</span></div>
                                {isAssigned ? (
                                  <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                                    <input type="number" min="0" max="100" placeholder="Share %" defaultValue={ownerEntry ? ownerEntry.sharePercent : ""}
                                      id={"fshare2_"+u.id+"_"+f.id}
                                      style={{ width:74, background:"#1E1E1E", border:"1px solid #222", color:"#E0E0E0", padding:"6px 8px", borderRadius:6, fontFamily:"Outfit,sans-serif", fontSize:12, outline:"none", textAlign:"center" }} />
                                    <button className="btn btn-sm" style={{ background:"rgba(77,231,166,0.1)", color:"#4DE7A6", border:"1px solid rgba(52,211,153,0.3)", fontSize:11, padding:"4px 10px" }}
                                      onClick={function() {
                                        var inp = document.getElementById("fshare2_"+u.id+"_"+f.id);
                                        var sp = inp ? inp.value : "";
                                        var newOwners = owners.filter(function(o) { return !(o.email && o.email.toLowerCase() === u.email.toLowerCase()); });
                                        newOwners.push({ name:u.name, email:u.email, phone:u.phone||"", sharePercent:sp });
                                        apiPut("/api/franchises/" + f.id + "/owners", { owners:newOwners }).then(function() {
                                          save(franchises.map(function(fr) { return fr.id === f.id ? Object.assign({}, fr, { owners:newOwners }) : fr; }));
                                          DB.logActivity("Updated franchisee share", u.name + " - " + f.name + " - " + sp + "%");
                                          logActivity("Updated franchisee share", u.name + " - " + f.name + " - " + sp + "%");
                                          showToast("Share updated!");
                                        });
                                      }}>Save %</button>
                                    <button className="btn btn-sm" style={{ background:"rgba(207,102,121,0.1)", color:"#cf6679", border:"1px solid rgba(240,104,104,0.3)", fontSize:11, padding:"4px 10px" }}
                                      onClick={function() {
                                        var newOwners = owners.filter(function(o) { return !(o.email && o.email.toLowerCase() === u.email.toLowerCase()); });
                                        apiPut("/api/franchises/" + f.id + "/owners", { owners:newOwners }).then(function() {
                                          apiPut("/api/users/" + u.id, { franchiseId:null });
                                          save(franchises.map(function(fr) { return fr.id === f.id ? Object.assign({}, fr, { owners:newOwners }) : fr; }));
                                          setUsers(users.map(function(uu) { return uu.id === u.id && uu.franchiseId === f.id ? Object.assign({}, uu, { franchiseId:null }) : uu; }));
                                          DB.logActivity("Removed franchisee from branch", u.name + " from " + f.name);
                                          logActivity("Removed franchisee from branch", u.name + " from " + f.name);
                                          showToast("Removed from " + f.name);
                                        });
                                      }}>Remove</button>
                                  </div>
                                ) : (
                                  <button className="btn btn-sm" style={{ background:"rgba(77,231,166,0.1)", color:"#4DE7A6", border:"1px solid rgba(52,211,153,0.3)", fontSize:11, padding:"4px 10px" }}
                                    onClick={function() {
                                      var newOwners = [].concat(owners, [{ name:u.name, email:u.email, phone:u.phone||"", sharePercent:"" }]);
                                      apiPut("/api/franchises/" + f.id + "/owners", { owners:newOwners }).then(function() {
                                        apiPut("/api/users/" + u.id, { franchiseId: u.franchiseId || f.id });
                                        save(franchises.map(function(fr) { return fr.id === f.id ? Object.assign({}, fr, { owners:newOwners }) : fr; }));
                                        setUsers(users.map(function(uu) { return uu.id === u.id ? Object.assign({}, uu, { franchiseId: uu.franchiseId || f.id }) : uu; }));
                                        DB.logActivity("Assigned franchisee to branch", u.name + " to " + f.name);
                                        logActivity("Assigned franchisee to branch", u.name + " to " + f.name);
                                        showToast("Added to " + f.name);
                                      });
                                    }}>+ Assign</button>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}

                    {/* Section access toggles - available for all non-admin users */}
                    {u.role !== "admin" && isEditing && (
                      <div className="fade-in" style={{ marginTop:14, borderTop:"1px solid #374151", paddingTop:14 }}>
                        <label className="label" style={{ marginBottom:10 }}>SECTION ACCESS</label>
                        <p style={{ fontSize:11, color:"#56B9E9", marginBottom:10 }}>Toggle which sections this user can access when logged in.</p>
                        <div style={{ display:"flex", flexWrap:"wrap", gap:8 }}>
                          {HO_SECTIONS.map(function(section) {
                            var allowed = u.hoAccess ? u.hoAccess.indexOf(section) !== -1 : false;
                            var label = section.charAt(0).toUpperCase() + section.slice(1).replace("_"," ");
                            return (
                              <div key={section} onClick={function() {
                                var current = u.hoAccess ? [].concat(u.hoAccess) : [];
                                var next = allowed ? current.filter(function(s) { return s !== section; }) : current.concat([section]);
                                apiPut("/api/users/" + u.id, { hoAccess:next }).then(function() {
                                  setUsers(users.map(function(uu) { return uu.id === u.id ? Object.assign({}, uu, { hoAccess:next }) : uu; }));
                                });
                              }} style={{ padding:"6px 14px", borderRadius:20, fontSize:12, cursor:"pointer", background:allowed?"rgba(56,189,248,0.15)":"#1E1E1E", color:allowed?"#56B9E9":"#56B9E9", border:"1px solid "+(allowed?"rgba(56,189,248,0.3)":"#2A2A2A"), userSelect:"none", transition:"all 0.15s" }}>
                                {allowed ? "✓ " : ""}{label}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </div>
                );
              };
              return (
                <div>
                  <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
                    {activeUsers.map(renderUser)}
                    {activeUsers.length === 0 && <div className="card" style={{ color:"rgba(224,224,224,0.45)", fontSize:13, textAlign:"center", padding:32 }}>No users match your filters.</div>}
                  </div>
                  {inactiveUsers.length > 0 && (
                    <div style={{ marginTop:18 }}>
                      <button onClick={function() { setShowInactive(function(s) { return !s; }); }}
                        style={{ display:"flex", alignItems:"center", gap:8, background:"transparent", border:"none", cursor:"pointer", color:"rgba(224,224,224,0.45)", fontSize:13, padding:"10px 0", width:"100%" }}>
                        <div style={{ flex:1, height:1, background:"#2A2A2A" }} />
                        <span style={{ whiteSpace:"nowrap", fontSize:12, letterSpacing:"0.08em" }}>INACTIVE USERS ({inactiveUsers.length}) {showInactive ? "▲" : "▼"}</span>
                        <div style={{ flex:1, height:1, background:"#2A2A2A" }} />
                      </button>
                      {showInactive && (
                        <div className="fade-in" style={{ display:"flex", flexDirection:"column", gap:10, marginTop:10 }}>
                          {inactiveUsers.map(renderUser)}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              );
            })()}
          </div>
        )}

        {view === "royalty" && royaltyAdminView && (
          <div className="fade-in">
            <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:24 }}>
              <button className="btn btn-secondary btn-sm" onClick={function(){ setRoyaltyAdminView(false); setRoyaltyLinkId(null); }}>← Back</button>
              <div>
                <h1 style={{ fontFamily:"Playfair Display,serif", fontWeight:900, fontSize:24, letterSpacing:"-0.04em" }}>All Submissions</h1>
                <p style={{ color:"rgba(224,224,224,0.5)", fontSize:13, marginTop:2 }}>All JotForm submissions — unallocated highlighted in red</p>
              </div>
              <button className="btn btn-primary btn-sm" style={{ marginLeft:"auto" }} onClick={function(){
                setRoyaltyLoading(true);
                fetch(API_URL + "/api/royalty/sync", { method:"POST", headers:{"Content-Type":"application/json","Authorization":"Bearer "+(localStorage.getItem("gi_token")||"")} })
                  .then(function(r){ return r.json(); }).then(function(r){
                    showToast(r.message || "Synced!");
                    apiFetch("/api/royalty").then(function(d){ if(d&&Array.isArray(d)) setRoyaltyPayments(d); setRoyaltyLoading(false); });
                  }).catch(function(){ showToast("Sync failed."); setRoyaltyLoading(false); });
              }}>⟳ Sync JotForm</button>
            </div>

            {/* Summary */}
            {(function() {
              var unlinked = royaltyPayments.filter(function(p){ return !p.franchiseId; });
              var linked = royaltyPayments.filter(function(p){ return p.franchiseId; });
              return (
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:12, marginBottom:20 }}>
                  <div className="card" style={{ padding:14, borderLeft:"3px solid #56B9E9" }}>
                    <div className="label" style={{ marginBottom:4 }}>TOTAL SUBMISSIONS</div>
                    <div style={{ fontFamily:"Playfair Display,serif", fontWeight:800, fontSize:22, color:"#56B9E9" }}>{royaltyPayments.length}</div>
                  </div>
                  <div className="card" style={{ padding:14, borderLeft:"3px solid #4DE7A6" }}>
                    <div className="label" style={{ marginBottom:4 }}>ALLOCATED</div>
                    <div style={{ fontFamily:"Playfair Display,serif", fontWeight:800, fontSize:22, color:"#4DE7A6" }}>{linked.length}</div>
                  </div>
                  <div className="card" style={{ padding:14, borderLeft:"3px solid #cf6679" }}>
                    <div className="label" style={{ marginBottom:4 }}>UNALLOCATED</div>
                    <div style={{ fontFamily:"Playfair Display,serif", fontWeight:800, fontSize:22, color:"#cf6679" }}>{unlinked.length}</div>
                  </div>
                </div>
              );
            })()}

            {/* Search + Filters */}
            <div style={{ display:"flex", flexDirection:"column", gap:10, marginBottom:16 }}>
              <input placeholder="Search by branch name, allocated to, month..." value={adminSubSearch}
                onChange={function(e){ setAdminSubSearch(e.target.value); }}
                style={{ width:"100%", background:"#1E1E1E", border:"1px solid #2A2A2A", color:"#E0E0E0", padding:"11px 16px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:14, outline:"none" }} />
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10 }}>
                <select value={adminSubStatus} onChange={function(e){ setAdminSubStatus(e.target.value); }}
                  style={{ background:"#1E1E1E", border:"1px solid #2A2A2A", color:"rgba(224,224,224,0.7)", padding:"9px 14px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none" }}>
                  <option value="all">All Status</option>
                  <option value="unallocated">Unallocated</option>
                  <option value="allocated">Allocated</option>
                </select>
                <select value={adminSubBranch} onChange={function(e){ setAdminSubBranch(e.target.value); }}
                  style={{ background:"#1E1E1E", border:"1px solid #2A2A2A", color:"rgba(224,224,224,0.7)", padding:"9px 14px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none" }}>
                  <option value="all">All Branches</option>
                  {franchises.map(function(f){ return <option key={f.id} value={f.id}>{(f.location||f.name)+(f.location&&f.location!==f.name?" — "+f.name:"")}</option>; })}
                  <option value="none">Not Linked</option>
                </select>
                <select value={adminSubMonth} onChange={function(e){ setAdminSubMonth(e.target.value); }}
                  style={{ background:"#1E1E1E", border:"1px solid #2A2A2A", color:"rgba(224,224,224,0.7)", padding:"9px 14px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none" }}>
                  <option value="all">All Months</option>
                  {(function(){
                    var allMonths = Array.from(new Set(royaltyPayments.map(function(p){ return p.month||""; }).filter(Boolean))).sort(function(a,b){ return parseMonthDate(b)-parseMonthDate(a); });
                    return allMonths.map(function(m){ return <option key={m} value={m}>{m}</option>; });
                  })()}
                </select>
                <select value={adminSubMethod} onChange={function(e){ setAdminSubMethod(e.target.value); }}
                  style={{ background:"#1E1E1E", border:"1px solid #2A2A2A", color:"rgba(224,224,224,0.7)", padding:"9px 14px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none" }}>
                  <option value="all">All Methods</option>
                  <option value="jotform">JotForm</option>
                  <option value="cash">Cash</option>
                  <option value="transfer">Transfer</option>
                  <option value="manual">Manual</option>
                </select>
              </div>
            </div>

            {/* Full submissions table */}
            <div className="card" style={{ padding:0, overflow:"hidden" }}>
              <table style={{ width:"100%", borderCollapse:"collapse", fontSize:13 }}>
                <thead>
                  <tr style={{ borderBottom:"1px solid #2A2A2A" }}>
                    {["STATUS","BRANCH (JOTFORM)","ALLOCATED TO","MONTH","REVENUE","ROYALTY","METHOD","ACTION"].map(function(h){
                      return <th key={h} style={{ padding:"12px 18px", textAlign:"left", fontSize:10, letterSpacing:"0.08em", color:"rgba(224,224,224,0.45)", fontWeight:700 }}>{h}</th>;
                    })}
                  </tr>
                </thead>
                <tbody>
                  {[].concat(royaltyPayments).filter(function(p) {
                    var isUnlinked2 = !p.franchiseId;
                    var franchise5 = franchises.find(function(f){ return f.id === p.franchiseId; });
                    var q = adminSubSearch.toLowerCase();
                    var matchSearch = !adminSubSearch || (p.franchiseName||"").toLowerCase().includes(q) || (franchise5?(franchise5.name||"").toLowerCase().includes(q):false) || (p.month||"").toLowerCase().includes(q);
                    var matchStatus = adminSubStatus==="all" || (adminSubStatus==="unallocated"&&isUnlinked2) || (adminSubStatus==="allocated"&&!isUnlinked2);
                    var matchBranch = adminSubBranch==="all" || (adminSubBranch==="none"&&isUnlinked2) || p.franchiseId===adminSubBranch;
                    var mn = p.month ? p.month.toString().split(" ")[0] : "";
                    var matchMonth = adminSubMonth==="all" || mn===adminSubMonth;
                    var pm4 = p.paymentMethod || (p.source==="jotform"?"jotform":"");
                    var matchMethod = adminSubMethod==="all" || pm4===adminSubMethod || (adminSubMethod==="manual"&&!pm4);
                    return matchSearch && matchStatus && matchBranch && matchMonth && matchMethod;
                  }).sort(function(a,b){ return parseMonthDate(b.month)-parseMonthDate(a.month); }).map(function(p, pi) {
                    var isUnlinked = !p.franchiseId;
                    var franchise = franchises.find(function(f){ return f.id === p.franchiseId; });
                    var isLinking = royaltyLinkId === p.id;
                    return (
                      <tr key={pi} style={{ borderBottom:"1px solid rgba(255,255,255,0.04)", background:isUnlinked?"rgba(207,102,121,0.06)":"transparent" }}>
                        <td style={{ padding:"12px 18px" }}>
                          <span className="tag" style={{ background:isUnlinked?"rgba(207,102,121,0.12)":"rgba(77,231,166,0.1)", color:isUnlinked?"#cf6679":"#4DE7A6", fontSize:10, border:"1px solid "+(isUnlinked?"rgba(207,102,121,0.3)":"rgba(77,231,166,0.25)") }}>
                            {isUnlinked ? "⚠ Unallocated" : "✓ Allocated"}
                          </span>
                        </td>
                        <td style={{ padding:"12px 18px", color:isUnlinked?"#cf6679":"rgba(224,224,224,0.7)", fontWeight:isUnlinked?600:400 }}>{p.franchiseName || "—"}</td>
                        <td style={{ padding:"12px 18px" }}>
                          {franchise
                            ? <div><div style={{ color:"#E0E0E0", fontWeight:500, fontSize:12 }}>{franchise.name}</div><div style={{ color:"rgba(224,224,224,0.45)", fontSize:11 }}>{franchise.location}</div></div>
                            : <span style={{ color:"rgba(224,224,224,0.3)", fontSize:12 }}>Not linked</span>}
                        </td>
                        <td style={{ padding:"12px 18px", color:"rgba(224,224,224,0.7)" }}>{p.month}</td>
                        <td style={{ padding:"12px 18px", color:"#56B9E9", fontWeight:500 }}>{fmt(parseFloat(p.revenue)||0)}</td>
                        <td style={{ padding:"12px 18px", color:"#4DE7A6", fontWeight:600 }}>{fmt(parseFloat(p.royalty)||0)}</td>
                        <td style={{ padding:"12px 18px" }}>
                          {(function(){
                            var pm3 = p.paymentMethod || (p.source === "jotform" ? "jotform" : "");
                            if (!pm3) return <span style={{ color:"rgba(224,224,224,0.3)", fontSize:11 }}>-</span>;
                            var bg3 = pm3==="jotform"?"rgba(86,185,233,0.1)":pm3==="cash"?"rgba(77,231,166,0.1)":"rgba(224,224,224,0.08)";
                            var col3 = pm3==="jotform"?"#56B9E9":pm3==="cash"?"#4DE7A6":"#E0E0E0";
                            var lbl3 = pm3==="jotform"?"JotForm":pm3==="cash"?"Cash":"Transfer";
                            return <span className="tag" style={{ background:bg3, color:col3, fontSize:10, border:"1px solid rgba(255,255,255,0.1)" }}>{lbl3}</span>;
                          })()}
                        </td>
                        <td style={{ padding:"12px 18px" }}>
                          <button className="btn btn-secondary btn-sm" style={{ fontSize:11 }}
                            onClick={function(){ setRoyaltyLinkId(p.id); setRoyaltyLinkFranchiseId(p.franchiseId||""); setRoyaltyLinkSearch(""); }}>
                            {isUnlinked ? "Allocate" : "Re-allocate"}
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {view === "royalty" && royaltyDetailId && !royaltyAdminView && (function() {
          var detailFranchise = franchises.find(function(f){ return f.id === royaltyDetailId; });
          if (!detailFranchise) return null;
          var detailPayments = [].concat(royaltyPayments).filter(function(p){ return p.franchiseId === royaltyDetailId; });
          var nowD = new Date();

          // Build all months from franchise start to now
          var startMonthStrD = detailFranchise.royaltyStartMonth || null;
          var parsedD = startMonthStrD ? startMonthStrD.toString().match(/([A-Za-z]+) (20[0-9][0-9])/) : null;
          var sIdxD = parsedD ? parseInt(parsedD[2]) * 12 + MONTH_NAMES.indexOf(parsedD[1]) : 2025 * 12 + 8;
          var eIdxD = nowD.getFullYear() * 12 + nowD.getMonth();
          var allMonthsD = [];
          for (var dmi = sIdxD; dmi <= eIdxD; dmi++) {
            var dYr = Math.floor(dmi / 12);
            var dMo = dmi % 12;
            var dDue = new Date(dYr, dMo + 1, 10);
            if (dDue <= nowD) allMonthsD.push(MONTH_NAMES[dMo] + " " + dYr);
          }

          // Group by year
          var yearGroupsD = {};
          allMonthsD.forEach(function(m) {
            var yr2D = m.split(" ")[1];
            if (!yearGroupsD[yr2D]) yearGroupsD[yr2D] = [];
            yearGroupsD[yr2D].push(m);
          });
          var yearKeysD = Object.keys(yearGroupsD).sort(function(a,b){ return b-a; });

          // Chart data
          var chartDataD = detailPayments.slice().sort(function(a,b){ return parseMonthDate(a.month)-parseMonthDate(b.month); }).slice(-12).map(function(p){
            return { month:p.month, royalty:parseFloat(p.royalty)||0, revenue:parseFloat(p.revenue)||0 };
          });

          return (
            <div className="fade-in">
              <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:24 }}>
                <button className="btn btn-secondary btn-sm" onClick={function(){ setRoyaltyDetailId(null); }}>← Back</button>
                <div>
                  <h1 style={{ fontFamily:"Playfair Display,serif", fontWeight:900, fontSize:24, letterSpacing:"-0.04em" }}>{detailFranchise.name}</h1>
                  <p style={{ color:"rgba(224,224,224,0.5)", fontSize:13, marginTop:2 }}>{detailFranchise.location} · Royalty History</p>
                </div>
              </div>

              {chartDataD.length > 1 && (
                <div className="card" style={{ padding:20, marginBottom:20 }}>
                  <label className="label" style={{ marginBottom:14 }}>ROYALTY TREND (LAST 12 MONTHS)</label>
                  <ResponsiveContainer width="100%" height={200}>
                    <LineChart data={chartDataD}>
                      <CartesianGrid strokeDasharray="3 3" stroke="#2A2A2A" vertical={false} />
                      <XAxis dataKey="month" tick={{ fill:"rgba(224,224,224,0.4)", fontSize:11 }} axisLine={false} tickLine={false} />
                      <YAxis tick={{ fill:"rgba(224,224,224,0.4)", fontSize:11 }} axisLine={false} tickLine={false} tickFormatter={function(v){ return "£"+v.toLocaleString(); }} />
                      <Tooltip content={function(props) {
                        if (!props.active || !props.payload || !props.payload.length) return null;
                        return (
                          <div style={{ background:"#1E1E1E", border:"1px solid #2A2A2A", borderRadius:8, padding:"10px 14px", fontSize:12 }}>
                            <div style={{ color:"rgba(224,224,224,0.6)", marginBottom:6 }}>{props.label}</div>
                            {props.payload.map(function(p2){ return <div key={p2.dataKey} style={{ color:p2.color }}>{p2.name}: {fmt(p2.value)}</div>; })}
                          </div>
                        );
                      }} />
                      <Line type="monotone" dataKey="revenue" stroke="#56B9E9" strokeWidth={2} dot={false} name="Revenue" />
                      <Line type="monotone" dataKey="royalty" stroke="#4DE7A6" strokeWidth={2} dot={{ fill:"#4DE7A6", r:3 }} name="Royalty" />
                    </LineChart>
                  </ResponsiveContainer>
                </div>
              )}

              {yearKeysD.map(function(yrD) {
                var yrMonthsD = yearGroupsD[yrD];
                var yrPaymentsD = detailPayments.filter(function(p){ return (p.month||"").endsWith(yrD); });
                var yrRevenueD = yrPaymentsD.reduce(function(s,p){ return s+(parseFloat(p.revenue)||0); }, 0);
                var yrRoyaltyD = yrPaymentsD.reduce(function(s,p){ return s+(parseFloat(p.royalty)||0); }, 0);
                var yrRateD = yrRevenueD > 0 ? yrRoyaltyD/yrRevenueD*100 : 0;
                var paidD = yrPaymentsD.length;
                var unpaidD = yrMonthsD.filter(function(m){ return !detailPayments.some(function(p){ return p.month===m; }); }).length;
                return (
                  <div key={yrD} style={{ marginBottom:20 }}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:10 }}>
                      <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                        <label className="label" style={{ margin:0 }}>{yrD}</label>
                        <span className="tag" style={{ background:"rgba(77,231,166,0.08)", color:"#4DE7A6", fontSize:10, border:"1px solid rgba(77,231,166,0.2)" }}>{paidD} paid</span>
                        <span className="tag" style={{ background:unpaidD>0?"rgba(207,102,121,0.1)":"rgba(255,255,255,0.05)", color:unpaidD>0?"#cf6679":"rgba(224,224,224,0.35)", fontSize:10, border:"1px solid "+(unpaidD>0?"rgba(207,102,121,0.25)":"rgba(255,255,255,0.08)") }}>{unpaidD} unpaid</span>
                      </div>
                      <div style={{ display:"flex", gap:16, fontSize:12 }}>
                        {yrRevenueD > 0 && <span style={{ color:"#56B9E9" }}>Revenue: {fmt(yrRevenueD)}</span>}
                        {yrRoyaltyD > 0 && <span style={{ color:"#4DE7A6" }}>Royalty: {fmt(yrRoyaltyD)}</span>}
                        {yrRateD > 0 && <span style={{ color:"rgba(224,224,224,0.5)" }}>Rate: {pct(yrRateD)}</span>}
                      </div>
                    </div>
                    <div className="card" style={{ padding:0, overflow:"hidden" }}>
                      <table style={{ width:"100%", borderCollapse:"collapse", fontSize:13 }}>
                        <thead>
                          <tr style={{ borderBottom:"1px solid #2A2A2A" }}>
                            {["MONTH","STATUS","REVENUE","ROYALTY","RATE","PAYMENT DATE","METHOD",""].map(function(h){
                              return <th key={h} style={{ padding:"10px 18px", textAlign:"left", fontSize:10, letterSpacing:"0.08em", color:"rgba(224,224,224,0.45)", fontWeight:700 }}>{h}</th>;
                            })}
                          </tr>
                        </thead>
                        <tbody>
                          {yrMonthsD.slice().reverse().map(function(month) {
                            var pD = detailPayments.find(function(dp){ return dp.month === month; });
                            var dueDt = new Date(parseInt(month.split(" ")[1]), MONTH_NAMES.indexOf(month.split(" ")[0])+1, 10);
                            var isUnpaidD = !pD && dueDt <= nowD;
                            var rate2D = pD && (parseFloat(pD.revenue)||0) > 0 ? (parseFloat(pD.royalty)||0)/(parseFloat(pD.revenue)||1)*100 : 0;
                            var pm2D = pD ? (pD.paymentMethod || (pD.source==="jotform"?"jotform":"")) : "";
                            return (
                              <tr key={month} style={{ borderBottom:"1px solid rgba(255,255,255,0.04)", background:isUnpaidD?"rgba(207,102,121,0.04)":"transparent" }}>
                                <td style={{ padding:"10px 18px", color:isUnpaidD?"#cf6679":"rgba(224,224,224,0.7)", fontWeight:isUnpaidD?500:400 }}>{month}</td>
                                <td style={{ padding:"10px 18px" }}>
                                  {pD
                                    ? <span className="tag" style={{ background:"rgba(77,231,166,0.1)", color:"#4DE7A6", fontSize:10, border:"1px solid rgba(77,231,166,0.25)" }}>✓ Paid</span>
                                    : <span className="tag" style={{ background:"rgba(207,102,121,0.1)", color:"#cf6679", fontSize:10, border:"1px solid rgba(207,102,121,0.25)" }}>⚠ Unpaid</span>
                                  }
                                </td>
                                <td style={{ padding:"10px 18px", color:pD?"#56B9E9":"rgba(224,224,224,0.2)" }}>{pD ? fmt(parseFloat(pD.revenue)||0) : "—"}</td>
                                <td style={{ padding:"10px 18px", color:pD?"#4DE7A6":"rgba(224,224,224,0.2)", fontWeight:pD?600:400 }}>{pD ? fmt(parseFloat(pD.royalty)||0) : "—"}</td>
                                <td style={{ padding:"10px 18px", color:"rgba(224,224,224,0.6)" }}>{pD ? pct(rate2D) : "—"}</td>
                                <td style={{ padding:"10px 18px", color:"rgba(224,224,224,0.6)" }}>{pD && pD.paymentDate ? new Date(pD.paymentDate).toLocaleDateString("en-GB") : "—"}</td>
                                <td style={{ padding:"10px 18px" }}>
                                  {pm2D ? <span className="tag" style={{ background:pm2D==="jotform"?"rgba(86,185,233,0.1)":pm2D==="cash"?"rgba(77,231,166,0.1)":"rgba(224,224,224,0.08)", color:pm2D==="jotform"?"#56B9E9":pm2D==="cash"?"#4DE7A6":"#E0E0E0", fontSize:10, border:"1px solid rgba(255,255,255,0.1)" }}>{pm2D==="jotform"?"JotForm":pm2D==="cash"?"Cash":"Transfer"}</span> : <span style={{ color:"rgba(224,224,224,0.2)", fontSize:11 }}>—</span>}
                                </td>
                                <td style={{ padding:"10px 18px" }}>
                                  {pD
                                    ? <button className="btn btn-secondary btn-sm" style={{ fontSize:11 }} onClick={function(){ setRoyaltyForm({ id:pD.id, franchiseId:pD.franchiseId||"", month:pD.month||"", revenue:pD.revenue||"", royalty:pD.royalty||"", paymentDate:pD.paymentDate ? pD.paymentDate.toString().slice(0,10) : "", paymentMethod:pD.paymentMethod||"" }); setRoyaltyModal("edit"); }}>Edit</button>
                                    : <button className="btn btn-sm" style={{ background:"rgba(86,185,233,0.1)", color:"#56B9E9", border:"1px solid rgba(86,185,233,0.2)", fontSize:11 }} onClick={function(){ setRoyaltyForm({ franchiseId:detailFranchise.id, month:month, revenue:"", royalty:"", paymentDate:"", paymentMethod:"" }); setRoyaltyModal("new"); }}>+ Add</button>
                                  }
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                );
              })}
            </div>
          );
        })()}
        {view === "royalty" && !royaltyDetailId && (
          <div className="fade-in">
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:24 }}>
              <div>
                <h1 style={{ fontFamily:"Playfair Display,serif", fontWeight:900, fontSize:28, letterSpacing:"-0.04em" }}>Royalty</h1>
                <p style={{ color:"rgba(224,224,224,0.5)", fontSize:13, marginTop:4 }}>Track monthly royalty payments across all branches</p>
              </div>
              <div style={{ display:"flex", gap:10 }}>
                <a href="https://www.jotform.com" target="_blank" rel="noreferrer"
                  className="btn btn-secondary" style={{ fontSize:13, textDecoration:"none", display:"flex", alignItems:"center", gap:6 }}>
                  ↗ Open JotForm
                </a>
                <button className="btn btn-secondary" onClick={function() { setRoyaltyAdminView(true); }}>⚙ Manage Submissions</button>
                <button className="btn btn-primary" onClick={function() {
                  setRoyaltyForm({ franchiseId:"", month:"", revenue:"", royalty:"", paymentDate:"" });
                  setRoyaltyModal("new");
                }}>+ Add Payment</button>
              </div>
            </div>

            {/* Search + Filters */}
            <div style={{ display:"flex", flexDirection:"column", gap:10, marginBottom:20 }}>
              <input placeholder="Search by branch, month..." value={royaltySearch} onChange={function(e){ setRoyaltySearch(e.target.value); }}
                style={{ width:"100%", background:"#1E1E1E", border:"1px solid #2A2A2A", color:"#E0E0E0", padding:"11px 16px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:14, outline:"none" }} />
              <div style={{ display:"flex", gap:10, flexWrap:"wrap", alignItems:"center" }}>
                <div style={{ display:"flex", alignItems:"center", gap:8, background:"#1E1E1E", border:"1px solid #2A2A2A", borderRadius:8, padding:"6px 12px" }}>
                  <button onClick={function(){ setRoyaltyYear(String(parseInt(royaltyYear)-1)); }} className="btn btn-secondary btn-sm" style={{ padding:"4px 10px" }}>←</button>
                  <span style={{ fontSize:14, fontWeight:600, color:"#E0E0E0", minWidth:40, textAlign:"center" }}>{royaltyYear}</span>
                  <button onClick={function(){ setRoyaltyYear(String(parseInt(royaltyYear)+1)); }} className="btn btn-secondary btn-sm" style={{ padding:"4px 10px" }}>→</button>
                </div>
                <select value={royaltyFilterMonth} onChange={function(e){ setRoyaltyFilterMonth(e.target.value); }}
                  style={{ flex:1, background:"#1E1E1E", border:"1px solid #2A2A2A", color:"rgba(224,224,224,0.7)", padding:"9px 14px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none" }}>
                  <option value="all">All Months</option>
                  {MONTH_NAMES.map(function(m){ return <option key={m} value={m}>{m}</option>; })}
                </select>
                <select value={royaltyFilterBranch} onChange={function(e){ setRoyaltyFilterBranch(e.target.value); }}
                  style={{ flex:1, background:"#1E1E1E", border:"1px solid #2A2A2A", color:"rgba(224,224,224,0.7)", padding:"9px 14px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none" }}>
                  <option value="all">All Branches</option>
                  {franchises.map(function(f){ return <option key={f.id} value={f.id}>{(f.location||f.name)+(f.location&&f.location!==f.name?" — "+f.name:"")}</option>; })}
                </select>
                <button className="btn btn-secondary" style={{ fontSize:12 }} onClick={function(){
                  setRoyaltyLoading(true);
                  apiFetch("/api/royalty").then(function(d){ if(d&&Array.isArray(d)) setRoyaltyPayments(d); setRoyaltyLoading(false); }).catch(function(){ setRoyaltyLoading(false); });
                }}>↻ Refresh</button>
                <button className="btn btn-primary" style={{ fontSize:12 }} onClick={function(){
                  setRoyaltyLoading(true);
                  fetch(API_URL + "/api/royalty/sync", { method:"POST", headers:{"Content-Type":"application/json","Authorization":"Bearer "+(localStorage.getItem("gi_token")||"")} })
                    .then(function(r){ return r.json(); }).then(function(r){
                      showToast(r.message || "Synced!");
                      apiFetch("/api/royalty").then(function(d){ if(d&&Array.isArray(d)) setRoyaltyPayments(d); setRoyaltyLoading(false); });
                    }).catch(function(){ showToast("Sync failed."); setRoyaltyLoading(false); });
                }}>⟳ Sync JotForm</button>
              </div>
            </div>

            {/* Summary KPIs */}
            {(function() {
              var filtered = royaltyPayments.filter(function(p) {
                var match = p.month && p.month.toString().match(/(20[0-9][0-9])/);
                var yr = match ? match[1] : "";
                var mn = p.month ? p.month.toString().split(" ")[0] : "";
                var matchYear = yr === royaltyYear;
                var matchMonth = royaltyFilterMonth === "all" || mn === royaltyFilterMonth;
                var matchBranch = royaltyFilterBranch === "all" || p.franchiseId === royaltyFilterBranch;
                var franchise2 = franchises.find(function(f){ return f.id === p.franchiseId; });
                var searchQ = royaltySearch.toLowerCase();
                var matchSearch = !royaltySearch || (p.franchiseName||"").toLowerCase().includes(searchQ) || (franchise2 ? (franchise2.name||"").toLowerCase().includes(searchQ) : false) || (p.month||"").toLowerCase().includes(searchQ);
                return matchYear && matchMonth && matchBranch && matchSearch;
              });
              var totalRevenue = filtered.reduce(function(s,p){ return s+(parseFloat(p.revenue)||0); }, 0);
              var totalRoyalty = filtered.reduce(function(s,p){ return s+(parseFloat(p.royalty)||0); }, 0);
              var avgRate = totalRevenue > 0 ? totalRoyalty/totalRevenue*100 : 0;
              return (
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:12, marginBottom:20 }}>
                  <div className="card" style={{ padding:16, borderLeft:"3px solid #56B9E9" }}>
                    <div className="label" style={{ marginBottom:6 }}>TOTAL REVENUE</div>
                    <div style={{ fontFamily:"Playfair Display,serif", fontWeight:800, fontSize:22, color:"#56B9E9" }}>{fmt(totalRevenue)}</div>
                  </div>
                  <div className="card" style={{ padding:16, borderLeft:"3px solid #4DE7A6" }}>
                    <div className="label" style={{ marginBottom:6 }}>TOTAL ROYALTY</div>
                    <div style={{ fontFamily:"Playfair Display,serif", fontWeight:800, fontSize:22, color:"#4DE7A6" }}>{fmt(totalRoyalty)}</div>
                  </div>
                  <div className="card" style={{ padding:16, borderLeft:"3px solid #cf6679" }}>
                    <div className="label" style={{ marginBottom:6 }}>AVG ROYALTY RATE</div>
                    <div style={{ fontFamily:"Playfair Display,serif", fontWeight:800, fontSize:22, color:"#cf6679" }}>{pct(avgRate)}</div>
                  </div>
                </div>
              );
            })()}

            {/* Overdue Royalty */}
            {(function() {
              var now = new Date();
              var overdueMonths = [];
              var startYear = 2025, startMonth = 8; // Sep 2025 (0-indexed)
              var curYear = now.getFullYear(), curMonth = now.getMonth();
              var totalMonths = (curYear - startYear) * 12 + (curMonth - startMonth) + 1;
              for (var mi3 = 0; mi3 < totalMonths; mi3++) {
                var mIdx = startMonth + mi3;
                var royaltyYear2 = startYear + Math.floor(mIdx / 12);
                var royaltyMonthIdx = mIdx % 12;
                var dueDate2 = new Date(royaltyYear2, royaltyMonthIdx + 1, 10);
                if (now < dueDate2) break;
                var monthStr2 = MONTH_NAMES[royaltyMonthIdx] + " " + royaltyYear2;
                var unpaidFranchises2 = franchises.filter(function(f) {
                  if (f.status === "closed") return false;
                  return !royaltyPayments.some(function(p) {
                    return p.franchiseId === f.id && p.month === monthStr2;
                  });
                });
                if (unpaidFranchises2.length > 0) {
                  overdueMonths.push({ month:monthStr2, dueDate:dueDate2, franchises:unpaidFranchises2 });
                }
              }
              if (overdueMonths.length === 0) return null;
              return (
                <div style={{ marginBottom:20 }}>
                  <div style={{ background:"rgba(207,102,121,0.08)", border:"1px solid rgba(207,102,121,0.25)", borderRadius:12, overflow:"hidden" }}>
                    <div style={{ display:"flex", alignItems:"center", gap:10, padding:"14px 20px", cursor:"pointer" }}
                      onClick={function(){ setShowOverdueRoyalty(function(v){ return !v; }); }}>
                      <span style={{ fontSize:18 }}>⚠</span>
                      <label className="label" style={{ margin:0, color:"#cf6679", cursor:"pointer" }}>OVERDUE ROYALTY PAYMENTS</label>
                      <span className="tag" style={{ background:"rgba(207,102,121,0.15)", color:"#cf6679", fontSize:10, border:"1px solid rgba(207,102,121,0.3)" }}>{overdueMonths.reduce(function(s,i){ return s+i.franchises.length; },0)} outstanding</span>
                      <span style={{ marginLeft:"auto", color:"rgba(224,224,224,0.4)", fontSize:14 }}>{showOverdueRoyalty ? "▲" : "▼"}</span>
                    </div>
                    {showOverdueRoyalty && (
                      <div className="fade-in" style={{ borderTop:"1px solid rgba(207,102,121,0.2)", padding:"16px 20px", display:"flex", flexDirection:"column", gap:10 }}>
                    <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
                      {overdueMonths.map(function(item) {
                        return (
                          <div key={item.month}>
                            <div style={{ fontSize:12, color:"rgba(224,224,224,0.5)", marginBottom:8 }}>
                              <strong style={{ color:"#cf6679" }}>{item.month}</strong>
                              <span style={{ marginLeft:8 }}>— was due by {item.dueDate.toLocaleDateString("en-GB")}</span>
                            </div>
                            <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
                              {item.franchises.map(function(f) {
                                return (
                                  <div key={f.id} style={{ background:"rgba(207,102,121,0.12)", border:"1px solid rgba(207,102,121,0.3)", borderRadius:8, padding:"8px 14px", display:"flex", alignItems:"center", gap:10 }}>
                                    <div>
                                      <div style={{ fontWeight:600, fontSize:13, color:"#E0E0E0" }}>{f.name}</div>
                                      <div style={{ fontSize:11, color:"rgba(224,224,224,0.45)" }}>{f.location}</div>
                                    </div>
                                    <button className="btn btn-sm" style={{ background:"rgba(207,102,121,0.15)", color:"#cf6679", border:"1px solid rgba(207,102,121,0.3)", fontSize:11, marginLeft:8 }}
                                      onClick={function() {
                                        setRoyaltyForm({ franchiseId:f.id, month:item.month, revenue:"", royalty:"", paymentDate:"" });
                                        setRoyaltyModal("new");
                                      }}>+ Add Payment</button>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                      </div>
                    )}
                  </div>
                </div>
              );
            })()}

            {/* Payments table - all franchises, grouped by branch */}
            {(function() {
              if (royaltyLoading) return <div className="card" style={{ padding:"22px 18px", color:"rgba(224,224,224,0.45)", fontSize:13 }}>Loading...</div>;

              var now6 = new Date();
              var yr = parseInt(royaltyYear);

              // Build helper to get months from a start month to now
              var getMonthsFrom = function(startMonth) {
                var months = [];
                var parsed = startMonth ? startMonth.toString().match(/([A-Za-z]+) (20[0-9][0-9])/) : null;
                var sIdx = parsed ? (2025 * 12 + 8) : (2025 * 12 + 8); // default Sep 2025
                if (parsed) { sIdx = parseInt(parsed[2]) * 12 + MONTH_NAMES.indexOf(parsed[1]); }
                var eIdx = now6.getFullYear() * 12 + now6.getMonth();
                for (var hmi2 = sIdx; hmi2 <= eIdx; hmi2++) {
                  var hYr2 = Math.floor(hmi2 / 12);
                  var hMo2 = hmi2 % 12;
                  var hDue2 = new Date(hYr2, hMo2 + 1, 10);
                  if (hDue2 <= now6) months.push(MONTH_NAMES[hMo2] + " " + hYr2);
                }
                return months;
              };
              var allHistMonths = getMonthsFrom(null); // default all months

              // Build list of months for selected year (for header display + filters)
              var monthsInYear = MONTH_NAMES.map(function(m){ return m + " " + yr; });
              // Filter months based on month filter
              var visibleMonths = royaltyFilterMonth === "all" ? monthsInYear : monthsInYear.filter(function(m){ return m.startsWith(royaltyFilterMonth); });
              // Only show months up to now
              visibleMonths = visibleMonths.filter(function(m){ return parseMonthDate(m) <= parseMonthDate(MONTH_NAMES[now6.getMonth()] + " " + now6.getFullYear()); });

              // Get unlinked payments (not matched to any franchise)
              var unlinkedPayments = royaltyPayments.filter(function(p){
                var match = p.month && p.month.toString().match(/(20[0-9][0-9])/);
                var yr2 = match ? match[1] : "";
                return !p.franchiseId && yr2 === royaltyYear;
              });
              // Group unlinked by franchiseName
              var unlinkedGroups = {};
              unlinkedPayments.forEach(function(p){
                var key = p.franchiseName || "Unknown";
                if (!unlinkedGroups[key]) unlinkedGroups[key] = [];
                unlinkedGroups[key].push(p);
              });

              // Filter franchises by search and branch filter
              var searchQ6 = royaltySearch.toLowerCase();
              // Separate active and closed for display
              var visibleFranchises = franchises.filter(function(f){
                var matchBranch = royaltyFilterBranch === "all" || f.id === royaltyFilterBranch;
                var matchSearch = !royaltySearch || (f.name||"").toLowerCase().includes(searchQ6) || (f.location||"").toLowerCase().includes(searchQ6);
                return matchBranch && matchSearch;
              });

              return (
                <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
                  {/* All created franchises */}
                  {visibleFranchises.map(function(franchise) {
                    var fPayments = royaltyPayments.filter(function(p){
                      var match = p.month && p.month.toString().match(/(20[0-9][0-9])/);
                      var yr2 = match ? match[1] : "";
                      return p.franchiseId === franchise.id && yr2 === royaltyYear && (royaltyFilterMonth === "all" || (p.month||"").startsWith(royaltyFilterMonth));
                    });
                    // All payments for this franchise (for totals row - scoped to year)
                    var allFPayments = royaltyPayments.filter(function(p){ return p.franchiseId === franchise.id; });
                    var totalRev = fPayments.reduce(function(s,p){ return s+(parseFloat(p.revenue)||0); }, 0);
                    var totalRoy = fPayments.reduce(function(s,p){ return s+(parseFloat(p.royalty)||0); }, 0);
                    var avgRate = totalRev > 0 ? totalRoy/totalRev*100 : 0;
                    var paidCount = fPayments.length;
                    var histUnpaid = franchise.status === "closed" ? 0 : getMonthsFrom(franchise.royaltyStartMonth).filter(function(m){
                      return !royaltyPayments.some(function(p){ return p.franchiseId === franchise.id && p.month === m; });
                    }).length;
                    var unpaidCount = visibleMonths.filter(function(m){
                      var due = new Date(parseInt(m.split(" ")[1]), MONTH_NAMES.indexOf(m.split(" ")[0])+1, 10);
                      return due <= now6 && !fPayments.some(function(p){ return p.month===m; });
                    }).length;
                    var isExpanded = royaltyExpandedId === franchise.id;
                    var hasIssue = unpaidCount > 0;

                    return (
                      <div key={franchise.id} className="card" style={{ padding:0, overflow:"hidden", border:"1px solid "+(franchise.status==="closed"?"rgba(255,255,255,0.08)":hasIssue?"rgba(207,102,121,0.25)":"#2A2A2A"), opacity:franchise.status==="closed"?0.6:1 }}>
                        <div style={{ display:"flex", alignItems:"center", gap:16, padding:"14px 20px", background:hasIssue?"rgba(207,102,121,0.03)":"transparent" }}>
                          <div style={{ flex:1, cursor:"pointer" }} onClick={function(){ setRoyaltyDetailId(franchise.id); }}>
                            <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                              <span style={{ fontWeight:600, fontSize:14, color:"#56B9E9", textDecoration:"underline" }}>{franchise.name}</span>
                              {franchise.status === "closed" && <span className="tag" style={{ background:"rgba(255,255,255,0.06)", color:"rgba(224,224,224,0.4)", fontSize:10, border:"1px solid rgba(255,255,255,0.1)" }}>Closed{franchise.closedDate?" · "+franchise.closedDate:""}</span>}
                            </div>
                            <div style={{ fontSize:11, color:"rgba(224,224,224,0.45)", marginTop:2 }}>{franchise.location}</div>
                          </div>
                          <div style={{ display:"flex", gap:16, alignItems:"center" }}>
                            <div style={{ textAlign:"right" }}>
                              <div style={{ fontSize:10, color:"rgba(224,224,224,0.4)", letterSpacing:"0.08em", marginBottom:2 }}>REVENUE</div>
                              <div style={{ color:"#56B9E9", fontWeight:600, fontSize:13 }}>{totalRev > 0 ? fmt(totalRev) : "—"}</div>
                            </div>
                            <div style={{ textAlign:"right" }}>
                              <div style={{ fontSize:10, color:"rgba(224,224,224,0.4)", letterSpacing:"0.08em", marginBottom:2 }}>ROYALTY</div>
                              <div style={{ color:"#4DE7A6", fontWeight:700, fontSize:13 }}>{totalRoy > 0 ? fmt(totalRoy) : "—"}</div>
                            </div>
                            <div style={{ textAlign:"right" }}>
                              <div style={{ fontSize:10, color:"rgba(224,224,224,0.4)", letterSpacing:"0.08em", marginBottom:2 }}>RATE</div>
                              <div style={{ color:"rgba(224,224,224,0.6)", fontSize:13 }}>{avgRate > 0 ? pct(avgRate) : "—"}</div>
                            </div>
                            <span className="tag" style={{ background:"rgba(77,231,166,0.08)", color:"#4DE7A6", fontSize:11, border:"1px solid rgba(77,231,166,0.2)" }}>{paidCount} paid</span>
                            <span className="tag" style={{ background:histUnpaid>0?"rgba(207,102,121,0.1)":"rgba(255,255,255,0.05)", color:histUnpaid>0?"#cf6679":"rgba(224,224,224,0.35)", fontSize:11, border:"1px solid "+(histUnpaid>0?"rgba(207,102,121,0.25)":"rgba(255,255,255,0.08)") }}>{histUnpaid} unpaid</span>
                            <span style={{ color:"rgba(224,224,224,0.3)", fontSize:14, cursor:"pointer", padding:"4px 8px" }}
                              onClick={function(){ setRoyaltyExpandedId(isExpanded ? null : franchise.id); }}>
                              {isExpanded ? "▲" : "▼"}
                            </span>
                          </div>
                        </div>

                        {isExpanded && (
                          <div className="fade-in" style={{ borderTop:"1px solid #2A2A2A" }}>
                            <table style={{ width:"100%", borderCollapse:"collapse", fontSize:12 }}>
                              <thead>
                                <tr style={{ background:"rgba(255,255,255,0.02)", borderBottom:"1px solid #2A2A2A" }}>
                                  {["MONTH","STATUS","REVENUE","ROYALTY","RATE","PAYMENT DATE","METHOD",""].map(function(h){
                                    return <th key={h} style={{ padding:"10px 18px", textAlign:"left", fontSize:10, letterSpacing:"0.08em", color:"rgba(224,224,224,0.35)", fontWeight:700 }}>{h}</th>;
                                  })}
                                </tr>
                              </thead>
                              <tbody>
                                {(function(){
                                  var franchiseMonths = getMonthsFrom(franchise.royaltyStartMonth);
                                  // Only show last 12 months
                                  var last12 = franchiseMonths.slice(-12);
                                  if (royaltyFilterMonth !== "all") return last12.filter(function(m){ return m.startsWith(royaltyFilterMonth); });
                                  return last12;
                                })().map(function(month) {
                                  var payment = allFPayments.find(function(p){ return p.month === month; });
                                  var dueDate6 = new Date(parseInt(month.split(" ")[1]), MONTH_NAMES.indexOf(month.split(" ")[0])+1, 10);
                                  var isOverdueMonth = !payment && dueDate6 <= now6;
                                  var isFuture = !payment && dueDate6 > now6;
                                  var rate3 = payment && (parseFloat(payment.revenue)||0) > 0 ? (parseFloat(payment.royalty)||0)/(parseFloat(payment.revenue)||1)*100 : 0;
                                  var pm6 = payment ? (payment.paymentMethod || (payment.source==="jotform"?"jotform":"")) : "";
                                  return (
                                    <tr key={month} style={{ borderBottom:"1px solid rgba(255,255,255,0.03)", background:isOverdueMonth?"rgba(207,102,121,0.04)":"transparent" }}>
                                      <td style={{ padding:"10px 18px", color:isOverdueMonth?"#cf6679":isFuture?"rgba(224,224,224,0.3)":"rgba(224,224,224,0.7)", fontWeight:isOverdueMonth?500:400 }}>{month}</td>
                                      <td style={{ padding:"10px 18px" }}>
                                        {payment
                                          ? <span className="tag" style={{ background:"rgba(77,231,166,0.1)", color:"#4DE7A6", fontSize:10, border:"1px solid rgba(77,231,166,0.25)" }}>✓ Paid</span>
                                          : isFuture
                                            ? <span className="tag" style={{ background:"rgba(255,255,255,0.05)", color:"rgba(224,224,224,0.3)", fontSize:10, border:"1px solid rgba(255,255,255,0.08)" }}>Not due</span>
                                            : <span className="tag" style={{ background:"rgba(207,102,121,0.1)", color:"#cf6679", fontSize:10, border:"1px solid rgba(207,102,121,0.25)" }}>⚠ Unpaid</span>
                                        }
                                      </td>
                                      <td style={{ padding:"10px 18px", color:payment?"#56B9E9":"rgba(224,224,224,0.2)", fontWeight:payment?500:400 }}>{payment ? fmt(parseFloat(payment.revenue)||0) : "—"}</td>
                                      <td style={{ padding:"10px 18px", color:payment?"#4DE7A6":"rgba(224,224,224,0.2)", fontWeight:payment?600:400 }}>{payment ? fmt(parseFloat(payment.royalty)||0) : "—"}</td>
                                      <td style={{ padding:"10px 18px", color:"rgba(224,224,224,0.6)" }}>{payment ? pct(rate3) : "—"}</td>
                                      <td style={{ padding:"10px 18px", color:"rgba(224,224,224,0.6)" }}>{payment && payment.paymentDate ? new Date(payment.paymentDate).toLocaleDateString("en-GB") : "—"}</td>
                                      <td style={{ padding:"10px 18px" }}>
                                        {pm6 ? <span className="tag" style={{ background:pm6==="jotform"?"rgba(86,185,233,0.1)":pm6==="cash"?"rgba(77,231,166,0.1)":"rgba(224,224,224,0.08)", color:pm6==="jotform"?"#56B9E9":pm6==="cash"?"#4DE7A6":"#E0E0E0", fontSize:10, border:"1px solid rgba(255,255,255,0.1)" }}>{pm6==="jotform"?"JotForm":pm6==="cash"?"Cash":"Transfer"}</span> : <span style={{ color:"rgba(224,224,224,0.2)", fontSize:11 }}>—</span>}
                                      </td>
                                      <td style={{ padding:"10px 18px" }}>
                                        {payment
                                          ? <button className="btn btn-secondary btn-sm" style={{ fontSize:11 }} onClick={function(){ setRoyaltyForm({ id:payment.id, franchiseId:payment.franchiseId||"", month:payment.month||"", revenue:payment.revenue||"", royalty:payment.royalty||"", paymentDate:payment.paymentDate ? payment.paymentDate.toString().slice(0,10) : "", paymentMethod:payment.paymentMethod||"" }); setRoyaltyModal("edit"); }}>Edit</button>
                                          : !isFuture ? <button className="btn btn-sm" style={{ background:"rgba(86,185,233,0.1)", color:"#56B9E9", border:"1px solid rgba(86,185,233,0.2)", fontSize:11 }} onClick={function(){ setRoyaltyForm({ franchiseId:franchise.id, month:month, revenue:"", royalty:"", paymentDate:"", paymentMethod:"" }); setRoyaltyModal("new"); }}>+ Add</button> : null
                                        }
                                      </td>
                                    </tr>
                                  );
                                })}
                                {fPayments.length > 0 && (
                                  <tr style={{ borderTop:"2px solid #2A2A2A", background:"rgba(255,255,255,0.02)" }}>
                                    <td colSpan={2} style={{ padding:"10px 18px", color:"rgba(224,224,224,0.4)", fontSize:11, fontWeight:700 }}>TOTAL</td>
                                    <td style={{ padding:"10px 18px", color:"#56B9E9", fontWeight:700, fontFamily:"Playfair Display,serif" }}>{fmt(totalRev)}</td>
                                    <td style={{ padding:"10px 18px", color:"#4DE7A6", fontWeight:700, fontFamily:"Playfair Display,serif" }}>{fmt(totalRoy)}</td>
                                    <td style={{ padding:"10px 18px", color:"rgba(224,224,224,0.5)", fontWeight:600 }}>{pct(avgRate)}</td>
                                    <td colSpan={3}></td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        )}
                      </div>
                    );
                  })}

                  {/* Unlinked payments at bottom */}
                  {Object.keys(unlinkedGroups).length > 0 && (
                    <div>
                      <label className="label" style={{ margin:"16px 0 10px", color:"#cf6679" }}>UNLINKED PAYMENTS</label>
                      {Object.keys(unlinkedGroups).map(function(name) {
                        var uPmts = unlinkedGroups[name];
                        var uRev = uPmts.reduce(function(s,p){ return s+(parseFloat(p.revenue)||0); }, 0);
                        var uRoy = uPmts.reduce(function(s,p){ return s+(parseFloat(p.royalty)||0); }, 0);
                        var uExpanded = royaltyExpandedId === ("__unlinked__"+name);
                        return (
                          <div key={name} className="card" style={{ padding:0, overflow:"hidden", border:"1px solid rgba(207,102,121,0.3)", marginBottom:8 }}>
                            <div style={{ display:"flex", alignItems:"center", gap:16, padding:"14px 20px", cursor:"pointer", background:"rgba(207,102,121,0.04)" }}
                              onClick={function(){ setRoyaltyExpandedId(uExpanded ? null : "__unlinked__"+name); }}>
                              <div style={{ flex:1, display:"flex", alignItems:"center", gap:10 }}>
                                <span style={{ color:"#cf6679" }}>⚠</span>
                                <div>
                                  <div style={{ fontWeight:600, fontSize:14, color:"#cf6679" }}>{name}</div>
                                  <div style={{ fontSize:11, color:"rgba(224,224,224,0.45)", marginTop:2 }}>Not linked to a branch</div>
                                </div>
                              </div>
                              <div style={{ display:"flex", gap:16, alignItems:"center" }}>
                                <span style={{ color:"#56B9E9", fontSize:13, fontWeight:600 }}>{fmt(uRev)}</span>
                                <span style={{ color:"#4DE7A6", fontSize:13, fontWeight:700 }}>{fmt(uRoy)}</span>
                                <span className="tag" style={{ background:"rgba(255,255,255,0.06)", color:"rgba(224,224,224,0.5)", fontSize:11 }}>{uPmts.length} payments</span>
                                <button className="btn btn-sm" style={{ background:"rgba(207,102,121,0.12)", color:"#cf6679", border:"1px solid rgba(207,102,121,0.3)", fontSize:11 }}
                                  onClick={function(e){ e.stopPropagation(); setRoyaltyLinkId(uPmts[0].id); setRoyaltyLinkFranchiseId(""); setRoyaltyLinkSearch(""); }}>Link branch</button>
                                <span style={{ color:"rgba(224,224,224,0.3)", fontSize:14 }}>{uExpanded?"▲":"▼"}</span>
                              </div>
                            </div>
                            {uExpanded && (
                              <div className="fade-in" style={{ borderTop:"1px solid #2A2A2A" }}>
                                <table style={{ width:"100%", borderCollapse:"collapse", fontSize:12 }}>
                                  <thead><tr style={{ borderBottom:"1px solid #2A2A2A" }}>{["MONTH","REVENUE","ROYALTY","ACTION"].map(function(h){ return <th key={h} style={{ padding:"10px 18px", textAlign:"left", fontSize:10, color:"rgba(224,224,224,0.35)", fontWeight:700 }}>{h}</th>; })}</tr></thead>
                                  <tbody>
                                    {uPmts.sort(function(a,b){ return parseMonthDate(b.month)-parseMonthDate(a.month); }).map(function(p,pi){
                                      return (
                                        <tr key={pi} style={{ borderBottom:"1px solid rgba(255,255,255,0.03)" }}>
                                          <td style={{ padding:"10px 18px", color:"rgba(224,224,224,0.7)" }}>{p.month}</td>
                                          <td style={{ padding:"10px 18px", color:"#56B9E9" }}>{fmt(parseFloat(p.revenue)||0)}</td>
                                          <td style={{ padding:"10px 18px", color:"#4DE7A6", fontWeight:600 }}>{fmt(parseFloat(p.royalty)||0)}</td>
                                          <td style={{ padding:"10px 18px" }}>
                                            <button className="btn btn-secondary btn-sm" style={{ fontSize:11 }} onClick={function(){ setRoyaltyLinkId(p.id); setRoyaltyLinkFranchiseId(""); setRoyaltyLinkSearch(""); }}>Link</button>
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            })()}
          </div>
        )}

{/* Add/Edit Modal */}
            {royaltyModal && (
              <div className="modal-bg" onClick={function(){ setRoyaltyModal(null); }}>
                <div className="card fade-in" style={{ width:460, padding:28, maxHeight:"90vh", overflowY:"auto" }} onClick={function(e){ e.stopPropagation(); }}>
                  <h3 style={{ fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:18, marginBottom:20 }}>
                    {royaltyModal === "new" ? "Add Royalty Payment" : "Edit Royalty Payment"}
                  </h3>
                  <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
                    <div>
                      <label className="label">BRANCH</label>
                      <select value={royaltyForm.franchiseId} onChange={function(e){ setRoyaltyForm(function(f){ return Object.assign({},f,{franchiseId:e.target.value}); }); }}
                        style={{ background:"#252525", border:"1px solid #2A2A2A", color:"#E0E0E0", padding:"11px 14px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none", width:"100%" }}>
                        <option value="">Select branch...</option>
                        {franchises.map(function(f){ return <option key={f.id} value={f.id}>{(f.location||f.name)+(f.location&&f.location!==f.name?" — "+f.name:"")}</option>; })}
                      </select>
                    </div>
                    <div>
                      <label className="label">MONTH</label>
                      <MonthPicker value={royaltyForm.month} onChange={function(v){ setRoyaltyForm(function(f){ return Object.assign({},f,{month:v}); }); }} />
                    </div>
                    <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
                      <div>
                        <label className="label">REVENUE (£)</label>
                        <input type="number" placeholder="0.00" value={royaltyForm.revenue}
                          onChange={function(e){ setRoyaltyForm(function(f){ return Object.assign({},f,{revenue:e.target.value}); }); }}
                          style={{ background:"#252525", border:"1px solid #2A2A2A", color:"#E0E0E0", padding:"11px 14px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none", width:"100%" }} />
                      </div>
                      <div>
                        <label className="label">ROYALTY (£)</label>
                        <input type="number" placeholder="0.00" value={royaltyForm.royalty}
                          onChange={function(e){ setRoyaltyForm(function(f){ return Object.assign({},f,{royalty:e.target.value}); }); }}
                          style={{ background:"#252525", border:"1px solid #2A2A2A", color:"#E0E0E0", padding:"11px 14px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none", width:"100%" }} />
                      </div>
                    </div>
                    {royaltyForm.revenue && royaltyForm.royalty && (
                      <div style={{ background:"rgba(77,231,166,0.06)", border:"1px solid rgba(77,231,166,0.2)", borderRadius:8, padding:"10px 14px", fontSize:12, color:"#4DE7A6" }}>
                        Rate: {pct((parseFloat(royaltyForm.royalty)||0)/(parseFloat(royaltyForm.revenue)||1)*100)}
                      </div>
                    )}
                    <div>
                      <label className="label">PAYMENT DATE</label>
                      <input type="date" value={royaltyForm.paymentDate}
                        onChange={function(e){ setRoyaltyForm(function(f){ return Object.assign({},f,{paymentDate:e.target.value}); }); }}
                        style={{ background:"#252525", border:"1px solid #2A2A2A", color:"#E0E0E0", padding:"11px 14px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none", width:"100%" }} />
                    </div>
                    <div>
                      <label className="label">PAYMENT METHOD</label>
                      <select value={royaltyForm.paymentMethod} onChange={function(e){ setRoyaltyForm(function(f){ return Object.assign({},f,{paymentMethod:e.target.value}); }); }}
                        style={{ background:"#252525", border:"1px solid #2A2A2A", color:"#E0E0E0", padding:"11px 14px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none", width:"100%" }}>
                        <option value="">Select method...</option>
                        <option value="jotform">JotForm (Card)</option>
                        <option value="cash">Cash</option>
                        <option value="transfer">Bank Transfer</option>
                      </select>
                    </div>
                  </div>
                  <div style={{ display:"flex", gap:10, marginTop:20 }}>
                    <button className="btn btn-primary" onClick={function(){
                      if (!royaltyForm.franchiseId || !royaltyForm.month) { showToast("Branch and month are required."); return; }
                      var franchise = franchises.find(function(f){ return f.id === royaltyForm.franchiseId; });
                      var payload = {
                        franchiseId: royaltyForm.franchiseId,
                        franchiseName: franchise ? franchise.name : "",
                        month: royaltyForm.month,
                        revenue: parseFloat(royaltyForm.revenue)||0,
                        royalty: parseFloat(royaltyForm.royalty)||0,
                        paymentDate: royaltyForm.paymentDate || null,
                        paymentMethod: royaltyForm.paymentMethod || null
                      };
                      var call = royaltyModal === "new"
                        ? fetch(API_URL + "/api/royalty", { method:"POST", headers:{"Content-Type":"application/json","Authorization":"Bearer "+(localStorage.getItem("gi_token")||"")}, body:JSON.stringify(payload) })
                        : fetch(API_URL + "/api/royalty/" + royaltyForm.id, { method:"PUT", headers:{"Content-Type":"application/json","Authorization":"Bearer "+(localStorage.getItem("gi_token")||"")}, body:JSON.stringify(payload) });
                      call.then(function(r){ return r.json(); }).then(function(){
                        apiFetch("/api/royalty").then(function(d){ if(d&&Array.isArray(d)) setRoyaltyPayments(d); });
                        setRoyaltyModal(null);
                        showToast(royaltyModal === "new" ? "Payment added!" : "Payment updated!");
                        logActivity(royaltyModal === "new" ? "Added royalty payment" : "Updated royalty payment", (franchise?franchise.name:"") + " " + royaltyForm.month);
                      }).catch(function(){ showToast("Error saving. Please try again."); });
                    }}>{royaltyModal === "new" ? "Add Payment" : "Save Changes"}</button>
                    <button className="btn btn-secondary" onClick={function(){ setRoyaltyModal(null); }}>Cancel</button>
                    {royaltyModal === "edit" && (
                      <button className="btn btn-sm" style={{ background:"rgba(207,102,121,0.1)", color:"#cf6679", border:"1px solid rgba(207,102,121,0.25)", marginLeft:"auto" }}
                        onClick={function(){
                          if (!confirm("Delete this payment?")) return;
                          fetch(API_URL + "/api/royalty/" + royaltyForm.id, { method:"DELETE", headers:{"Authorization":"Bearer "+(localStorage.getItem("gi_token")||"")} })
                            .then(function(){ apiFetch("/api/royalty").then(function(d){ if(d&&Array.isArray(d)) setRoyaltyPayments(d); }); setRoyaltyModal(null); showToast("Deleted."); });
                        }}>Delete</button>
                    )}
                  </div>
                </div>
              </div>
            )}

        {/* PROFIT — AdminApp */}
        {view === "profit" && (
          <div className="fade-in">
            <h1 style={{ fontFamily:"Playfair Display,serif", fontWeight:900, fontSize:28, marginBottom:16 }}>Profit</h1>
            <input placeholder="Search branches or people..." value={profitTopSearch} onChange={function(e){ setProfitTopSearch(e.target.value); }} style={{ marginBottom:16, width:"100%" }} />
            {/* Summary banner — total owed per person across all branches */}
            {!profitLoading && profitData.length > 0 && (function(){
              var personMap = {};
              profitData.forEach(function(f){
                (f.owners||[]).concat(f.investors||[]).forEach(function(p){
                  if (!personMap[p.name]) personMap[p.name] = { name:p.name, remaining:0, type:p.type };
                  personMap[p.name].remaining += (p.remaining||0);
                });
              });
              var people = Object.values(personMap).sort(function(a,b){ return b.remaining - a.remaining; });
              if (!people.length) return null;
              return (
                <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(180px,1fr))", gap:10, marginBottom:16 }}>
                  {people.map(function(p, i){
                    var color = p.type === "owner" ? "#4DE7A6" : "#7B9EFF";
                    return (
                      <div key={i} className="card" style={{ padding:"12px 16px", borderLeft:"3px solid "+color }}>
                        <div style={{ fontSize:11, color:"rgba(224,224,224,0.5)", marginBottom:4, fontWeight:600 }}>{p.name}</div>
                        <div style={{ fontSize:16, fontWeight:800, color: p.remaining >= 0 ? color : "#cf6679" }}>{fmt(p.remaining)}</div>
                        <div style={{ fontSize:9, color:"rgba(224,224,224,0.35)", marginTop:2, letterSpacing:"0.08em" }}>TOTAL REMAINING</div>
                      </div>
                    );
                  })}
                </div>
              );
            })()}
            {profitLoading ? <div style={{ color:"#56B9E9" }}>Loading...</div> : (
              <div style={{ display:"flex", flexDirection:"column", gap:16 }}>
                {profitData.length === 0 && <div style={{ color:"rgba(224,224,224,0.5)", fontSize:13 }}>No profit data yet.</div>}
                {profitData.filter(function(f){
                  if (!profitTopSearch) return true;
                  var q = profitTopSearch.toLowerCase();
                  return (f.franchiseName||'').toLowerCase().includes(q) || (f.owners||[]).concat(f.investors||[]).some(function(p){ return (p.name||'').toLowerCase().includes(q); });
                }).map(function(f) {
                  var allPeople = (f.owners||[]).concat(f.investors||[]);
                  var isExpanded = expandedFranchiseProfit[f.franchiseId] !== false;
                  return (
                    <div key={f.franchiseId} className="card" style={{ padding:0, overflow:"hidden" }}>
                      <div onClick={function(){ setExpandedFranchiseProfit(function(p){ var n=Object.assign({},p); n[f.franchiseId]=!isExpanded; return n; }); }}
                        style={{ padding:"14px 18px", cursor:"pointer", display:"flex", justifyContent:"space-between", alignItems:"center", borderBottom:isExpanded?"1px solid #2A2A2A":"none" }}>
                        <div>
                          <div style={{ fontWeight:700, fontSize:15, color:"#E0E0E0" }}>{f.franchiseName}</div>
                          {f.location && <div style={{ fontSize:11, color:"rgba(224,224,224,0.5)" }}>{f.location}</div>}
                        </div>
                        <div style={{ display:"flex", alignItems:"center", gap:12 }}>
                          <div style={{ textAlign:"right" }}>
                            <div style={{ fontSize:10, color:"rgba(224,224,224,0.45)", letterSpacing:"0.08em" }}>TOTAL REMAINING</div>
                            <div style={{ fontSize:16, fontWeight:800, color:allPeople.reduce(function(s,p){ return s+p.remaining; },0)>=0?"#4DE7A6":"#cf6679" }}>{fmt(allPeople.reduce(function(s,p){ return s+p.remaining; },0))}</div>
                          </div>
                          <span style={{ color:"rgba(224,224,224,0.4)", fontSize:12 }}>{isExpanded?"▲":"▼"}</span>
                        </div>
                      </div>
                      {isExpanded && (
                        <div style={{ padding:"14px 18px" }}>
                          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:16 }}>
                            {allPeople.map(function(person,pi){
                              var color=person.type==="owner"?"#4DE7A6":"#7B9EFF";
                              return (
                                <div key={pi} className="card" style={{ padding:"13px 16px", borderLeft:"3px solid "+color }}>
                                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:10 }}>
                                    <div>
                                      <div style={{ fontWeight:600, fontSize:13, color:"#E0E0E0" }}>{person.name}</div>
                                      <div style={{ fontSize:10, color:"rgba(224,224,224,0.5)", marginTop:2 }}>{person.type==="owner"?"Franchisee":"Investor"} · {person.sharePercent}%</div>
                                    </div>
                                    <div style={{ display:"flex", gap:6, alignItems:"center" }}>
                                      <button className="btn btn-sm" style={{ background:"rgba(207,183,100,0.1)", color:"#CFB764", border:"1px solid rgba(207,183,100,0.3)", fontSize:10, padding:"3px 8px" }}
                                        onClick={function(){
                                          setOpeningBalanceModal({ franchiseId:f.franchiseId, userId:person.userId, name:person.name, franchiseName:f.franchiseName, current:person.openingBalance||0 });
                                          setOpeningBalanceAmount(person.openingBalance ? String(person.openingBalance) : '');
                                          setOpeningBalanceNotes('');
                                        }}>⚖ Opening Balance</button>
                                      <button className="btn btn-sm" style={{ background:color+"15", color:color, border:"1px solid "+color+"40", fontSize:11, padding:"4px 10px" }}
                                        onClick={function(){
                                          var today=new Date().toISOString().split("T")[0];
                                          setWithdrawModal({ franchiseId:f.franchiseId, userId:person.userId, name:person.name, franchiseName:f.franchiseName, email:person.email });
                                          setWithdrawForm({ amount:"", method:"Bank Transfer", date:today, notes:"" });
                                        }}>+ Take Profit</button>
                                    </div>
                                  </div>
                                  <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr 1fr", gap:8 }}>
                                    {person.openingBalance > 0 && <div><div style={{ fontSize:9, color:"#CFB764", marginBottom:2 }}>OPENING BAL.</div><div style={{ fontSize:12, fontWeight:700, color:"#CFB764" }}>{fmt(person.openingBalance)}</div></div>}
                                    <div style={{ gridColumn: person.openingBalance > 0 ? "auto" : "span 1" }}><div style={{ fontSize:9, color:"rgba(224,224,224,0.45)", marginBottom:2 }}>TOTAL OWED</div><div style={{ fontSize:13, fontWeight:700, color:person.totalOwed>=0?color:"#cf6679" }}>{fmt(person.totalOwed)}</div></div>
                                    <div><div style={{ fontSize:9, color:"rgba(224,224,224,0.45)", marginBottom:2 }}>TAKEN</div><div style={{ fontSize:13, fontWeight:700, color:"rgba(224,224,224,0.5)" }}>{fmt(person.totalTaken)}</div></div>
                                    <div><div style={{ fontSize:9, color:"rgba(224,224,224,0.45)", marginBottom:2 }}>REMAINING</div><div style={{ fontSize:13, fontWeight:800, color:person.remaining>=0?"#4DE7A6":"#cf6679" }}>{fmt(person.remaining)}</div></div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                          {/* P&L breakdown button */}
                          {(function(){
                            var franchise = franchises.find(function(fr){ return fr.id === f.franchiseId; });
                            if (!franchise || !franchise.financials || !franchise.financials.length) return null;
                            var showPL = profitPLFranchise === f.franchiseId;
                            var allMths = franchise.financials.slice().sort(function(a,b){ return new Date('01 '+b.month) - new Date('01 '+a.month); });
                            var availYears = Array.from(new Set(allMths.map(function(m){ var match = (m.month||'').match(/(\d{4})/); return match ? parseInt(match[1]) : null; }).filter(Boolean))).sort(function(a,b){return b-a;});
                            var mths = allMths.filter(function(m){ return (m.month||'').includes(String(profitPLYear)); });
                            var allOwners = (franchise.owners || []).filter(function(o){ return o.isCurrent !== false; });
                            var allInvs = franchise.investors || [];
                            return (
                              <div style={{ marginBottom:16 }}>
                                <div style={{ display:"flex", gap:8, flexWrap:"wrap", marginBottom: (showPL || profitHistFranchise===f.franchiseId) ? 12 : 0 }}>
                                  <button className="btn btn-sm btn-secondary"
                                    onClick={function(){ setProfitPLFranchise(showPL ? null : f.franchiseId); }}>
                                    {showPL ? "Hide P&L ▲" : "View Monthly P&L ▼"}
                                  </button>
                                  <button className="btn btn-sm btn-secondary"
                                    onClick={function(){ setProfitHistFranchise(profitHistFranchise===f.franchiseId?null:f.franchiseId); setProfitHistSearch(''); }}>
                                    {profitHistFranchise===f.franchiseId ? "Hide History ▲" : "Profit Taken History ▼"}
                                  </button>
                                </div>
                                {/* Profit Taken History */}
                                {profitHistFranchise === f.franchiseId && (
                                  <div style={{ marginBottom:12 }}>
                                    <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:10 }}>
                                      <input placeholder="Search transactions..." value={profitHistSearch}
                                        onChange={function(e){ setProfitHistSearch(e.target.value); }}
                                        style={{ flex:1, marginRight:12, marginBottom:0 }} />
                                      <div style={{ display:"flex", alignItems:"center", gap:6, flexShrink:0 }}>
                                        <button className="btn btn-sm btn-secondary" style={{ padding:"3px 10px" }}
                                          onClick={function(){ setProfitHistYear(function(y){ return y <= 2025 ? 0 : y-1; }); }}>‹</button>
                                        <span style={{ fontSize:13, fontWeight:700, color:"#E0E0E0", minWidth:40, textAlign:"center" }}>{profitHistYear === 0 ? "All" : profitHistYear}</span>
                                        <button className="btn btn-sm btn-secondary" style={{ padding:"3px 10px" }}
                                          onClick={function(){ setProfitHistYear(function(y){ return y+1 <= new Date().getFullYear() ? y+1 : y; }); }}>›</button>
                                      </div>
                                    </div>
                                    {(function(){
                                      var filteredW = (f.withdrawals||[]).filter(function(w){
                                        var yr = w.dateTaken ? new Date(w.dateTaken).getFullYear() : null;
                                        if (profitHistYear !== 0 && yr !== profitHistYear) return false;
                                        if (!profitHistSearch) return true;
                                        var q=profitHistSearch.toLowerCase();
                                        return (w.userName||'').toLowerCase().includes(q)||(w.method||'').toLowerCase().includes(q)||(w.notes||'').toLowerCase().includes(q);
                                      });
                                      if (!filteredW.length) return <div style={{ color:"rgba(224,224,224,0.5)", fontSize:13 }}>{profitHistYear === 0 ? "No transactions yet" : "No transactions for " + profitHistYear}</div>;
                                      return filteredW.map(function(w,wi){
                                          return (
                                            <div key={wi} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"8px 0", borderBottom:"1px solid rgba(255,255,255,0.04)", fontSize:12 }}>
                                              <div>
                                                <div style={{ fontWeight:600, color:"#E0E0E0" }}>{w.userName}</div>
                                                <div style={{ color:"rgba(224,224,224,0.5)", marginTop:2 }}>{w.method} · {w.dateTaken?new Date(w.dateTaken).toLocaleDateString("en-GB"):""}</div>
                                                {w.notes&&<div style={{ color:"rgba(224,224,224,0.35)", fontSize:11 }}>{w.notes}</div>}
                                              </div>
                                              <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                                                <span style={{ color:"#cf6679", fontWeight:700 }}>-{fmt(w.amount)}</span>
                                                <button className="btn btn-sm" style={{ background:"rgba(86,185,233,0.1)", color:"#56B9E9", border:"1px solid rgba(86,185,233,0.3)", fontSize:10, padding:"3px 8px" }}
                                                  onClick={function(){ setEditWithdrawModal({id:w.id}); setEditWithdrawForm({amount:w.amount,method:w.method,date:w.dateTaken?w.dateTaken.split("T")[0]:"",notes:w.notes||""}); }}>Edit</button>
                                                <button className="btn btn-sm" style={{ background:"rgba(207,102,121,0.1)", color:"#cf6679", border:"1px solid rgba(207,102,121,0.3)", fontSize:10, padding:"3px 8px" }}
                                                  onClick={function(){ if(!window.confirm("Delete this transaction?")) return; DB.deleteWithdrawal(w.id).then(function(){ setProfitLoading(true); DB.getProfit().then(function(d){ setProfitData(d||[]); setProfitLoading(false); }); showToast("Deleted."); }); }}>Delete</button>
                                              </div>
                                            </div>
                                          );
                                        });
                                    })()}
                                  </div>
                                )}
                                {showPL && (
                                  <div style={{ overflowX:"auto" }}>
                                  <div style={{ display:"flex", alignItems:"center", justifyContent:"flex-end", gap:8, marginBottom:10 }}>
                                    <button className="btn btn-sm btn-secondary" style={{ padding:"3px 10px" }}
                                      onClick={function(){ var idx=availYears.indexOf(profitPLYear); if(idx<availYears.length-1) setProfitPLYear(availYears[idx+1]); }}>‹</button>
                                    <span style={{ fontSize:13, fontWeight:700, color:"#E0E0E0", minWidth:40, textAlign:"center" }}>{profitPLYear}</span>
                                    <button className="btn btn-sm btn-secondary" style={{ padding:"3px 10px" }}
                                      onClick={function(){ var idx=availYears.indexOf(profitPLYear); if(idx>0) setProfitPLYear(availYears[idx-1]); }}>›</button>
                                  </div>
                                    <table style={{ width:"100%", borderCollapse:"collapse", fontSize:12 }}>
                                      <thead>
                                        <tr style={{ borderBottom:"1px solid #2A2A2A" }}>
                                          <th style={{ padding:"8px 12px", textAlign:"left", fontSize:10, color:"rgba(224,224,224,0.45)", fontWeight:700 }}>MONTH</th>
                                          <th style={{ padding:"8px 12px", textAlign:"right", fontSize:10, color:"rgba(224,224,224,0.45)", fontWeight:700 }}>NET PROFIT</th>
                                          {allOwners.map(function(o,oi){ return <th key={oi} style={{ padding:"8px 12px", textAlign:"right", fontSize:10, color:"#4DE7A6", fontWeight:700, whiteSpace:"nowrap" }}>{o.name.split(" ")[0]}</th>; })}
                                          {allInvs.map(function(inv,ii){ return <th key={ii} style={{ padding:"8px 12px", textAlign:"right", fontSize:10, color:"#7B9EFF", fontWeight:700, whiteSpace:"nowrap" }}>{inv.name.split(" ")[0]}</th>; })}
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {mths.map(function(m){
                                          var net = m.income - m.rent - m.salaries - m.royalty - m.otherExpenses;
                                          var allOwnerSals = allOwners.reduce(function(s,o){
                                            var sal = (franchise.salaries||[]).filter(function(sl){ return (sl.userEmail||"").toLowerCase()===(o.email||"").toLowerCase(); })
                                              .sort(function(a,b){ return new Date('01 '+b.effectiveFrom)-new Date('01 '+a.effectiveFrom); });
                                            return s + (sal.length ? parseFloat(sal[0].amount) : 0);
                                          }, 0);
                                          return (
                                            <tr key={m.month} style={{ borderBottom:"1px solid rgba(255,255,255,0.04)" }}>
                                              <td style={{ padding:"8px 12px", color:"rgba(224,224,224,0.6)" }}>{m.month}</td>
                                              <td style={{ padding:"8px 12px", textAlign:"right", color:net>=0?"#56B9E9":"#cf6679", fontWeight:600 }}>{fmt(net)}</td>
                                              {allOwners.map(function(o,oi){
                                                var sal = (franchise.salaries||[]).filter(function(sl){ return (sl.userEmail||"").toLowerCase()===(o.email||"").toLowerCase(); })
                                                  .sort(function(a,b){ return new Date('01 '+b.effectiveFrom)-new Date('01 '+a.effectiveFrom); });
                                                var oSal = sal.length ? parseFloat(sal[0].amount) : 0;
                                                var share = parseFloat(o.sharePercent||0)/100;
                                                var th = (net - allOwnerSals) * share + oSal;
                                                return <td key={oi} style={{ padding:"8px 12px", textAlign:"right", color:th>=0?"#4DE7A6":"#cf6679" }}>{fmt(th)}</td>;
                                              })}
                                              {allInvs.map(function(inv,ii){
                                                var invProfit = net * parseFloat(inv.sharePercent||0)/100;
                                                return <td key={ii} style={{ padding:"8px 12px", textAlign:"right", color:invProfit>=0?"#7B9EFF":"#cf6679" }}>{fmt(invProfit)}</td>;
                                              })}
                                            </tr>
                                          );
                                        })}
                                      </tbody>
                                    </table>
                                  </div>
                                )}
                              </div>
                            );
                          })()}
                        </div>
                      )}
                    </div>
                  );
                })}
                <div className="card" style={{ padding:0, overflow:"hidden" }}>
                  <div onClick={function(){ setProfitHistoryOpen(function(p){ return !p; }); }} style={{ padding:"14px 18px", cursor:"pointer", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                    <div style={{ fontWeight:700, fontSize:13, color:"#E0E0E0" }}>ALL TRANSACTIONS</div>
                    <span style={{ color:"rgba(224,224,224,0.4)", fontSize:12 }}>{profitHistoryOpen?"▲":"▼"}</span>
                  </div>
                  {profitHistoryOpen && (
                    <div style={{ padding:"0 18px 18px" }}>
                      <input placeholder="Search..." value={profitSearch} onChange={function(e){ setProfitSearch(e.target.value); }} style={{ marginBottom:12, width:"100%" }} />
                      {(function(){
                        var allW=profitData.reduce(function(acc,f){ return acc.concat((f.withdrawals||[]).map(function(w){ return Object.assign({},w,{franchiseName:f.franchiseName}); })); },[])
                          .filter(function(w){ if(!profitSearch) return true; var q=profitSearch.toLowerCase(); return (w.userName||"").toLowerCase().includes(q)||(w.franchiseName||"").toLowerCase().includes(q)||(w.method||"").toLowerCase().includes(q); })
                          .sort(function(a,b){ return new Date(b.dateTaken)-new Date(a.dateTaken); });
                        if (!allW.length) return <div style={{ color:"rgba(224,224,224,0.5)", fontSize:13 }}>No transactions found</div>;
                        return allW.map(function(w,wi){
                          return (
                            <div key={wi} style={{ display:"flex", justifyContent:"space-between", padding:"10px 0", borderBottom:"1px solid rgba(255,255,255,0.04)" }}>
                              <div>
                                <div style={{ fontSize:13, fontWeight:600, color:"#E0E0E0" }}>{w.userName}</div>
                                <div style={{ fontSize:11, color:"rgba(224,224,224,0.5)" }}>{w.franchiseName} · {w.method} · {w.dateTaken?new Date(w.dateTaken).toLocaleDateString("en-GB"):""}</div>
                              </div>
                              <span style={{ fontSize:14, fontWeight:700, color:"#cf6679" }}>-{fmt(w.amount)}</span>
                            </div>
                          );
                        });
                      })()}
                    </div>
                  )}
                </div>
              </div>
            )}
            {/* Opening Balance Modal */}
            {openingBalanceModal && (
              <div className="modal-bg" onClick={function(){ setOpeningBalanceModal(null); }}>
                <div className="card fade-in" style={{ width:420, padding:28 }} onClick={function(e){ e.stopPropagation(); }}>
                  <h3 style={{ fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:18, marginBottom:4 }}>Opening Balance</h3>
                  <p style={{ fontSize:12, color:"rgba(224,224,224,0.5)", marginBottom:4 }}>{openingBalanceModal.name} · {openingBalanceModal.franchiseName}</p>
                  <p style={{ fontSize:11, color:"rgba(224,224,224,0.4)", marginBottom:20 }}>Profit accumulated before the system started. This will be added to their Total Owed.</p>
                  {openingBalanceModal.current > 0 && (
                    <div style={{ background:"rgba(207,183,100,0.08)", border:"1px solid rgba(207,183,100,0.25)", borderRadius:8, padding:"10px 14px", marginBottom:14 }}>
                      <span style={{ fontSize:12, color:"#CFB764" }}>Current opening balance: </span>
                      <span style={{ fontSize:14, fontWeight:700, color:"#CFB764" }}>{fmt(openingBalanceModal.current)}</span>
                    </div>
                  )}
                  <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
                    <div><label className="label">AMOUNT (£)</label><input type="number" min="0" step="0.01" placeholder="0.00" value={openingBalanceAmount} onChange={function(e){ setOpeningBalanceAmount(e.target.value); }} /></div>
                    <div><label className="label">NOTES (optional)</label><input placeholder="e.g. Accumulated profit Sept 2024 – Aug 2025" value={openingBalanceNotes} onChange={function(e){ setOpeningBalanceNotes(e.target.value); }} /></div>
                    <div style={{ display:"flex", gap:10, marginTop:4, flexWrap:"wrap" }}>
                      <button className="btn btn-primary" onClick={function(){
                        if (!openingBalanceAmount) { showToast("Please enter an amount."); return; }
                        DB.setOpeningBalance({ franchiseId:openingBalanceModal.franchiseId, userId:openingBalanceModal.userId, amount:parseFloat(openingBalanceAmount), notes:openingBalanceNotes||null })
                          .then(function(){
                            setOpeningBalanceModal(null);
                            setProfitLoading(true);
                            DB.getProfit().then(function(d){ setProfitData(d||[]); setProfitLoading(false); });
                            showToast("Opening balance saved!");
                          }).catch(function(){ showToast("Error saving."); });
                      }}>Save</button>
                      {openingBalanceModal.current > 0 && (
                        <button className="btn btn-sm" style={{ background:"rgba(207,102,121,0.1)", color:"#cf6679", border:"1px solid rgba(207,102,121,0.3)" }}
                          onClick={function(){
                            DB.deleteOpeningBalance({ franchiseId:openingBalanceModal.franchiseId, userId:openingBalanceModal.userId })
                              .then(function(){
                                setOpeningBalanceModal(null);
                                setProfitLoading(true);
                                DB.getProfit().then(function(d){ setProfitData(d||[]); setProfitLoading(false); });
                                showToast("Opening balance removed.");
                              });
                          }}>Remove Balance</button>
                      )}
                      <button className="btn btn-secondary" onClick={function(){ setOpeningBalanceModal(null); }}>Cancel</button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {withdrawModal && (
              <div className="modal-bg" onClick={function(){ setWithdrawModal(null); }}>
                <div className="card fade-in" style={{ width:440, padding:28 }} onClick={function(e){ e.stopPropagation(); }}>
                  <h3 style={{ fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:18, marginBottom:4 }}>Take Profit</h3>
                  <p style={{ fontSize:12, color:"rgba(224,224,224,0.5)", marginBottom:20 }}>{withdrawModal.name} · {withdrawModal.franchiseName}</p>
                  <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
                    <div><label className="label">AMOUNT (£)</label><input type="number" min="0" step="0.01" placeholder="0.00" value={withdrawForm.amount} onChange={function(e){ setWithdrawForm(function(p){ return Object.assign({},p,{amount:e.target.value}); }); }} /></div>
                    <div><label className="label">DATE</label><input type="date" value={withdrawForm.date} onChange={function(e){ setWithdrawForm(function(p){ return Object.assign({},p,{date:e.target.value}); }); }} /></div>
                    <div>
                      <label className="label">METHOD</label>
                      <div style={{ display:"flex", gap:8, flexWrap:"wrap", marginTop:6 }}>
                        {["Bank Transfer","Card","Cash","Cheque"].map(function(m){ var sel=withdrawForm.method===m; return <button key={m} onClick={function(){ setWithdrawForm(function(p){ return Object.assign({},p,{method:m}); }); }} className="btn btn-sm" style={{ background:sel?"rgba(77,231,166,0.12)":"#1E1E1E", color:sel?"#4DE7A6":"rgba(224,224,224,0.5)", border:"1px solid "+(sel?"rgba(77,231,166,0.3)":"#2A2A2A") }}>{m}</button>; })}
                      </div>
                    </div>
                    <div><label className="label">NOTES (optional)</label><input placeholder="Any notes..." value={withdrawForm.notes} onChange={function(e){ setWithdrawForm(function(p){ return Object.assign({},p,{notes:e.target.value}); }); }} /></div>
                    <div style={{ display:"flex", gap:10, marginTop:4 }}>
                      <button className="btn btn-primary" onClick={function(){
                        if (!withdrawForm.amount||!withdrawForm.date){ showToast("Please enter amount and date."); return; }
                        DB.postWithdrawal({ franchiseId:withdrawModal.franchiseId, userId:withdrawModal.userId, userEmail:withdrawModal.email, amount:parseFloat(withdrawForm.amount), method:withdrawForm.method, dateTaken:withdrawForm.date, notes:withdrawForm.notes||null })
                          .then(function(){
                            setWithdrawModal(null);
                            setProfitLoading(true);
                            DB.getProfit().then(function(d){ setProfitData(d||[]); setProfitLoading(false); });
                            showToast("Withdrawal recorded!");
                          }).catch(function(){ showToast("Error saving withdrawal."); });
                      }}>Save</button>
                      <button className="btn btn-secondary" onClick={function(){ setWithdrawModal(null); }}>Cancel</button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {/* Edit Withdrawal Modal */}
            {editWithdrawModal && (
              <div className="modal-bg" onClick={function(){ setEditWithdrawModal(null); }}>
                <div className="card fade-in" style={{ width:440, padding:28 }} onClick={function(e){ e.stopPropagation(); }}>
                  <h3 style={{ fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:18, marginBottom:16 }}>Edit Transaction</h3>
                  <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
                    <div><label className="label">AMOUNT (£)</label><input type="number" min="0" step="0.01" value={editWithdrawForm.amount} onChange={function(e){ setEditWithdrawForm(function(p){ return Object.assign({},p,{amount:e.target.value}); }); }} /></div>
                    <div><label className="label">DATE</label><input type="date" value={editWithdrawForm.date} onChange={function(e){ setEditWithdrawForm(function(p){ return Object.assign({},p,{date:e.target.value}); }); }} /></div>
                    <div>
                      <label className="label">METHOD</label>
                      <div style={{ display:"flex", gap:8, flexWrap:"wrap", marginTop:6 }}>
                        {["Bank Transfer","Card","Cash","Cheque"].map(function(m){ var sel=editWithdrawForm.method===m; return <button key={m} onClick={function(){ setEditWithdrawForm(function(p){ return Object.assign({},p,{method:m}); }); }} className="btn btn-sm" style={{ background:sel?"rgba(77,231,166,0.12)":"#1E1E1E", color:sel?"#4DE7A6":"rgba(224,224,224,0.5)", border:"1px solid "+(sel?"rgba(77,231,166,0.3)":"#2A2A2A") }}>{m}</button>; })}
                      </div>
                    </div>
                    <div><label className="label">NOTES (optional)</label><input value={editWithdrawForm.notes} onChange={function(e){ setEditWithdrawForm(function(p){ return Object.assign({},p,{notes:e.target.value}); }); }} /></div>
                    <div style={{ display:"flex", gap:10, marginTop:4 }}>
                      <button className="btn btn-primary" onClick={function(){
                        if (!editWithdrawForm.amount||!editWithdrawForm.date){ showToast("Please enter amount and date."); return; }
                        DB.editWithdrawal(editWithdrawModal.id, { amount:parseFloat(editWithdrawForm.amount), method:editWithdrawForm.method, dateTaken:editWithdrawForm.date, notes:editWithdrawForm.notes||null })
                          .then(function(){
                            setEditWithdrawModal(null);
                            setProfitLoading(true);
                            DB.getProfit().then(function(d){ setProfitData(d||[]); setProfitLoading(false); });
                            showToast("Transaction updated!");
                          }).catch(function(){ showToast("Error updating transaction."); });
                      }}>Save Changes</button>
                      <button className="btn btn-secondary" onClick={function(){ setEditWithdrawModal(null); }}>Cancel</button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {view === "activity" && (
          <div className="fade-in">
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-end", marginBottom:28 }}>
              <div>
                <h1 style={{ fontFamily:"Playfair Display,serif", fontWeight:900, fontSize:28, letterSpacing:"-0.04em" }}>Activity Log</h1>
                <p style={{ color:"#56B9E9", fontSize:13, marginTop:4 }}>{activity.length} recorded actions</p>
              </div>
              {activity.length > 0 && <button className="btn btn-secondary btn-sm" onClick={function() { if (!confirm("Clear all logs?")) return; DB.clearActivity().then(function() { setActivity([]); showToast("Log cleared."); }); }}>Clear Log</button>}
            </div>
            {activity.length === 0
              ? <div className="card" style={{ color:"#56B9E9", fontSize:13, textAlign:"center", padding:48 }}>No activity recorded yet.</div>
              : (
                <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
                  {activity.map(function(entry, i) {
                    var dt = entry.timestamp ? new Date(entry.timestamp) : (entry.created_at ? new Date(entry.created_at) : null);
                    var ac = entry.action.indexOf("Approved") === 0 ? "#4DE7A6" : entry.action.indexOf("Rejected") === 0 || entry.action.indexOf("Deleted") === 0 || entry.action.indexOf("Suspended") === 0 ? "#cf6679" : entry.action.indexOf("Edited") === 0 ? "#cf6679" : "#56B9E9";
                    return (
                      <div key={entry.id} className="card" style={{ padding:"14px 20px", display:"flex", alignItems:"flex-start", gap:16, cursor:"pointer" }}
                        onClick={function(){ setActivityDetail(entry); }}
                        onMouseEnter={function(e){ e.currentTarget.style.borderColor="#374151"; }}
                        onMouseLeave={function(e){ e.currentTarget.style.borderColor="#2A2A2A"; }}>
                        <div style={{ width:10, height:10, borderRadius:"50%", background:ac, marginTop:4, flexShrink:0 }} />
                        <div style={{ flex:1 }}>
                          <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:4 }}>
                            <span className="tag" style={{ background:ac+"22", color:ac, fontSize:11 }}>{entry.action}</span>
                            <span style={{ fontSize:12, color:"#E0E0E0", fontWeight:500 }}>{entry.adminName}</span>
                          </div>
                          <div style={{ fontSize:13, color:"rgba(224,224,224,0.6)", marginBottom:6 }}>{entry.details}</div>
                          <div style={{ fontSize:11, color:"#56B9E9" }}>{dt && !isNaN(dt) ? dt.toLocaleDateString("en-GB") + " · " + dt.toLocaleTimeString("en-GB") : "—"}</div>
                        </div>
                        <span style={{ color:"rgba(224,224,224,0.3)", fontSize:14 }}>›</span>
                      </div>
                    );
                  })}
                </div>
              )}
          </div>
        )}

        {view === "pipeline" && (
          <div className="fade-in">
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-end", marginBottom:18 }}>
              <div>
                <h1 style={{ fontFamily:"Playfair Display,serif", fontWeight:900, fontSize:28, letterSpacing:"-0.04em" }}>Pipeline</h1>
                <p style={{ color:"#56B9E9", fontSize:13, marginTop:4 }}>Potential and pending franchises</p>
              </div>
              <button className="btn btn-primary btn-sm" onClick={function() {
                setPendingForm({ id:null, companyName:"", location:"", status:"potential", franchisees:[{ name:"", email:"", phone:"", sharePercent:"", paying:"" }], investors:[{ name:"", type:"individual", companyName:"", email:"", phone:"", sharePercent:"", paying:"" }], franchiseCost:"", paymentPlan:"", ilaSignedFranchisee:false, ilaSignedInvestor:false, contractSigned:false, notes:"" });
                setPendingModal("new");
              }}>+ Add to Pipeline</button>
            </div>
            <div style={{ display:"flex", gap:10, marginBottom:18 }}>
              <input placeholder="Search pipeline..." value={searchPipeline} onChange={function(e) { setSearchPipeline(e.target.value); }}
                style={{ flex:1, background:"#1E1E1E", border:"1px solid #374151", color:"#E0E0E0", padding:"10px 14px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none" }} />
              <select value={filterStatus} onChange={function(e) { setFilterStatus(e.target.value); }}
                style={{ flex:1, background:"#1E1E1E", border:"1px solid #374151", color:"rgba(224,224,224,0.6)", padding:"10px 14px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none" }}>
                <option value="all">All Statuses</option>
                <option value="potential">Potential</option>
                <option value="signed">Signed</option>
                <option value="active">Active</option>
              </select>
            </div>

            {pendingFranchises.length === 0 && (
              <div className="card" style={{ textAlign:"center", padding:48, color:"#56B9E9", fontSize:13 }}>No pending franchises yet. Add one to get started.</div>
            )}

            {(function(){
              var q = searchPipeline.toLowerCase();
              var filtered = pendingFranchises.filter(function(pf) {
                var matchSearch = !searchPipeline || (pf.companyName||"").toLowerCase().includes(q) || (pf.location||"").toLowerCase().includes(q);
                var matchStatus = filterStatus === "all" || pf.status === filterStatus;
                return matchSearch && matchStatus;
              });
              var nonActive = filtered.filter(function(pf){ return pf.status !== "active"; });
              var active = filtered.filter(function(pf){ return pf.status === "active"; });
              var renderCard = function(pf) {
                var statusColor = pf.status === "active" ? "#4DE7A6" : pf.status === "signed" ? "#56B9E9" : "#cf6679";
                var statusBg = pf.status === "active" ? "rgba(77,231,166,0.1)" : pf.status === "signed" ? "rgba(123,158,255,0.1)" : "rgba(207,102,121,0.1)";
                var totalFranchiseePaying = pf.franchisees.reduce(function(s,f) { return s+(parseFloat(f.paying)||0); }, 0);
                var totalInvestorPaying = pf.investors.reduce(function(s,i) { return s+(parseFloat(i.paying)||0); }, 0);
                var isExpanded = expandedPipelineId === pf.id;
                return (
                  <div key={pf.id} className="card" style={{ padding:0, overflow:"hidden" }}>
                    {/* Collapsed header — always visible, click to expand */}
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"16px 20px", cursor:"pointer" }}
                      onClick={function() { setExpandedPipelineId(isExpanded ? null : pf.id); }}>
                      <div style={{ display:"flex", alignItems:"center", gap:12 }}>
                        <div style={{ width:36, height:36, borderRadius:"50%", background:"rgba(86,185,233,0.1)", border:"1px solid rgba(86,185,233,0.2)", display:"flex", alignItems:"center", justifyContent:"center", color:"#56B9E9", fontFamily:"Playfair Display,serif", fontWeight:800, fontSize:14 }}>{(pf.companyName||"?").charAt(0)}</div>
                        <div>
                          <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                            <span style={{ fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:16, color:"#E0E0E0" }}>{pf.companyName || "Unnamed"}</span>
                            <span className="tag" style={{ background:statusBg, color:statusColor }}>{pf.status}</span>
                          </div>
                          <div style={{ fontSize:12, color:"rgba(224,224,224,0.5)", marginTop:2 }}>
                            {pf.location}
                            {pf.franchisees.filter(function(f){return f.name;}).length > 0 && <span style={{ marginLeft:10 }}>· {pf.franchisees.filter(function(f){return f.name;}).length} franchisee{pf.franchisees.filter(function(f){return f.name;}).length !== 1 ? "s":""}</span>}
                            {pf.investors.filter(function(i){return i.name||i.companyName;}).length > 0 && <span style={{ marginLeft:6 }}>· {pf.investors.filter(function(i){return i.name||i.companyName;}).length} investor{pf.investors.filter(function(i){return i.name||i.companyName;}).length !== 1 ? "s":""}</span>}
                          </div>
                        </div>
                      </div>
                      <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                        <div style={{ display:"flex", gap:4 }}>
                          {["ILA (F)","ILA (I)","Contract"].map(function(lbl, li) {
                            var signed = li===0 ? pf.ilaSignedFranchisee : li===1 ? pf.ilaSignedInvestor : pf.contractSigned;
                            return <span key={lbl} className="tag" style={{ background:signed?"rgba(77,231,166,0.1)":"rgba(255,255,255,0.04)", color:signed?"#4DE7A6":"rgba(224,224,224,0.3)", fontSize:10, border:"1px solid "+(signed?"rgba(77,231,166,0.25)":"rgba(255,255,255,0.06)") }}>{lbl} {signed?"✓":"✗"}</span>;
                          })}
                        </div>
                        <button className="btn btn-sm btn-secondary" style={{ fontSize:11 }} onClick={function(e) { e.stopPropagation(); setPendingForm(Object.assign({}, pf)); setPendingModal(pf.id); }}>Edit</button>
                        <button className="btn btn-sm" style={{ background:"rgba(207,102,121,0.1)", color:"#cf6679", border:"1px solid rgba(207,102,121,0.25)", fontSize:11 }}
                          onClick={function(e) { e.stopPropagation(); if (!confirm("Delete?")) return; DB.deletePipeline(pf.id).then(function() { setPendingFranchises(pendingFranchises.filter(function(p) { return p.id !== pf.id; })); showToast("Deleted."); }); }}>✕</button>
                        <span style={{ color:"rgba(224,224,224,0.4)", fontSize:16, marginLeft:4 }}>{isExpanded ? "▲" : "▼"}</span>
                      </div>
                    </div>

                    {/* Expanded detail view */}
                    {isExpanded && (
                      <div className="fade-in" style={{ borderTop:"1px solid #2A2A2A", padding:"20px 20px" }}>
                        {/* Financial summary */}
                        <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:10, marginBottom:20 }}>
                          {[
                            ["FRANCHISE COST", pf.franchiseCost ? "£"+parseFloat(pf.franchiseCost).toLocaleString("en-GB") : "—", "#56B9E9"],
                            ["FRANCHISEES PAYING", totalFranchiseePaying ? "£"+totalFranchiseePaying.toLocaleString("en-GB") : "—", "#4DE7A6"],
                            ["INVESTORS PAYING", totalInvestorPaying ? "£"+totalInvestorPaying.toLocaleString("en-GB") : "—", "#E0E0E0"],
                            ["PAYMENT PLAN", pf.paymentPlan || "—", "#cf6679"],
                          ].map(function(item) {
                            return (
                              <div key={item[0]} style={{ background:"#252525", borderRadius:10, padding:"12px 14px" }}>
                                <div style={{ fontSize:10, color:"rgba(224,224,224,0.45)", letterSpacing:"0.1em", marginBottom:6 }}>{item[0]}</div>
                                <div style={{ color:item[2], fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:14 }}>{item[1]}</div>
                              </div>
                            );
                          })}
                        </div>

                        {/* Franchisees + Investors */}
                        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16, marginBottom:pf.notes ? 16 : 0 }}>
                          <div>
                            <label className="label" style={{ marginBottom:10 }}>FRANCHISEES</label>
                            {pf.franchisees.filter(function(f) { return f.name; }).length === 0
                              ? <div style={{ color:"rgba(224,224,224,0.4)", fontSize:12 }}>None added</div>
                              : pf.franchisees.filter(function(f) { return f.name; }).map(function(f, fi) {
                                return (
                                  <div key={fi} style={{ background:"#252525", borderRadius:8, padding:"10px 14px", marginBottom:8 }}>
                                    <div style={{ display:"flex", justifyContent:"space-between", marginBottom:4 }}>
                                      <span style={{ color:"#E0E0E0", fontWeight:600, fontSize:13 }}>{f.name}</span>
                                      <div style={{ display:"flex", gap:8 }}>
                                        {f.sharePercent && <span className="tag" style={{ background:"rgba(77,231,166,0.1)", color:"#4DE7A6", fontSize:10 }}>{f.sharePercent}%</span>}
                                        {f.paying && <span style={{ color:"#56B9E9", fontSize:12 }}>£{parseFloat(f.paying).toLocaleString("en-GB")}</span>}
                                      </div>
                                    </div>
                                    {f.email && <div style={{ fontSize:11, color:"rgba(224,224,224,0.5)" }}>{f.email}</div>}
                                    {f.phone && <div style={{ fontSize:11, color:"rgba(224,224,224,0.5)" }}>{f.phone}</div>}
                                    {f.docs && Object.keys(f.docs).length > 0 && (
                                      <div style={{ display:"flex", gap:6, marginTop:6, flexWrap:"wrap" }}>
                                        {Object.keys(f.docs).map(function(d) {
                                          return <span key={d} className="tag" style={{ background:"rgba(77,231,166,0.08)", color:"#4DE7A6", fontSize:10, border:"1px solid rgba(77,231,166,0.2)" }}>✓ {d}</span>;
                                        })}
                                      </div>
                                    )}
                                  </div>
                                );
                              })
                            }
                          </div>
                          <div>
                            <label className="label" style={{ marginBottom:10 }}>INVESTORS</label>
                            {pf.investors.filter(function(i) { return i.name || i.companyName; }).length === 0
                              ? <div style={{ color:"rgba(224,224,224,0.4)", fontSize:12 }}>None added</div>
                              : pf.investors.filter(function(i) { return i.name || i.companyName; }).map(function(inv, ii) {
                                var dispName = inv.type === "company" ? (inv.companyName || inv.name) : inv.name;
                                return (
                                  <div key={ii} style={{ background:"#252525", borderRadius:8, padding:"10px 14px", marginBottom:8 }}>
                                    <div style={{ display:"flex", justifyContent:"space-between", marginBottom:4 }}>
                                      <div style={{ display:"flex", alignItems:"center", gap:6 }}>
                                        <span style={{ color:"#E0E0E0", fontWeight:600, fontSize:13 }}>{dispName}</span>
                                        <span className="tag" style={{ background:"rgba(86,185,233,0.1)", color:"#56B9E9", fontSize:10 }}>{inv.type}</span>
                                      </div>
                                      <div style={{ display:"flex", gap:8 }}>
                                        {inv.sharePercent && <span className="tag" style={{ background:"rgba(86,185,233,0.1)", color:"#56B9E9", fontSize:10 }}>{inv.sharePercent}%</span>}
                                        {inv.paying && <span style={{ color:"#56B9E9", fontSize:12 }}>£{parseFloat(inv.paying).toLocaleString("en-GB")}</span>}
                                      </div>
                                    </div>
                                    {inv.email && <div style={{ fontSize:11, color:"rgba(224,224,224,0.5)" }}>{inv.email}</div>}
                                    {inv.phone && <div style={{ fontSize:11, color:"rgba(224,224,224,0.5)" }}>{inv.phone}</div>}
                                  </div>
                                );
                              })
                            }
                          </div>
                        </div>

                        {/* Notes */}
                        {pf.notes && (
                          <div style={{ background:"#252525", borderRadius:8, padding:"12px 14px" }}>
                            <label className="label" style={{ marginBottom:6 }}>NOTES</label>
                            <div style={{ fontSize:13, color:"rgba(224,224,224,0.7)", lineHeight:1.6 }}>{pf.notes}</div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                );
              };
              return (
                <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
                  {nonActive.map(function(pf){ return renderCard(pf); })}
                  {active.length > 0 && (
                    <div>
                      <div style={{ display:"flex", alignItems:"center", gap:10, padding:"12px 16px", background:"rgba(77,231,166,0.05)", border:"1px solid rgba(77,231,166,0.2)", borderRadius: showActivePipeline ? "12px 12px 0 0" : 12, cursor:"pointer" }}
                        onClick={function(){ setShowActivePipeline(function(v){ return !v; }); }}>
                        <span style={{ color:"#4DE7A6", fontSize:14 }}>✓</span>
                        <span style={{ fontWeight:700, fontSize:14, color:"#4DE7A6" }}>Active</span>
                        <span style={{ background:"rgba(77,231,166,0.15)", color:"#4DE7A6", fontSize:10, padding:"3px 10px", borderRadius:20, border:"1px solid rgba(77,231,166,0.3)" }}>{active.length}</span>
                        <span style={{ marginLeft:"auto", color:"rgba(224,224,224,0.4)", fontSize:13 }}>{showActivePipeline ? "▲" : "▼"}</span>
                      </div>
                      {showActivePipeline && (
                        <div style={{ border:"1px solid rgba(77,231,166,0.2)", borderTop:"none", borderRadius:"0 0 12px 12px", display:"flex", flexDirection:"column", gap:0, overflow:"hidden" }}>
                          {active.map(function(pf){ return renderCard(pf); })}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              );
            })()}
          </div>
        )}


        {view === "compliance" && (
          <div className="fade-in">
            {complianceView === "list" && (
              <div>
                <div style={{ marginBottom:28 }}>
                  <h1 style={{ fontFamily:"Playfair Display,serif", fontWeight:900, fontSize:28, letterSpacing:"-0.04em" }}>Compliance</h1>
                  <p style={{ color:"#56B9E9", fontSize:13, marginTop:4 }}>Manage ID, proof of address, franchise contracts and ILA agreements</p>
                </div>

                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:24 }}>

                  {/* Investors column */}
                  <div>
                    <label className="label" style={{ marginBottom:14 }}>INVESTORS</label>
                    <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
                      {allInvestors.map(function(inv, i) {
                        var key = "investor_" + inv.email;
                        var docs = compliance[key] || {};
                        var docTypes = ["ID", "Proof of Address", "ILA Agreement"];
                        var uploaded = docTypes.filter(function(t) { return docs[t]; }).length;
                        var color = PALETTE[i % PALETTE.length];
                        return (
                          <div key={inv.email} className="card" style={{ cursor:"pointer", padding:"14px 18px" }}
                            onClick={function() { setCompliancePersonId(inv.email); setCompliancePersonType("investor"); setComplianceView("person");
                            var invUser = users.find(function(u) { return u.email === inv.email; });
                            if (invUser && invUser.id) { DB.getCompliance(invUser.id).then(function(res) {
                              if (res && res.docs) {
                                var updated = Object.assign({}, compliance);
                                var k2 = "investor_" + inv.email;
                                if (!updated[k2]) updated[k2] = {};
                                res.docs.forEach(function(doc) { updated[k2][doc.doc_type] = { name:doc.file_name, uploadedAt:doc.uploaded_at, s3Key:doc.s3_key, userId:invUser.id }; });
                                setCompliance(updated);
                              }
                            }); } }}
                            onMouseEnter={function(e) { e.currentTarget.style.borderColor="#4b5563"; }}
                            onMouseLeave={function(e) { e.currentTarget.style.borderColor="#2A2A2A"; }}>
                            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                              <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                                <div style={{ width:34, height:34, borderRadius:"50%", background:color+"22", border:"1px solid "+color+"44", display:"flex", alignItems:"center", justifyContent:"center", color:color, fontFamily:"Playfair Display,serif", fontWeight:800, fontSize:13 }}>{inv.name.charAt(0)}</div>
                                <div>
                                  <div style={{ fontWeight:600, fontSize:13 }}>{inv.name}</div>
                                  <div style={{ fontSize:11, color:"rgba(224,224,224,0.6)" }}>Investor</div>
                                </div>
                              </div>
                              <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                                <div style={{ display:"flex", gap:4 }}>
                                  {docTypes.map(function(t) {
                                    return <div key={t} title={t} style={{ width:8, height:8, borderRadius:"50%", background:docs[t] ? "#4DE7A6" : "#56B9E9" }} />;
                                  })}
                                </div>
                                <span style={{ fontSize:11, color: uploaded === docTypes.length ? "#4DE7A6" : "#cf6679" }}>{uploaded}/{docTypes.length}</span>
                                <span style={{ color:"rgba(224,224,224,0.6)", fontSize:14 }}>›</span>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                      {allInvestors.length === 0 && <div style={{ color:"#56B9E9", fontSize:13 }}>No investors yet.</div>}
                    </div>
                  </div>

                  {/* Franchisees column */}
                  <div>
                    <label className="label" style={{ marginBottom:14 }}>FRANCHISEES</label>
                    <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
                      {users.filter(function(u) { return u.role === "franchisee" || u.role === "franchisee_investor"; }).map(function(u, i) {
                        var key = "franchisee_" + u.email;
                        var docs = compliance[key] || {};
                        var docTypes = ["ID", "Proof of Address", "Franchise Contract", "ILA Agreement"];
                        var uploaded = docTypes.filter(function(t) { return docs[t]; }).length;
                        var color = PALETTE[(i + 2) % PALETTE.length];
                        return (
                          <div key={u.id} className="card" style={{ cursor:"pointer", padding:"14px 18px" }}
                            onClick={function() { setCompliancePersonId(u.email); setCompliancePersonType("franchisee"); setComplianceView("person");
                              if (u.id) { DB.getCompliance(u.id).then(function(res) {
                                if (res && res.docs) {
                                  var updated = Object.assign({}, compliance);
                                  var k2 = "franchisee_" + u.email;
                                  if (!updated[k2]) updated[k2] = {};
                                  res.docs.forEach(function(doc) { updated[k2][doc.doc_type] = { name:doc.file_name, uploadedAt:doc.uploaded_at, s3Key:doc.s3_key, userId:u.id }; });
                                  setCompliance(updated);
                                }
                              }); } }}
                            onMouseEnter={function(e) { e.currentTarget.style.borderColor="#4b5563"; }}
                            onMouseLeave={function(e) { e.currentTarget.style.borderColor="#2A2A2A"; }}>
                            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                              <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                                <div style={{ width:34, height:34, borderRadius:"50%", background:color+"22", border:"1px solid "+color+"44", display:"flex", alignItems:"center", justifyContent:"center", color:color, fontFamily:"Playfair Display,serif", fontWeight:800, fontSize:13 }}>{u.name.charAt(0)}</div>
                                <div>
                                  <div style={{ fontWeight:600, fontSize:13 }}>{u.name}</div>
                                  <div style={{ fontSize:11, color:"rgba(224,224,224,0.6)" }}>Franchisee{u.franchiseId ? " · " + ((franchises.find(function(f) { return f.id === u.franchiseId; }) || {name:""}).name) : ""}</div>
                                </div>
                              </div>
                              <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                                <div style={{ display:"flex", gap:4 }}>
                                  {docTypes.map(function(t) {
                                    return <div key={t} title={t} style={{ width:8, height:8, borderRadius:"50%", background:docs[t] ? "#4DE7A6" : "#56B9E9" }} />;
                                  })}
                                </div>
                                <span style={{ fontSize:11, color: uploaded === docTypes.length ? "#4DE7A6" : "#cf6679" }}>{uploaded}/{docTypes.length}</span>
                                <span style={{ color:"rgba(224,224,224,0.6)", fontSize:14 }}>›</span>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                      {users.filter(function(u) { return u.role === "franchisee"; }).length === 0 && <div style={{ color:"#56B9E9", fontSize:13 }}>No franchisees yet.</div>}
                    </div>
                  </div>

                </div>
              </div>
            )}

            {complianceView === "person" && (function() {
              var isInvestor = compliancePersonType === "investor";
              var person = isInvestor
                ? allInvestors.find(function(i) { return i.email === compliancePersonId; })
                : users.find(function(u) { return u.email === compliancePersonId; });
              if (!person) return null;
              var key = compliancePersonType + "_" + compliancePersonId;
              var docs = compliance[key] || {};
              var meta = docs["_meta"] || {};
              var docTypes = isInvestor
                ? ["ID", "Proof of Address", "ILA Agreement"]
                : ["ID", "Proof of Address", "Franchise Contract", "ILA Agreement"];
              var totalUploaded = docTypes.filter(function(t) { return docs[t]; }).length;

              // Branches the person is invested in (investors only)
              var branches = isInvestor
                ? (person.stakes || [])
                : (function() {
                    var f = franchises.find(function(fr) { return fr.id === person.franchiseId; });
                    return f ? [{ franchise:f.name, sharePercent:"—" }] : [];
                  })();

              return (
                <div>
                  <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:24 }}>
                    <button className="btn btn-secondary btn-sm" onClick={function() { setComplianceView("list"); }}>Back</button>
                    <div>
                      <h1 style={{ fontFamily:"Playfair Display,serif", fontWeight:900, fontSize:24 }}>{person.name}</h1>
                      <p style={{ color:"#56B9E9", fontSize:13, marginTop:2 }}>
                        {person.email}
                        {person.phone ? " · " + person.phone : ""}
                        {" · "}
                        <span style={{ color: isInvestor ? "#E0E0E0" : "#4DE7A6" }}>{compliancePersonType}</span>
                      </p>
                    </div>
                    <div style={{ marginLeft:"auto", textAlign:"right" }}>
                      <div style={{ fontSize:11, color:"#56B9E9", marginBottom:4 }}>DOCUMENTS</div>
                      <div style={{ fontFamily:"Playfair Display,serif", fontWeight:800, fontSize:22, color: totalUploaded === docTypes.length ? "#4DE7A6" : "#cf6679" }}>{totalUploaded}/{docTypes.length}</div>
                    </div>
                  </div>

                  {/* Contact info + branches */}
                  <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16, marginBottom:24 }}>
                    {/* Contact details */}
                    <div className="card" style={{ padding:18 }}>
                      <label className="label" style={{ marginBottom:14 }}>CONTACT DETAILS</label>
                      <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
                        <div>
                          <div style={{ fontSize:10, color:"rgba(224,224,224,0.6)", letterSpacing:"0.1em", marginBottom:5 }}>LOGIN EMAIL</div>
                          <div style={{ fontSize:13, color:"rgba(224,224,224,0.6)" }}>{person.email}</div>
                        </div>
                        <div>
                          <div style={{ fontSize:10, color:"rgba(224,224,224,0.6)", letterSpacing:"0.1em", marginBottom:5 }}>PHONE</div>
                          <div style={{ fontSize:13, color:person.phone ? "#E0E0E0" : "#56B9E9" }}>{person.phone || "Not provided"}</div>
                        </div>
                        <div>
                          <label className="label">PERSONAL EMAIL</label>
                          <input
                            type="email"
                            placeholder="personal@email.com"
                            value={meta.personalEmail || ""}
                            onChange={function(e) {
                              var val = e.target.value;
                              var updated = Object.assign({}, compliance);
                              if (!updated[key]) updated[key] = {};
                              updated[key] = Object.assign({}, updated[key]);
                              updated[key]["_meta"] = Object.assign({}, meta, { personalEmail:val });
                              saveCompliance(updated);
                            }}
                            style={{ background:"#1E1E1E", border:"1px solid #222", color:"#E0E0E0", padding:"9px 12px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:12, outline:"none", width:"100%" }}
                          />
                        </div>
                        <div>
                          <label className="label">NOTES</label>
                          <textarea
                            placeholder="Any additional notes..."
                            value={meta.notes || ""}
                            onChange={function(e) {
                              var val = e.target.value;
                              var updated = Object.assign({}, compliance);
                              if (!updated[key]) updated[key] = {};
                              updated[key] = Object.assign({}, updated[key]);
                              updated[key]["_meta"] = Object.assign({}, meta, { notes:val });
                              saveCompliance(updated);
                            }}
                            rows={3}
                            style={{ background:"#1E1E1E", border:"1px solid #222", color:"#E0E0E0", padding:"9px 12px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:12, outline:"none", width:"100%", resize:"vertical" }}
                          />
                        </div>
                      </div>
                    </div>

                    {/* Branch investments */}
                    <div className="card" style={{ padding:18 }}>
                      <label className="label" style={{ marginBottom:14 }}>{isInvestor ? "BRANCH INVESTMENTS" : "ASSIGNED FRANCHISE"}</label>
                      {branches.length === 0
                        ? <div style={{ fontSize:13, color:"#56B9E9" }}>No branches assigned.</div>
                        : (
                          <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
                            {branches.map(function(b, bi) {
                              var bColor = PALETTE[bi % PALETTE.length];
                              return (
                                <div key={bi} style={{ background:"#252525", borderRadius:10, padding:"12px 14px", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                                  <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                                    <div style={{ width:30, height:30, borderRadius:8, background:bColor+"22", display:"flex", alignItems:"center", justifyContent:"center", color:bColor, fontSize:14 }}>◈</div>
                                    <div style={{ fontWeight:500, fontSize:13 }}>{b.franchise}</div>
                                  </div>
                                  {b.sharePercent && b.sharePercent !== "—" && (
                                    <span className="tag" style={{ background:bColor+"22", color:bColor }}>{b.sharePercent}%</span>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        )}
                    </div>
                  </div>

                  {/* Documents grid */}
                  <label className="label" style={{ marginBottom:14 }}>DOCUMENTS</label>
                  <div style={{ display:"grid", gridTemplateColumns:"repeat(2,1fr)", gap:16 }}>
                    {docTypes.map(function(docType) {
                      var existing = docs[docType];
                      return (
                        <div key={docType} className="card" style={{ padding:20 }}>
                          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:14 }}>
                            <div>
                              <div style={{ fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:15 }}>{docType}</div>
                              {existing
                                ? <div style={{ fontSize:11, color:"#4DE7A6", marginTop:4 }}>✓ Uploaded · {existing.name} · {existing.uploadedAt ? new Date(existing.uploadedAt).toLocaleDateString("en-GB") : ""}</div>
                                : <div style={{ fontSize:11, color:"#cf6679", marginTop:4 }}>Not uploaded</div>}
                            </div>
                            <div style={{ width:10, height:10, borderRadius:"50%", background:existing ? "#4DE7A6" : "#56B9E9", flexShrink:0, marginTop:4 }} />
                          </div>

                          {existing && (
                            <div style={{ display:"flex", gap:8, marginBottom:12 }}>
                              <button className="btn btn-sm" style={{ background:"rgba(86,185,233,0.1)", color:"#56B9E9", border:"1px solid rgba(86,185,233,0.25)", fontSize:11 }}
                                onClick={function() {
                                  var userId = person.id || person.userId || (existing && existing.userId);
                                  if (userId) {
                                    apiFetch("/api/compliance/" + userId + "/" + encodeURIComponent(docType) + "/url").then(function(res) {
                                      if (res && res.url) { window.open(res.url, "_blank"); }
                                      else { showToast("Could not get download link."); }
                                    });
                                  } else if (existing.dataUrl) {
                                    var link = document.createElement("a");
                                    link.href = existing.dataUrl;
                                    link.download = existing.name;
                                    link.click();
                                  }
                                }}>View / Download</button>
                              <button className="btn btn-sm" style={{ background:"rgba(207,102,121,0.1)", color:"#cf6679", border:"1px solid rgba(207,102,121,0.25)", fontSize:11 }}
                                onClick={function() {
                                  var userId = person.id || person.userId || (existing && existing.userId);
                                  if (userId) {
                                    DB.deleteDoc(userId, docType).then(function() {
                                      DB.getCompliance().then(function(d) { setCompliance(d || {}); });
    apiFetch("/api/royalty").then(function(d) { if (d && Array.isArray(d)) setRoyaltyPayments(d); }).catch(function(){});
    try { var savedMap = localStorage.getItem("gi_royalty_map"); if (savedMap) setRoyaltyBranchMap(JSON.parse(savedMap)); } catch(e) {}
                                      logActivity("Removed document", person.name + " - " + docType);
                                      showToast(docType + " removed.");
                                    });
                                  } else {
                                    var updated = Object.assign({}, compliance);
                                    var personDocs = Object.assign({}, updated[key]);
                                    delete personDocs[docType];
                                    updated[key] = personDocs;
                                    saveCompliance(updated);
                                    logActivity("Removed document", person.name + " - " + docType);
                                    showToast(docType + " removed.");
                                  }
                                }}>Remove</button>
                            </div>
                          )}

                          <label style={{ display:"block", cursor:"pointer" }}>
                            <div className="btn btn-secondary btn-sm" style={{ width:"100%", justifyContent:"center", fontSize:11 }}>
                              {existing ? "Replace File" : "Upload File"}
                            </div>
                            <input type="file" accept=".pdf,.jpg,.jpeg,.png,.doc,.docx" style={{ display:"none" }}
                              onChange={function(e) {
                                var file = e.target.files[0];
                                if (!file) return;
                                var userId = person.id || person.userId;
                                if (userId) {
                                  DB.uploadDoc(userId, docType, file).then(function() {
                                    DB.getCompliance().then(function(d) { setCompliance(d || {}); });
    apiFetch("/api/royalty").then(function(d) { if (d && Array.isArray(d)) setRoyaltyPayments(d); }).catch(function(){});
    try { var savedMap = localStorage.getItem("gi_royalty_map"); if (savedMap) setRoyaltyBranchMap(JSON.parse(savedMap)); } catch(e) {}
                                    DB.getCompliance(userId).then(function(res) {
                                      var updated = Object.assign({}, compliance);
                                      updated[key] = Object.assign({}, updated[key]);
                                      if (res && res.docs) {
                                        res.docs.forEach(function(doc) {
                                          updated[key][doc.doc_type] = { name:doc.file_name, uploadedAt:doc.uploaded_at, s3Key:doc.s3_key, userId:userId };
                                        });
                                      }
                                      setCompliance(updated);
                                      logActivity("Uploaded document", person.name + " - " + docType + " (" + file.name + ")");
                                      showToast(docType + " uploaded!");
                                    });
                                  }).catch(function() { showToast("Upload failed. Please try again."); });
                                } else {
                                  showToast("Cannot upload: user account not found.");
                                }
                                e.target.value = "";
                              }} />
                          </label>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })()}
          </div>
        )}


      </div>

      {modal && (
        <div className="modal-bg" onClick={function() { setModal(null); }}>
          <div className="card fade-in" style={{ width:modal === "new-franchise" ? 560 : modal === "new-financial" ? 500 : 420, padding:30, maxHeight:"90vh", overflowY:"auto" }} onClick={function(e) { e.stopPropagation(); }}>

            {modal === "new-franchise" && (
              <div>
                <h3 style={{ fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:19, marginBottom:6 }}>New Franchise</h3>
                <p style={{ fontSize:12, color:"rgba(224,224,224,0.6)", marginBottom:20 }}>Set up franchise details, ownership structure, and optional investors.</p>
                <div style={{ display:"flex", flexDirection:"column", gap:14 }}>

                  {/* Franchise details */}
                  <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
                    <div><label className="label">COMPANY NAME</label><input placeholder="e.g. Midtown Cafe" value={fForm.name} onChange={function(e) { setFForm(function(p) { return Object.assign({}, p, { name:e.target.value }); }); }} /></div>
                    <div><label className="label">LOCATION</label><input placeholder="e.g. London, UK" value={fForm.location} onChange={function(e) { setFForm(function(p) { return Object.assign({}, p, { location:e.target.value }); }); }} /></div>
                  </div>
                  <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
                    <div><label className="label">FRANCHISE EMAIL</label><input type="email" placeholder="franchise@email.com" value={fForm.email} onChange={function(e) { setFForm(function(p) { return Object.assign({}, p, { email:e.target.value }); }); }} /></div>
                    <div><label className="label">FRANCHISE PHONE</label><input type="tel" placeholder="+44 7700 900000" value={fForm.phone} onChange={function(e) { setFForm(function(p) { return Object.assign({}, p, { phone:e.target.value }); }); }} /></div>
                  </div>

                  {/* Successor link */}
                  <div>
                    <label className="label">SUCCESSOR TO (OPTIONAL)</label>
                    <p style={{ fontSize:11, color:"rgba(224,224,224,0.45)", marginBottom:8 }}>If this branch is replacing a closed one, link it here for reference</p>
                    <input placeholder="Search closed franchise..." value={successorSearch}
                      onChange={function(e){ setSuccessorSearch(e.target.value); }}
                      style={{ background:"#1E1E1E", border:"1px solid #2A2A2A", color:"#E0E0E0", padding:"9px 14px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none", width:"100%", marginBottom:6 }} />
                    <div style={{ background:"#1E1E1E", border:"1px solid #2A2A2A", borderRadius:8, maxHeight:160, overflowY:"auto" }}>
                      {franchises.filter(function(f){
                        if (f.status !== "closed") return false;
                        if (!successorSearch) return true;
                        var q = successorSearch.toLowerCase();
                        return (f.name||"").toLowerCase().includes(q) || (f.location||"").toLowerCase().includes(q);
                      }).map(function(f){
                        var isSel = fForm.successorId === f.id;
                        return (
                          <div key={f.id} onClick={function(){ setFForm(function(p){ return Object.assign({},p,{successorId:isSel?"":f.id}); }); setSuccessorSearch(""); }}
                            style={{ padding:"10px 14px", cursor:"pointer", background:isSel?"rgba(86,185,233,0.1)":"transparent", borderBottom:"1px solid rgba(255,255,255,0.04)", display:"flex", justifyContent:"space-between", alignItems:"center" }}
                            onMouseEnter={function(e){ if(!isSel) e.currentTarget.style.background="rgba(255,255,255,0.04)"; }}
                            onMouseLeave={function(e){ if(!isSel) e.currentTarget.style.background="transparent"; }}>
                            <div>
                              <div style={{ fontSize:13, color:"#E0E0E0", fontWeight:500 }}>{f.name}</div>
                              <div style={{ fontSize:11, color:"rgba(224,224,224,0.45)" }}>{f.location}{f.closedDate ? " · Closed "+f.closedDate : ""}</div>
                            </div>
                            {isSel && <span style={{ color:"#56B9E9", fontSize:12 }}>✓</span>}
                          </div>
                        );
                      })}
                      {franchises.filter(function(f){ return f.status==="closed"; }).length === 0 && (
                        <div style={{ padding:"12px 14px", color:"rgba(224,224,224,0.35)", fontSize:12 }}>No closed franchises found</div>
                      )}
                    </div>
                    {fForm.successorId && (function(){
                      var pred = franchises.find(function(f){ return f.id === fForm.successorId; });
                      return pred ? <div style={{ marginTop:8, padding:"8px 12px", background:"rgba(86,185,233,0.08)", border:"1px solid rgba(86,185,233,0.2)", borderRadius:6, fontSize:12, color:"#56B9E9" }}>✓ Successor to: {pred.name}</div> : null;
                    })()}
                  </div>

                  {/* Franchise owners */}
                  <div style={{ borderTop:"1px solid #374151", paddingTop:16 }}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:8 }}>
                      <div>
                        <label className="label" style={{ margin:0 }}>FRANCHISE OWNERS</label>
                        <div style={{ fontSize:11, color:"#56B9E9", marginTop:3 }}>Add all owners and their share % of the franchise itself</div>
                      </div>
                      <button className="btn btn-secondary btn-sm" onClick={function() { setFOwners(function(s) { return s.concat([{ userId:"", name:"", email:"", phone:"", sharePercent:"", isNew:false }]); }); }}>+ Add Owner</button>
                    </div>
                    <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
                      {fOwners.map(function(owner, idx) {
                        var eligibleUsers = users.filter(function(u) { return u.role === "franchisee" || u.role === "franchisee_investor" || u.role === "investor"; });
                        return (
                          <div key={idx} style={{ background:"#252525", borderRadius:10, padding:"14px", position:"relative" }}>
                            {fOwners.length > 1 && (
                              <button onClick={function() { setFOwners(function(s) { return s.filter(function(_, i) { return i !== idx; }); }); }} style={{ position:"absolute", top:10, right:12, background:"transparent", border:"none", cursor:"pointer", color:"#56B9E9", fontSize:14 }} onMouseEnter={function(e) { e.target.style.color="#cf6679"; }} onMouseLeave={function(e) { e.target.style.color="#56B9E9"; }}>✕</button>
                            )}
                            {/* Select existing or create new toggle */}
                            <div style={{ display:"flex", gap:8, marginBottom:10 }}>
                              <button className="btn btn-sm" style={{ background:!owner.isNew?"rgba(77,231,166,0.1)":"#1E1E1E", color:!owner.isNew?"#4DE7A6":"#56B9E9", border:"1px solid "+(!owner.isNew?"rgba(52,211,153,0.4)":"#2A2A2A"), fontSize:11 }}
                                onClick={function() { setFOwners(function(s) { return s.map(function(r,i) { return i===idx?Object.assign({},r,{isNew:false,userId:"",name:"",email:"",phone:""}):r; }); }); }}>
                                Select Existing
                              </button>
                              <button className="btn btn-sm" style={{ background:owner.isNew?"rgba(86,185,233,0.12)":"#1E1E1E", color:owner.isNew?"#56B9E9":"#56B9E9", border:"1px solid "+(owner.isNew?"rgba(86,185,233,0.2)":"#2A2A2A"), fontSize:11 }}
                                onClick={function() { setFOwners(function(s) { return s.map(function(r,i) { return i===idx?Object.assign({},r,{isNew:true,userId:""}):r; }); }); }}>
                                + New Person
                              </button>
                            </div>
                            {!owner.isNew ? (
                              <div style={{ display:"grid", gridTemplateColumns:"1fr 80px", gap:8 }}>
                                <div>
                                  <label className="label">SELECT OWNER</label>
                                  <input placeholder="Search by name or email..." value={ownerSearch[idx]||""}
                                    onChange={function(e){ var v=e.target.value; var k=idx; setOwnerSearch(function(s){ var n=Object.assign({},s); n[k]=v; return n; }); }}
                                    style={{ background:"#1E1E1E", border:"1px solid #374151", color:"#E0E0E0", padding:"9px 14px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:12, outline:"none", width:"100%", marginBottom:6 }} />
                                  <div style={{ background:"#1E1E1E", border:"1px solid #374151", borderRadius:8, maxHeight:160, overflowY:"auto" }}>
                                    {users.filter(function(u) {
                                      if (u.role==="admin"||u.role==="hq_support") return false;
                                      var q2=(ownerSearch[idx]||"").toLowerCase();
                                      return !q2||(u.name||"").toLowerCase().includes(q2)||(u.email||"").toLowerCase().includes(q2);
                                    }).map(function(u){
                                      var isSel=owner.userId===u.id;
                                      return <div key={u.id} onClick={function(){ setFOwners(function(s){return s.map(function(r,i){return i===idx?Object.assign({},r,{userId:u.id,name:u.name,email:u.email,phone:u.phone||""}):r;});}); setOwnerSearch(function(s){ var n=Object.assign({},s); n[idx]=""; return n; });}}
                                        style={{ padding:"8px 12px", cursor:"pointer", background:isSel?"rgba(86,185,233,0.1)":"transparent", borderBottom:"1px solid rgba(255,255,255,0.04)", fontSize:12 }}
                                        onMouseEnter={function(e){if(!isSel)e.currentTarget.style.background="rgba(255,255,255,0.04)";}}
                                        onMouseLeave={function(e){if(!isSel)e.currentTarget.style.background="transparent";}}>
                                        <span style={{color:"#E0E0E0",fontWeight:500}}>{u.name}</span>
                                        <span style={{color:"rgba(224,224,224,0.4)",fontSize:11,marginLeft:8}}>{u.email}</span>
                                      </div>;
                                    })}
                                  </div>
                                  {owner.userId && <div style={{marginTop:6,padding:"6px 10px",background:"rgba(86,185,233,0.08)",border:"1px solid rgba(86,185,233,0.2)",borderRadius:6,fontSize:12,color:"#56B9E9"}}>✓ {owner.name}</div>}
                                </div>
                                <div><label className="label">SHARE %</label><input type="number" min="0" max="100" placeholder="50" value={owner.sharePercent} onChange={function(e) { var val = e.target.value; setFOwners(function(s) { return s.map(function(r, i) { return i === idx ? Object.assign({}, r, { sharePercent:val }) : r; }); }); }} /></div>
                              </div>
                            ) : (
                              <div>
                                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 80px", gap:8, marginBottom:8 }}>
                                  <div><label className="label">FULL NAME</label><input placeholder="Owner name" value={owner.name} onChange={function(e) { var val = e.target.value; setFOwners(function(s) { return s.map(function(r, i) { return i === idx ? Object.assign({}, r, { name:val }) : r; }); }); }} /></div>
                                  <div><label className="label">EMAIL</label><input type="email" placeholder="owner@email.com" value={owner.email} onChange={function(e) { var val = e.target.value; setFOwners(function(s) { return s.map(function(r, i) { return i === idx ? Object.assign({}, r, { email:val }) : r; }); }); }} /></div>
                                  <div><label className="label">SHARE %</label><input type="number" min="0" max="100" placeholder="50" value={owner.sharePercent} onChange={function(e) { var val = e.target.value; setFOwners(function(s) { return s.map(function(r, i) { return i === idx ? Object.assign({}, r, { sharePercent:val }) : r; }); }); }} /></div>
                                </div>
                                <div><label className="label">PHONE</label><input type="tel" placeholder="+44 7700 900000" value={owner.phone||""} onChange={function(e) { var val = e.target.value; setFOwners(function(s) { return s.map(function(r, i) { return i === idx ? Object.assign({}, r, { phone:val }) : r; }); }); }} /></div>
                              </div>
                            )}
                          </div>
                        );
                      })}
                      {fOwners.filter(function(o) { return o.sharePercent; }).length > 0 && (
                        <div style={{ background:"#252525", borderRadius:8, padding:"10px 14px", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                          <span style={{ fontSize:11, color:"rgba(224,224,224,0.6)" }}>OWNERS SUBTOTAL</span>
                          <span style={{ fontFamily:"Playfair Display,serif", fontWeight:700, color:"#56B9E9", fontSize:13 }}>
                            {fOwners.reduce(function(s,o) { return s + (parseFloat(o.sharePercent)||0); }, 0)}%
                          </span>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Investors */}
                  <div style={{ borderTop:"1px solid #374151", paddingTop:16 }}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:8 }}>
                      <div>
                        <label className="label" style={{ margin:0 }}>INVESTORS (optional)</label>
                        <div style={{ fontSize:11, color:"#56B9E9", marginTop:3 }}>Investors who own a share of the profits</div>
                      </div>
                      <button className="btn btn-secondary btn-sm" onClick={function() { setFInvestors(function(s) { return s.concat([{ userId:"", name:"", email:"", phone:"", sharePercent:"", isNew:false }]); }); }}>+ Add Investor</button>
                    </div>
                    {fInvestors.length === 0 && <div style={{ fontSize:12, color:"#56B9E9", padding:"8px 0" }}>No investors added — can be added later.</div>}
                    <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
                      {fInvestors.map(function(inv, idx) {
                        return (
                          <div key={idx} style={{ background:"#252525", borderRadius:10, padding:"14px", position:"relative" }}>
                            <button onClick={function() { setFInvestors(function(s) { return s.filter(function(_, i) { return i !== idx; }); }); }} style={{ position:"absolute", top:10, right:12, background:"transparent", border:"none", cursor:"pointer", color:"#56B9E9", fontSize:14 }} onMouseEnter={function(e) { e.target.style.color="#cf6679"; }} onMouseLeave={function(e) { e.target.style.color="#56B9E9"; }}>✕</button>
                            {/* Select existing or create new toggle */}
                            <div style={{ display:"flex", gap:8, marginBottom:10 }}>
                              <button className="btn btn-sm" style={{ background:!inv.isNew?"rgba(86,185,233,0.12)":"#1E1E1E", color:!inv.isNew?"#56B9E9":"#56B9E9", border:"1px solid "+(!inv.isNew?"rgba(86,185,233,0.2)":"#2A2A2A"), fontSize:11 }}
                                onClick={function() { setFInvestors(function(s) { return s.map(function(r,i) { return i===idx?Object.assign({},r,{isNew:false,userId:"",name:"",email:"",phone:""}):r; }); }); }}>
                                Select Existing
                              </button>
                              <button className="btn btn-sm" style={{ background:inv.isNew?"#2A2A2A":"#1E1E1E", color:inv.isNew?"#E0E0E0":"#56B9E9", border:"1px solid "+(inv.isNew?"rgba(167,139,250,0.4)":"#2A2A2A"), fontSize:11 }}
                                onClick={function() { setFInvestors(function(s) { return s.map(function(r,i) { return i===idx?Object.assign({},r,{isNew:true,userId:""}):r; }); }); }}>
                                + New Person
                              </button>
                            </div>
                            {!inv.isNew ? (
                              <div style={{ display:"grid", gridTemplateColumns:"1fr 80px", gap:8 }}>
                                <div>
                                  <label className="label">SELECT INVESTOR</label>
                                  <select value={inv.userId||""} onChange={function(e) { var uid = e.target.value; var u = users.find(function(u) { return u.id === uid; }); setFInvestors(function(s) { return s.map(function(r,i) { return i===idx?Object.assign({},r,{userId:uid,name:u?u.name:"",email:u?u.email:"",phone:u?u.phone||"":""}):r; }); }); }} style={{ background:"#1E1E1E", border:"1px solid #374151", color:inv.userId?"#E0E0E0":"#56B9E9", padding:"11px 14px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none", width:"100%" }}>
                                    <option value="">Select existing person...</option>
                                    {users.filter(function(u) { return u.role !== "admin" && u.role !== "hq_support"; }).map(function(u) { return <option key={u.id} value={u.id}>{u.name} — {u.email} ({u.role})</option>; })}
                                  </select>
                                </div>
                                <div><label className="label">SHARE %</label><input type="number" min="0" max="100" placeholder="10" value={inv.sharePercent} onChange={function(e) { var val = e.target.value; setFInvestors(function(s) { return s.map(function(r, i) { return i === idx ? Object.assign({}, r, { sharePercent:val }) : r; }); }); }} /></div>
                              </div>
                            ) : (
                              <div>
                                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 80px", gap:8, marginBottom:8 }}>
                                  <div><label className="label">NAME</label><input placeholder="Full name" value={inv.name} onChange={function(e) { var val = e.target.value; setFInvestors(function(s) { return s.map(function(r, i) { return i === idx ? Object.assign({}, r, { name:val }) : r; }); }); }} /></div>
                                  <div><label className="label">EMAIL</label><input type="email" placeholder="email@example.com" value={inv.email} onChange={function(e) { var val = e.target.value; setFInvestors(function(s) { return s.map(function(r, i) { return i === idx ? Object.assign({}, r, { email:val }) : r; }); }); }} /></div>
                                  <div><label className="label">SHARE %</label><input type="number" min="0" max="100" placeholder="10" value={inv.sharePercent} onChange={function(e) { var val = e.target.value; setFInvestors(function(s) { return s.map(function(r, i) { return i === idx ? Object.assign({}, r, { sharePercent:val }) : r; }); }); }} /></div>
                                </div>
                                <div><label className="label">PHONE</label><input type="tel" placeholder="+44 7700 900000" value={inv.phone||""} onChange={function(e) { var val = e.target.value; setFInvestors(function(s) { return s.map(function(r, i) { return i === idx ? Object.assign({}, r, { phone:val }) : r; }); }); }} /></div>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  {/* Combined total ownership */}
                  {(function() {
                    var ownerTotal = fOwners.reduce(function(s,o) { return s+(parseFloat(o.sharePercent)||0); }, 0);
                    var invTotal = fInvestors.filter(function(i) { return !i.isNew || i.sharePercent; }).reduce(function(s,i) { return s+(parseFloat(i.sharePercent)||0); }, 0);
                    var grandTotal = ownerTotal + invTotal;
                    if (grandTotal === 0) return null;
                    return (
                      <div style={{ background:"#252525", borderRadius:10, padding:"14px 16px", border:"1px solid "+(grandTotal === 100 ? "rgba(77,231,166,0.3)" : "rgba(207,102,121,0.3)") }}>
                        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:10 }}>
                          <span style={{ fontSize:11, color:"rgba(224,224,224,0.6)", letterSpacing:"0.08em" }}>TOTAL OWNERSHIP (OWNERS + INVESTORS)</span>
                          <span style={{ fontFamily:"Playfair Display,serif", fontWeight:800, fontSize:18, color: grandTotal === 100 ? "#4DE7A6" : "#cf6679" }}>
                            {grandTotal}% {grandTotal === 100 ? "✓" : "(must equal 100%)"}
                          </span>
                        </div>
                        <div style={{ display:"flex", height:6, borderRadius:4, overflow:"hidden", background:"rgba(255,255,255,0.06)" }}>
                          <div style={{ width:Math.min(ownerTotal,100)+"%", background:"#56B9E9", transition:"width 0.3s" }} title={"Owners: "+ownerTotal+"%"} />
                          <div style={{ width:Math.min(invTotal, 100-ownerTotal)+"%", background:"#4DE7A6", transition:"width 0.3s" }} title={"Investors: "+invTotal+"%"} />
                        </div>
                        <div style={{ display:"flex", gap:16, marginTop:8, fontSize:11 }}>
                          <span style={{ color:"#56B9E9" }}>■ Owners {ownerTotal}%</span>
                          <span style={{ color:"#4DE7A6" }}>■ Investors {invTotal}%</span>
                        </div>
                      </div>
                    );
                  })()}

                  <div style={{ display:"flex", gap:10, marginTop:4 }}>
                    <button className="btn btn-primary" onClick={addFranchise}>Create Franchise</button>
                    <button className="btn btn-secondary" onClick={function() { setModal(null); setFInvestors([]); setFOwners([{ name:"", email:"", phone:"", sharePercent:"" }]); }}>Cancel</button>
                  </div>
                </div>
              </div>
            )}

            {modal === "new-investor" && (
              <div>
                <h3 style={{ fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:19, marginBottom:6 }}>Onboard Investor</h3>
                <p style={{ fontSize:12, color:"rgba(224,224,224,0.6)", marginBottom:16 }}>Select an existing person or create a new investor account.</p>
                <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
                  {/* Select existing or new toggle */}
                  <div style={{ display:"flex", gap:8 }}>
                    <button className="btn btn-sm" style={{ background:!invForm.isNew?"rgba(86,185,233,0.12)":"#1E1E1E", color:!invForm.isNew?"#56B9E9":"#56B9E9", border:"1px solid "+(!invForm.isNew?"rgba(86,185,233,0.2)":"#2A2A2A") }}
                      onClick={function() { setInvForm(function(p) { return Object.assign({},p,{isNew:false,name:"",email:"",phone:"",userId:""}); }); }}>
                      Select Existing
                    </button>
                    <button className="btn btn-sm" style={{ background:invForm.isNew?"#2A2A2A":"#1E1E1E", color:invForm.isNew?"#E0E0E0":"#56B9E9", border:"1px solid "+(invForm.isNew?"rgba(167,139,250,0.4)":"#2A2A2A") }}
                      onClick={function() { setInvForm(function(p) { return Object.assign({},p,{isNew:true,userId:""}); }); }}>
                      + New Person
                    </button>
                  </div>
                  {!invForm.isNew ? (
                    <div>
                      <label className="label">SELECT PERSON</label>
                      <input placeholder="Search by name or email..." value={invSearch}
                        onChange={function(e){ setInvSearch(e.target.value); }}
                        style={{ background:"#1E1E1E", border:"1px solid #374151", color:"#E0E0E0", padding:"9px 14px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none", width:"100%", marginBottom:8 }} />
                      <div style={{ background:"#1E1E1E", border:"1px solid #374151", borderRadius:8, maxHeight:200, overflowY:"auto" }}>
                        {users.filter(function(u) {
                          if (u.role === "admin" || u.role === "hq_support") return false;
                          if (!invSearch) return true;
                          var q = invSearch.toLowerCase();
                          return (u.name||"").toLowerCase().includes(q) || (u.email||"").toLowerCase().includes(q);
                        }).map(function(u) {
                          var isSelected = invForm.userId === u.id;
                          return (
                            <div key={u.id}
                              onClick={function(){ setInvForm(function(p){ return Object.assign({},p,{userId:u.id,name:u.name,email:u.email,phone:u.phone||""}); }); setInvSearch(""); }}
                              style={{ padding:"10px 14px", cursor:"pointer", background:isSelected?"rgba(86,185,233,0.1)":"transparent", borderBottom:"1px solid rgba(255,255,255,0.04)", display:"flex", justifyContent:"space-between", alignItems:"center" }}
                              onMouseEnter={function(e){ if(!isSelected) e.currentTarget.style.background="rgba(255,255,255,0.04)"; }}
                              onMouseLeave={function(e){ if(!isSelected) e.currentTarget.style.background="transparent"; }}>
                              <div>
                                <div style={{ fontSize:13, color:"#E0E0E0", fontWeight:500 }}>{u.name}</div>
                                <div style={{ fontSize:11, color:"rgba(224,224,224,0.45)" }}>{u.email}</div>
                              </div>
                              <span className="tag" style={{ background:"rgba(86,185,233,0.1)", color:"#56B9E9", fontSize:10 }}>{u.role}</span>
                            </div>
                          );
                        })}
                        {users.filter(function(u){ if (u.role==="admin"||u.role==="hq_support") return false; if (!invSearch) return true; var q=invSearch.toLowerCase(); return (u.name||"").toLowerCase().includes(q)||(u.email||"").toLowerCase().includes(q); }).length === 0 && (
                          <div style={{ padding:"14px", color:"rgba(224,224,224,0.4)", fontSize:13, textAlign:"center" }}>No results</div>
                        )}
                      </div>
                      {invForm.userId && (
                        <div style={{ marginTop:8, padding:"8px 12px", background:"rgba(86,185,233,0.08)", border:"1px solid rgba(86,185,233,0.2)", borderRadius:8, fontSize:12, color:"#56B9E9" }}>
                          ✓ Selected: {invForm.name}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
                      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
                        <div><label className="label">FULL NAME</label><input placeholder="Full name" value={invForm.name} onChange={function(e) { setInvForm(function(p) { return Object.assign({}, p, { name:e.target.value }); }); }} /></div>
                        <div><label className="label">EMAIL</label><input type="email" placeholder="investor@email.com" value={invForm.email} onChange={function(e) { setInvForm(function(p) { return Object.assign({}, p, { email:e.target.value }); }); }} /></div>
                      </div>
                      <div><label className="label">PHONE NUMBER</label><input type="tel" placeholder="+44 7700 900000" value={invForm.phone} onChange={function(e) { setInvForm(function(p) { return Object.assign({}, p, { phone:e.target.value }); }); }} /></div>
                    </div>
                  )}
                  <div style={{ borderTop:"1px solid #374151", paddingTop:16 }}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}>
                      <label className="label" style={{ margin:0 }}>FRANCHISE SHARES</label>
                      <button className="btn btn-secondary btn-sm" onClick={function() { setInvStakes(function(s) { return s.concat([{ franchiseId:"", sharePercent:"" }]); }); }}>+ Add Branch</button>
                    </div>
                    <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
                      {invStakes.map(function(stake, idx) {
                        return (
                          <div key={idx} style={{ display:"grid", gridTemplateColumns:"1fr 100px 32px", gap:8, alignItems:"center" }}>
                            <select value={stake.franchiseId} onChange={function(e) { var val = e.target.value; setInvStakes(function(s) { return s.map(function(r, i) { return i === idx ? Object.assign({}, r, { franchiseId:val }) : r; }); }); }} style={{ background:"#1E1E1E", border:"1px solid #374151", color:stake.franchiseId ? "#E0E0E0" : "#56B9E9", padding:"10px 12px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:12, outline:"none" }}>
                              <option value="">Select franchise...</option>
                              {franchises.map(function(f) { return <option key={f.id} value={f.id}>{f.location + " - " + f.name}</option>; })}
                            </select>
                            <input type="number" min="0" max="100" placeholder="e.g. 10" value={stake.sharePercent} onChange={function(e) { var val = e.target.value; setInvStakes(function(s) { return s.map(function(r, i) { return i === idx ? Object.assign({}, r, { sharePercent:val }) : r; }); }); }} />
                            <button onClick={function() { setInvStakes(function(s) { return s.filter(function(_, i) { return i !== idx; }); }); }} style={{ background:"transparent", border:"none", cursor:"pointer", color:"#56B9E9", fontSize:15 }} onMouseEnter={function(e) { e.target.style.color="#cf6679"; }} onMouseLeave={function(e) { e.target.style.color="#56B9E9"; }}>✕</button>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div style={{ display:"flex", gap:10, marginTop:4 }}>
                    <button className="btn btn-primary" onClick={addInvestor}>Onboard Investor</button>
                    <button className="btn btn-secondary" onClick={function() { setModal(null); setInvStakes([{ franchiseId:"", sharePercent:"" }]); setInvForm({ name:"", email:"", phone:"", password:"investor123", isNew:false, userId:"" }); }}>Cancel</button>
                  </div>
                </div>
              </div>
            )}

            {modal === "new-financial" && (
              <div>
                <h3 style={{ fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:19, marginBottom:6 }}>Add Monthly Data</h3>
                <p style={{ fontSize:12, color:"rgba(224,224,224,0.6)", marginBottom:18 }}>Enter income and break down expenses by category.</p>
                <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
                  <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
                    <MonthPicker value={finForm.month} onChange={function(v) { setFinForm(function(p) { return Object.assign({}, p, { month:v }); }); }} />
                    <div><label className="label">INCOME (£)</label><input type="number" placeholder="e.g. 85000" value={finForm.income} onChange={function(e) { setFinForm(function(p) { return Object.assign({}, p, { income:e.target.value }); }); }} /></div>
                  </div>
                  <div style={{ borderTop:"1px solid #374151", paddingTop:14 }}>
                    <label className="label" style={{ marginBottom:12 }}>EXPENSE BREAKDOWN</label>
                    <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10 }}>
                      <div><label className="label">RENT (£)</label><input type="number" placeholder="0" value={finForm.rent} onChange={function(e) { setFinForm(function(p) { return Object.assign({}, p, { rent:e.target.value }); }); }} /></div>
                      <div><label className="label">SALARIES (£)</label><input type="number" placeholder="0" value={finForm.salaries} onChange={function(e) { setFinForm(function(p) { return Object.assign({}, p, { salaries:e.target.value }); }); }} /></div>
                      <div><label className="label">ROYALTY (£)</label><input type="number" placeholder="0" value={finForm.royalty} onChange={function(e) { setFinForm(function(p) { return Object.assign({}, p, { royalty:e.target.value }); }); }} /></div>
                      <div><label className="label">OTHER (£)</label><input type="number" placeholder="0" value={finForm.otherExpenses} onChange={function(e) { setFinForm(function(p) { return Object.assign({}, p, { otherExpenses:e.target.value }); }); }} /></div>
                    </div>
                  </div>
                  {(finForm.rent || finForm.salaries || finForm.royalty || finForm.otherExpenses) && (
                    <div style={{ background:"#252525", borderRadius:8, padding:"12px 14px", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                      <span style={{ fontSize:11, color:"rgba(224,224,224,0.6)" }}>TOTAL EXPENSES</span>
                      <span style={{ fontFamily:"Playfair Display,serif", fontWeight:700, color:"#cf6679" }}>{fmt((parseFloat(finForm.rent)||0)+(parseFloat(finForm.salaries)||0)+(parseFloat(finForm.royalty)||0)+(parseFloat(finForm.otherExpenses)||0))}</span>
                    </div>
                  )}
                  <div style={{ display:"flex", gap:10, marginTop:4 }}>
                    <button className="btn btn-primary" onClick={addFinancial}>Save Month</button>
                    <button className="btn btn-secondary" onClick={function() { setModal(null); }}>Cancel</button>
                  </div>
                </div>
              </div>
            )}

            {modal === "new-user" && (
              <div>
                <h3 style={{ fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:19, marginBottom:6 }}>Add User</h3>
                <p style={{ fontSize:12, color:"rgba(224,224,224,0.6)", marginBottom:18 }}>Create a login account.</p>
                <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
                  <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
                    <div><label className="label">FULL NAME</label><input placeholder="Full name" value={userForm.name} onChange={function(e) { setUserForm(function(p) { return Object.assign({}, p, { name:e.target.value }); }); }} /></div>
                    <div><label className="label">ROLE</label>
                      <select value={userForm.role} onChange={function(e) { setUserForm(function(p) { return Object.assign({}, p, { role:e.target.value }); }); }} style={{ background:"#1E1E1E", border:"1px solid #222", color:"#E0E0E0", padding:"11px 14px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none", width:"100%" }}>
                        <option value="investor">Investor</option>
                        <option value="franchisee">Franchisee</option>
                        <option value="franchisee_investor">Franchisee + Investor</option>
                        <option value="hq_support">HQ Support</option>
                        <option value="admin">Admin</option>
                      </select>
                    </div>
                  </div>
                  <div><label className="label">EMAIL</label><input type="email" placeholder="user@email.com" value={userForm.email} onChange={function(e) { setUserForm(function(p) { return Object.assign({}, p, { email:e.target.value }); }); }} /></div>
                  <div><label className="label">PASSWORD</label><input type="password" value={userForm.password} onChange={function(e) { setUserForm(function(p) { return Object.assign({}, p, { password:e.target.value }); }); }} /></div>
                  {(userForm.role === "franchisee" || userForm.role === "investor") && (
                    <div style={{ borderTop:"1px solid #374151", paddingTop:14 }}>
                      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:10 }}>
                        <label className="label" style={{ margin:0 }}>{userForm.role === "franchisee" ? "ASSIGN FRANCHISES" : "ASSIGN INVESTOR BRANCHES"}</label>
                        <button className="btn btn-secondary btn-sm" onClick={function() {
                          setInvStakes(function(s) { return s.concat([{ franchiseId:"", sharePercent:"" }]); });
                        }}>+ Add Branch</button>
                      </div>
                      <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
                        {invStakes.map(function(stake, idx) {
                          return (
                            <div key={idx} style={{ display:"grid", gridTemplateColumns:"1fr 100px 32px", gap:8, alignItems:"center" }}>
                              <select value={stake.franchiseId} onChange={function(e) { var val = e.target.value; setInvStakes(function(s) { return s.map(function(r, i) { return i === idx ? Object.assign({}, r, { franchiseId:val }) : r; }); }); }} style={{ background:"#1E1E1E", border:"1px solid #374151", color:stake.franchiseId ? "#E0E0E0" : "#56B9E9", padding:"10px 12px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:12, outline:"none" }}>
                                <option value="">Select franchise...</option>
                                {franchises.map(function(f) { return <option key={f.id} value={f.id}>{f.location + " - " + f.name}</option>; })}
                              </select>
                              <input type="number" min="0" max="100" placeholder="Share %" value={stake.sharePercent} onChange={function(e) { var val = e.target.value; setInvStakes(function(s) { return s.map(function(r, i) { return i === idx ? Object.assign({}, r, { sharePercent:val }) : r; }); }); }} />
                              <button onClick={function() { setInvStakes(function(s) { return s.filter(function(_, i) { return i !== idx; }); }); }} style={{ background:"transparent", border:"none", cursor:"pointer", color:"#56B9E9", fontSize:15 }} onMouseEnter={function(e) { e.target.style.color="#cf6679"; }} onMouseLeave={function(e) { e.target.style.color="#56B9E9"; }}>✕</button>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                  <div style={{ display:"flex", gap:10, marginTop:4 }}>
                    <button className="btn btn-primary" onClick={function() {
                      if (!userForm.name || !userForm.email) return;
                      var newId = "u" + Date.now();
                      var newUser = Object.assign({}, userForm, { id:newId, active:true });
                      // For franchisee, set first franchise as primary franchiseId
                      var validStakes = invStakes.filter(function(s) { return s.franchiseId; });
                      if (userForm.role === "franchisee" && validStakes.length > 0) {
                        newUser.franchiseId = validStakes[0].franchiseId;
                      }
                      var updatedUsers = users.concat([newUser]);
                      DB.createUser(newUser).then(function(res) {
                        if (res.error) { showToast("Error: " + res.error); return; }
                        var createdId = res.id || newId;
                        // Assign investor branches
                        if (userForm.role === "investor" && validStakes.length > 0) {
                          validStakes.forEach(function(stake) {
                            apiPost("/api/franchises/" + stake.franchiseId + "/investors", { userId:createdId, sharePercent:parseFloat(stake.sharePercent)||0 });
                          });
                        }
                        // Assign franchisee ownership
                        if (userForm.role === "franchisee" && validStakes.length > 0) {
                          validStakes.forEach(function(stake) {
                            var f = franchises.find(function(fr) { return fr.id === stake.franchiseId; });
                            if (!f) return;
                            var owners = [].concat(f.owners || [], [{ name:userForm.name, email:userForm.email, phone:userForm.phone||"", sharePercent:stake.sharePercent||"" }]);
                            apiPut("/api/franchises/" + stake.franchiseId + "/owners", { owners:owners });
                          });
                        }
                        DB.getUsers().then(function(d) { setUsers(d); });
                        DB.getFranchises().then(function(d) {
    setFranchises(d.map(function(f) {
      return Object.assign({}, f, {
        financials: (f.financials || []).map(function(m) {
          return { month:m.month, income:parseFloat(m.income)||0, rent:parseFloat(m.rent)||0, salaries:parseFloat(m.salaries)||0, royalty:parseFloat(m.royalty)||0, otherExpenses:parseFloat(m.otherExpenses)||0 };
        })
      });
    }));
  });
                        DB.logActivity("Created user", userForm.name + " (" + userForm.role + ")");
                        logActivity("Created user", userForm.name + " (" + userForm.role + ")");
                        setUserForm({ name:"", email:"", password:"investor123", role:"investor" });
                        setInvStakes([{ franchiseId:"", sharePercent:"" }]);
                        setModal(null); showToast("User created!");
                      });
                    }}>Create User</button>
                    <button className="btn btn-secondary" onClick={function() { setModal(null); setInvStakes([{ franchiseId:"", sharePercent:"" }]); }}>Cancel</button>
                  </div>
                </div>
              </div>
            )}

          </div>
        </div>
      )}

      {/* Pipeline Modal */}
      {pendingModal && pendingForm && (
        <div className="modal-bg" onClick={function() { setPendingModal(null); setPendingForm(null); }}>
          <div className="card fade-in" style={{ width:680, padding:32, maxHeight:"92vh", overflowY:"auto" }} onClick={function(e) { e.stopPropagation(); }}>
            <h3 style={{ fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:20, marginBottom:6 }}>{pendingModal === "new" ? "Add to Pipeline" : "Edit Pipeline Entry"}</h3>
            <p style={{ fontSize:12, color:"rgba(224,224,224,0.6)", marginBottom:22 }}>Track potential or pending franchises before they go live.</p>

            <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
              {/* Basic info */}
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 120px", gap:12 }}>
                <div><label className="label">COMPANY NAME</label><input placeholder="e.g. Sunrise Foods Ltd" value={pendingForm.companyName} onChange={function(e){var v=e.target.value;setPendingForm(function(p){return Object.assign({},p,{companyName:v});});}} /></div>
                <div><label className="label">LOCATION</label><input placeholder="e.g. Manchester, UK" value={pendingForm.location} onChange={function(e){var v=e.target.value;setPendingForm(function(p){return Object.assign({},p,{location:v});});}} /></div>
                <div><label className="label">STATUS</label>
                  <select value={pendingForm.status} onChange={function(e){var v=e.target.value;setPendingForm(function(p){return Object.assign({},p,{status:v});});}} style={{ background:"#1E1E1E", border:"1px solid #222", color:"#E0E0E0", padding:"11px 12px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:12, outline:"none", width:"100%" }}>
                    <option value="potential">Potential</option>
                    <option value="signed">Signed</option>
                    <option value="active">Active</option>
                  </select>
                </div>
              </div>

              {/* Franchise cost + payment */}
              <div style={{ borderTop:"1px solid #374151", paddingTop:14 }}>
                <label className="label" style={{ marginBottom:12 }}>FINANCIALS</label>
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
                  <div><label className="label">FRANCHISE COST (£)</label><input type="number" placeholder="e.g. 25000" value={pendingForm.franchiseCost} onChange={function(e){var v=e.target.value;setPendingForm(function(p){return Object.assign({},p,{franchiseCost:v});});}} /></div>
                  <div><label className="label">PAYMENT PLAN</label><input placeholder="e.g. 50% upfront, 50% on signing" value={pendingForm.paymentPlan} onChange={function(e){var v=e.target.value;setPendingForm(function(p){return Object.assign({},p,{paymentPlan:v});});}} /></div>
                </div>
              </div>

              {/* Franchisees */}
              <div style={{ borderTop:"1px solid #374151", paddingTop:14 }}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}>
                  <label className="label" style={{ margin:0 }}>FRANCHISEES</label>
                  <button className="btn btn-secondary btn-sm" onClick={function(){setPendingForm(function(p){return Object.assign({},p,{franchisees:p.franchisees.concat([{name:"",email:"",phone:"",sharePercent:"",paying:""}])});});}}>+ Add</button>
                </div>
                {pendingForm.franchisees.map(function(f, fi) {
                  return (
                    <div key={fi} style={{ background:"#252525", borderRadius:10, padding:"12px 14px", marginBottom:8, position:"relative" }}>
                      {pendingForm.franchisees.length > 1 && <button onClick={function(){setPendingForm(function(p){return Object.assign({},p,{franchisees:p.franchisees.filter(function(_,i){return i!==fi;})});});}} style={{ position:"absolute",top:10,right:12,background:"transparent",border:"none",cursor:"pointer",color:"#56B9E9",fontSize:13 }} onMouseEnter={function(e){e.target.style.color="#cf6679";}} onMouseLeave={function(e){e.target.style.color="#56B9E9";}}>✕</button>}
                      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 80px 100px", gap:8, marginBottom:8 }}>
                        <div><label className="label">NAME</label><input placeholder="Full name" value={f.name} onChange={function(e){var v=e.target.value;setPendingForm(function(p){var arr=p.franchisees.map(function(r,i){return i===fi?Object.assign({},r,{name:v}):r;});return Object.assign({},p,{franchisees:arr});});}} /></div>
                        <div><label className="label">EMAIL</label><input type="email" placeholder="email@example.com" value={f.email} onChange={function(e){var v=e.target.value;setPendingForm(function(p){var arr=p.franchisees.map(function(r,i){return i===fi?Object.assign({},r,{email:v}):r;});return Object.assign({},p,{franchisees:arr});});}} /></div>
                        <div><label className="label">SHARE %</label><input type="number" min="0" max="100" placeholder="50" value={f.sharePercent} onChange={function(e){var v=e.target.value;setPendingForm(function(p){var arr=p.franchisees.map(function(r,i){return i===fi?Object.assign({},r,{sharePercent:v}):r;});return Object.assign({},p,{franchisees:arr});});}} /></div>
                        <div><label className="label">PAYING (£)</label><input type="number" placeholder="0" value={f.paying} onChange={function(e){var v=e.target.value;setPendingForm(function(p){var arr=p.franchisees.map(function(r,i){return i===fi?Object.assign({},r,{paying:v}):r;});return Object.assign({},p,{franchisees:arr});});}} /></div>
                      </div>
                      <div><label className="label">PHONE</label><input type="tel" placeholder="+44 7700 900000" value={f.phone} onChange={function(e){var v=e.target.value;setPendingForm(function(p){var arr=p.franchisees.map(function(r,i){return i===fi?Object.assign({},r,{phone:v}):r;});return Object.assign({},p,{franchisees:arr});});}} /></div>
                      {/* Document uploads */}
                      <div style={{ borderTop:"1px solid #2A2A2A", marginTop:10, paddingTop:10 }}>
                        <label className="label" style={{ marginBottom:8 }}>DOCUMENTS</label>
                        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:8 }}>
                          {["ID","Proof of Address"].map(function(docType) {
                            var docKey = "pf_" + fi + "_" + docType;
                            var existing = f.docs && f.docs[docType];
                            return (
                              <div key={docType}>
                                <label className="label" style={{ fontSize:9 }}>{docType.toUpperCase()}</label>
                                {existing
                                  ? <div style={{ display:"flex", alignItems:"center", gap:6, background:"rgba(77,231,166,0.08)", border:"1px solid rgba(77,231,166,0.2)", borderRadius:6, padding:"6px 10px" }}>
                                      <span style={{ color:"#4DE7A6", fontSize:11, flex:1 }}>✓ {existing}</span>
                                      <button onClick={function() { setPendingForm(function(p) { var arr=p.franchisees.map(function(r,i){ if(i!==fi) return r; var d=Object.assign({},r.docs||{}); delete d[docType]; return Object.assign({},r,{docs:d}); }); return Object.assign({},p,{franchisees:arr}); }); }} style={{ background:"transparent",border:"none",cursor:"pointer",color:"#cf6679",fontSize:12 }}>✕</button>
                                    </div>
                                  : <div style={{ position:"relative" }}>
                                      <input type="file" accept=".pdf,.jpg,.jpeg,.png" id={docKey}
                                        onChange={function(e) {
                                          var file = e.target.files[0];
                                          if (!file) return;
                                          var fn = fi;
                                          var pf2 = pendingForm.franchisees[fn];
                                          // Find or create user account first, then upload immediately
                                          var existingUser = users.find(function(u) { return u.email && pf2.email && u.email.toLowerCase() === pf2.email.toLowerCase(); });
                                          var doImmediateUpload = function(userId) {
                                            if (!userId) { showToast("Save the pipeline entry first to enable document upload."); return; }
                                            DB.uploadDoc(userId, docType, file).then(function() {
                                              setPendingForm(function(p) {
                                                var arr = p.franchisees.map(function(r,i) {
                                                  if (i !== fn) return r;
                                                  var d = Object.assign({}, r.docs || {});
                                                  d[docType] = file.name;
                                                  return Object.assign({}, r, { docs:d });
                                                });
                                                return Object.assign({}, p, { franchisees:arr });
                                              });
                                              DB.getCompliance().then(function(d) { setCompliance(d || {}); });
    apiFetch("/api/royalty").then(function(d) { if (d && Array.isArray(d)) setRoyaltyPayments(d); }).catch(function(){});
    try { var savedMap = localStorage.getItem("gi_royalty_map"); if (savedMap) setRoyaltyBranchMap(JSON.parse(savedMap)); } catch(e) {}
                                              showToast(docType + " uploaded to compliance!");
                                            }).catch(function() { showToast("Upload failed. Please try again."); });
                                          };
                                          if (existingUser) {
                                            doImmediateUpload(existingUser.id);
                                          } else if (pf2.name && pf2.email) {
                                            DB.createUser({ name:pf2.name, email:pf2.email, phone:pf2.phone||"", password:"Welcome123!", role:"franchisee" }).then(function(res) {
                                              DB.getUsers().then(function(d) { setUsers(d); });
                                              doImmediateUpload(res && res.id);
                                            });
                                          } else {
                                            showToast("Please enter a name and email for this franchisee first.");
                                          }
                                        }}
                                        style={{ opacity:0, position:"absolute", width:"100%", height:"100%", cursor:"pointer", top:0, left:0 }} />
                                      <div style={{ background:"#1E1E1E", border:"1px dashed #2A2A2A", borderRadius:6, padding:"6px 10px", fontSize:11, color:"rgba(224,224,224,0.45)", textAlign:"center", cursor:"pointer" }}>+ Upload {docType}</div>
                                    </div>
                                }
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  );
                })}
                {pendingForm.franchisees.some(function(f){return f.paying;}) && (
                  <div style={{ background:"#252525", borderRadius:8, padding:"8px 12px", display:"flex", justifyContent:"space-between", fontSize:12 }}>
                    <span style={{ color:"rgba(224,224,224,0.6)" }}>Total Franchisees Paying</span>
                    <span style={{ color:"#4DE7A6", fontWeight:600 }}>£{pendingForm.franchisees.reduce(function(s,f){return s+(parseFloat(f.paying)||0);},0).toLocaleString("en-GB")}</span>
                  </div>
                )}
              </div>

              {/* Investors */}
              <div style={{ borderTop:"1px solid #374151", paddingTop:14 }}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}>
                  <label className="label" style={{ margin:0 }}>INVESTORS</label>
                  <button className="btn btn-secondary btn-sm" onClick={function(){setPendingForm(function(p){return Object.assign({},p,{investors:p.investors.concat([{name:"",type:"individual",companyName:"",email:"",phone:"",sharePercent:"",paying:""}])});});}}>+ Add</button>
                </div>
                {pendingForm.investors.map(function(inv, ii) {
                  return (
                    <div key={ii} style={{ background:"#252525", borderRadius:10, padding:"12px 14px", marginBottom:8, position:"relative" }}>
                      {pendingForm.investors.length > 1 && <button onClick={function(){setPendingForm(function(p){return Object.assign({},p,{investors:p.investors.filter(function(_,i){return i!==ii;})});});}} style={{ position:"absolute",top:10,right:12,background:"transparent",border:"none",cursor:"pointer",color:"#56B9E9",fontSize:13 }} onMouseEnter={function(e){e.target.style.color="#cf6679";}} onMouseLeave={function(e){e.target.style.color="#56B9E9";}}>✕</button>}
                      <div style={{ display:"grid", gridTemplateColumns:"120px 1fr 1fr", gap:8, marginBottom:8 }}>
                        <div><label className="label">TYPE</label>
                          <select value={inv.type} onChange={function(e){var v=e.target.value;setPendingForm(function(p){var arr=p.investors.map(function(r,i){return i===ii?Object.assign({},r,{type:v}):r;});return Object.assign({},p,{investors:arr});});}} style={{ background:"#1E1E1E",border:"1px solid #222",color:"#E0E0E0",padding:"10px 10px",borderRadius:8,fontFamily:"Outfit,sans-serif",fontSize:12,outline:"none",width:"100%" }}>
                            <option value="individual">Individual</option>
                            <option value="company">Company</option>
                          </select>
                        </div>
                        <div><label className="label">{inv.type === "company" ? "COMPANY NAME" : "FULL NAME"}</label><input placeholder={inv.type === "company" ? "Company Ltd" : "Full name"} value={inv.type === "company" ? inv.companyName : inv.name} onChange={function(e){var v=e.target.value;var field=inv.type==="company"?"companyName":"name";setPendingForm(function(p){var arr=p.investors.map(function(r,i){if(i!==ii)return r;var u={};u[field]=v;return Object.assign({},r,u);});return Object.assign({},p,{investors:arr});});}} /></div>
                        <div><label className="label">EMAIL</label><input type="email" placeholder="email@example.com" value={inv.email} onChange={function(e){var v=e.target.value;setPendingForm(function(p){var arr=p.investors.map(function(r,i){return i===ii?Object.assign({},r,{email:v}):r;});return Object.assign({},p,{investors:arr});});}} /></div>
                      </div>
                      <div style={{ display:"grid", gridTemplateColumns:"1fr 80px 100px", gap:8 }}>
                        <div><label className="label">PHONE</label><input type="tel" placeholder="+44 7700 900000" value={inv.phone} onChange={function(e){var v=e.target.value;setPendingForm(function(p){var arr=p.investors.map(function(r,i){return i===ii?Object.assign({},r,{phone:v}):r;});return Object.assign({},p,{investors:arr});});}} /></div>
                        <div><label className="label">SHARE %</label><input type="number" min="0" max="100" placeholder="50" value={inv.sharePercent} onChange={function(e){var v=e.target.value;setPendingForm(function(p){var arr=p.investors.map(function(r,i){return i===ii?Object.assign({},r,{sharePercent:v}):r;});return Object.assign({},p,{investors:arr});});}} /></div>
                        <div><label className="label">PAYING (£)</label><input type="number" placeholder="0" value={inv.paying} onChange={function(e){var v=e.target.value;setPendingForm(function(p){var arr=p.investors.map(function(r,i){return i===ii?Object.assign({},r,{paying:v}):r;});return Object.assign({},p,{investors:arr});});}} /></div>
                      </div>
                    </div>
                  );
                })}
                {pendingForm.investors.some(function(i){return i.paying;}) && (
                  <div style={{ background:"#252525", borderRadius:8, padding:"8px 12px", display:"flex", justifyContent:"space-between", fontSize:12 }}>
                    <span style={{ color:"rgba(224,224,224,0.6)" }}>Total Investors Paying</span>
                    <span style={{ color:"#E0E0E0", fontWeight:600 }}>£{pendingForm.investors.reduce(function(s,i){return s+(parseFloat(i.paying)||0);},0).toLocaleString("en-GB")}</span>
                  </div>
                )}
              </div>

              {/* Agreements */}
              <div style={{ borderTop:"1px solid #374151", paddingTop:14 }}>
                <label className="label" style={{ marginBottom:12 }}>AGREEMENTS & SIGNATURES</label>
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:10 }}>
                  {[["ilaSignedFranchisee","ILA Signed (Franchisee)"],["ilaSignedInvestor","ILA Signed (Investor)"],["contractSigned","Franchise Contract Signed"]].map(function(item) {
                    var signed = pendingForm[item[0]];
                    return (
                      <div key={item[0]} onClick={function(){var u={};u[item[0]]=!signed;setPendingForm(function(p){return Object.assign({},p,u);});}}
                        style={{ padding:"12px 14px", borderRadius:10, background:signed?"rgba(52,211,153,0.08)":"#252525", border:"1px solid "+(signed?"rgba(52,211,153,0.25)":"#2A2A2A"), cursor:"pointer", userSelect:"none", transition:"all 0.15s" }}>
                        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:4 }}>
                          <span style={{ fontSize:12, fontWeight:500, color:signed?"#4DE7A6":"#999" }}>{item[1]}</span>
                          <div style={{ width:18, height:18, borderRadius:"50%", background:signed?"#4DE7A6":"#2A2A2A", border:"1px solid "+(signed?"#4DE7A6":"#333333"), display:"flex", alignItems:"center", justifyContent:"center", fontSize:10, color:"#080808" }}>{signed?"✓":""}</div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Notes */}
              <div>
                <label className="label">NOTES</label>
                <textarea placeholder="Any additional notes about this pipeline entry..." value={pendingForm.notes} rows={3}
                  onChange={function(e){var v=e.target.value;setPendingForm(function(p){return Object.assign({},p,{notes:v});});}}
                  style={{ background:"#1E1E1E",border:"1px solid #222",color:"#E0E0E0",padding:"10px 14px",borderRadius:8,fontFamily:"Outfit,sans-serif",fontSize:13,outline:"none",width:"100%",resize:"vertical" }} />
              </div>

              <div style={{ display:"flex", gap:10, marginTop:4 }}>
                <button className="btn btn-primary" onClick={function() {
                  var entry = Object.assign({}, pendingForm);
                  var isNew = pendingModal === "new";
                  var prevEntry = !isNew ? pendingFranchises.find(function(p) { return p.id === entry.id; }) : null;
                  var justActivated = entry.status === "active" && (!prevEntry || prevEntry.status !== "active");
                  // Auto-create user accounts for franchisees (docs are uploaded immediately on selection)
                  var pipelineFranchisees = (entry.franchisees || []).filter(function(f) { return f.name && f.email; });
                  pipelineFranchisees.forEach(function(pf) {
                    var exists = users.find(function(u) { return u.email && u.email.toLowerCase() === pf.email.toLowerCase(); });
                    if (!exists) {
                      DB.createUser({ name:pf.name, email:pf.email, phone:pf.phone||"", password:"Welcome123!", role:"franchisee" }).then(function() {
                        DB.getUsers().then(function(d) { setUsers(d); });
                      });
                    }
                  });
                  var apiCall = isNew ? DB.createPipeline(entry) : DB.updatePipeline(entry.id, entry);
                  apiCall.then(function(res) {
                    DB.getPending().then(function(d) { setPendingFranchises(d); });
                    DB.logActivity(isNew ? "Added pipeline entry" : "Updated pipeline entry", entry.companyName + " - " + entry.location);
                    logActivity(isNew ? "Added pipeline entry" : "Updated pipeline entry", entry.companyName + " - " + entry.location);
                    // Auto-create franchise when marked as active
                    if (justActivated && entry.companyName && entry.location) {
                      var owners = (entry.franchisees || []).filter(function(f) { return f.name; }).map(function(f) {
                        return { name:f.name, email:f.email||"", phone:f.phone||"", sharePercent:f.sharePercent||"" };
                      });
                      var investors = (entry.investors || []).filter(function(i) { return i.name; }).map(function(i) {
                        return { name:i.name, email:i.email||"", phone:i.phone||"", sharePercent:parseFloat(i.sharePercent)||0 };
                      });
                      apiPost("/api/franchises", { name:entry.companyName, location:entry.location, phone:"", email:"", owners:owners, investors:investors }).then(function() {
                        DB.getFranchises().then(function(d) {
                          setFranchises(d.map(function(f) {
                            return Object.assign({}, f, { financials:(f.financials||[]).map(function(m) { return { month:m.month, income:parseFloat(m.income)||0, rent:parseFloat(m.rent)||0, salaries:parseFloat(m.salaries)||0, royalty:parseFloat(m.royalty)||0, otherExpenses:parseFloat(m.otherExpenses)||0 }; }) });
                          }));
                        });
                        DB.getUsers().then(function(d) { setUsers(d); });
                        logActivity("Auto-created franchise from pipeline", entry.companyName);
                        DB.logActivity("Auto-created franchise from pipeline", entry.companyName);
                        showToast("Franchise created from pipeline!");
                      });
                    } else {
                      setPendingModal(null); setPendingForm(null); showToast("Saved!");
                    }
                    if (justActivated) { setPendingModal(null); setPendingForm(null); }
                  });
                }}>Save</button>
                <button className="btn btn-secondary" onClick={function() { setPendingModal(null); setPendingForm(null); }}>Cancel</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Activity Detail Modal */}
      {activityDetail && (function() {
        var e2 = activityDetail;
        var dt2 = e2.timestamp ? new Date(e2.timestamp) : (e2.created_at ? new Date(e2.created_at) : null);
        var ac2 = (e2.action||"").indexOf("Approved") === 0 ? "#4DE7A6" : (e2.action||"").indexOf("Rejected") === 0 || (e2.action||"").indexOf("Deleted") === 0 || (e2.action||"").indexOf("Suspended") === 0 ? "#cf6679" : (e2.action||"").indexOf("Edited") === 0 ? "#cf6679" : "#56B9E9";
        return (
          <div className="modal-bg" onClick={function(){ setActivityDetail(null); }}>
            <div className="card fade-in" style={{ width:460, padding:28 }} onClick={function(e3){ e3.stopPropagation(); }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:20 }}>
                <h3 style={{ fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:18 }}>Activity Detail</h3>
                <button onClick={function(){ setActivityDetail(null); }} style={{ background:"transparent", border:"none", cursor:"pointer", color:"rgba(224,224,224,0.4)", fontSize:18 }}>✕</button>
              </div>
              <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
                <div style={{ background:"#252525", borderRadius:8, padding:"12px 16px" }}>
                  <div className="label" style={{ marginBottom:6 }}>ACTION</div>
                  <span className="tag" style={{ background:ac2+"22", color:ac2, fontSize:12 }}>{e2.action}</span>
                </div>
                <div style={{ background:"#252525", borderRadius:8, padding:"12px 16px" }}>
                  <div className="label" style={{ marginBottom:6 }}>DETAILS</div>
                  <div style={{ fontSize:13, color:"#E0E0E0", lineHeight:1.6 }}>{e2.details || "—"}</div>
                </div>
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
                  <div style={{ background:"#252525", borderRadius:8, padding:"12px 16px" }}>
                    <div className="label" style={{ marginBottom:6 }}>BY</div>
                    <div style={{ fontSize:13, color:"#E0E0E0", fontWeight:500 }}>{e2.adminName || "—"}</div>
                  </div>
                  <div style={{ background:"#252525", borderRadius:8, padding:"12px 16px" }}>
                    <div className="label" style={{ marginBottom:6 }}>WHEN</div>
                    <div style={{ fontSize:13, color:"#56B9E9" }}>{dt2 && !isNaN(dt2) ? dt2.toLocaleDateString("en-GB") : "—"}</div>
                    <div style={{ fontSize:11, color:"rgba(224,224,224,0.45)", marginTop:2 }}>{dt2 && !isNaN(dt2) ? dt2.toLocaleTimeString("en-GB") : ""}</div>
                  </div>
                </div>
                {e2.id && (
                  <div style={{ background:"#252525", borderRadius:8, padding:"12px 16px" }}>
                    <div className="label" style={{ marginBottom:6 }}>REFERENCE ID</div>
                    <div style={{ fontSize:11, color:"rgba(224,224,224,0.4)", fontFamily:"monospace" }}>{e2.id}</div>
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      })()}

      {/* Edit Name/Email Modal */}
      {editingNameId && (function() {
        var editUser = users.find(function(u) { return u.id === editingNameId; });
        return (
          <div className="modal-bg" onClick={function() { setEditingNameId(null); }}>
            <div className="card fade-in" style={{ width:400, padding:28 }} onClick={function(e) { e.stopPropagation(); }}>
              <h3 style={{ fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:18, marginBottom:6 }}>Edit User</h3>
              <p style={{ fontSize:12, color:"rgba(224,224,224,0.6)", marginBottom:20 }}>Update name and email for <strong style={{ color:"#E0E0E0" }}>{editUser ? editUser.name : ""}</strong></p>
              <div style={{ display:"flex", flexDirection:"column", gap:12, marginBottom:20 }}>
                <div>
                  <label className="label">FULL NAME</label>
                  <input placeholder="Full name" value={editNameForm.name}
                    onChange={function(e) { setEditNameForm(function(f) { return Object.assign({},f,{name:e.target.value}); }); }}
                    style={{ background:"#252525", border:"1px solid #2A2A2A", color:"#E0E0E0", padding:"11px 14px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none", width:"100%" }} />
                </div>
                <div>
                  <label className="label">EMAIL</label>
                  <input type="email" placeholder="email@example.com" value={editNameForm.email}
                    onChange={function(e) { setEditNameForm(function(f) { return Object.assign({},f,{email:e.target.value}); }); }}
                    style={{ background:"#252525", border:"1px solid #2A2A2A", color:"#E0E0E0", padding:"11px 14px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none", width:"100%" }} />
                </div>
              </div>
              <div style={{ display:"flex", gap:10 }}>
                <button className="btn btn-primary"
                  onClick={function() {
                    if (!editNameForm.name || !editNameForm.email) { showToast("Name and email are required."); return; }
                    fetch(API_URL + "/api/users/" + editingNameId + "/edit", {
                      method: "PUT",
                      headers: { "Content-Type":"application/json", "Authorization":"Bearer " + (localStorage.getItem("gi_token")||"") },
                      body: JSON.stringify({ name:editNameForm.name, email:editNameForm.email.toLowerCase().trim() })
                    }).then(function(r) { return r.json(); }).then(function(r) {
                      if (r && r.error) { showToast("Error: " + r.error); return; }
                      setUsers(users.map(function(u) { return u.id === editingNameId ? Object.assign({},u,{name:editNameForm.name,email:editNameForm.email}) : u; }));
                      DB.logActivity("Updated user details", editNameForm.name);
                      logActivity("Updated user details", editNameForm.name);
                      setEditingNameId(null);
                      showToast("User updated!");
                    }).catch(function() { showToast("Network error. Please try again."); });
                  }}>Save Changes</button>
                <button className="btn btn-secondary" onClick={function() { setEditingNameId(null); }}>Cancel</button>
              </div>
            </div>
          </div>
        );
      })()}

      {/* Allocate Royalty Payment Modal */}
      {royaltyLinkId && (function() {
        var linkPayment = royaltyPayments.find(function(p){ return p.id === royaltyLinkId; });
        return (
          <div className="modal-bg" onClick={function(){ setRoyaltyLinkId(null); setRoyaltyLinkFranchiseId(""); setRoyaltyLinkSearch(""); }}>
            <div className="card fade-in" style={{ width:440, padding:28 }} onClick={function(e){ e.stopPropagation(); }}>
              <h3 style={{ fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:18, marginBottom:6 }}>Allocate Payment</h3>
              <p style={{ fontSize:12, color:"rgba(224,224,224,0.6)", marginBottom:20 }}>
                Linking <strong style={{ color:"#cf6679" }}>{linkPayment ? linkPayment.franchiseName : ""}</strong> — {linkPayment ? linkPayment.month : ""}
              </p>
              <div style={{ marginBottom:16 }}>
                <label className="label">SEARCH BRANCH</label>
                <input placeholder="Type to search..." value={royaltyLinkSearch}
                  autoFocus={true}
                  onChange={function(e){ setRoyaltyLinkSearch(e.target.value); }}
                  style={{ background:"#252525", border:"1px solid #2A2A2A", color:"#E0E0E0", padding:"11px 14px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none", width:"100%", marginBottom:8 }} />
                <div style={{ background:"#252525", border:"1px solid #2A2A2A", borderRadius:8, maxHeight:220, overflowY:"auto" }}>
                  {franchises.filter(function(f){
                    if (!royaltyLinkSearch) return true;
                    var q2 = royaltyLinkSearch.toLowerCase();
                    return (f.name||"").toLowerCase().includes(q2) || (f.location||"").toLowerCase().includes(q2);
                  }).map(function(f){
                    var isSel = royaltyLinkFranchiseId === f.id;
                    return (
                      <div key={f.id} onClick={function(){ setRoyaltyLinkFranchiseId(f.id); }}
                        style={{ padding:"10px 14px", cursor:"pointer", background:isSel?"rgba(86,185,233,0.12)":"transparent", borderBottom:"1px solid rgba(255,255,255,0.04)" }}
                        onMouseEnter={function(e){ if(!isSel) e.currentTarget.style.background="rgba(255,255,255,0.04)"; }}
                        onMouseLeave={function(e){ if(!isSel) e.currentTarget.style.background="transparent"; }}>
                        <div style={{ color:isSel?"#56B9E9":"#E0E0E0", fontWeight:isSel?600:400, fontSize:13 }}>{f.name} {isSel ? "✓" : ""}</div>
                        <div style={{ color:"rgba(224,224,224,0.4)", fontSize:11 }}>{f.location}</div>
                      </div>
                    );
                  })}
                  {franchises.filter(function(f){ if (!royaltyLinkSearch) return true; var q2=royaltyLinkSearch.toLowerCase(); return (f.name||"").toLowerCase().includes(q2)||(f.location||"").toLowerCase().includes(q2); }).length === 0 && (
                    <div style={{ padding:"16px 14px", color:"rgba(224,224,224,0.35)", fontSize:13, textAlign:"center" }}>No branches found</div>
                  )}
                </div>
                {royaltyLinkFranchiseId && (
                  <div style={{ marginTop:8, padding:"8px 12px", background:"rgba(86,185,233,0.08)", border:"1px solid rgba(86,185,233,0.2)", borderRadius:6, fontSize:12, color:"#56B9E9" }}>
                    ✓ Selected: {(franchises.find(function(f){ return f.id === royaltyLinkFranchiseId; })||{}).name}
                  </div>
                )}
              </div>
              <div style={{ display:"flex", gap:10 }}>
                <button className="btn btn-primary" style={{ opacity:royaltyLinkFranchiseId?1:0.4 }}
                  onClick={function(){
                    if (!royaltyLinkFranchiseId) return;
                    var f4 = franchises.find(function(f){ return f.id === royaltyLinkFranchiseId; });
                    var pData = royaltyPayments.find(function(p){ return p.id === royaltyLinkId; });
                    if (!pData) return;
                    fetch(API_URL + "/api/royalty/" + royaltyLinkId, {
                      method:"PUT",
                      headers:{"Content-Type":"application/json","Authorization":"Bearer "+(localStorage.getItem("gi_token")||"")},
                      body:JSON.stringify(Object.assign({},pData,{franchiseId:royaltyLinkFranchiseId, franchiseName:f4?f4.name:pData.franchiseName}))
                    }).then(function(){
                      // Save mapping for future auto-link
                      var newMap = Object.assign({}, royaltyBranchMap);
                      newMap[(pData.franchiseName||"").toLowerCase()] = royaltyLinkFranchiseId;
                      setRoyaltyBranchMap(newMap);
                      try { localStorage.setItem("gi_royalty_map", JSON.stringify(newMap)); } catch(e2) {}
                      apiFetch("/api/royalty").then(function(d){ if(d&&Array.isArray(d)) setRoyaltyPayments(d); });
                      setRoyaltyLinkId(null); setRoyaltyLinkFranchiseId(""); setRoyaltyLinkSearch("");
                      showToast("Allocated to " + (f4?f4.name:"branch") + "!");
                    });
                  }}>Save Allocation</button>
                <button className="btn btn-secondary" onClick={function(){ setRoyaltyLinkId(null); setRoyaltyLinkFranchiseId(""); setRoyaltyLinkSearch(""); }}>Cancel</button>
              </div>
            </div>
          </div>
        );
      })()}

      {/* Reset Password Modal */}
      {resetPwUserId && (function() {
        var resetUser = users.find(function(u) { return u.id === resetPwUserId; });
        return (
          <div className="modal-bg" onClick={function() { setResetPwUserId(null); setResetPwVal(""); }}>
            <div className="card fade-in" style={{ width:400, padding:28 }} onClick={function(e) { e.stopPropagation(); }}>
              <h3 style={{ fontFamily:"Playfair Display,serif", fontWeight:700, fontSize:18, marginBottom:6 }}>Reset Password</h3>
              <p style={{ fontSize:12, color:"rgba(224,224,224,0.6)", marginBottom:20 }}>
                Setting new password for <strong style={{ color:"#E0E0E0" }}>{resetUser ? resetUser.name : ""}</strong>
              </p>
              <div style={{ marginBottom:20 }}>
                <label className="label">NEW PASSWORD</label>
                <input type="password" placeholder="Min 8 characters" value={resetPwVal}
                  onChange={function(e) { setResetPwVal(e.target.value); }}
                  style={{ background:"#252525", border:"1px solid #2A2A2A", color:"#E0E0E0", padding:"11px 14px", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none", width:"100%" }}
                />
                {resetPwVal.length > 0 && resetPwVal.length < 8 && (
                  <div style={{ fontSize:11, color:"#cf6679", marginTop:6 }}>Must be at least 8 characters</div>
                )}
                {resetPwVal.length >= 8 && (
                  <div style={{ fontSize:11, color:"#4DE7A6", marginTop:6 }}>✓ Ready to save</div>
                )}
              </div>
              <div style={{ display:"flex", gap:10 }}>
                <button className="btn btn-primary" style={{ opacity: resetPwVal.length < 8 ? 0.4 : 1 }}
                  onClick={function() {
                    if (resetPwVal.length < 8) { showToast("Password must be at least 8 characters."); return; }
                    fetch(API_URL + "/api/users/" + resetPwUserId + "/reset-password", {
                      method: "PUT",
                      headers: { "Content-Type":"application/json", "Authorization":"Bearer " + (localStorage.getItem("gi_token")||"") },
                      body: JSON.stringify({ password: resetPwVal })
                    }).then(function(r) { return r.json(); }).then(function(r) {
                      if (r && r.error) { showToast("Error: " + r.error); return; }
                      DB.logActivity("Reset password", resetUser ? resetUser.name : "");
                      logActivity("Reset password", resetUser ? resetUser.name : "");
                      setResetPwUserId(null);
                      setResetPwVal("");
                      showToast("Password reset for " + (resetUser ? resetUser.name : "") + "!");
                    }).catch(function() { showToast("Network error. Please try again."); });
                  }}>Set Password</button>
                <button className="btn btn-secondary" onClick={function() { setResetPwUserId(null); setResetPwVal(""); }}>Cancel</button>
              </div>
            </div>
          </div>
        );
      })()}
    </div>
  );
}

// ─── FRANCHISEE + INVESTOR PORTAL ────────────────────────────────────────────
function FranchiseeInvestorPortal(props) {
  var user = props.user;
  var franchises = props.franchises;
  var onLogout = props.onLogout;
  var [view, setView] = useState("franchisee");

  return (
    <div style={{ minHeight:"100vh", background:"#121212", color:"#E0E0E0", fontFamily:"Outfit,sans-serif" }}>
      <div style={{ background:"#1E1E1E", borderBottom:"1px solid #374151", padding:"0 32px" }}>
        <div style={{ maxWidth:1100, margin:"0 auto", display:"flex", alignItems:"center", justifyContent:"space-between", height:58 }}>
          <div style={{ display:"flex", alignItems:"center", gap:10 }}>
            <img src="https://www.goinvestors.co.uk/finance-emblem-white.svg" onClick={function(e){ triggerEasterEgg(e.currentTarget); }} alt="GoTutors" style={{ height:26 }} />
            <img src="https://www.goinvestors.co.uk/finance-wordmark-white.svg" alt="GoInvestors" style={{ height:16 }} />
            <span className="tag" style={{ background:"#2A2A2A", color:"#E0E0E0", fontSize:10, marginLeft:4 }}>Franchisee + Investor</span>
          </div>
          <div style={{ display:"flex", gap:6 }}>
            <button className={"nav-pill" + (view === "franchisee" ? " active" : "")} onClick={function() { setView("franchisee"); }}>My Franchise</button>
            <button className={"nav-pill" + (view === "investor" ? " active" : "")} onClick={function() { setView("investor"); }}>My Investments</button>
          </div>
          <div style={{ display:"flex", alignItems:"center", gap:12 }}>
            <span style={{ fontSize:13, color:"#56B9E9" }}>{user.name}</span>
            <button className="btn btn-secondary btn-sm" onClick={onLogout}>Sign Out</button>
          </div>
        </div>
      </div>
      <div style={{ maxWidth:1100, margin:"0 auto", padding:"32px 24px" }}>
        {view === "franchisee" && <FranchiseePortal user={user} franchises={franchises} onLogout={onLogout} embedded={true} />}
        {view === "investor" && <InvestorPortal user={user} franchises={franchises} onLogout={onLogout} embedded={true} />}
      </div>
    </div>
  );
}

// ─── ROOT ─────────────────────────────────────────────────────────────────────
export default function App() {
  var [showRain, setShowRain] = useState(false);
  var [session, setSession] = useState(undefined);
  var [franchises, setFranchises] = useState([]);
  useEffect(function() { window.__setShowRain__ = setShowRain; }, [setShowRain]);
  var [currentPath, setCurrentPath] = useState(window.location.pathname);

  useEffect(function() {
    var VER = "v6";
    if (localStorage.getItem("gi_schema_ver") !== VER) {
      DB.reset();
      localStorage.setItem("gi_schema_ver", VER);
    }
    DB.getSession().then(function(s) { setSession(s); });
    DB.getFranchises().then(function(d) {
    setFranchises(d.map(function(f) {
      return Object.assign({}, f, {
        financials: (f.financials || []).map(function(m) {
          return { month:m.month, income:parseFloat(m.income)||0, rent:parseFloat(m.rent)||0, salaries:parseFloat(m.salaries)||0, royalty:parseFloat(m.royalty)||0, otherExpenses:parseFloat(m.otherExpenses)||0 };
        })
      });
    }));
  });

    // ── Browser history routing ──────────────────────────────────────────────
    function handlePopState() {
      var path = window.location.pathname;
      setCurrentPath(path);
    }
    window.addEventListener("popstate", handlePopState);
    return function() { window.removeEventListener("popstate", handlePopState); };
  }, []);

  // ── Auto-logout after 30 minutes of inactivity ───────────────────────────
  useEffect(function() {
    if (!session) return;
    var TIMEOUT = 30 * 60 * 1000;
    var timer = null;
    function resetTimer() {
      clearTimeout(timer);
      timer = setTimeout(function() {
        DB.clearSession();
        setSession(null);
        window.history.pushState({}, "", "/");
        alert("You have been logged out due to inactivity.");
      }, TIMEOUT);
    }
    var events = ["mousedown","mousemove","keydown","scroll","touchstart","click"];
    events.forEach(function(e) { window.addEventListener(e, resetTimer); });
    resetTimer();
    return function() {
      clearTimeout(timer);
      events.forEach(function(e) { window.removeEventListener(e, resetTimer); });
    };
  }, [session]);

  function handleLogout() { DB.clearSession(); setSession(null); window.history.pushState({}, "", "/"); }
  function navigate(path) { window.history.pushState({}, "", path); setCurrentPath(path); }

  if (session === undefined) {
    return (
      <div style={{ background:"#121212", minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center" }}>
        <style>{CSS}</style>
        <img src="https://www.goinvestors.co.uk/finance-emblem-white.svg" onClick={function(e){ triggerEasterEgg(e.currentTarget); }} alt="GoTutors" style={{ height:22 }} />
        <img src="https://www.goinvestors.co.uk/finance-wordmark-white.svg" alt="GoInvestors" style={{ height:14 }} />
      </div>
    );
  }

  if (!session) return <><LoginScreen onLogin={function(s) { setSession(s); DB.getFranchises().then(function(d) { setFranchises(d); }); }} />{showRain && <EasterEggRain onDone={function(){ setShowRain(false); }} />}</>;
  if (session.role === "investor")   return <>{showRain && <EasterEggRain onDone={function(){ setShowRain(false); }} />}<InvestorPortal user={session} franchises={franchises} onLogout={handleLogout} /></>;
  if (session.role === "franchisee") return <>{showRain && <EasterEggRain onDone={function(){ setShowRain(false); }} />}<FranchiseePortal user={session} franchises={franchises} onLogout={handleLogout} /></>;
  if (session.role === "director")   return <>{showRain && <EasterEggRain onDone={function(){ setShowRain(false); }} />}<FranchiseePortal user={session} franchises={franchises} onLogout={handleLogout} /></>;
  if (session.role === "franchisee_investor") return <>{showRain && <EasterEggRain onDone={function(){ setShowRain(false); }} />}<FranchiseeInvestorPortal user={session} franchises={franchises} onLogout={handleLogout} /></>;
  return <>{showRain && <EasterEggRain onDone={function(){ setShowRain(false); }} />}<AdminApp user={session} onLogout={handleLogout} /></>;
}
